/* Object fit polyfill */
!function () {
    "use strict";
    if ("undefined" != typeof window) {
        var t = window.navigator.userAgent.match(/Edge\/(\d{2})\./), n = !!t && 16 <= parseInt(t[1], 10);
        if (!("objectFit" in document.documentElement.style != !1) || n) {
            var o = function (t, e, i) {
                var n, o, l, a, d;
                if ((i = i.split(" ")).length < 2 && (i[1] = i[0]), "x" === t) n = i[0], o = i[1], l = "left", a = "right", d = e.clientWidth; else {
                    if ("y" !== t) return;
                    n = i[1], o = i[0], l = "top", a = "bottom", d = e.clientHeight
                }
                if (n !== l && o !== l) {
                    if (n !== a && o !== a) return "center" === n || "50%" === n ? (e.style[l] = "50%", void (e.style["margin-" + l] = d / -2 + "px")) : void (0 <= n.indexOf("%") ? (n = parseInt(n)) < 50 ? (e.style[l] = n + "%", e.style["margin-" + l] = d * (n / -100) + "px") : (n = 100 - n, e.style[a] = n + "%", e.style["margin-" + a] = d * (n / -100) + "px") : e.style[l] = n);
                    e.style[a] = "0"
                } else e.style[l] = "0"
            }, l = function (t) {
                var e = t.dataset ? t.dataset.objectFit : t.getAttribute("data-object-fit"),
                    i = t.dataset ? t.dataset.objectPosition : t.getAttribute("data-object-position");
                e = e || "cover", i = i || "50% 50%";
                var n = t.parentNode;
                return function (t) {
                    var e = window.getComputedStyle(t, null), i = e.getPropertyValue("position"),
                        n = e.getPropertyValue("overflow"), o = e.getPropertyValue("display");
                    i && "static" !== i || (t.style.position = "relative"), "hidden" !== n && (t.style.overflow = "hidden"), o && "inline" !== o || (t.style.display = "block"), 0 === t.clientHeight && (t.style.height = "100%"), -1 === t.className.indexOf("object-fit-polyfill") && (t.className = t.className + " object-fit-polyfill")
                }(n), function (t) {
                    var e = window.getComputedStyle(t, null), i = {
                        "max-width": "none",
                        "max-height": "none",
                        "min-width": "0px",
                        "min-height": "0px",
                        top: "auto",
                        right: "auto",
                        bottom: "auto",
                        left: "auto",
                        "margin-top": "0px",
                        "margin-right": "0px",
                        "margin-bottom": "0px",
                        "margin-left": "0px"
                    };
                    for (var n in i) e.getPropertyValue(n) !== i[n] && (t.style[n] = i[n])
                }(t), t.style.position = "absolute", t.style.width = "auto", t.style.height = "auto", "scale-down" === e && (e = t.clientWidth < n.clientWidth && t.clientHeight < n.clientHeight ? "none" : "contain"), "none" === e ? (o("x", t, i), void o("y", t, i)) : "fill" === e ? (t.style.width = "100%", t.style.height = "100%", o("x", t, i), void o("y", t, i)) : (t.style.height = "100%", void ("cover" === e && t.clientWidth > n.clientWidth || "contain" === e && t.clientWidth < n.clientWidth ? (t.style.top = "0", t.style.marginTop = "0", o("x", t, i)) : (t.style.width = "100%", t.style.height = "auto", t.style.left = "0", t.style.marginLeft = "0", o("y", t, i))))
            }, e = function (t) {
                if (void 0 === t || t instanceof Event) t = document.querySelectorAll("[data-object-fit]"); else if (t && t.nodeName) t = [t]; else {
                    if ("object" != typeof t || !t.length || !t[0].nodeName) return !1;
                    t = t
                }
                for (var e = 0; e < t.length; e++) if (t[e].nodeName) {
                    var i = t[e].nodeName.toLowerCase();
                    if ("img" === i) {
                        if (n) continue;
                        t[e].complete ? l(t[e]) : t[e].addEventListener("load", function () {
                            l(this)
                        })
                    } else "video" === i ? 0 < t[e].readyState ? l(t[e]) : t[e].addEventListener("loadedmetadata", function () {
                        l(this)
                    }) : l(t[e])
                }
                return !0
            };
            "loading" === document.readyState ? document.addEventListener("DOMContentLoaded", e) : e(), window.addEventListener("resize", e), window.objectFitPolyfill = e
        } else window.objectFitPolyfill = function () {
            return !1
        }
    }
}();

/*!
  * Stickyfill – `position: sticky` polyfill
  * v. 2.1.0 | https://github.com/wilddeer/stickyfill
  * MIT License
  */
!function (a, b) {
    "use strict";

    function c(a, b) {
        if (!(a instanceof b)) throw new TypeError("Cannot call a class as a function")
    }

    function d(a, b) {
        for (var c in b) b.hasOwnProperty(c) && (a[c] = b[c])
    }

    function e(a) {
        return parseFloat(a) || 0
    }

    function f(a) {
        for (var b = 0; a;) b += a.offsetTop, a = a.offsetParent;
        return b
    }

    function g() {
        function c() {
            a.pageXOffset != m.left ? (m.top = a.pageYOffset, m.left = a.pageXOffset, p.refreshAll()) : a.pageYOffset != m.top && (m.top = a.pageYOffset, m.left = a.pageXOffset, n.forEach(function (a) {
                return a._recalcPosition()
            }))
        }

        function d() {
            f = setInterval(function () {
                n.forEach(function (a) {
                    return a._fastCheck()
                })
            }, 500)
        }

        function e() {
            clearInterval(f)
        }

        if (!k) {
            k = !0, c(), a.addEventListener("scroll", c), a.addEventListener("resize", p.refreshAll), a.addEventListener("orientationchange", p.refreshAll);
            var f = void 0, g = void 0, h = void 0;
            "hidden" in b ? (g = "hidden", h = "visibilitychange") : "webkitHidden" in b && (g = "webkitHidden", h = "webkitvisibilitychange"), h ? (b[g] || d(), b.addEventListener(h, function () {
                b[g] ? e() : d()
            })) : d()
        }
    }

    var h = function () {
        function a(a, b) {
            for (var c = 0; c < b.length; c++) {
                var d = b[c];
                d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(a, d.key, d)
            }
        }

        return function (b, c, d) {
            return c && a(b.prototype, c), d && a(b, d), b
        }
    }(), i = !1, j = "undefined" != typeof a;
    j && a.getComputedStyle ? !function () {
        var a = b.createElement("div");
        ["", "-webkit-", "-moz-", "-ms-"].some(function (b) {
            try {
                a.style.position = b + "sticky"
            } catch (a) {
            }
            return "" != a.style.position
        }) && (i = !0)
    }() : i = !0;
    var k = !1, l = "undefined" != typeof ShadowRoot, m = {top: null, left: null}, n = [], o = function () {
        function g(a) {
            if (c(this, g), !(a instanceof HTMLElement)) throw new Error("First argument must be HTMLElement");
            if (n.some(function (b) {
                return b._node === a
            })) throw new Error("Stickyfill is already applied to this node");
            this._node = a, this._stickyMode = null, this._active = !1, n.push(this), this.refresh()
        }

        return h(g, [{
            key: "refresh", value: function () {
                if (!i && !this._removed) {
                    this._active && this._deactivate();
                    var c = this._node, g = getComputedStyle(c), h = {
                        position: g.position,
                        top: g.top,
                        display: g.display,
                        marginTop: g.marginTop,
                        marginBottom: g.marginBottom,
                        marginLeft: g.marginLeft,
                        marginRight: g.marginRight,
                        cssFloat: g.cssFloat
                    };
                    if (!isNaN(parseFloat(h.top)) && "table-cell" != h.display && "none" != h.display) {
                        this._active = !0;
                        var j = c.style.position;
                        "sticky" != g.position && "-webkit-sticky" != g.position || (c.style.position = "static");
                        var k = c.parentNode, m = l && k instanceof ShadowRoot ? k.host : k,
                            n = c.getBoundingClientRect(), o = m.getBoundingClientRect(), p = getComputedStyle(m);
                        this._parent = {
                            node: m,
                            styles: {position: m.style.position},
                            offsetHeight: m.offsetHeight
                        }, this._offsetToWindow = {
                            left: n.left,
                            right: b.documentElement.clientWidth - n.right
                        }, this._offsetToParent = {
                            top: n.top - o.top - e(p.borderTopWidth),
                            left: n.left - o.left - e(p.borderLeftWidth),
                            right: -n.right + o.right - e(p.borderRightWidth)
                        }, this._styles = {
                            position: j,
                            top: c.style.top,
                            bottom: c.style.bottom,
                            left: c.style.left,
                            right: c.style.right,
                            width: c.style.width,
                            marginTop: c.style.marginTop,
                            marginLeft: c.style.marginLeft,
                            marginRight: c.style.marginRight
                        };
                        var q = e(h.top);
                        this._limits = {
                            start: n.top + a.pageYOffset - q,
                            end: o.top + a.pageYOffset + m.offsetHeight - e(p.borderBottomWidth) - c.offsetHeight - q - e(h.marginBottom)
                        };
                        var r = p.position;
                        "absolute" != r && "relative" != r && (m.style.position = "relative"), this._recalcPosition();
                        var s = this._clone = {};
                        s.node = b.createElement("div"), d(s.node.style, {
                            width: n.right - n.left + "px",
                            height: n.bottom - n.top + "px",
                            marginTop: h.marginTop,
                            marginBottom: h.marginBottom,
                            marginLeft: h.marginLeft,
                            marginRight: h.marginRight,
                            cssFloat: h.cssFloat,
                            padding: 0,
                            border: 0,
                            borderSpacing: 0,
                            fontSize: "1em",
                            position: "static"
                        }), k.insertBefore(s.node, c), s.docOffsetTop = f(s.node)
                    }
                }
            }
        }, {
            key: "_recalcPosition", value: function () {
                if (this._active && !this._removed) {
                    var a = m.top <= this._limits.start ? "start" : m.top >= this._limits.end ? "end" : "middle";
                    if (this._stickyMode != a) {
                        switch (a) {
                            case"start":
                                d(this._node.style, {
                                    position: "absolute",
                                    left: this._offsetToParent.left + "px",
                                    right: this._offsetToParent.right + "px",
                                    top: this._offsetToParent.top + "px",
                                    bottom: "auto",
                                    width: "auto",
                                    marginLeft: 0,
                                    marginRight: 0,
                                    marginTop: 0
                                });
                                break;
                            case"middle":
                                d(this._node.style, {
                                    position: "fixed",
                                    left: this._offsetToWindow.left + "px",
                                    right: this._offsetToWindow.right + "px",
                                    top: this._styles.top,
                                    bottom: "auto",
                                    width: "auto",
                                    marginLeft: 0,
                                    marginRight: 0,
                                    marginTop: 0
                                });
                                break;
                            case"end":
                                d(this._node.style, {
                                    position: "absolute",
                                    left: this._offsetToParent.left + "px",
                                    right: this._offsetToParent.right + "px",
                                    top: "auto",
                                    bottom: 0,
                                    width: "auto",
                                    marginLeft: 0,
                                    marginRight: 0
                                })
                        }
                        this._stickyMode = a
                    }
                }
            }
        }, {
            key: "_fastCheck", value: function () {
                this._active && !this._removed && (Math.abs(f(this._clone.node) - this._clone.docOffsetTop) > 1 || Math.abs(this._parent.node.offsetHeight - this._parent.offsetHeight) > 1) && this.refresh()
            }
        }, {
            key: "_deactivate", value: function () {
                var a = this;
                this._active && !this._removed && (this._clone.node.parentNode.removeChild(this._clone.node), delete this._clone, d(this._node.style, this._styles), delete this._styles, n.some(function (b) {
                    return b !== a && b._parent && b._parent.node === a._parent.node
                }) || d(this._parent.node.style, this._parent.styles), delete this._parent, this._stickyMode = null, this._active = !1, delete this._offsetToWindow, delete this._offsetToParent, delete this._limits)
            }
        }, {
            key: "remove", value: function () {
                var a = this;
                this._deactivate(), n.some(function (b, c) {
                    if (b._node === a._node) return n.splice(c, 1), !0
                }), this._removed = !0
            }
        }]), g
    }(), p = {
        stickies: n, Sticky: o, forceSticky: function () {
            i = !1, g(), this.refreshAll()
        }, addOne: function (a) {
            if (!(a instanceof HTMLElement)) {
                if (!a.length || !a[0]) return;
                a = a[0]
            }
            for (var b = 0; b < n.length; b++) if (n[b]._node === a) return n[b];
            return new o(a)
        }, add: function (a) {
            if (a instanceof HTMLElement && (a = [a]), a.length) {
                for (var b = [], c = function (c) {
                    var d = a[c];
                    return d instanceof HTMLElement ? n.some(function (a) {
                        if (a._node === d) return b.push(a), !0
                    }) ? "continue" : void b.push(new o(d)) : (b.push(void 0), "continue")
                }, d = 0; d < a.length; d++) {
                    c(d)
                }
                return b
            }
        }, refreshAll: function () {
            n.forEach(function (a) {
                return a.refresh()
            })
        }, removeOne: function (a) {
            if (!(a instanceof HTMLElement)) {
                if (!a.length || !a[0]) return;
                a = a[0]
            }
            n.some(function (b) {
                if (b._node === a) return b.remove(), !0
            })
        }, remove: function (a) {
            if (a instanceof HTMLElement && (a = [a]), a.length) for (var b = function (b) {
                var c = a[b];
                n.some(function (a) {
                    if (a._node === c) return a.remove(), !0
                })
            }, c = 0; c < a.length; c++) b(c)
        }, removeAll: function () {
            for (; n.length;) n[0].remove()
        }
    };
    i || g(), "undefined" != typeof module && module.exports ? module.exports = p : j && (a.Stickyfill = p)
}(window, document);

/* Assign polyfill IE11 */
"function" != typeof Object.assign && (Object.assign = function (n) {
    "use strict";
    if (null == n) throw new TypeError("Cannot convert undefined or null to object");
    n = Object(n);
    for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        if (null != r) for (var e in r) Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e])
    }
    return n
});

/*!
 * Scroll lock
 * https://github.com/FL3NKEY/scroll-lock
*/
!function (e, t) {
    "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.scrollLock = t() : e.scrollLock = t()
}(this, function () {
    return function (l) {
        var r = {};

        function o(e) {
            if (r[e]) return r[e].exports;
            var t = r[e] = {i: e, l: !1, exports: {}};
            return l[e].call(t.exports, t, t.exports, o), t.l = !0, t.exports
        }

        return o.m = l, o.c = r, o.d = function (e, t, l) {
            o.o(e, t) || Object.defineProperty(e, t, {enumerable: !0, get: l})
        }, o.r = function (e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {value: "Module"}), Object.defineProperty(e, "__esModule", {value: !0})
        }, o.t = function (t, e) {
            if (1 & e && (t = o(t)), 8 & e) return t;
            if (4 & e && "object" == typeof t && t && t.__esModule) return t;
            var l = Object.create(null);
            if (o.r(l), Object.defineProperty(l, "default", {
                enumerable: !0,
                value: t
            }), 2 & e && "string" != typeof t) for (var r in t) o.d(l, r, function (e) {
                return t[e]
            }.bind(null, r));
            return l
        }, o.n = function (e) {
            var t = e && e.__esModule ? function () {
                return e.default
            } : function () {
                return e
            };
            return o.d(t, "a", t), t
        }, o.o = function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t)
        }, o.p = "", o(o.s = 0)
    }([function (e, t, l) {
        "use strict";
        l.r(t);
        var r = function (e) {
            return Array.isArray(e) ? e : [e]
        }, a = function (e) {
            return e instanceof Node
        }, o = function (e, t) {
            if (e && t) {
                e = e instanceof NodeList ? e : [e];
                for (var l = 0; l < e.length && !0 !== t(e[l], l, e.length); l++) ;
            }
        }, n = function (e) {
            return console.error("[scroll-lock] ".concat(e))
        }, b = function (e) {
            if (Array.isArray(e)) return e.join(", ")
        }, c = function (e) {
            var t = [];
            return o(e, function (e) {
                return t.push(e)
            }), t
        }, h = function (e, t) {
            var l = !(2 < arguments.length && void 0 !== arguments[2]) || arguments[2],
                r = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : document;
            if (l && -1 !== c(r.querySelectorAll(t)).indexOf(e)) return e;
            for (; (e = e.parentElement) && -1 === c(r.querySelectorAll(t)).indexOf(e);) ;
            return e
        }, v = function (e, t) {
            var l = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : document;
            return -1 !== c(l.querySelectorAll(t)).indexOf(e)
        }, i = function (e) {
            if (e) return "hidden" === getComputedStyle(e).overflow
        }, m = function (e) {
            if (e) return !!i(e) || e.scrollTop <= 0
        }, S = function (e) {
            if (e) {
                if (i(e)) return !0;
                var t = e.scrollTop;
                return e.scrollHeight <= t + e.offsetHeight
            }
        }, y = function (e) {
            if (e) return !!i(e) || e.scrollLeft <= 0
        }, k = function (e) {
            if (e) {
                if (i(e)) return !0;
                var t = e.scrollLeft;
                return e.scrollWidth <= t + e.offsetWidth
            }
        };
        l.d(t, "disablePageScroll", function () {
            return d
        }), l.d(t, "enablePageScroll", function () {
            return s
        }), l.d(t, "getScrollState", function () {
            return f
        }), l.d(t, "clearQueueScrollLocks", function () {
            return p
        }), l.d(t, "getTargetScrollBarWidth", function () {
            return g
        }), l.d(t, "getCurrentTargetScrollBarWidth", function () {
            return A
        }), l.d(t, "getPageScrollBarWidth", function () {
            return G
        }), l.d(t, "getCurrentPageScrollBarWidth", function () {
            return T
        }), l.d(t, "addScrollableTarget", function () {
            return L
        }), l.d(t, "removeScrollableTarget", function () {
            return W
        }), l.d(t, "addScrollableSelector", function () {
            return x
        }), l.d(t, "removeScrollableSelector", function () {
            return F
        }), l.d(t, "addLockableTarget", function () {
            return Y
        }), l.d(t, "addLockableSelector", function () {
            return E
        }), l.d(t, "setFillGapMethod", function () {
            return O
        }), l.d(t, "addFillGapTarget", function () {
            return P
        }), l.d(t, "removeFillGapTarget", function () {
            return j
        }), l.d(t, "addFillGapSelector", function () {
            return q
        }), l.d(t, "removeFillGapSelector", function () {
            return M
        }), l.d(t, "refillGaps", function () {
            return N
        });
        var u = ["padding", "margin", "width", "max-width", "none"], w = {
            scroll: !0,
            queue: 0,
            scrollableSelectors: ["[data-scroll-lock-scrollable]"],
            lockableSelectors: ["body", "[data-scroll-lock-lockable]"],
            fillGapSelectors: ["body", "[data-scroll-lock-fill-gap]", "[data-scroll-lock-lockable]"],
            fillGapMethod: u[0],
            startTouchY: 0,
            startTouchX: 0
        }, d = function (e) {
            w.queue <= 0 && (w.scroll = !1, B(), X()), L(e), w.queue++
        }, s = function (e) {
            0 < w.queue && w.queue--, w.queue <= 0 && (w.scroll = !0, C(), Q()), W(e)
        }, f = function () {
            return w.scroll
        }, p = function () {
            w.queue = 0
        }, g = function (e) {
            var t = 1 < arguments.length && void 0 !== arguments[1] && arguments[1];
            if (a(e)) {
                var l = e.style.overflowY;
                t ? f() || (e.style.overflowY = e.getAttribute("data-scroll-lock-saved-overflow-y-property")) : e.style.overflowY = "scroll";
                var r = A(e);
                return e.style.overflowY = l, r
            }
            return 0
        }, A = function (e) {
            if (a(e)) {
                if (e === document.body) {
                    var t = document.documentElement.clientWidth;
                    return window.innerWidth - t
                }
                var l = e.style.borderLeftWidth, r = e.style.borderRightWidth;
                e.style.borderLeftWidth = "0px", e.style.borderRightWidth = "0px";
                var o = e.offsetWidth - e.clientWidth;
                return e.style.borderLeftWidth = l, e.style.borderRightWidth = r, o
            }
            return 0
        }, G = function () {
            var e = 0 < arguments.length && void 0 !== arguments[0] && arguments[0];
            return g(document.body, e)
        }, T = function () {
            return A(document.body)
        }, L = function (e) {
            e && r(e).map(function (e) {
                o(e, function (e) {
                    a(e) ? e.setAttribute("data-scroll-lock-scrollable", "") : n('"'.concat(e, '" is not a Element.'))
                })
            })
        }, W = function (e) {
            e && r(e).map(function (e) {
                o(e, function (e) {
                    a(e) ? e.removeAttribute("data-scroll-lock-scrollable") : n('"'.concat(e, '" is not a Element.'))
                })
            })
        }, x = function (e) {
            e && r(e).map(function (e) {
                w.scrollableSelectors.push(e)
            })
        }, F = function (e) {
            e && r(e).map(function (t) {
                w.scrollableSelectors = w.scrollableSelectors.filter(function (e) {
                    return e !== t
                })
            })
        }, Y = function (e) {
            e && (r(e).map(function (e) {
                o(e, function (e) {
                    a(e) ? e.setAttribute("data-scroll-lock-lockable", "") : n('"'.concat(e, '" is not a Element.'))
                })
            }), f() || B())
        }, E = function (e) {
            e && (r(e).map(function (e) {
                w.lockableSelectors.push(e)
            }), f() || B(), q(e))
        }, O = function (e) {
            if (e) if (-1 !== u.indexOf(e)) w.fillGapMethod = e, N(); else {
                var t = u.join(", ");
                n('"'.concat(e, '" method is not available!\nAvailable fill gap methods: ').concat(t, "."))
            }
        }, P = function (e) {
            e && r(e).map(function (e) {
                o(e, function (e) {
                    a(e) ? (e.setAttribute("data-scroll-lock-fill-gap", ""), w.scroll || H(e)) : n('"'.concat(e, '" is not a Element.'))
                })
            })
        }, j = function (e) {
            e && r(e).map(function (e) {
                o(e, function (e) {
                    a(e) ? (e.removeAttribute("data-scroll-lock-fill-gap"), w.scroll || I(e)) : n('"'.concat(e, '" is not a Element.'))
                })
            })
        }, q = function (e) {
            e && r(e).map(function (e) {
                -1 === w.fillGapSelectors.indexOf(e) && (w.fillGapSelectors.push(e), w.scroll || D(e))
            })
        }, M = function (e) {
            e && r(e).map(function (t) {
                w.fillGapSelectors = w.fillGapSelectors.filter(function (e) {
                    return e !== t
                }), w.scroll || z(t)
            })
        }, N = function () {
            w.scroll || X()
        }, B = function () {
            var e = b(w.lockableSelectors);
            K(e)
        }, C = function () {
            var e = b(w.lockableSelectors);
            R(e)
        }, K = function (e) {
            var t = document.querySelectorAll(e);
            o(t, function (e) {
                U(e)
            })
        }, R = function (e) {
            var t = document.querySelectorAll(e);
            o(t, function (e) {
                _(e)
            })
        }, U = function (e) {
            if (a(e) && "true" !== e.getAttribute("data-scroll-lock-locked")) {
                var t = window.getComputedStyle(e);
                e.setAttribute("data-scroll-lock-saved-overflow-y-property", t.overflowY), e.setAttribute("data-scroll-lock-saved-inline-overflow-property", e.style.overflow), e.setAttribute("data-scroll-lock-saved-inline-overflow-y-property", e.style.overflowY), e.style.overflow = "hidden", e.setAttribute("data-scroll-lock-locked", "true")
            }
        }, _ = function (e) {
            a(e) && "true" === e.getAttribute("data-scroll-lock-locked") && (e.style.overflow = e.getAttribute("data-scroll-lock-saved-inline-overflow-property"), e.style.overflowY = e.getAttribute("data-scroll-lock-saved-inline-overflow-y-property"), e.removeAttribute("data-scroll-lock-saved-overflow-property"), e.removeAttribute("data-scroll-lock-saved-inline-overflow-property"), e.removeAttribute("data-scroll-lock-saved-inline-overflow-y-property"), e.removeAttribute("data-scroll-lock-locked"))
        }, X = function () {
            w.fillGapSelectors.map(function (e) {
                D(e)
            })
        }, Q = function () {
            w.fillGapSelectors.map(function (e) {
                z(e)
            })
        }, D = function (e) {
            var t = document.querySelectorAll(e), l = -1 !== w.lockableSelectors.indexOf(e);
            o(t, function (e) {
                H(e, l)
            })
        }, H = function (e) {
            var t = 1 < arguments.length && void 0 !== arguments[1] && arguments[1];
            if (a(e)) {
                var l;
                if ("" === e.getAttribute("data-scroll-lock-lockable") || t) l = g(e, !0); else {
                    var r = h(e, b(w.lockableSelectors));
                    l = g(r, !0)
                }
                "true" === e.getAttribute("data-scroll-lock-filled-gap") && I(e);
                var o = window.getComputedStyle(e);
                if (e.setAttribute("data-scroll-lock-filled-gap", "true"), e.setAttribute("data-scroll-lock-current-fill-gap-method", w.fillGapMethod), "margin" === w.fillGapMethod) {
                    var n = parseFloat(o.marginRight);
                    e.style.marginRight = "".concat(n + l, "px")
                } else if ("width" === w.fillGapMethod) e.style.width = "calc(100% - ".concat(l, "px)"); else if ("max-width" === w.fillGapMethod) e.style.maxWidth = "calc(100% - ".concat(l, "px)"); else if ("padding" === w.fillGapMethod) {
                    var c = parseFloat(o.paddingRight);
                    e.style.paddingRight = "".concat(c + l, "px")
                }
            }
        }, z = function (e) {
            var t = document.querySelectorAll(e);
            o(t, function (e) {
                I(e)
            })
        }, I = function (e) {
            if (a(e) && "true" === e.getAttribute("data-scroll-lock-filled-gap")) {
                var t = e.getAttribute("data-scroll-lock-current-fill-gap-method");
                e.removeAttribute("data-scroll-lock-filled-gap"), e.removeAttribute("data-scroll-lock-current-fill-gap-method"), "margin" === t ? e.style.marginRight = "" : "width" === t ? e.style.width = "" : "max-width" === t ? e.style.maxWidth = "" : "padding" === t && (e.style.paddingRight = "")
            }
        };
        "undefined" != typeof window && window.addEventListener("resize", function (e) {
            N()
        }), "undefined" != typeof document && (document.addEventListener("touchstart", function (e) {
            w.scroll || (w.startTouchY = e.touches[0].clientY, w.startTouchX = e.touches[0].clientX)
        }), document.addEventListener("touchmove", function (n) {
            if (!w.scroll) {
                var e = w.startTouchY, t = w.startTouchX, l = n.touches[0].clientY, r = n.touches[0].clientX;
                if (n.touches.length < 2) {
                    var c = b(w.scrollableSelectors), a = e < l, i = l < e, u = t < r, d = r < t, s = e + 3 < l,
                        f = l < e - 3, p = t + 3 < r, g = r < t - 3;
                    !function e(t) {
                        var l = 1 < arguments.length && void 0 !== arguments[1] && arguments[1];
                        if (t) {
                            var r = h(t, c, !1);
                            if (v(t, 'input[type="range"]')) return !1;
                            if (l || v(t, 'textarea, [contenteditable="true"]') && h(t, c) || v(t, c)) {
                                var o = !1;
                                y(t) && k(t) ? (a && m(t) || i && S(t)) && (o = !0) : m(t) && S(t) ? (u && y(t) || d && k(t)) && (o = !0) : (s && m(t) || f && S(t) || p && y(t) || g && k(t)) && (o = !0), o && (r ? e(r, !0) : n.preventDefault())
                            } else e(r)
                        } else n.preventDefault()
                    }(n.target)
                }
            }
        }, {passive: !1}), document.addEventListener("touchend", function (e) {
            w.scroll || (w.startTouchY = 0, w.startTouchX = 0)
        }));
        var J = {
            hide: function (e) {
                n('"hide" is deprecated! Use "disablePageScroll" instead. \n https://github.com/FL3NKEY/scroll-lock#disablepagescrollscrollabletarget'), d(e)
            }, show: function (e) {
                n('"show" is deprecated! Use "enablePageScroll" instead. \n https://github.com/FL3NKEY/scroll-lock#enablepagescrollscrollabletarget'), s(e)
            }, toggle: function (e) {
                n('"toggle" is deprecated! Do not use it.'), f() ? d() : s(e)
            }, getState: function () {
                return n('"getState" is deprecated! Use "getScrollState" instead. \n https://github.com/FL3NKEY/scroll-lock#getscrollstate'), f()
            }, getWidth: function () {
                return n('"getWidth" is deprecated! Use "getPageScrollBarWidth" instead. \n https://github.com/FL3NKEY/scroll-lock#getpagescrollbarwidth'), G()
            }, getCurrentWidth: function () {
                return n('"getCurrentWidth" is deprecated! Use "getCurrentPageScrollBarWidth" instead. \n https://github.com/FL3NKEY/scroll-lock#getcurrentpagescrollbarwidth'), T()
            }, setScrollableTargets: function (e) {
                n('"setScrollableTargets" is deprecated! Use "addScrollableTarget" instead. \n https://github.com/FL3NKEY/scroll-lock#addscrollabletargetscrollabletarget'), L(e)
            }, setFillGapSelectors: function (e) {
                n('"setFillGapSelectors" is deprecated! Use "addFillGapSelector" instead. \n https://github.com/FL3NKEY/scroll-lock#addfillgapselectorfillgapselector'), q(e)
            }, setFillGapTargets: function (e) {
                n('"setFillGapTargets" is deprecated! Use "addFillGapTarget" instead. \n https://github.com/FL3NKEY/scroll-lock#addfillgaptargetfillgaptarget'), P(e)
            }, clearQueue: function () {
                n('"clearQueue" is deprecated! Use "clearQueueScrollLocks" instead. \n https://github.com/FL3NKEY/scroll-lock#clearqueuescrolllocks'), p()
            }
        }, V = function (o) {
            for (var e = 1; e < arguments.length; e++) {
                var n = null != arguments[e] ? arguments[e] : {}, t = Object.keys(n);
                "function" == typeof Object.getOwnPropertySymbols && (t = t.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
                    return Object.getOwnPropertyDescriptor(n, e).enumerable
                }))), t.forEach(function (e) {
                    var t, l, r;
                    t = o, r = n[l = e], l in t ? Object.defineProperty(t, l, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : t[l] = r
                })
            }
            return o
        }({
            disablePageScroll: d,
            enablePageScroll: s,
            getScrollState: f,
            clearQueueScrollLocks: p,
            getTargetScrollBarWidth: g,
            getCurrentTargetScrollBarWidth: A,
            getPageScrollBarWidth: G,
            getCurrentPageScrollBarWidth: T,
            addScrollableSelector: x,
            removeScrollableSelector: F,
            addScrollableTarget: L,
            removeScrollableTarget: W,
            addLockableSelector: E,
            addLockableTarget: Y,
            addFillGapSelector: q,
            removeFillGapSelector: M,
            addFillGapTarget: P,
            removeFillGapTarget: j,
            setFillGapMethod: O,
            refillGaps: N,
            _state: w
        }, J);
        t.default = V
    }]).default
});

//# sourceMappingURL=gmaps.min.js.map
"use strict";
!function (a, b) {
    "object" == typeof exports ? module.exports = b() : "function" == typeof define && define.amd ? define(["jquery", "googlemaps!"], b) : a.GMaps = b()
}(this, function () {
    var a = function (a, b) {
        var c;
        if (a === b) return a;
        for (c in b) void 0 !== b[c] && (a[c] = b[c]);
        return a
    }, b = function (a, b) {
        var c, d = Array.prototype.slice.call(arguments, 2), e = [], f = a.length;
        if (Array.prototype.map && a.map === Array.prototype.map) e = Array.prototype.map.call(a, function (a) {
            var c = d.slice(0);
            return c.splice(0, 0, a), b.apply(this, c)
        }); else for (c = 0; c < f; c++) callback_params = d, callback_params.splice(0, 0, a[c]), e.push(b.apply(this, callback_params));
        return e
    }, c = function (a) {
        var b, c = [];
        for (b = 0; b < a.length; b++) c = c.concat(a[b]);
        return c
    }, d = function (a, b) {
        var c = a[0], d = a[1];
        return b && (c = a[1], d = a[0]), new google.maps.LatLng(c, d)
    }, f = function (a, b) {
        var c;
        for (c = 0; c < a.length; c++) a[c] instanceof google.maps.LatLng || (a[c].length > 0 && "object" == typeof a[c][0] ? a[c] = f(a[c], b) : a[c] = d(a[c], b));
        return a
    }, g = function (a, b) {
        var c = a.replace(".", "");
        return "jQuery" in this && b ? $("." + c, b)[0] : document.getElementsByClassName(c)[0]
    }, h = function (a, b) {
        var a = a.replace("#", "");
        return "jQuery" in window && b ? $("#" + a, b)[0] : document.getElementById(a)
    }, i = function (a) {
        var b = 0, c = 0;
        if (a.getBoundingClientRect) {
            var d = a.getBoundingClientRect(), e = -(window.scrollX ? window.scrollX : window.pageXOffset),
                f = -(window.scrollY ? window.scrollY : window.pageYOffset);
            return [d.left - e, d.top - f]
        }
        if (a.offsetParent) do b += a.offsetLeft, c += a.offsetTop; while (a = a.offsetParent);
        return [b, c]
    }, j = function (b) {
        var c = document, d = function (b) {
            if ("object" != typeof window.google || !window.google.maps) return "object" == typeof window.console && window.console.error && console.error("Google Maps API is required. Please register the following JavaScript library https://maps.googleapis.com/maps/api/js."), function () {
            };
            if (!this) return new d(b);
            b.zoom = b.zoom || 15, b.mapType = b.mapType || "roadmap";
            var e, f = function (a, b) {
                    return void 0 === a ? b : a
                }, j = this,
                k = ["bounds_changed", "center_changed", "click", "dblclick", "drag", "dragend", "dragstart", "idle", "maptypeid_changed", "projection_changed", "resize", "tilesloaded", "zoom_changed"],
                l = ["mousemove", "mouseout", "mouseover"],
                m = ["el", "lat", "lng", "mapType", "width", "height", "markerClusterer", "enableNewStyle"],
                n = b.el || b.div, o = b.markerClusterer, p = google.maps.MapTypeId[b.mapType.toUpperCase()],
                q = new google.maps.LatLng(b.lat, b.lng), r = f(b.zoomControl, !0),
                s = b.zoomControlOpt || {style: "DEFAULT", position: "TOP_LEFT"}, t = s.style || "DEFAULT",
                u = s.position || "TOP_LEFT", v = f(b.panControl, !0), w = f(b.mapTypeControl, !0),
                x = f(b.scaleControl, !0), y = f(b.streetViewControl, !0), z = f(z, !0), A = {},
                B = {zoom: this.zoom, center: q, mapTypeId: p}, C = {
                    panControl: v,
                    zoomControl: r,
                    zoomControlOptions: {style: google.maps.ZoomControlStyle[t], position: google.maps.ControlPosition[u]},
                    mapTypeControl: w,
                    scaleControl: x,
                    streetViewControl: y,
                    overviewMapControl: z
                };
            if ("string" == typeof b.el || "string" == typeof b.div ? n.indexOf("#") > -1 ? this.el = h(n, b.context) : this.el = g.apply(this, [n, b.context]) : this.el = n, void 0 === this.el || null === this.el) throw"No element defined.";
            for (window.context_menu = window.context_menu || {}, window.context_menu[j.el.id] = {}, this.controls = [], this.overlays = [], this.layers = [], this.singleLayers = {}, this.markers = [], this.polylines = [], this.routes = [], this.polygons = [], this.infoWindow = null, this.overlay_el = null, this.zoom = b.zoom, this.registered_events = {}, this.el.style.width = b.width || this.el.scrollWidth || this.el.offsetWidth, this.el.style.height = b.height || this.el.scrollHeight || this.el.offsetHeight, google.maps.visualRefresh = b.enableNewStyle, e = 0; e < m.length; e++) delete b[m[e]];
            for (1 != b.disableDefaultUI && (B = a(B, C)), A = a(B, b), e = 0; e < k.length; e++) delete A[k[e]];
            for (e = 0; e < l.length; e++) delete A[l[e]];
            this.map = new google.maps.Map(this.el, A), o && (this.markerClusterer = o.apply(this, [this.map]));
            var D = function (a, b) {
                var c = "", d = window.context_menu[j.el.id][a];
                for (var e in d) if (d.hasOwnProperty(e)) {
                    var f = d[e];
                    c += '<li><a id="' + a + "_" + e + '" href="#">' + f.title + "</a></li>"
                }
                if (h("gmaps_context_menu")) {
                    var g = h("gmaps_context_menu");
                    g.innerHTML = c;
                    var e, k = g.getElementsByTagName("a"), l = k.length;
                    for (e = 0; e < l; e++) {
                        var m = k[e], n = function (c) {
                            c.preventDefault(), d[this.id.replace(a + "_", "")].action.apply(j, [b]), j.hideContextMenu()
                        };
                        google.maps.event.clearListeners(m, "click"), google.maps.event.addDomListenerOnce(m, "click", n, !1)
                    }
                    var o = i.apply(this, [j.el]), p = o[0] + b.pixel.x - 15, q = o[1] + b.pixel.y - 15;
                    g.style.left = p + "px", g.style.top = q + "px"
                }
            };
            this.buildContextMenu = function (a, b) {
                if ("marker" === a) {
                    b.pixel = {};
                    var c = new google.maps.OverlayView;
                    c.setMap(j.map), c.draw = function () {
                        var d = c.getProjection(), e = b.marker.getPosition();
                        b.pixel = d.fromLatLngToContainerPixel(e), D(a, b)
                    }
                } else D(a, b);
                var d = h("gmaps_context_menu");
                setTimeout(function () {
                    d.style.display = "block"
                }, 0)
            }, this.setContextMenu = function (a) {
                window.context_menu[j.el.id][a.control] = {};
                var b, d = c.createElement("ul");
                for (b in a.options) if (a.options.hasOwnProperty(b)) {
                    var e = a.options[b];
                    window.context_menu[j.el.id][a.control][e.name] = {title: e.title, action: e.action}
                }
                d.id = "gmaps_context_menu", d.style.display = "none", d.style.position = "absolute", d.style.minWidth = "100px", d.style.background = "white", d.style.listStyle = "none", d.style.padding = "8px", d.style.boxShadow = "2px 2px 6px #ccc", h("gmaps_context_menu") || c.body.appendChild(d);
                var f = h("gmaps_context_menu");
                google.maps.event.addDomListener(f, "mouseout", function (a) {
                    a.relatedTarget && this.contains(a.relatedTarget) || window.setTimeout(function () {
                        f.style.display = "none"
                    }, 400)
                }, !1)
            }, this.hideContextMenu = function () {
                var a = h("gmaps_context_menu");
                a && (a.style.display = "none")
            };
            var E = function (a, c) {
                google.maps.event.addListener(a, c, function (a) {
                    void 0 == a && (a = this), b[c].apply(this, [a]), j.hideContextMenu()
                })
            };
            google.maps.event.addListener(this.map, "zoom_changed", this.hideContextMenu);
            for (var F = 0; F < k.length; F++) {
                var G = k[F];
                G in b && E(this.map, G)
            }
            for (var F = 0; F < l.length; F++) {
                var G = l[F];
                G in b && E(this.map, G)
            }
            google.maps.event.addListener(this.map, "rightclick", function (a) {
                b.rightclick && b.rightclick.apply(this, [a]), void 0 != window.context_menu[j.el.id].map && j.buildContextMenu("map", a)
            }), this.refresh = function () {
                google.maps.event.trigger(this.map, "resize")
            }, this.fitZoom = function () {
                var a, b = [], c = this.markers.length;
                for (a = 0; a < c; a++) "boolean" == typeof this.markers[a].visible && this.markers[a].visible && b.push(this.markers[a].getPosition());
                this.fitLatLngBounds(b)
            }, this.fitLatLngBounds = function (a) {
                var b, c = a.length, d = new google.maps.LatLngBounds;
                for (b = 0; b < c; b++) d.extend(a[b]);
                this.map.fitBounds(d)
            }, this.setCenter = function (a, b, c) {
                this.map.panTo(new google.maps.LatLng(a, b)), c && c()
            }, this.getElement = function () {
                return this.el
            }, this.zoomIn = function (a) {
                a = a || 1, this.zoom = this.map.getZoom() + a, this.map.setZoom(this.zoom)
            }, this.zoomOut = function (a) {
                a = a || 1, this.zoom = this.map.getZoom() - a, this.map.setZoom(this.zoom)
            };
            var H, I = [];
            for (H in this.map) "function" != typeof this.map[H] || this[H] || I.push(H);
            for (e = 0; e < I.length; e++) !function (a, b, c) {
                a[c] = function () {
                    return b[c].apply(b, arguments)
                }
            }(this, this.map, I[e])
        };
        return d
    }(this);
    j.prototype.createControl = function (a) {
        var b = document.createElement("div");
        b.style.cursor = "pointer", a.disableDefaultStyles !== !0 && (b.style.fontFamily = "Roboto, Arial, sans-serif", b.style.fontSize = "11px", b.style.boxShadow = "rgba(0, 0, 0, 0.298039) 0px 1px 4px -1px");
        for (var c in a.style) b.style[c] = a.style[c];
        a.id && (b.id = a.id), a.title && (b.title = a.title), a.classes && (b.className = a.classes), a.content && ("string" == typeof a.content ? b.innerHTML = a.content : a.content instanceof HTMLElement && b.appendChild(a.content)), a.position && (b.position = google.maps.ControlPosition[a.position.toUpperCase()]);
        for (var d in a.events) !function (b, c) {
            google.maps.event.addDomListener(b, c, function () {
                a.events[c].apply(this, [this])
            })
        }(b, d);
        return b.index = 1, b
    }, j.prototype.addControl = function (a) {
        var b = this.createControl(a);
        return this.controls.push(b), this.map.controls[b.position].push(b), b
    }, j.prototype.removeControl = function (a) {
        var b, c = null;
        for (b = 0; b < this.controls.length; b++) this.controls[b] == a && (c = this.controls[b].position, this.controls.splice(b, 1));
        if (c) for (b = 0; b < this.map.controls.length; b++) {
            var d = this.map.controls[a.position];
            if (d.getAt(b) == a) {
                d.removeAt(b);
                break
            }
        }
        return a
    }, j.prototype.createMarker = function (b) {
        if (void 0 == b.lat && void 0 == b.lng && void 0 == b.position) throw"No latitude or longitude defined.";
        var c = this, d = b.details, e = b.fences, f = b.outside,
            g = {position: new google.maps.LatLng(b.lat, b.lng), map: null}, h = a(g, b);
        delete h.lat, delete h.lng, delete h.fences, delete h.outside;
        var i = new google.maps.Marker(h);
        if (i.fences = e, b.infoWindow) {
            i.infoWindow = new google.maps.InfoWindow(b.infoWindow);
            for (var j = ["closeclick", "content_changed", "domready", "position_changed", "zindex_changed"], k = 0; k < j.length; k++) !function (a, c) {
                b.infoWindow[c] && google.maps.event.addListener(a, c, function (a) {
                    b.infoWindow[c].apply(this, [a])
                })
            }(i.infoWindow, j[k])
        }
        for (var l = ["animation_changed", "clickable_changed", "cursor_changed", "draggable_changed", "flat_changed", "icon_changed", "position_changed", "shadow_changed", "shape_changed", "title_changed", "visible_changed", "zindex_changed"], m = ["dblclick", "drag", "dragend", "dragstart", "mousedown", "mouseout", "mouseover", "mouseup"], k = 0; k < l.length; k++) !function (a, c) {
            b[c] && google.maps.event.addListener(a, c, function () {
                b[c].apply(this, [this])
            })
        }(i, l[k]);
        for (var k = 0; k < m.length; k++) !function (a, c, d) {
            b[d] && google.maps.event.addListener(c, d, function (c) {
                c.pixel || (c.pixel = a.getProjection().fromLatLngToPoint(c.latLng)), b[d].apply(this, [c])
            })
        }(this.map, i, m[k]);
        return google.maps.event.addListener(i, "click", function () {
            this.details = d, b.click && b.click.apply(this, [this]), i.infoWindow && (c.hideInfoWindows(), i.infoWindow.open(c.map, i))
        }), google.maps.event.addListener(i, "rightclick", function (a) {
            a.marker = this, b.rightclick && b.rightclick.apply(this, [a]), void 0 != window.context_menu[c.el.id].marker && c.buildContextMenu("marker", a)
        }), i.fences && google.maps.event.addListener(i, "dragend", function () {
            c.checkMarkerGeofence(i, function (a, b) {
                f(a, b)
            })
        }), i
    }, j.prototype.addMarker = function (a) {
        var b;
        if (a.hasOwnProperty("gm_accessors_")) b = a; else {
            if (!(a.hasOwnProperty("lat") && a.hasOwnProperty("lng") || a.position)) throw"No latitude or longitude defined.";
            b = this.createMarker(a)
        }
        return b.setMap(this.map), this.markerClusterer && this.markerClusterer.addMarker(b), this.markers.push(b), j.fire("marker_added", b, this), b
    }, j.prototype.addMarkers = function (a) {
        for (var b, c = 0; b = a[c]; c++) this.addMarker(b);
        return this.markers
    }, j.prototype.hideInfoWindows = function () {
        for (var a, b = 0; a = this.markers[b]; b++) a.infoWindow && a.infoWindow.close()
    }, j.prototype.removeMarker = function (a) {
        for (var b = 0; b < this.markers.length; b++) if (this.markers[b] === a) {
            this.markers[b].setMap(null), this.markers.splice(b, 1), this.markerClusterer && this.markerClusterer.removeMarker(a), j.fire("marker_removed", a, this);
            break
        }
        return a
    }, j.prototype.removeMarkers = function (a) {
        var b = [];
        if (void 0 === a) {
            for (var c = 0; c < this.markers.length; c++) {
                var d = this.markers[c];
                d.setMap(null), j.fire("marker_removed", d, this)
            }
            this.markerClusterer && this.markerClusterer.clearMarkers && this.markerClusterer.clearMarkers(), this.markers = b
        } else {
            for (var c = 0; c < a.length; c++) {
                var e = this.markers.indexOf(a[c]);
                if (e > -1) {
                    var d = this.markers[e];
                    d.setMap(null), this.markerClusterer && this.markerClusterer.removeMarker(d), j.fire("marker_removed", d, this)
                }
            }
            for (var c = 0; c < this.markers.length; c++) {
                var d = this.markers[c];
                null != d.getMap() && b.push(d)
            }
            this.markers = b
        }
    }, j.prototype.drawOverlay = function (a) {
        var b = new google.maps.OverlayView, c = !0;
        return b.setMap(this.map), null != a.auto_show && (c = a.auto_show), b.onAdd = function () {
            var c = document.createElement("div");
            c.style.borderStyle = "none", c.style.borderWidth = "0px", c.style.position = "absolute", c.style.zIndex = 100, c.innerHTML = a.content, b.el = c, a.layer || (a.layer = "overlayLayer");
            var d = this.getPanes(), e = d[a.layer], f = ["contextmenu", "DOMMouseScroll", "dblclick", "mousedown"];
            e.appendChild(c);
            for (var g = 0; g < f.length; g++) !function (a, b) {
                google.maps.event.addDomListener(a, b, function (a) {
                    navigator.userAgent.toLowerCase().indexOf("msie") != -1 && document.all ? (a.cancelBubble = !0, a.returnValue = !1) : a.stopPropagation()
                })
            }(c, f[g]);
            a.click && (d.overlayMouseTarget.appendChild(b.el), google.maps.event.addDomListener(b.el, "click", function () {
                a.click.apply(b, [b])
            })), google.maps.event.trigger(this, "ready")
        }, b.draw = function () {
            var d = this.getProjection(), e = d.fromLatLngToDivPixel(new google.maps.LatLng(a.lat, a.lng));
            a.horizontalOffset = a.horizontalOffset || 0, a.verticalOffset = a.verticalOffset || 0;
            var f = b.el, g = f.children[0], h = g.clientHeight, i = g.clientWidth;
            switch (a.verticalAlign) {
                case"top":
                    f.style.top = e.y - h + a.verticalOffset + "px";
                    break;
                default:
                case"middle":
                    f.style.top = e.y - h / 2 + a.verticalOffset + "px";
                    break;
                case"bottom":
                    f.style.top = e.y + a.verticalOffset + "px"
            }
            switch (a.horizontalAlign) {
                case"left":
                    f.style.left = e.x - i + a.horizontalOffset + "px";
                    break;
                default:
                case"center":
                    f.style.left = e.x - i / 2 + a.horizontalOffset + "px";
                    break;
                case"right":
                    f.style.left = e.x + a.horizontalOffset + "px"
            }
            f.style.display = c ? "block" : "none", c || a.show.apply(this, [f])
        }, b.onRemove = function () {
            var c = b.el;
            a.remove ? a.remove.apply(this, [c]) : (b.el.parentNode.removeChild(b.el), b.el = null)
        }, this.overlays.push(b), b
    }, j.prototype.removeOverlay = function (a) {
        for (var b = 0; b < this.overlays.length; b++) if (this.overlays[b] === a) {
            this.overlays[b].setMap(null), this.overlays.splice(b, 1);
            break
        }
    }, j.prototype.removeOverlays = function () {
        for (var a, b = 0; a = this.overlays[b]; b++) a.setMap(null);
        this.overlays = []
    }, j.prototype.drawPolyline = function (a) {
        var b = [], c = a.path;
        if (c.length) if (void 0 === c[0][0]) b = c; else for (var d, e = 0; d = c[e]; e++) b.push(new google.maps.LatLng(d[0], d[1]));
        var f = {
            map: this.map,
            path: b,
            strokeColor: a.strokeColor,
            strokeOpacity: a.strokeOpacity,
            strokeWeight: a.strokeWeight,
            geodesic: a.geodesic,
            clickable: !0,
            editable: !1,
            visible: !0
        };
        a.hasOwnProperty("clickable") && (f.clickable = a.clickable), a.hasOwnProperty("editable") && (f.editable = a.editable), a.hasOwnProperty("icons") && (f.icons = a.icons), a.hasOwnProperty("zIndex") && (f.zIndex = a.zIndex);
        for (var g = new google.maps.Polyline(f), h = ["click", "dblclick", "mousedown", "mousemove", "mouseout", "mouseover", "mouseup", "rightclick"], i = 0; i < h.length; i++) !function (b, c) {
            a[c] && google.maps.event.addListener(b, c, function (b) {
                a[c].apply(this, [b])
            })
        }(g, h[i]);
        return this.polylines.push(g), j.fire("polyline_added", g, this), g
    }, j.prototype.removePolyline = function (a) {
        for (var b = 0; b < this.polylines.length; b++) if (this.polylines[b] === a) {
            this.polylines[b].setMap(null), this.polylines.splice(b, 1), j.fire("polyline_removed", a, this);
            break
        }
    }, j.prototype.removePolylines = function () {
        for (var a, b = 0; a = this.polylines[b]; b++) a.setMap(null);
        this.polylines = []
    }, j.prototype.drawCircle = function (b) {
        b = a({map: this.map, center: new google.maps.LatLng(b.lat, b.lng)}, b), delete b.lat, delete b.lng;
        for (var c = new google.maps.Circle(b), d = ["click", "dblclick", "mousedown", "mousemove", "mouseout", "mouseover", "mouseup", "rightclick"], e = 0; e < d.length; e++) !function (a, c) {
            b[c] && google.maps.event.addListener(a, c, function (a) {
                b[c].apply(this, [a])
            })
        }(c, d[e]);
        return this.polygons.push(c), c
    }, j.prototype.drawRectangle = function (b) {
        b = a({map: this.map}, b);
        var c = new google.maps.LatLngBounds(new google.maps.LatLng(b.bounds[0][0], b.bounds[0][1]), new google.maps.LatLng(b.bounds[1][0], b.bounds[1][1]));
        b.bounds = c;
        for (var d = new google.maps.Rectangle(b), e = ["click", "dblclick", "mousedown", "mousemove", "mouseout", "mouseover", "mouseup", "rightclick"], f = 0; f < e.length; f++) !function (a, c) {
            b[c] && google.maps.event.addListener(a, c, function (a) {
                b[c].apply(this, [a])
            })
        }(d, e[f]);
        return this.polygons.push(d), d
    }, j.prototype.drawPolygon = function (d) {
        var e = !1;
        d.hasOwnProperty("useGeoJSON") && (e = d.useGeoJSON), delete d.useGeoJSON, d = a({map: this.map}, d), 0 == e && (d.paths = [d.paths.slice(0)]), d.paths.length > 0 && d.paths[0].length > 0 && (d.paths = c(b(d.paths, f, e)));
        for (var g = new google.maps.Polygon(d), h = ["click", "dblclick", "mousedown", "mousemove", "mouseout", "mouseover", "mouseup", "rightclick"], i = 0; i < h.length; i++) !function (a, b) {
            d[b] && google.maps.event.addListener(a, b, function (a) {
                d[b].apply(this, [a])
            })
        }(g, h[i]);
        return this.polygons.push(g), j.fire("polygon_added", g, this), g
    }, j.prototype.removePolygon = function (a) {
        for (var b = 0; b < this.polygons.length; b++) if (this.polygons[b] === a) {
            this.polygons[b].setMap(null), this.polygons.splice(b, 1), j.fire("polygon_removed", a, this);
            break
        }
    }, j.prototype.removePolygons = function () {
        for (var a, b = 0; a = this.polygons[b]; b++) a.setMap(null);
        this.polygons = []
    }, j.prototype.getFromFusionTables = function (a) {
        var b = a.events;
        delete a.events;
        var c = a, d = new google.maps.FusionTablesLayer(c);
        for (var e in b) !function (a, c) {
            google.maps.event.addListener(a, c, function (a) {
                b[c].apply(this, [a])
            })
        }(d, e);
        return this.layers.push(d), d
    }, j.prototype.loadFromFusionTables = function (a) {
        var b = this.getFromFusionTables(a);
        return b.setMap(this.map), b
    }, j.prototype.getFromKML = function (a) {
        var b = a.url, c = a.events;
        delete a.url, delete a.events;
        var d = a, e = new google.maps.KmlLayer(b, d);
        for (var f in c) !function (a, b) {
            google.maps.event.addListener(a, b, function (a) {
                c[b].apply(this, [a])
            })
        }(e, f);
        return this.layers.push(e), e
    }, j.prototype.loadFromKML = function (a) {
        var b = this.getFromKML(a);
        return b.setMap(this.map), b
    }, j.prototype.addLayer = function (a, b) {
        b = b || {};
        var c;
        switch (a) {
            case"weather":
                this.singleLayers.weather = c = new google.maps.weather.WeatherLayer;
                break;
            case"clouds":
                this.singleLayers.clouds = c = new google.maps.weather.CloudLayer;
                break;
            case"traffic":
                this.singleLayers.traffic = c = new google.maps.TrafficLayer;
                break;
            case"transit":
                this.singleLayers.transit = c = new google.maps.TransitLayer;
                break;
            case"bicycling":
                this.singleLayers.bicycling = c = new google.maps.BicyclingLayer;
                break;
            case"panoramio":
                this.singleLayers.panoramio = c = new google.maps.panoramio.PanoramioLayer, c.setTag(b.filter), delete b.filter, b.click && google.maps.event.addListener(c, "click", function (a) {
                    b.click(a), delete b.click
                });
                break;
            case"places":
                if (this.singleLayers.places = c = new google.maps.places.PlacesService(this.map), b.search || b.nearbySearch || b.radarSearch) {
                    var d = {
                        bounds: b.bounds || null,
                        keyword: b.keyword || null,
                        location: b.location || null,
                        name: b.name || null,
                        radius: b.radius || null,
                        rankBy: b.rankBy || null,
                        types: b.types || null
                    };
                    b.radarSearch && c.radarSearch(d, b.radarSearch), b.search && c.search(d, b.search), b.nearbySearch && c.nearbySearch(d, b.nearbySearch)
                }
                if (b.textSearch) {
                    var e = {
                        bounds: b.bounds || null,
                        location: b.location || null,
                        query: b.query || null,
                        radius: b.radius || null
                    };
                    c.textSearch(e, b.textSearch)
                }
        }
        if (void 0 !== c) return "function" == typeof c.setOptions && c.setOptions(b), "function" == typeof c.setMap && c.setMap(this.map), c
    }, j.prototype.removeLayer = function (a) {
        if ("string" == typeof a && void 0 !== this.singleLayers[a]) this.singleLayers[a].setMap(null), delete this.singleLayers[a]; else for (var b = 0; b < this.layers.length; b++) if (this.layers[b] === a) {
            this.layers[b].setMap(null), this.layers.splice(b, 1);
            break
        }
    };
    var k, l;
    return j.prototype.getRoutes = function (b) {
        switch (b.travelMode) {
            case"bicycling":
                k = google.maps.TravelMode.BICYCLING;
                break;
            case"transit":
                k = google.maps.TravelMode.TRANSIT;
                break;
            case"driving":
                k = google.maps.TravelMode.DRIVING;
                break;
            default:
                k = google.maps.TravelMode.WALKING
        }
        l = "imperial" === b.unitSystem ? google.maps.UnitSystem.IMPERIAL : google.maps.UnitSystem.METRIC;
        var c = {avoidHighways: !1, avoidTolls: !1, optimizeWaypoints: !1, waypoints: []}, d = a(c, b);
        d.origin = /string/.test(typeof b.origin) ? b.origin : new google.maps.LatLng(b.origin[0], b.origin[1]), d.destination = /string/.test(typeof b.destination) ? b.destination : new google.maps.LatLng(b.destination[0], b.destination[1]), d.travelMode = k, d.unitSystem = l, delete d.callback, delete d.error;
        var e = [];
        (new google.maps.DirectionsService).route(d, function (a, c) {
            if (c === google.maps.DirectionsStatus.OK) {
                for (var d in a.routes) a.routes.hasOwnProperty(d) && e.push(a.routes[d]);
                b.callback && b.callback(e, a, c)
            } else b.error && b.error(a, c)
        })
    }, j.prototype.removeRoutes = function () {
        this.routes.length = 0
    }, j.prototype.getElevations = function (d) {
        d = a({
            locations: [],
            path: !1,
            samples: 256
        }, d), d.locations.length > 0 && d.locations[0].length > 0 && (d.locations = c(b([d.locations], f, !1)));
        var e = d.callback;
        delete d.callback;
        var g = new google.maps.ElevationService;
        if (d.path) {
            var h = {path: d.locations, samples: d.samples};
            g.getElevationAlongPath(h, function (a, b) {
                e && "function" == typeof e && e(a, b)
            })
        } else delete d.path, delete d.samples, g.getElevationForLocations(d, function (a, b) {
            e && "function" == typeof e && e(a, b)
        })
    }, j.prototype.cleanRoute = j.prototype.removePolylines, j.prototype.renderRoute = function (b, c) {
        var d, e = "string" == typeof c.panel ? document.getElementById(c.panel.replace("#", "")) : c.panel;
        c.panel = e, c = a({map: this.map}, c), d = new google.maps.DirectionsRenderer(c), this.getRoutes({
            origin: b.origin,
            destination: b.destination,
            travelMode: b.travelMode,
            waypoints: b.waypoints,
            unitSystem: b.unitSystem,
            error: b.error,
            avoidHighways: b.avoidHighways,
            avoidTolls: b.avoidTolls,
            optimizeWaypoints: b.optimizeWaypoints,
            callback: function (a, b, c) {
                c === google.maps.DirectionsStatus.OK && d.setDirections(b)
            }
        })
    }, j.prototype.drawRoute = function (a) {
        var b = this;
        this.getRoutes({
            origin: a.origin,
            destination: a.destination,
            travelMode: a.travelMode,
            waypoints: a.waypoints,
            unitSystem: a.unitSystem,
            error: a.error,
            avoidHighways: a.avoidHighways,
            avoidTolls: a.avoidTolls,
            optimizeWaypoints: a.optimizeWaypoints,
            callback: function (c) {
                if (c.length > 0) {
                    var d = {
                        path: c[c.length - 1].overview_path,
                        strokeColor: a.strokeColor,
                        strokeOpacity: a.strokeOpacity,
                        strokeWeight: a.strokeWeight
                    };
                    a.hasOwnProperty("icons") && (d.icons = a.icons), b.drawPolyline(d), a.callback && a.callback(c[c.length - 1])
                }
            }
        })
    }, j.prototype.travelRoute = function (a) {
        if (a.origin && a.destination) this.getRoutes({
            origin: a.origin,
            destination: a.destination,
            travelMode: a.travelMode,
            waypoints: a.waypoints,
            unitSystem: a.unitSystem,
            error: a.error,
            callback: function (b) {
                if (b.length > 0 && a.start && a.start(b[b.length - 1]), b.length > 0 && a.step) {
                    var c = b[b.length - 1];
                    if (c.legs.length > 0) for (var d, e = c.legs[0].steps, f = 0; d = e[f]; f++) d.step_number = f, a.step(d, c.legs[0].steps.length - 1)
                }
                b.length > 0 && a.end && a.end(b[b.length - 1])
            }
        }); else if (a.route && a.route.legs.length > 0) for (var b, c = a.route.legs[0].steps, d = 0; b = c[d]; d++) b.step_number = d, a.step(b)
    }, j.prototype.drawSteppedRoute = function (a) {
        var b = this;
        if (a.origin && a.destination) this.getRoutes({
            origin: a.origin,
            destination: a.destination,
            travelMode: a.travelMode,
            waypoints: a.waypoints,
            error: a.error,
            callback: function (c) {
                if (c.length > 0 && a.start && a.start(c[c.length - 1]), c.length > 0 && a.step) {
                    var d = c[c.length - 1];
                    if (d.legs.length > 0) for (var e, f = d.legs[0].steps, g = 0; e = f[g]; g++) {
                        e.step_number = g;
                        var h = {
                            path: e.path,
                            strokeColor: a.strokeColor,
                            strokeOpacity: a.strokeOpacity,
                            strokeWeight: a.strokeWeight
                        };
                        a.hasOwnProperty("icons") && (h.icons = a.icons), b.drawPolyline(h), a.step(e, d.legs[0].steps.length - 1)
                    }
                }
                c.length > 0 && a.end && a.end(c[c.length - 1])
            }
        }); else if (a.route && a.route.legs.length > 0) for (var c, d = a.route.legs[0].steps, e = 0; c = d[e]; e++) {
            c.step_number = e;
            var f = {
                path: c.path,
                strokeColor: a.strokeColor,
                strokeOpacity: a.strokeOpacity,
                strokeWeight: a.strokeWeight
            };
            a.hasOwnProperty("icons") && (f.icons = a.icons), b.drawPolyline(f), a.step(c)
        }
    }, j.Route = function (a) {
        this.origin = a.origin, this.destination = a.destination, this.waypoints = a.waypoints, this.map = a.map, this.route = a.route, this.step_count = 0, this.steps = this.route.legs[0].steps, this.steps_length = this.steps.length;
        var b = {
            path: new google.maps.MVCArray,
            strokeColor: a.strokeColor,
            strokeOpacity: a.strokeOpacity,
            strokeWeight: a.strokeWeight
        };
        a.hasOwnProperty("icons") && (b.icons = a.icons), this.polyline = this.map.drawPolyline(b).getPath()
    }, j.Route.prototype.getRoute = function (a) {
        var b = this;
        this.map.getRoutes({
            origin: this.origin,
            destination: this.destination,
            travelMode: a.travelMode,
            waypoints: this.waypoints || [],
            error: a.error,
            callback: function () {
                b.route = e[0], a.callback && a.callback.call(b)
            }
        })
    }, j.Route.prototype.back = function () {
        if (this.step_count > 0) {
            this.step_count--;
            var a = this.route.legs[0].steps[this.step_count].path;
            for (var b in a) a.hasOwnProperty(b) && this.polyline.pop()
        }
    }, j.Route.prototype.forward = function () {
        if (this.step_count < this.steps_length) {
            var a = this.route.legs[0].steps[this.step_count].path;
            for (var b in a) a.hasOwnProperty(b) && this.polyline.push(a[b]);
            this.step_count++
        }
    }, j.prototype.checkGeofence = function (a, b, c) {
        return c.containsLatLng(new google.maps.LatLng(a, b))
    }, j.prototype.checkMarkerGeofence = function (a, b) {
        if (a.fences) for (var c, d = 0; c = a.fences[d]; d++) {
            var e = a.getPosition();
            this.checkGeofence(e.lat(), e.lng(), c) || b(a, c)
        }
    }, j.prototype.toImage = function (a) {
        var a = a || {}, b = {};
        if (b.size = a.size || [this.el.clientWidth, this.el.clientHeight], b.lat = this.getCenter().lat(), b.lng = this.getCenter().lng(), this.markers.length > 0) {
            b.markers = [];
            for (var c = 0; c < this.markers.length; c++) b.markers.push({
                lat: this.markers[c].getPosition().lat(),
                lng: this.markers[c].getPosition().lng()
            })
        }
        if (this.polylines.length > 0) {
            var d = this.polylines[0];
            b.polyline = {}, b.polyline.path = google.maps.geometry.encoding.encodePath(d.getPath()), b.polyline.strokeColor = d.strokeColor, b.polyline.strokeOpacity = d.strokeOpacity, b.polyline.strokeWeight = d.strokeWeight
        }
        return j.staticMapURL(b)
    }, j.staticMapURL = function (a) {
        function b(a, b) {
            if ("#" === a[0] && (a = a.replace("#", "0x"), b)) {
                if (b = parseFloat(b), 0 === (b = Math.min(1, Math.max(b, 0)))) return "0x00000000";
                b = (255 * b).toString(16), 1 === b.length && (b += b), a = a.slice(0, 8) + b
            }
            return a
        }

        var c, d = [],
            e = ("file:" === location.protocol ? "http:" : location.protocol) + "//maps.googleapis.com/maps/api/staticmap";
        a.url && (e = a.url, delete a.url), e += "?";
        var f = a.markers;
        delete a.markers, !f && a.marker && (f = [a.marker], delete a.marker);
        var g = a.styles;
        delete a.styles;
        var h = a.polyline;
        if (delete a.polyline, a.center) d.push("center=" + a.center), delete a.center; else if (a.address) d.push("center=" + a.address), delete a.address; else if (a.lat) d.push(["center=", a.lat, ",", a.lng].join("")), delete a.lat, delete a.lng; else if (a.visible) {
            var i = encodeURI(a.visible.join("|"));
            d.push("visible=" + i)
        }
        var j = a.size;
        j ? (j.join && (j = j.join("x")), delete a.size) : j = "630x300", d.push("size=" + j), a.zoom || a.zoom === !1 || (a.zoom = 15);
        var k = !a.hasOwnProperty("sensor") || !!a.sensor;
        delete a.sensor, d.push("sensor=" + k);
        for (var l in a) a.hasOwnProperty(l) && d.push(l + "=" + a[l]);
        if (f) for (var m, n, o = 0; c = f[o]; o++) {
            m = [], c.size && "normal" !== c.size ? (m.push("size:" + c.size), delete c.size) : c.icon && (m.push("icon:" + encodeURI(c.icon)), delete c.icon), c.color && (m.push("color:" + c.color.replace("#", "0x")), delete c.color), c.label && (m.push("label:" + c.label[0].toUpperCase()), delete c.label), n = c.address ? c.address : c.lat + "," + c.lng, delete c.address, delete c.lat, delete c.lng;
            for (var l in c) c.hasOwnProperty(l) && m.push(l + ":" + c[l]);
            m.length || 0 === o ? (m.push(n), m = m.join("|"), d.push("markers=" + encodeURI(m))) : (m = d.pop() + encodeURI("|" + n), d.push(m))
        }
        if (g) for (var o = 0; o < g.length; o++) {
            var p = [];
            g[o].featureType && p.push("feature:" + g[o].featureType.toLowerCase()), g[o].elementType && p.push("element:" + g[o].elementType.toLowerCase());
            for (var q = 0; q < g[o].stylers.length; q++) for (var r in g[o].stylers[q]) {
                var s = g[o].stylers[q][r];
                "hue" != r && "color" != r || (s = "0x" + s.substring(1)), p.push(r + ":" + s)
            }
            var t = p.join("|");
            "" != t && d.push("style=" + t)
        }
        if (h) {
            if (c = h, h = [], c.strokeWeight && h.push("weight:" + parseInt(c.strokeWeight, 10)), c.strokeColor) {
                var u = b(c.strokeColor, c.strokeOpacity);
                h.push("color:" + u)
            }
            if (c.fillColor) {
                var v = b(c.fillColor, c.fillOpacity);
                h.push("fillcolor:" + v)
            }
            var w = c.path;
            if (w.join) for (var x, q = 0; x = w[q]; q++) h.push(x.join(",")); else h.push("enc:" + w);
            h = h.join("|"), d.push("path=" + encodeURI(h))
        }
        var y = window.devicePixelRatio || 1;
        return d.push("scale=" + y), d = d.join("&"), e + d
    }, j.prototype.addMapType = function (a, b) {
        if (!b.hasOwnProperty("getTileUrl") || "function" != typeof b.getTileUrl) throw"'getTileUrl' function required.";
        b.tileSize = b.tileSize || new google.maps.Size(256, 256);
        var c = new google.maps.ImageMapType(b);
        this.map.mapTypes.set(a, c)
    }, j.prototype.addOverlayMapType = function (a) {
        if (!a.hasOwnProperty("getTile") || "function" != typeof a.getTile) throw"'getTile' function required.";
        var b = a.index;
        delete a.index, this.map.overlayMapTypes.insertAt(b, a)
    }, j.prototype.removeOverlayMapType = function (a) {
        this.map.overlayMapTypes.removeAt(a)
    }, j.prototype.addStyle = function (a) {
        var b = new google.maps.StyledMapType(a.styles, {name: a.styledMapName});
        this.map.mapTypes.set(a.mapTypeId, b)
    }, j.prototype.setStyle = function (a) {
        this.map.setMapTypeId(a)
    }, j.prototype.createPanorama = function (a) {
        return a.hasOwnProperty("lat") && a.hasOwnProperty("lng") || (a.lat = this.getCenter().lat(), a.lng = this.getCenter().lng()), this.panorama = j.createPanorama(a), this.map.setStreetView(this.panorama), this.panorama
    }, j.createPanorama = function (b) {
        var c = h(b.el, b.context);
        b.position = new google.maps.LatLng(b.lat, b.lng), delete b.el, delete b.context, delete b.lat, delete b.lng;
        for (var d = ["closeclick", "links_changed", "pano_changed", "position_changed", "pov_changed", "resize", "visible_changed"], e = a({visible: !0}, b), f = 0; f < d.length; f++) delete e[d[f]];
        for (var g = new google.maps.StreetViewPanorama(c, e), f = 0; f < d.length; f++) !function (a, c) {
            b[c] && google.maps.event.addListener(a, c, function () {
                b[c].apply(this)
            })
        }(g, d[f]);
        return g
    }, j.prototype.on = function (a, b) {
        return j.on(a, this, b)
    }, j.prototype.off = function (a) {
        j.off(a, this)
    }, j.prototype.once = function (a, b) {
        return j.once(a, this, b)
    }, j.custom_events = ["marker_added", "marker_removed", "polyline_added", "polyline_removed", "polygon_added", "polygon_removed", "geolocated", "geolocation_failed"], j.on = function (a, b, c) {
        if (j.custom_events.indexOf(a) == -1) return b instanceof j && (b = b.map), google.maps.event.addListener(b, a, c);
        var d = {handler: c, eventName: a};
        return b.registered_events[a] = b.registered_events[a] || [], b.registered_events[a].push(d), d
    }, j.off = function (a, b) {
        j.custom_events.indexOf(a) == -1 ? (b instanceof j && (b = b.map), google.maps.event.clearListeners(b, a)) : b.registered_events[a] = []
    }, j.once = function (a, b, c) {
        if (j.custom_events.indexOf(a) == -1) return b instanceof j && (b = b.map), google.maps.event.addListenerOnce(b, a, c)
    }, j.fire = function (a, b, c) {
        if (j.custom_events.indexOf(a) == -1) google.maps.event.trigger(b, a, Array.prototype.slice.apply(arguments).slice(2)); else if (a in c.registered_events) for (var d = c.registered_events[a], e = 0; e < d.length; e++) !function (a, b, c) {
            a.apply(b, [c])
        }(d[e].handler, c, b)
    }, j.geolocate = function (a) {
        var b = a.always || a.complete;
        navigator.geolocation ? navigator.geolocation.getCurrentPosition(function (c) {
            a.success(c), b && b()
        }, function (c) {
            a.error(c), b && b()
        }, a.options) : (a.not_supported(), b && b())
    }, j.geocode = function (a) {
        this.geocoder = new google.maps.Geocoder;
        var b = a.callback;
        a.hasOwnProperty("lat") && a.hasOwnProperty("lng") && (a.latLng = new google.maps.LatLng(a.lat, a.lng)), delete a.lat, delete a.lng, delete a.callback, this.geocoder.geocode(a, function (a, c) {
            b(a, c)
        })
    }, "object" == typeof window.google && window.google.maps && (google.maps.Polygon.prototype.getBounds || (google.maps.Polygon.prototype.getBounds = function (a) {
        for (var b, c = new google.maps.LatLngBounds, d = this.getPaths(), e = 0; e < d.getLength(); e++) {
            b = d.getAt(e);
            for (var f = 0; f < b.getLength(); f++) c.extend(b.getAt(f))
        }
        return c
    }), google.maps.Polygon.prototype.containsLatLng || (google.maps.Polygon.prototype.containsLatLng = function (a) {
        var b = this.getBounds();
        if (null !== b && !b.contains(a)) return !1;
        for (var c = !1, d = this.getPaths().getLength(), e = 0; e < d; e++) for (var f = this.getPaths().getAt(e), g = f.getLength(), h = g - 1, i = 0; i < g; i++) {
            var j = f.getAt(i), k = f.getAt(h);
            (j.lng() < a.lng() && k.lng() >= a.lng() || k.lng() < a.lng() && j.lng() >= a.lng()) && j.lat() + (a.lng() - j.lng()) / (k.lng() - j.lng()) * (k.lat() - j.lat()) < a.lat() && (c = !c), h = i
        }
        return c
    }), google.maps.Circle.prototype.containsLatLng || (google.maps.Circle.prototype.containsLatLng = function (a) {
        return !google.maps.geometry || google.maps.geometry.spherical.computeDistanceBetween(this.getCenter(), a) <= this.getRadius()
    }), google.maps.Rectangle.prototype.containsLatLng = function (a) {
        return this.getBounds().contains(a)
    }, google.maps.LatLngBounds.prototype.containsLatLng = function (a) {
        return this.contains(a)
    }, google.maps.Marker.prototype.setFences = function (a) {
        this.fences = a
    }, google.maps.Marker.prototype.addFence = function (a) {
        this.fences.push(a)
    }, google.maps.Marker.prototype.getId = function () {
        return this.__gm_id
    }), Array.prototype.indexOf || (Array.prototype.indexOf = function (a) {
        if (null == this) throw new TypeError;
        var b = Object(this), c = b.length >>> 0;
        if (0 === c) return -1;
        var d = 0;
        if (arguments.length > 1 && (d = Number(arguments[1]), d != d ? d = 0 : 0 != d && d != 1 / 0 && d != -(1 / 0) && (d = (d > 0 || -1) * Math.floor(Math.abs(d)))), d >= c) return -1;
        for (var e = d >= 0 ? d : Math.max(c - Math.abs(d), 0); e < c; e++) if (e in b && b[e] === a) return e;
        return -1
    }), j
});

/*!
 * enquire.js v2.1.6 - Awesome Media Queries in JavaScript
 * Copyright (c) 2017 Nick Williams - http://wicky.nillia.ms/enquire.js
 * License: MIT */

!function (a) {
    if ("object" == typeof exports && "undefined" != typeof module) module.exports = a(); else if ("function" == typeof define && define.amd) define([], a); else {
        var b;
        b = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this, b.enquire = a()
    }
}(function () {
    return function a(b, c, d) {
        function e(g, h) {
            if (!c[g]) {
                if (!b[g]) {
                    var i = "function" == typeof require && require;
                    if (!h && i) return i(g, !0);
                    if (f) return f(g, !0);
                    var j = new Error("Cannot find module '" + g + "'");
                    throw j.code = "MODULE_NOT_FOUND", j
                }
                var k = c[g] = {exports: {}};
                b[g][0].call(k.exports, function (a) {
                    var c = b[g][1][a];
                    return e(c ? c : a)
                }, k, k.exports, a, b, c, d)
            }
            return c[g].exports
        }

        for (var f = "function" == typeof require && require, g = 0; g < d.length; g++) e(d[g]);
        return e
    }({
        1: [function (a, b, c) {
            function d(a, b) {
                this.query = a, this.isUnconditional = b, this.handlers = [], this.mql = window.matchMedia(a);
                var c = this;
                this.listener = function (a) {
                    c.mql = a.currentTarget || a, c.assess()
                }, this.mql.addListener(this.listener)
            }

            var e = a(3), f = a(4).each;
            d.prototype = {
                constuctor: d, addHandler: function (a) {
                    var b = new e(a);
                    this.handlers.push(b), this.matches() && b.on()
                }, removeHandler: function (a) {
                    var b = this.handlers;
                    f(b, function (c, d) {
                        if (c.equals(a)) return c.destroy(), !b.splice(d, 1)
                    })
                }, matches: function () {
                    return this.mql.matches || this.isUnconditional
                }, clear: function () {
                    f(this.handlers, function (a) {
                        a.destroy()
                    }), this.mql.removeListener(this.listener), this.handlers.length = 0
                }, assess: function () {
                    var a = this.matches() ? "on" : "off";
                    f(this.handlers, function (b) {
                        b[a]()
                    })
                }
            }, b.exports = d
        }, {3: 3, 4: 4}], 2: [function (a, b, c) {
            function d() {
                if (!window.matchMedia) throw new Error("matchMedia not present, legacy browsers require a polyfill");
                this.queries = {}, this.browserIsIncapable = !window.matchMedia("only all").matches
            }

            var e = a(1), f = a(4), g = f.each, h = f.isFunction, i = f.isArray;
            d.prototype = {
                constructor: d, register: function (a, b, c) {
                    var d = this.queries, f = c && this.browserIsIncapable;
                    return d[a] || (d[a] = new e(a, f)), h(b) && (b = {match: b}), i(b) || (b = [b]), g(b, function (b) {
                        h(b) && (b = {match: b}), d[a].addHandler(b)
                    }), this
                }, unregister: function (a, b) {
                    var c = this.queries[a];
                    return c && (b ? c.removeHandler(b) : (c.clear(), delete this.queries[a])), this
                }
            }, b.exports = d
        }, {1: 1, 4: 4}], 3: [function (a, b, c) {
            function d(a) {
                this.options = a, !a.deferSetup && this.setup()
            }

            d.prototype = {
                constructor: d, setup: function () {
                    this.options.setup && this.options.setup(), this.initialised = !0
                }, on: function () {
                    !this.initialised && this.setup(), this.options.match && this.options.match()
                }, off: function () {
                    this.options.unmatch && this.options.unmatch()
                }, destroy: function () {
                    this.options.destroy ? this.options.destroy() : this.off()
                }, equals: function (a) {
                    return this.options === a || this.options.match === a
                }
            }, b.exports = d
        }, {}], 4: [function (a, b, c) {
            function d(a, b) {
                var c = 0, d = a.length;
                for (c; c < d && b(a[c], c) !== !1; c++) ;
            }

            function e(a) {
                return "[object Array]" === Object.prototype.toString.apply(a)
            }

            function f(a) {
                return "function" == typeof a
            }

            b.exports = {isFunction: f, isArray: e, each: d}
        }, {}], 5: [function (a, b, c) {
            var d = a(2);
            b.exports = new d
        }, {2: 2}]
    }, {}, [5])(5)
});

/*!
 * Flickity PACKAGED v2.2.1
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2019 Metafizzy
 */

!function (e, i) {
    "function" == typeof define && define.amd ? define("jquery-bridget/jquery-bridget", ["jquery"], function (t) {
        return i(e, t)
    }) : "object" == typeof module && module.exports ? module.exports = i(e, require("jquery")) : e.jQueryBridget = i(e, e.jQuery)
}(window, function (t, e) {
    "use strict";
    var d = Array.prototype.slice, i = t.console, u = void 0 === i ? function () {
    } : function (t) {
        i.error(t)
    };

    function n(h, s, c) {
        (c = c || e || t.jQuery) && (s.prototype.option || (s.prototype.option = function (t) {
            c.isPlainObject(t) && (this.options = c.extend(!0, this.options, t))
        }), c.fn[h] = function (t) {
            if ("string" != typeof t) return n = t, this.each(function (t, e) {
                var i = c.data(e, h);
                i ? (i.option(n), i._init()) : (i = new s(e, n), c.data(e, h, i))
            }), this;
            var e, o, r, a, l, n, i = d.call(arguments, 1);
            return r = i, l = "$()." + h + '("' + (o = t) + '")', (e = this).each(function (t, e) {
                var i = c.data(e, h);
                if (i) {
                    var n = i[o];
                    if (n && "_" != o.charAt(0)) {
                        var s = n.apply(i, r);
                        a = void 0 === a ? s : a
                    } else u(l + " is not a valid method")
                } else u(h + " not initialized. Cannot call methods, i.e. " + l)
            }), void 0 !== a ? a : e
        }, o(c))
    }

    function o(t) {
        !t || t && t.bridget || (t.bridget = n)
    }

    return o(e || t.jQuery), n
}), function (t, e) {
    "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", e) : "object" == typeof module && module.exports ? module.exports = e() : t.EvEmitter = e()
}("undefined" != typeof window ? window : this, function () {
    function t() {
    }

    var e = t.prototype;
    return e.on = function (t, e) {
        if (t && e) {
            var i = this._events = this._events || {}, n = i[t] = i[t] || [];
            return -1 == n.indexOf(e) && n.push(e), this
        }
    }, e.once = function (t, e) {
        if (t && e) {
            this.on(t, e);
            var i = this._onceEvents = this._onceEvents || {};
            return (i[t] = i[t] || {})[e] = !0, this
        }
    }, e.off = function (t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
            var n = i.indexOf(e);
            return -1 != n && i.splice(n, 1), this
        }
    }, e.emitEvent = function (t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
            i = i.slice(0), e = e || [];
            for (var n = this._onceEvents && this._onceEvents[t], s = 0; s < i.length; s++) {
                var o = i[s];
                n && n[o] && (this.off(t, o), delete n[o]), o.apply(this, e)
            }
            return this
        }
    }, e.allOff = function () {
        delete this._events, delete this._onceEvents
    }, t
}), function (t, e) {
    "function" == typeof define && define.amd ? define("get-size/get-size", e) : "object" == typeof module && module.exports ? module.exports = e() : t.getSize = e()
}(window, function () {
    "use strict";

    function m(t) {
        var e = parseFloat(t);
        return -1 == t.indexOf("%") && !isNaN(e) && e
    }

    var i = "undefined" == typeof console ? function () {
        } : function (t) {
            console.error(t)
        },
        y = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"],
        b = y.length;

    function E(t) {
        var e = getComputedStyle(t);
        return e || i("Style returned " + e + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"), e
    }

    var S, C = !1;

    function x(t) {
        if (!function () {
            if (!C) {
                C = !0;
                var t = document.createElement("div");
                t.style.width = "200px", t.style.padding = "1px 2px 3px 4px", t.style.borderStyle = "solid", t.style.borderWidth = "1px 2px 3px 4px", t.style.boxSizing = "border-box";
                var e = document.body || document.documentElement;
                e.appendChild(t);
                var i = E(t);
                S = 200 == Math.round(m(i.width)), x.isBoxSizeOuter = S, e.removeChild(t)
            }
        }(), "string" == typeof t && (t = document.querySelector(t)), t && "object" == typeof t && t.nodeType) {
            var e = E(t);
            if ("none" == e.display) return function () {
                for (var t = {
                    width: 0,
                    height: 0,
                    innerWidth: 0,
                    innerHeight: 0,
                    outerWidth: 0,
                    outerHeight: 0
                }, e = 0; e < b; e++) {
                    t[y[e]] = 0
                }
                return t
            }();
            var i = {};
            i.width = t.offsetWidth, i.height = t.offsetHeight;
            for (var n = i.isBorderBox = "border-box" == e.boxSizing, s = 0; s < b; s++) {
                var o = y[s], r = e[o], a = parseFloat(r);
                i[o] = isNaN(a) ? 0 : a
            }
            var l = i.paddingLeft + i.paddingRight, h = i.paddingTop + i.paddingBottom,
                c = i.marginLeft + i.marginRight, d = i.marginTop + i.marginBottom,
                u = i.borderLeftWidth + i.borderRightWidth, f = i.borderTopWidth + i.borderBottomWidth, p = n && S,
                g = m(e.width);
            !1 !== g && (i.width = g + (p ? 0 : l + u));
            var v = m(e.height);
            return !1 !== v && (i.height = v + (p ? 0 : h + f)), i.innerWidth = i.width - (l + u), i.innerHeight = i.height - (h + f), i.outerWidth = i.width + c, i.outerHeight = i.height + d, i
        }
    }

    return x
}), function (t, e) {
    "use strict";
    "function" == typeof define && define.amd ? define("desandro-matches-selector/matches-selector", e) : "object" == typeof module && module.exports ? module.exports = e() : t.matchesSelector = e()
}(window, function () {
    "use strict";
    var i = function () {
        var t = window.Element.prototype;
        if (t.matches) return "matches";
        if (t.matchesSelector) return "matchesSelector";
        for (var e = ["webkit", "moz", "ms", "o"], i = 0; i < e.length; i++) {
            var n = e[i] + "MatchesSelector";
            if (t[n]) return n
        }
    }();
    return function (t, e) {
        return t[i](e)
    }
}), function (e, i) {
    "function" == typeof define && define.amd ? define("fizzy-ui-utils/utils", ["desandro-matches-selector/matches-selector"], function (t) {
        return i(e, t)
    }) : "object" == typeof module && module.exports ? module.exports = i(e, require("desandro-matches-selector")) : e.fizzyUIUtils = i(e, e.matchesSelector)
}(window, function (h, o) {
    var c = {
        extend: function (t, e) {
            for (var i in e) t[i] = e[i];
            return t
        }, modulo: function (t, e) {
            return (t % e + e) % e
        }
    }, e = Array.prototype.slice;
    c.makeArray = function (t) {
        return Array.isArray(t) ? t : null == t ? [] : "object" == typeof t && "number" == typeof t.length ? e.call(t) : [t]
    }, c.removeFrom = function (t, e) {
        var i = t.indexOf(e);
        -1 != i && t.splice(i, 1)
    }, c.getParent = function (t, e) {
        for (; t.parentNode && t != document.body;) if (t = t.parentNode, o(t, e)) return t
    }, c.getQueryElement = function (t) {
        return "string" == typeof t ? document.querySelector(t) : t
    }, c.handleEvent = function (t) {
        var e = "on" + t.type;
        this[e] && this[e](t)
    }, c.filterFindElements = function (t, n) {
        t = c.makeArray(t);
        var s = [];
        return t.forEach(function (t) {
            if (t instanceof HTMLElement) if (n) {
                o(t, n) && s.push(t);
                for (var e = t.querySelectorAll(n), i = 0; i < e.length; i++) s.push(e[i])
            } else s.push(t)
        }), s
    }, c.debounceMethod = function (t, e, n) {
        n = n || 100;
        var s = t.prototype[e], o = e + "Timeout";
        t.prototype[e] = function () {
            var t = this[o];
            clearTimeout(t);
            var e = arguments, i = this;
            this[o] = setTimeout(function () {
                s.apply(i, e), delete i[o]
            }, n)
        }
    }, c.docReady = function (t) {
        var e = document.readyState;
        "complete" == e || "interactive" == e ? setTimeout(t) : document.addEventListener("DOMContentLoaded", t)
    }, c.toDashed = function (t) {
        return t.replace(/(.)([A-Z])/g, function (t, e, i) {
            return e + "-" + i
        }).toLowerCase()
    };
    var d = h.console;
    return c.htmlInit = function (a, l) {
        c.docReady(function () {
            var t = c.toDashed(l), s = "data-" + t, e = document.querySelectorAll("[" + s + "]"),
                i = document.querySelectorAll(".js-" + t), n = c.makeArray(e).concat(c.makeArray(i)),
                o = s + "-options", r = h.jQuery;
            n.forEach(function (e) {
                var t, i = e.getAttribute(s) || e.getAttribute(o);
                try {
                    t = i && JSON.parse(i)
                } catch (t) {
                    return void (d && d.error("Error parsing " + s + " on " + e.className + ": " + t))
                }
                var n = new a(e, t);
                r && r.data(e, l, n)
            })
        })
    }, c
}), function (e, i) {
    "function" == typeof define && define.amd ? define("flickity/js/cell", ["get-size/get-size"], function (t) {
        return i(e, t)
    }) : "object" == typeof module && module.exports ? module.exports = i(e, require("get-size")) : (e.Flickity = e.Flickity || {}, e.Flickity.Cell = i(e, e.getSize))
}(window, function (t, e) {
    function i(t, e) {
        this.element = t, this.parent = e, this.create()
    }

    var n = i.prototype;
    return n.create = function () {
        this.element.style.position = "absolute", this.element.setAttribute("aria-hidden", "true"), this.x = 0, this.shift = 0
    }, n.destroy = function () {
        this.unselect(), this.element.style.position = "";
        var t = this.parent.originSide;
        this.element.style[t] = ""
    }, n.getSize = function () {
        this.size = e(this.element)
    }, n.setPosition = function (t) {
        this.x = t, this.updateTarget(), this.renderPosition(t)
    }, n.updateTarget = n.setDefaultTarget = function () {
        var t = "left" == this.parent.originSide ? "marginLeft" : "marginRight";
        this.target = this.x + this.size[t] + this.size.width * this.parent.cellAlign
    }, n.renderPosition = function (t) {
        var e = this.parent.originSide;
        this.element.style[e] = this.parent.getPositionValue(t)
    }, n.select = function () {
        this.element.classList.add("is-selected"), this.element.removeAttribute("aria-hidden")
    }, n.unselect = function () {
        this.element.classList.remove("is-selected"), this.element.setAttribute("aria-hidden", "true")
    }, n.wrapShift = function (t) {
        this.shift = t, this.renderPosition(this.x + this.parent.slideableWidth * t)
    }, n.remove = function () {
        this.element.parentNode.removeChild(this.element)
    }, i
}), function (t, e) {
    "function" == typeof define && define.amd ? define("flickity/js/slide", e) : "object" == typeof module && module.exports ? module.exports = e() : (t.Flickity = t.Flickity || {}, t.Flickity.Slide = e())
}(window, function () {
    "use strict";

    function t(t) {
        this.parent = t, this.isOriginLeft = "left" == t.originSide, this.cells = [], this.outerWidth = 0, this.height = 0
    }

    var e = t.prototype;
    return e.addCell = function (t) {
        if (this.cells.push(t), this.outerWidth += t.size.outerWidth, this.height = Math.max(t.size.outerHeight, this.height), 1 == this.cells.length) {
            this.x = t.x;
            var e = this.isOriginLeft ? "marginLeft" : "marginRight";
            this.firstMargin = t.size[e]
        }
    }, e.updateTarget = function () {
        var t = this.isOriginLeft ? "marginRight" : "marginLeft", e = this.getLastCell(), i = e ? e.size[t] : 0,
            n = this.outerWidth - (this.firstMargin + i);
        this.target = this.x + this.firstMargin + n * this.parent.cellAlign
    }, e.getLastCell = function () {
        return this.cells[this.cells.length - 1]
    }, e.select = function () {
        this.cells.forEach(function (t) {
            t.select()
        })
    }, e.unselect = function () {
        this.cells.forEach(function (t) {
            t.unselect()
        })
    }, e.getCellElements = function () {
        return this.cells.map(function (t) {
            return t.element
        })
    }, t
}), function (e, i) {
    "function" == typeof define && define.amd ? define("flickity/js/animate", ["fizzy-ui-utils/utils"], function (t) {
        return i(e, t)
    }) : "object" == typeof module && module.exports ? module.exports = i(e, require("fizzy-ui-utils")) : (e.Flickity = e.Flickity || {}, e.Flickity.animatePrototype = i(e, e.fizzyUIUtils))
}(window, function (t, e) {
    var i = {
        startAnimation: function () {
            this.isAnimating || (this.isAnimating = !0, this.restingFrames = 0, this.animate())
        }, animate: function () {
            this.applyDragForce(), this.applySelectedAttraction();
            var t = this.x;
            if (this.integratePhysics(), this.positionSlider(), this.settle(t), this.isAnimating) {
                var e = this;
                requestAnimationFrame(function () {
                    e.animate()
                })
            }
        }, positionSlider: function () {
            var t = this.x;
            this.options.wrapAround && 1 < this.cells.length && (t = e.modulo(t, this.slideableWidth), t -= this.slideableWidth, this.shiftWrapCells(t)), this.setTranslateX(t, this.isAnimating), this.dispatchScrollEvent()
        }, setTranslateX: function (t, e) {
            t += this.cursorPosition, t = this.options.rightToLeft ? -t : t;
            var i = this.getPositionValue(t);
            this.slider.style.transform = e ? "translate3d(" + i + ",0,0)" : "translateX(" + i + ")"
        }, dispatchScrollEvent: function () {
            var t = this.slides[0];
            if (t) {
                var e = -this.x - t.target, i = e / this.slidesWidth;
                this.dispatchEvent("scroll", null, [i, e])
            }
        }, positionSliderAtSelected: function () {
            this.cells.length && (this.x = -this.selectedSlide.target, this.velocity = 0, this.positionSlider())
        }, getPositionValue: function (t) {
            return this.options.percentPosition ? .01 * Math.round(t / this.size.innerWidth * 1e4) + "%" : Math.round(t) + "px"
        }, settle: function (t) {
            this.isPointerDown || Math.round(100 * this.x) != Math.round(100 * t) || this.restingFrames++, 2 < this.restingFrames && (this.isAnimating = !1, delete this.isFreeScrolling, this.positionSlider(), this.dispatchEvent("settle", null, [this.selectedIndex]))
        }, shiftWrapCells: function (t) {
            var e = this.cursorPosition + t;
            this._shiftCells(this.beforeShiftCells, e, -1);
            var i = this.size.innerWidth - (t + this.slideableWidth + this.cursorPosition);
            this._shiftCells(this.afterShiftCells, i, 1)
        }, _shiftCells: function (t, e, i) {
            for (var n = 0; n < t.length; n++) {
                var s = t[n], o = 0 < e ? i : 0;
                s.wrapShift(o), e -= s.size.outerWidth
            }
        }, _unshiftCells: function (t) {
            if (t && t.length) for (var e = 0; e < t.length; e++) t[e].wrapShift(0)
        }, integratePhysics: function () {
            this.x += this.velocity, this.velocity *= this.getFrictionFactor()
        }, applyForce: function (t) {
            this.velocity += t
        }, getFrictionFactor: function () {
            return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"]
        }, getRestingPosition: function () {
            return this.x + this.velocity / (1 - this.getFrictionFactor())
        }, applyDragForce: function () {
            if (this.isDraggable && this.isPointerDown) {
                var t = this.dragX - this.x - this.velocity;
                this.applyForce(t)
            }
        }, applySelectedAttraction: function () {
            if (!(this.isDraggable && this.isPointerDown) && !this.isFreeScrolling && this.slides.length) {
                var t = (-1 * this.selectedSlide.target - this.x) * this.options.selectedAttraction;
                this.applyForce(t)
            }
        }
    };
    return i
}), function (r, a) {
    if ("function" == typeof define && define.amd) define("flickity/js/flickity", ["ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./cell", "./slide", "./animate"], function (t, e, i, n, s, o) {
        return a(r, t, e, i, n, s, o)
    }); else if ("object" == typeof module && module.exports) module.exports = a(r, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./cell"), require("./slide"), require("./animate")); else {
        var t = r.Flickity;
        r.Flickity = a(r, r.EvEmitter, r.getSize, r.fizzyUIUtils, t.Cell, t.Slide, t.animatePrototype)
    }
}(window, function (n, t, e, a, i, r, s) {
    var l = n.jQuery, o = n.getComputedStyle, h = n.console;

    function c(t, e) {
        for (t = a.makeArray(t); t.length;) e.appendChild(t.shift())
    }

    var d = 0, u = {};

    function f(t, e) {
        var i = a.getQueryElement(t);
        if (i) {
            if (this.element = i, this.element.flickityGUID) {
                var n = u[this.element.flickityGUID];
                return n.option(e), n
            }
            l && (this.$element = l(this.element)), this.options = a.extend({}, this.constructor.defaults), this.option(e), this._create()
        } else h && h.error("Bad element for Flickity: " + (i || t))
    }

    f.defaults = {
        accessibility: !0,
        cellAlign: "center",
        freeScrollFriction: .075,
        friction: .28,
        namespaceJQueryEvents: !0,
        percentPosition: !0,
        resize: !0,
        selectedAttraction: .025,
        setGallerySize: !0
    }, f.createMethods = [];
    var p = f.prototype;
    a.extend(p, t.prototype), p._create = function () {
        var t = this.guid = ++d;
        for (var e in this.element.flickityGUID = t, (u[t] = this).selectedIndex = 0, this.restingFrames = 0, this.x = 0, this.velocity = 0, this.originSide = this.options.rightToLeft ? "right" : "left", this.viewport = document.createElement("div"), this.viewport.className = "flickity-viewport", this._createSlider(), (this.options.resize || this.options.watchCSS) && n.addEventListener("resize", this), this.options.on) {
            var i = this.options.on[e];
            this.on(e, i)
        }
        f.createMethods.forEach(function (t) {
            this[t]()
        }, this), this.options.watchCSS ? this.watchCSS() : this.activate()
    }, p.option = function (t) {
        a.extend(this.options, t)
    }, p.activate = function () {
        this.isActive || (this.isActive = !0, this.element.classList.add("flickity-enabled"), this.options.rightToLeft && this.element.classList.add("flickity-rtl"), this.getSize(), c(this._filterFindCellElements(this.element.children), this.slider), this.viewport.appendChild(this.slider), this.element.appendChild(this.viewport), this.reloadCells(), this.options.accessibility && (this.element.tabIndex = 0, this.element.addEventListener("keydown", this)), this.emitEvent("activate"), this.selectInitialIndex(), this.isInitActivated = !0, this.dispatchEvent("ready"))
    }, p._createSlider = function () {
        var t = document.createElement("div");
        t.className = "flickity-slider", t.style[this.originSide] = 0, this.slider = t
    }, p._filterFindCellElements = function (t) {
        return a.filterFindElements(t, this.options.cellSelector)
    }, p.reloadCells = function () {
        this.cells = this._makeCells(this.slider.children), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize()
    }, p._makeCells = function (t) {
        return this._filterFindCellElements(t).map(function (t) {
            return new i(t, this)
        }, this)
    }, p.getLastCell = function () {
        return this.cells[this.cells.length - 1]
    }, p.getLastSlide = function () {
        return this.slides[this.slides.length - 1]
    }, p.positionCells = function () {
        this._sizeCells(this.cells), this._positionCells(0)
    }, p._positionCells = function (t) {
        t = t || 0, this.maxCellHeight = t && this.maxCellHeight || 0;
        var e = 0;
        if (0 < t) {
            var i = this.cells[t - 1];
            e = i.x + i.size.outerWidth
        }
        for (var n = this.cells.length, s = t; s < n; s++) {
            var o = this.cells[s];
            o.setPosition(e), e += o.size.outerWidth, this.maxCellHeight = Math.max(o.size.outerHeight, this.maxCellHeight)
        }
        this.slideableWidth = e, this.updateSlides(), this._containSlides(), this.slidesWidth = n ? this.getLastSlide().target - this.slides[0].target : 0
    }, p._sizeCells = function (t) {
        t.forEach(function (t) {
            t.getSize()
        })
    }, p.updateSlides = function () {
        if (this.slides = [], this.cells.length) {
            var n = new r(this);
            this.slides.push(n);
            var s = "left" == this.originSide ? "marginRight" : "marginLeft", o = this._getCanCellFit();
            this.cells.forEach(function (t, e) {
                if (n.cells.length) {
                    var i = n.outerWidth - n.firstMargin + (t.size.outerWidth - t.size[s]);
                    o.call(this, e, i) || (n.updateTarget(), n = new r(this), this.slides.push(n)), n.addCell(t)
                } else n.addCell(t)
            }, this), n.updateTarget(), this.updateSelectedSlide()
        }
    }, p._getCanCellFit = function () {
        var t = this.options.groupCells;
        if (!t) return function () {
            return !1
        };
        if ("number" == typeof t) {
            var e = parseInt(t, 10);
            return function (t) {
                return t % e != 0
            }
        }
        var i = "string" == typeof t && t.match(/^(\d+)%$/), n = i ? parseInt(i[1], 10) / 100 : 1;
        return function (t, e) {
            return e <= (this.size.innerWidth + 1) * n
        }
    }, p._init = p.reposition = function () {
        this.positionCells(), this.positionSliderAtSelected()
    }, p.getSize = function () {
        this.size = e(this.element), this.setCellAlign(), this.cursorPosition = this.size.innerWidth * this.cellAlign
    };
    var g = {center: {left: .5, right: .5}, left: {left: 0, right: 1}, right: {right: 0, left: 1}};
    return p.setCellAlign = function () {
        var t = g[this.options.cellAlign];
        this.cellAlign = t ? t[this.originSide] : this.options.cellAlign
    }, p.setGallerySize = function () {
        if (this.options.setGallerySize) {
            var t = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
            this.viewport.style.height = t + "px"
        }
    }, p._getWrapShiftCells = function () {
        if (this.options.wrapAround) {
            this._unshiftCells(this.beforeShiftCells), this._unshiftCells(this.afterShiftCells);
            var t = this.cursorPosition, e = this.cells.length - 1;
            this.beforeShiftCells = this._getGapCells(t, e, -1), t = this.size.innerWidth - this.cursorPosition, this.afterShiftCells = this._getGapCells(t, 0, 1)
        }
    }, p._getGapCells = function (t, e, i) {
        for (var n = []; 0 < t;) {
            var s = this.cells[e];
            if (!s) break;
            n.push(s), e += i, t -= s.size.outerWidth
        }
        return n
    }, p._containSlides = function () {
        if (this.options.contain && !this.options.wrapAround && this.cells.length) {
            var t = this.options.rightToLeft, e = t ? "marginRight" : "marginLeft",
                i = t ? "marginLeft" : "marginRight", n = this.slideableWidth - this.getLastCell().size[i],
                s = n < this.size.innerWidth, o = this.cursorPosition + this.cells[0].size[e],
                r = n - this.size.innerWidth * (1 - this.cellAlign);
            this.slides.forEach(function (t) {
                s ? t.target = n * this.cellAlign : (t.target = Math.max(t.target, o), t.target = Math.min(t.target, r))
            }, this)
        }
    }, p.dispatchEvent = function (t, e, i) {
        var n = e ? [e].concat(i) : i;
        if (this.emitEvent(t, n), l && this.$element) {
            var s = t += this.options.namespaceJQueryEvents ? ".flickity" : "";
            if (e) {
                var o = l.Event(e);
                o.type = t, s = o
            }
            this.$element.trigger(s, i)
        }
    }, p.select = function (t, e, i) {
        if (this.isActive && (t = parseInt(t, 10), this._wrapSelect(t), (this.options.wrapAround || e) && (t = a.modulo(t, this.slides.length)), this.slides[t])) {
            var n = this.selectedIndex;
            this.selectedIndex = t, this.updateSelectedSlide(), i ? this.positionSliderAtSelected() : this.startAnimation(), this.options.adaptiveHeight && this.setGallerySize(), this.dispatchEvent("select", null, [t]), t != n && this.dispatchEvent("change", null, [t]), this.dispatchEvent("cellSelect")
        }
    }, p._wrapSelect = function (t) {
        var e = this.slides.length;
        if (!(this.options.wrapAround && 1 < e)) return t;
        var i = a.modulo(t, e), n = Math.abs(i - this.selectedIndex), s = Math.abs(i + e - this.selectedIndex),
            o = Math.abs(i - e - this.selectedIndex);
        !this.isDragSelect && s < n ? t += e : !this.isDragSelect && o < n && (t -= e), t < 0 ? this.x -= this.slideableWidth : e <= t && (this.x += this.slideableWidth)
    }, p.previous = function (t, e) {
        this.select(this.selectedIndex - 1, t, e)
    }, p.next = function (t, e) {
        this.select(this.selectedIndex + 1, t, e)
    }, p.updateSelectedSlide = function () {
        var t = this.slides[this.selectedIndex];
        t && (this.unselectSelectedSlide(), (this.selectedSlide = t).select(), this.selectedCells = t.cells, this.selectedElements = t.getCellElements(), this.selectedCell = t.cells[0], this.selectedElement = this.selectedElements[0])
    }, p.unselectSelectedSlide = function () {
        this.selectedSlide && this.selectedSlide.unselect()
    }, p.selectInitialIndex = function () {
        var t = this.options.initialIndex;
        if (this.isInitActivated) this.select(this.selectedIndex, !1, !0); else {
            if (t && "string" == typeof t) if (this.queryCell(t)) return void this.selectCell(t, !1, !0);
            var e = 0;
            t && this.slides[t] && (e = t), this.select(e, !1, !0)
        }
    }, p.selectCell = function (t, e, i) {
        var n = this.queryCell(t);
        if (n) {
            var s = this.getCellSlideIndex(n);
            this.select(s, e, i)
        }
    }, p.getCellSlideIndex = function (t) {
        for (var e = 0; e < this.slides.length; e++) {
            if (-1 != this.slides[e].cells.indexOf(t)) return e
        }
    }, p.getCell = function (t) {
        for (var e = 0; e < this.cells.length; e++) {
            var i = this.cells[e];
            if (i.element == t) return i
        }
    }, p.getCells = function (t) {
        t = a.makeArray(t);
        var i = [];
        return t.forEach(function (t) {
            var e = this.getCell(t);
            e && i.push(e)
        }, this), i
    }, p.getCellElements = function () {
        return this.cells.map(function (t) {
            return t.element
        })
    }, p.getParentCell = function (t) {
        var e = this.getCell(t);
        return e || (t = a.getParent(t, ".flickity-slider > *"), this.getCell(t))
    }, p.getAdjacentCellElements = function (t, e) {
        if (!t) return this.selectedSlide.getCellElements();
        e = void 0 === e ? this.selectedIndex : e;
        var i = this.slides.length;
        if (i <= 1 + 2 * t) return this.getCellElements();
        for (var n = [], s = e - t; s <= e + t; s++) {
            var o = this.options.wrapAround ? a.modulo(s, i) : s, r = this.slides[o];
            r && (n = n.concat(r.getCellElements()))
        }
        return n
    }, p.queryCell = function (t) {
        if ("number" == typeof t) return this.cells[t];
        if ("string" == typeof t) {
            if (t.match(/^[#\.]?[\d\/]/)) return;
            t = this.element.querySelector(t)
        }
        return this.getCell(t)
    }, p.uiChange = function () {
        this.emitEvent("uiChange")
    }, p.childUIPointerDown = function (t) {
        "touchstart" != t.type && t.preventDefault(), this.focus()
    }, p.onresize = function () {
        this.watchCSS(), this.resize()
    }, a.debounceMethod(f, "onresize", 150), p.resize = function () {
        if (this.isActive) {
            this.getSize(), this.options.wrapAround && (this.x = a.modulo(this.x, this.slideableWidth)), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize(), this.emitEvent("resize");
            var t = this.selectedElements && this.selectedElements[0];
            this.selectCell(t, !1, !0)
        }
    }, p.watchCSS = function () {
        this.options.watchCSS && (-1 != o(this.element, ":after").content.indexOf("flickity") ? this.activate() : this.deactivate())
    }, p.onkeydown = function (t) {
        var e = document.activeElement && document.activeElement != this.element;
        if (this.options.accessibility && !e) {
            var i = f.keyboardHandlers[t.keyCode];
            i && i.call(this)
        }
    }, f.keyboardHandlers = {
        37: function () {
            var t = this.options.rightToLeft ? "next" : "previous";
            this.uiChange(), this[t]()
        }, 39: function () {
            var t = this.options.rightToLeft ? "previous" : "next";
            this.uiChange(), this[t]()
        }
    }, p.focus = function () {
        var t = n.pageYOffset;
        this.element.focus({preventScroll: !0}), n.pageYOffset != t && n.scrollTo(n.pageXOffset, t)
    }, p.deactivate = function () {
        this.isActive && (this.element.classList.remove("flickity-enabled"), this.element.classList.remove("flickity-rtl"), this.unselectSelectedSlide(), this.cells.forEach(function (t) {
            t.destroy()
        }), this.element.removeChild(this.viewport), c(this.slider.children, this.element), this.options.accessibility && (this.element.removeAttribute("tabIndex"), this.element.removeEventListener("keydown", this)), this.isActive = !1, this.emitEvent("deactivate"))
    }, p.destroy = function () {
        this.deactivate(), n.removeEventListener("resize", this), this.allOff(), this.emitEvent("destroy"), l && this.$element && l.removeData(this.element, "flickity"), delete this.element.flickityGUID, delete u[this.guid]
    }, a.extend(p, s), f.data = function (t) {
        var e = (t = a.getQueryElement(t)) && t.flickityGUID;
        return e && u[e]
    }, a.htmlInit(f, "flickity"), l && l.bridget && l.bridget("flickity", f), f.setJQuery = function (t) {
        l = t
    }, f.Cell = i, f.Slide = r, f
}), function (e, i) {
    "function" == typeof define && define.amd ? define("unipointer/unipointer", ["ev-emitter/ev-emitter"], function (t) {
        return i(e, t)
    }) : "object" == typeof module && module.exports ? module.exports = i(e, require("ev-emitter")) : e.Unipointer = i(e, e.EvEmitter)
}(window, function (s, t) {
    function e() {
    }

    var i = e.prototype = Object.create(t.prototype);
    i.bindStartEvent = function (t) {
        this._bindStartEvent(t, !0)
    }, i.unbindStartEvent = function (t) {
        this._bindStartEvent(t, !1)
    }, i._bindStartEvent = function (t, e) {
        var i = (e = void 0 === e || e) ? "addEventListener" : "removeEventListener", n = "mousedown";
        s.PointerEvent ? n = "pointerdown" : "ontouchstart" in s && (n = "touchstart"), t[i](n, this)
    }, i.handleEvent = function (t) {
        var e = "on" + t.type;
        this[e] && this[e](t)
    }, i.getTouch = function (t) {
        for (var e = 0; e < t.length; e++) {
            var i = t[e];
            if (i.identifier == this.pointerIdentifier) return i
        }
    }, i.onmousedown = function (t) {
        var e = t.button;
        e && 0 !== e && 1 !== e || this._pointerDown(t, t)
    }, i.ontouchstart = function (t) {
        this._pointerDown(t, t.changedTouches[0])
    }, i.onpointerdown = function (t) {
        this._pointerDown(t, t)
    }, i._pointerDown = function (t, e) {
        t.button || this.isPointerDown || (this.isPointerDown = !0, this.pointerIdentifier = void 0 !== e.pointerId ? e.pointerId : e.identifier, this.pointerDown(t, e))
    }, i.pointerDown = function (t, e) {
        this._bindPostStartEvents(t), this.emitEvent("pointerDown", [t, e])
    };
    var n = {
        mousedown: ["mousemove", "mouseup"],
        touchstart: ["touchmove", "touchend", "touchcancel"],
        pointerdown: ["pointermove", "pointerup", "pointercancel"]
    };
    return i._bindPostStartEvents = function (t) {
        if (t) {
            var e = n[t.type];
            e.forEach(function (t) {
                s.addEventListener(t, this)
            }, this), this._boundPointerEvents = e
        }
    }, i._unbindPostStartEvents = function () {
        this._boundPointerEvents && (this._boundPointerEvents.forEach(function (t) {
            s.removeEventListener(t, this)
        }, this), delete this._boundPointerEvents)
    }, i.onmousemove = function (t) {
        this._pointerMove(t, t)
    }, i.onpointermove = function (t) {
        t.pointerId == this.pointerIdentifier && this._pointerMove(t, t)
    }, i.ontouchmove = function (t) {
        var e = this.getTouch(t.changedTouches);
        e && this._pointerMove(t, e)
    }, i._pointerMove = function (t, e) {
        this.pointerMove(t, e)
    }, i.pointerMove = function (t, e) {
        this.emitEvent("pointerMove", [t, e])
    }, i.onmouseup = function (t) {
        this._pointerUp(t, t)
    }, i.onpointerup = function (t) {
        t.pointerId == this.pointerIdentifier && this._pointerUp(t, t)
    }, i.ontouchend = function (t) {
        var e = this.getTouch(t.changedTouches);
        e && this._pointerUp(t, e)
    }, i._pointerUp = function (t, e) {
        this._pointerDone(), this.pointerUp(t, e)
    }, i.pointerUp = function (t, e) {
        this.emitEvent("pointerUp", [t, e])
    }, i._pointerDone = function () {
        this._pointerReset(), this._unbindPostStartEvents(), this.pointerDone()
    }, i._pointerReset = function () {
        this.isPointerDown = !1, delete this.pointerIdentifier
    }, i.pointerDone = function () {
    }, i.onpointercancel = function (t) {
        t.pointerId == this.pointerIdentifier && this._pointerCancel(t, t)
    }, i.ontouchcancel = function (t) {
        var e = this.getTouch(t.changedTouches);
        e && this._pointerCancel(t, e)
    }, i._pointerCancel = function (t, e) {
        this._pointerDone(), this.pointerCancel(t, e)
    }, i.pointerCancel = function (t, e) {
        this.emitEvent("pointerCancel", [t, e])
    }, e.getPointerPoint = function (t) {
        return {x: t.pageX, y: t.pageY}
    }, e
}), function (e, i) {
    "function" == typeof define && define.amd ? define("unidragger/unidragger", ["unipointer/unipointer"], function (t) {
        return i(e, t)
    }) : "object" == typeof module && module.exports ? module.exports = i(e, require("unipointer")) : e.Unidragger = i(e, e.Unipointer)
}(window, function (o, t) {
    function e() {
    }

    var i = e.prototype = Object.create(t.prototype);
    i.bindHandles = function () {
        this._bindHandles(!0)
    }, i.unbindHandles = function () {
        this._bindHandles(!1)
    }, i._bindHandles = function (t) {
        for (var e = (t = void 0 === t || t) ? "addEventListener" : "removeEventListener", i = t ? this._touchActionValue : "", n = 0; n < this.handles.length; n++) {
            var s = this.handles[n];
            this._bindStartEvent(s, t), s[e]("click", this), o.PointerEvent && (s.style.touchAction = i)
        }
    }, i._touchActionValue = "none", i.pointerDown = function (t, e) {
        this.okayPointerDown(t) && (this.pointerDownPointer = e, t.preventDefault(), this.pointerDownBlur(), this._bindPostStartEvents(t), this.emitEvent("pointerDown", [t, e]))
    };
    var s = {TEXTAREA: !0, INPUT: !0, SELECT: !0, OPTION: !0},
        r = {radio: !0, checkbox: !0, button: !0, submit: !0, image: !0, file: !0};
    return i.okayPointerDown = function (t) {
        var e = s[t.target.nodeName], i = r[t.target.type], n = !e || i;
        return n || this._pointerReset(), n
    }, i.pointerDownBlur = function () {
        var t = document.activeElement;
        t && t.blur && t != document.body && t.blur()
    }, i.pointerMove = function (t, e) {
        var i = this._dragPointerMove(t, e);
        this.emitEvent("pointerMove", [t, e, i]), this._dragMove(t, e, i)
    }, i._dragPointerMove = function (t, e) {
        var i = {x: e.pageX - this.pointerDownPointer.pageX, y: e.pageY - this.pointerDownPointer.pageY};
        return !this.isDragging && this.hasDragStarted(i) && this._dragStart(t, e), i
    }, i.hasDragStarted = function (t) {
        return 3 < Math.abs(t.x) || 3 < Math.abs(t.y)
    }, i.pointerUp = function (t, e) {
        this.emitEvent("pointerUp", [t, e]), this._dragPointerUp(t, e)
    }, i._dragPointerUp = function (t, e) {
        this.isDragging ? this._dragEnd(t, e) : this._staticClick(t, e)
    }, i._dragStart = function (t, e) {
        this.isDragging = !0, this.isPreventingClicks = !0, this.dragStart(t, e)
    }, i.dragStart = function (t, e) {
        this.emitEvent("dragStart", [t, e])
    }, i._dragMove = function (t, e, i) {
        this.isDragging && this.dragMove(t, e, i)
    }, i.dragMove = function (t, e, i) {
        t.preventDefault(), this.emitEvent("dragMove", [t, e, i])
    }, i._dragEnd = function (t, e) {
        this.isDragging = !1, setTimeout(function () {
            delete this.isPreventingClicks
        }.bind(this)), this.dragEnd(t, e)
    }, i.dragEnd = function (t, e) {
        this.emitEvent("dragEnd", [t, e])
    }, i.onclick = function (t) {
        this.isPreventingClicks && t.preventDefault()
    }, i._staticClick = function (t, e) {
        this.isIgnoringMouseUp && "mouseup" == t.type || (this.staticClick(t, e), "mouseup" != t.type && (this.isIgnoringMouseUp = !0, setTimeout(function () {
            delete this.isIgnoringMouseUp
        }.bind(this), 400)))
    }, i.staticClick = function (t, e) {
        this.emitEvent("staticClick", [t, e])
    }, e.getPointerPoint = t.getPointerPoint, e
}), function (n, s) {
    "function" == typeof define && define.amd ? define("flickity/js/drag", ["./flickity", "unidragger/unidragger", "fizzy-ui-utils/utils"], function (t, e, i) {
        return s(n, t, e, i)
    }) : "object" == typeof module && module.exports ? module.exports = s(n, require("./flickity"), require("unidragger"), require("fizzy-ui-utils")) : n.Flickity = s(n, n.Flickity, n.Unidragger, n.fizzyUIUtils)
}(window, function (i, t, e, a) {
    a.extend(t.defaults, {draggable: ">1", dragThreshold: 3}), t.createMethods.push("_createDrag");
    var n = t.prototype;
    a.extend(n, e.prototype), n._touchActionValue = "pan-y";
    var s = "createTouch" in document, o = !1;
    n._createDrag = function () {
        this.on("activate", this.onActivateDrag), this.on("uiChange", this._uiChangeDrag), this.on("deactivate", this.onDeactivateDrag), this.on("cellChange", this.updateDraggable), s && !o && (i.addEventListener("touchmove", function () {
        }), o = !0)
    }, n.onActivateDrag = function () {
        this.handles = [this.viewport], this.bindHandles(), this.updateDraggable()
    }, n.onDeactivateDrag = function () {
        this.unbindHandles(), this.element.classList.remove("is-draggable")
    }, n.updateDraggable = function () {
        ">1" == this.options.draggable ? this.isDraggable = 1 < this.slides.length : this.isDraggable = this.options.draggable, this.isDraggable ? this.element.classList.add("is-draggable") : this.element.classList.remove("is-draggable")
    }, n.bindDrag = function () {
        this.options.draggable = !0, this.updateDraggable()
    }, n.unbindDrag = function () {
        this.options.draggable = !1, this.updateDraggable()
    }, n._uiChangeDrag = function () {
        delete this.isFreeScrolling
    }, n.pointerDown = function (t, e) {
        this.isDraggable ? this.okayPointerDown(t) && (this._pointerDownPreventDefault(t), this.pointerDownFocus(t), document.activeElement != this.element && this.pointerDownBlur(), this.dragX = this.x, this.viewport.classList.add("is-pointer-down"), this.pointerDownScroll = l(), i.addEventListener("scroll", this), this._pointerDownDefault(t, e)) : this._pointerDownDefault(t, e)
    }, n._pointerDownDefault = function (t, e) {
        this.pointerDownPointer = {
            pageX: e.pageX,
            pageY: e.pageY
        }, this._bindPostStartEvents(t), this.dispatchEvent("pointerDown", t, [e])
    };
    var r = {INPUT: !0, TEXTAREA: !0, SELECT: !0};

    function l() {
        return {x: i.pageXOffset, y: i.pageYOffset}
    }

    return n.pointerDownFocus = function (t) {
        r[t.target.nodeName] || this.focus()
    }, n._pointerDownPreventDefault = function (t) {
        var e = "touchstart" == t.type, i = "touch" == t.pointerType, n = r[t.target.nodeName];
        e || i || n || t.preventDefault()
    }, n.hasDragStarted = function (t) {
        return Math.abs(t.x) > this.options.dragThreshold
    }, n.pointerUp = function (t, e) {
        delete this.isTouchScrolling, this.viewport.classList.remove("is-pointer-down"), this.dispatchEvent("pointerUp", t, [e]), this._dragPointerUp(t, e)
    }, n.pointerDone = function () {
        i.removeEventListener("scroll", this), delete this.pointerDownScroll
    }, n.dragStart = function (t, e) {
        this.isDraggable && (this.dragStartPosition = this.x, this.startAnimation(), i.removeEventListener("scroll", this), this.dispatchEvent("dragStart", t, [e]))
    }, n.pointerMove = function (t, e) {
        var i = this._dragPointerMove(t, e);
        this.dispatchEvent("pointerMove", t, [e, i]), this._dragMove(t, e, i)
    }, n.dragMove = function (t, e, i) {
        if (this.isDraggable) {
            t.preventDefault();
            var n = this.options.rightToLeft ? -1 : 1;
            this.options.wrapAround && (i.x = i.x % this.slideableWidth);
            var s = this.dragStartPosition + i.x * n;
            if (!this.options.wrapAround && this.slides.length) {
                var o = Math.max(-this.slides[0].target, this.dragStartPosition);
                s = o < s ? .5 * (s + o) : s;
                var r = Math.min(-this.getLastSlide().target, this.dragStartPosition);
                s = s < r ? .5 * (s + r) : s
            }
            this.dragX !== s && (this.previousDragX = this.dragX), this.dragX = s, this.dragMoveTime = new Date, this.dispatchEvent("dragMove", t, [e, i])
        }
    }, n.dragEnd = function (t, e) {
        if (this.isDraggable) {
            this.options.freeScroll && (this.isFreeScrolling = !0);
            var i = this.dragEndRestingSelect();
            if (this.options.freeScroll && !this.options.wrapAround) {
                var n = this.getRestingPosition();
                this.isFreeScrolling = -n > this.slides[0].target && -n < this.getLastSlide().target
            } else this.options.freeScroll || i != this.selectedIndex || (i += this.dragEndBoostSelect());
            delete this.previousDragX, this.isDragSelect = this.options.wrapAround, this.select(i), delete this.isDragSelect, this.dispatchEvent("dragEnd", t, [e])
        }
    }, n.dragEndRestingSelect = function () {
        var t = this.getRestingPosition(), e = Math.abs(this.getSlideDistance(-t, this.selectedIndex)),
            i = this._getClosestResting(t, e, 1), n = this._getClosestResting(t, e, -1);
        return i.distance < n.distance ? i.index : n.index
    }, n._getClosestResting = function (t, e, i) {
        for (var n = this.selectedIndex, s = 1 / 0, o = this.options.contain && !this.options.wrapAround ? function (t, e) {
            return t <= e
        } : function (t, e) {
            return t < e
        }; o(e, s) && (n += i, s = e, null !== (e = this.getSlideDistance(-t, n)));) e = Math.abs(e);
        return {distance: s, index: n - i}
    }, n.getSlideDistance = function (t, e) {
        var i = this.slides.length, n = this.options.wrapAround && 1 < i, s = n ? a.modulo(e, i) : e,
            o = this.slides[s];
        if (!o) return null;
        var r = n ? this.slideableWidth * Math.floor(e / i) : 0;
        return t - (o.target + r)
    }, n.dragEndBoostSelect = function () {
        if (void 0 === this.previousDragX || !this.dragMoveTime || 100 < new Date - this.dragMoveTime) return 0;
        var t = this.getSlideDistance(-this.dragX, this.selectedIndex), e = this.previousDragX - this.dragX;
        return 0 < t && 0 < e ? 1 : t < 0 && e < 0 ? -1 : 0
    }, n.staticClick = function (t, e) {
        var i = this.getParentCell(t.target), n = i && i.element, s = i && this.cells.indexOf(i);
        this.dispatchEvent("staticClick", t, [e, n, s])
    }, n.onscroll = function () {
        var t = l(), e = this.pointerDownScroll.x - t.x, i = this.pointerDownScroll.y - t.y;
        (3 < Math.abs(e) || 3 < Math.abs(i)) && this._pointerDone()
    }, t
}), function (n, s) {
    "function" == typeof define && define.amd ? define("flickity/js/prev-next-button", ["./flickity", "unipointer/unipointer", "fizzy-ui-utils/utils"], function (t, e, i) {
        return s(n, t, e, i)
    }) : "object" == typeof module && module.exports ? module.exports = s(n, require("./flickity"), require("unipointer"), require("fizzy-ui-utils")) : s(n, n.Flickity, n.Unipointer, n.fizzyUIUtils)
}(window, function (t, e, i, n) {
    "use strict";
    var s = "http://www.w3.org/2000/svg";

    function o(t, e) {
        this.direction = t, this.parent = e, this._create()
    }

    (o.prototype = Object.create(i.prototype))._create = function () {
        this.isEnabled = !0, this.isPrevious = -1 == this.direction;
        var t = this.parent.options.rightToLeft ? 1 : -1;
        this.isLeft = this.direction == t;
        var e = this.element = document.createElement("button");
        e.className = "flickity-button flickity-prev-next-button", e.className += this.isPrevious ? " previous" : " next", e.setAttribute("type", "button"), this.disable(), e.setAttribute("aria-label", this.isPrevious ? "Previous" : "Next");
        var i = this.createSVG();
        e.appendChild(i), this.parent.on("select", this.update.bind(this)), this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent))
    }, o.prototype.activate = function () {
        this.bindStartEvent(this.element), this.element.addEventListener("click", this), this.parent.element.appendChild(this.element)
    }, o.prototype.deactivate = function () {
        this.parent.element.removeChild(this.element), this.unbindStartEvent(this.element), this.element.removeEventListener("click", this)
    }, o.prototype.createSVG = function () {
        var t = document.createElementNS(s, "svg");
        t.setAttribute("class", "flickity-button-icon"), t.setAttribute("viewBox", "0 0 100 100");
        var e, i = document.createElementNS(s, "path"),
            n = "string" != typeof (e = this.parent.options.arrowShape) ? "M " + e.x0 + ",50 L " + e.x1 + "," + (e.y1 + 50) + " L " + e.x2 + "," + (e.y2 + 50) + " L " + e.x3 + ",50  L " + e.x2 + "," + (50 - e.y2) + " L " + e.x1 + "," + (50 - e.y1) + " Z" : e;
        return i.setAttribute("d", n), i.setAttribute("class", "arrow"), this.isLeft || i.setAttribute("transform", "translate(100, 100) rotate(180) "), t.appendChild(i), t
    }, o.prototype.handleEvent = n.handleEvent, o.prototype.onclick = function () {
        if (this.isEnabled) {
            this.parent.uiChange();
            var t = this.isPrevious ? "previous" : "next";
            this.parent[t]()
        }
    }, o.prototype.enable = function () {
        this.isEnabled || (this.element.disabled = !1, this.isEnabled = !0)
    }, o.prototype.disable = function () {
        this.isEnabled && (this.element.disabled = !0, this.isEnabled = !1)
    }, o.prototype.update = function () {
        var t = this.parent.slides;
        if (this.parent.options.wrapAround && 1 < t.length) this.enable(); else {
            var e = t.length ? t.length - 1 : 0, i = this.isPrevious ? 0 : e;
            this[this.parent.selectedIndex == i ? "disable" : "enable"]()
        }
    }, o.prototype.destroy = function () {
        this.deactivate(), this.allOff()
    }, n.extend(e.defaults, {
        prevNextButtons: !0,
        arrowShape: {x0: 10, x1: 60, y1: 50, x2: 70, y2: 40, x3: 30}
    }), e.createMethods.push("_createPrevNextButtons");
    var r = e.prototype;
    return r._createPrevNextButtons = function () {
        this.options.prevNextButtons && (this.prevButton = new o(-1, this), this.nextButton = new o(1, this), this.on("activate", this.activatePrevNextButtons))
    }, r.activatePrevNextButtons = function () {
        this.prevButton.activate(), this.nextButton.activate(), this.on("deactivate", this.deactivatePrevNextButtons)
    }, r.deactivatePrevNextButtons = function () {
        this.prevButton.deactivate(), this.nextButton.deactivate(), this.off("deactivate", this.deactivatePrevNextButtons)
    }, e.PrevNextButton = o, e
}), function (n, s) {
    "function" == typeof define && define.amd ? define("flickity/js/page-dots", ["./flickity", "unipointer/unipointer", "fizzy-ui-utils/utils"], function (t, e, i) {
        return s(n, t, e, i)
    }) : "object" == typeof module && module.exports ? module.exports = s(n, require("./flickity"), require("unipointer"), require("fizzy-ui-utils")) : s(n, n.Flickity, n.Unipointer, n.fizzyUIUtils)
}(window, function (t, e, i, n) {
    function s(t) {
        this.parent = t, this._create()
    }

    (s.prototype = Object.create(i.prototype))._create = function () {
        this.holder = document.createElement("ol"), this.holder.className = "flickity-page-dots", this.dots = [], this.handleClick = this.onClick.bind(this), this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent))
    }, s.prototype.activate = function () {
        this.setDots(), this.holder.addEventListener("click", this.handleClick), this.bindStartEvent(this.holder), this.parent.element.appendChild(this.holder)
    }, s.prototype.deactivate = function () {
        this.holder.removeEventListener("click", this.handleClick), this.unbindStartEvent(this.holder), this.parent.element.removeChild(this.holder)
    }, s.prototype.setDots = function () {
        var t = this.parent.slides.length - this.dots.length;
        0 < t ? this.addDots(t) : t < 0 && this.removeDots(-t)
    }, s.prototype.addDots = function (t) {
        for (var e = document.createDocumentFragment(), i = [], n = this.dots.length, s = n + t, o = n; o < s; o++) {
            var r = document.createElement("li");
            r.className = "dot", r.setAttribute("aria-label", "Page dot " + (o + 1)), e.appendChild(r), i.push(r)
        }
        this.holder.appendChild(e), this.dots = this.dots.concat(i)
    }, s.prototype.removeDots = function (t) {
        this.dots.splice(this.dots.length - t, t).forEach(function (t) {
            this.holder.removeChild(t)
        }, this)
    }, s.prototype.updateSelected = function () {
        this.selectedDot && (this.selectedDot.className = "dot", this.selectedDot.removeAttribute("aria-current")), this.dots.length && (this.selectedDot = this.dots[this.parent.selectedIndex], this.selectedDot.className = "dot is-selected", this.selectedDot.setAttribute("aria-current", "step"))
    }, s.prototype.onTap = s.prototype.onClick = function (t) {
        var e = t.target;
        if ("LI" == e.nodeName) {
            this.parent.uiChange();
            var i = this.dots.indexOf(e);
            this.parent.select(i)
        }
    }, s.prototype.destroy = function () {
        this.deactivate(), this.allOff()
    }, e.PageDots = s, n.extend(e.defaults, {pageDots: !0}), e.createMethods.push("_createPageDots");
    var o = e.prototype;
    return o._createPageDots = function () {
        this.options.pageDots && (this.pageDots = new s(this), this.on("activate", this.activatePageDots), this.on("select", this.updateSelectedPageDots), this.on("cellChange", this.updatePageDots), this.on("resize", this.updatePageDots), this.on("deactivate", this.deactivatePageDots))
    }, o.activatePageDots = function () {
        this.pageDots.activate()
    }, o.updateSelectedPageDots = function () {
        this.pageDots.updateSelected()
    }, o.updatePageDots = function () {
        this.pageDots.setDots()
    }, o.deactivatePageDots = function () {
        this.pageDots.deactivate()
    }, e.PageDots = s, e
}), function (t, n) {
    "function" == typeof define && define.amd ? define("flickity/js/player", ["ev-emitter/ev-emitter", "fizzy-ui-utils/utils", "./flickity"], function (t, e, i) {
        return n(t, e, i)
    }) : "object" == typeof module && module.exports ? module.exports = n(require("ev-emitter"), require("fizzy-ui-utils"), require("./flickity")) : n(t.EvEmitter, t.fizzyUIUtils, t.Flickity)
}(window, function (t, e, i) {
    function n(t) {
        this.parent = t, this.state = "stopped", this.onVisibilityChange = this.visibilityChange.bind(this), this.onVisibilityPlay = this.visibilityPlay.bind(this)
    }

    (n.prototype = Object.create(t.prototype)).play = function () {
        "playing" != this.state && (document.hidden ? document.addEventListener("visibilitychange", this.onVisibilityPlay) : (this.state = "playing", document.addEventListener("visibilitychange", this.onVisibilityChange), this.tick()))
    }, n.prototype.tick = function () {
        if ("playing" == this.state) {
            var t = this.parent.options.autoPlay;
            t = "number" == typeof t ? t : 3e3;
            var e = this;
            this.clear(), this.timeout = setTimeout(function () {
                e.parent.next(!0), e.tick()
            }, t)
        }
    }, n.prototype.stop = function () {
        this.state = "stopped", this.clear(), document.removeEventListener("visibilitychange", this.onVisibilityChange)
    }, n.prototype.clear = function () {
        clearTimeout(this.timeout)
    }, n.prototype.pause = function () {
        "playing" == this.state && (this.state = "paused", this.clear())
    }, n.prototype.unpause = function () {
        "paused" == this.state && this.play()
    }, n.prototype.visibilityChange = function () {
        this[document.hidden ? "pause" : "unpause"]()
    }, n.prototype.visibilityPlay = function () {
        this.play(), document.removeEventListener("visibilitychange", this.onVisibilityPlay)
    }, e.extend(i.defaults, {pauseAutoPlayOnHover: !0}), i.createMethods.push("_createPlayer");
    var s = i.prototype;
    return s._createPlayer = function () {
        this.player = new n(this), this.on("activate", this.activatePlayer), this.on("uiChange", this.stopPlayer), this.on("pointerDown", this.stopPlayer), this.on("deactivate", this.deactivatePlayer)
    }, s.activatePlayer = function () {
        this.options.autoPlay && (this.player.play(), this.element.addEventListener("mouseenter", this))
    }, s.playPlayer = function () {
        this.player.play()
    }, s.stopPlayer = function () {
        this.player.stop()
    }, s.pausePlayer = function () {
        this.player.pause()
    }, s.unpausePlayer = function () {
        this.player.unpause()
    }, s.deactivatePlayer = function () {
        this.player.stop(), this.element.removeEventListener("mouseenter", this)
    }, s.onmouseenter = function () {
        this.options.pauseAutoPlayOnHover && (this.player.pause(), this.element.addEventListener("mouseleave", this))
    }, s.onmouseleave = function () {
        this.player.unpause(), this.element.removeEventListener("mouseleave", this)
    }, i.Player = n, i
}), function (i, n) {
    "function" == typeof define && define.amd ? define("flickity/js/add-remove-cell", ["./flickity", "fizzy-ui-utils/utils"], function (t, e) {
        return n(i, t, e)
    }) : "object" == typeof module && module.exports ? module.exports = n(i, require("./flickity"), require("fizzy-ui-utils")) : n(i, i.Flickity, i.fizzyUIUtils)
}(window, function (t, e, n) {
    var i = e.prototype;
    return i.insert = function (t, e) {
        var i = this._makeCells(t);
        if (i && i.length) {
            var n = this.cells.length;
            e = void 0 === e ? n : e;
            var s, o, r = (s = i, o = document.createDocumentFragment(), s.forEach(function (t) {
                o.appendChild(t.element)
            }), o), a = e == n;
            if (a) this.slider.appendChild(r); else {
                var l = this.cells[e].element;
                this.slider.insertBefore(r, l)
            }
            if (0 === e) this.cells = i.concat(this.cells); else if (a) this.cells = this.cells.concat(i); else {
                var h = this.cells.splice(e, n - e);
                this.cells = this.cells.concat(i).concat(h)
            }
            this._sizeCells(i), this.cellChange(e, !0)
        }
    }, i.append = function (t) {
        this.insert(t, this.cells.length)
    }, i.prepend = function (t) {
        this.insert(t, 0)
    }, i.remove = function (t) {
        var e = this.getCells(t);
        if (e && e.length) {
            var i = this.cells.length - 1;
            e.forEach(function (t) {
                t.remove();
                var e = this.cells.indexOf(t);
                i = Math.min(e, i), n.removeFrom(this.cells, t)
            }, this), this.cellChange(i, !0)
        }
    }, i.cellSizeChange = function (t) {
        var e = this.getCell(t);
        if (e) {
            e.getSize();
            var i = this.cells.indexOf(e);
            this.cellChange(i)
        }
    }, i.cellChange = function (t, e) {
        var i = this.selectedElement;
        this._positionCells(t), this._getWrapShiftCells(), this.setGallerySize();
        var n = this.getCell(i);
        n && (this.selectedIndex = this.getCellSlideIndex(n)), this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex), this.emitEvent("cellChange", [t]), this.select(this.selectedIndex), e && this.positionSliderAtSelected()
    }, e
}), function (i, n) {
    "function" == typeof define && define.amd ? define("flickity/js/lazyload", ["./flickity", "fizzy-ui-utils/utils"], function (t, e) {
        return n(i, t, e)
    }) : "object" == typeof module && module.exports ? module.exports = n(i, require("./flickity"), require("fizzy-ui-utils")) : n(i, i.Flickity, i.fizzyUIUtils)
}(window, function (t, e, o) {
    "use strict";
    e.createMethods.push("_createLazyload");
    var i = e.prototype;

    function s(t, e) {
        this.img = t, this.flickity = e, this.load()
    }

    return i._createLazyload = function () {
        this.on("select", this.lazyLoad)
    }, i.lazyLoad = function () {
        var t = this.options.lazyLoad;
        if (t) {
            var e = "number" == typeof t ? t : 0, i = this.getAdjacentCellElements(e), n = [];
            i.forEach(function (t) {
                var e = function (t) {
                    if ("IMG" == t.nodeName) {
                        var e = t.getAttribute("data-flickity-lazyload"),
                            i = t.getAttribute("data-flickity-lazyload-src"),
                            n = t.getAttribute("data-flickity-lazyload-srcset");
                        if (e || i || n) return [t]
                    }
                    var s = t.querySelectorAll("img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]");
                    return o.makeArray(s)
                }(t);
                n = n.concat(e)
            }), n.forEach(function (t) {
                new s(t, this)
            }, this)
        }
    }, s.prototype.handleEvent = o.handleEvent, s.prototype.load = function () {
        this.img.addEventListener("load", this), this.img.addEventListener("error", this);
        var t = this.img.getAttribute("data-flickity-lazyload") || this.img.getAttribute("data-flickity-lazyload-src"),
            e = this.img.getAttribute("data-flickity-lazyload-srcset");
        this.img.src = t, e && this.img.setAttribute("srcset", e), this.img.removeAttribute("data-flickity-lazyload"), this.img.removeAttribute("data-flickity-lazyload-src"), this.img.removeAttribute("data-flickity-lazyload-srcset")
    }, s.prototype.onload = function (t) {
        this.complete(t, "flickity-lazyloaded")
    }, s.prototype.onerror = function (t) {
        this.complete(t, "flickity-lazyerror")
    }, s.prototype.complete = function (t, e) {
        this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
        var i = this.flickity.getParentCell(this.img), n = i && i.element;
        this.flickity.cellSizeChange(n), this.img.classList.add(e), this.flickity.dispatchEvent("lazyLoad", t, n)
    }, e.LazyLoader = s, e
}), function (t) {
    "function" == typeof define && define.amd ? define("flickity/js/index", ["./flickity", "./drag", "./prev-next-button", "./page-dots", "./player", "./add-remove-cell", "./lazyload"], t) : "object" == typeof module && module.exports && (module.exports = t(require("./flickity"), require("./drag"), require("./prev-next-button"), require("./page-dots"), require("./player"), require("./add-remove-cell"), require("./lazyload")))
}((window, function (t) {
    return t
})), function (t, e) {
    "function" == typeof define && define.amd ? define("flickity-as-nav-for/as-nav-for", ["flickity/js/index", "fizzy-ui-utils/utils"], e) : "object" == typeof module && module.exports ? module.exports = e(require("flickity"), require("fizzy-ui-utils")) : t.Flickity = e(t.Flickity, t.fizzyUIUtils)
}(window, function (n, s) {
    n.createMethods.push("_createAsNavFor");
    var t = n.prototype;
    return t._createAsNavFor = function () {
        this.on("activate", this.activateAsNavFor), this.on("deactivate", this.deactivateAsNavFor), this.on("destroy", this.destroyAsNavFor);
        var t = this.options.asNavFor;
        if (t) {
            var e = this;
            setTimeout(function () {
                e.setNavCompanion(t)
            })
        }
    }, t.setNavCompanion = function (t) {
        t = s.getQueryElement(t);
        var e = n.data(t);
        if (e && e != this) {
            this.navCompanion = e;
            var i = this;
            this.onNavCompanionSelect = function () {
                i.navCompanionSelect()
            }, e.on("select", this.onNavCompanionSelect), this.on("staticClick", this.onNavStaticClick), this.navCompanionSelect(!0)
        }
    }, t.navCompanionSelect = function (t) {
        var e = this.navCompanion && this.navCompanion.selectedCells;
        if (e) {
            var i, n, s, o = e[0], r = this.navCompanion.cells.indexOf(o), a = r + e.length - 1,
                l = Math.floor((i = r, n = a, s = this.navCompanion.cellAlign, (n - i) * s + i));
            if (this.selectCell(l, !1, t), this.removeNavSelectedElements(), !(l >= this.cells.length)) {
                var h = this.cells.slice(r, 1 + a);
                this.navSelectedElements = h.map(function (t) {
                    return t.element
                }), this.changeNavSelectedClass("add")
            }
        }
    }, t.changeNavSelectedClass = function (e) {
        this.navSelectedElements.forEach(function (t) {
            t.classList[e]("is-nav-selected")
        })
    }, t.activateAsNavFor = function () {
        this.navCompanionSelect(!0)
    }, t.removeNavSelectedElements = function () {
        this.navSelectedElements && (this.changeNavSelectedClass("remove"), delete this.navSelectedElements)
    }, t.onNavStaticClick = function (t, e, i, n) {
        "number" == typeof n && this.navCompanion.selectCell(n)
    }, t.deactivateAsNavFor = function () {
        this.removeNavSelectedElements()
    }, t.destroyAsNavFor = function () {
        this.navCompanion && (this.navCompanion.off("select", this.onNavCompanionSelect), this.off("staticClick", this.onNavStaticClick), delete this.navCompanion)
    }, n
}), function (e, i) {
    "use strict";
    "function" == typeof define && define.amd ? define("imagesloaded/imagesloaded", ["ev-emitter/ev-emitter"], function (t) {
        return i(e, t)
    }) : "object" == typeof module && module.exports ? module.exports = i(e, require("ev-emitter")) : e.imagesLoaded = i(e, e.EvEmitter)
}("undefined" != typeof window ? window : this, function (e, t) {
    var o = e.jQuery, r = e.console;

    function a(t, e) {
        for (var i in e) t[i] = e[i];
        return t
    }

    var l = Array.prototype.slice;

    function h(t, e, i) {
        if (!(this instanceof h)) return new h(t, e, i);
        var n, s = t;
        ("string" == typeof t && (s = document.querySelectorAll(t)), s) ? (this.elements = (n = s, Array.isArray(n) ? n : "object" == typeof n && "number" == typeof n.length ? l.call(n) : [n]), this.options = a({}, this.options), "function" == typeof e ? i = e : a(this.options, e), i && this.on("always", i), this.getImages(), o && (this.jqDeferred = new o.Deferred), setTimeout(this.check.bind(this))) : r.error("Bad element for imagesLoaded " + (s || t))
    }

    (h.prototype = Object.create(t.prototype)).options = {}, h.prototype.getImages = function () {
        this.images = [], this.elements.forEach(this.addElementImages, this)
    }, h.prototype.addElementImages = function (t) {
        "IMG" == t.nodeName && this.addImage(t), !0 === this.options.background && this.addElementBackgroundImages(t);
        var e = t.nodeType;
        if (e && c[e]) {
            for (var i = t.querySelectorAll("img"), n = 0; n < i.length; n++) {
                var s = i[n];
                this.addImage(s)
            }
            if ("string" == typeof this.options.background) {
                var o = t.querySelectorAll(this.options.background);
                for (n = 0; n < o.length; n++) {
                    var r = o[n];
                    this.addElementBackgroundImages(r)
                }
            }
        }
    };
    var c = {1: !0, 9: !0, 11: !0};

    function i(t) {
        this.img = t
    }

    function n(t, e) {
        this.url = t, this.element = e, this.img = new Image
    }

    return h.prototype.addElementBackgroundImages = function (t) {
        var e = getComputedStyle(t);
        if (e) for (var i = /url\((['"])?(.*?)\1\)/gi, n = i.exec(e.backgroundImage); null !== n;) {
            var s = n && n[2];
            s && this.addBackground(s, t), n = i.exec(e.backgroundImage)
        }
    }, h.prototype.addImage = function (t) {
        var e = new i(t);
        this.images.push(e)
    }, h.prototype.addBackground = function (t, e) {
        var i = new n(t, e);
        this.images.push(i)
    }, h.prototype.check = function () {
        var n = this;

        function e(t, e, i) {
            setTimeout(function () {
                n.progress(t, e, i)
            })
        }

        this.progressedCount = 0, this.hasAnyBroken = !1, this.images.length ? this.images.forEach(function (t) {
            t.once("progress", e), t.check()
        }) : this.complete()
    }, h.prototype.progress = function (t, e, i) {
        this.progressedCount++, this.hasAnyBroken = this.hasAnyBroken || !t.isLoaded, this.emitEvent("progress", [this, t, e]), this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, t), this.progressedCount == this.images.length && this.complete(), this.options.debug && r && r.log("progress: " + i, t, e)
    }, h.prototype.complete = function () {
        var t = this.hasAnyBroken ? "fail" : "done";
        if (this.isComplete = !0, this.emitEvent(t, [this]), this.emitEvent("always", [this]), this.jqDeferred) {
            var e = this.hasAnyBroken ? "reject" : "resolve";
            this.jqDeferred[e](this)
        }
    }, (i.prototype = Object.create(t.prototype)).check = function () {
        this.getIsImageComplete() ? this.confirm(0 !== this.img.naturalWidth, "naturalWidth") : (this.proxyImage = new Image, this.proxyImage.addEventListener("load", this), this.proxyImage.addEventListener("error", this), this.img.addEventListener("load", this), this.img.addEventListener("error", this), this.proxyImage.src = this.img.src)
    }, i.prototype.getIsImageComplete = function () {
        return this.img.complete && this.img.naturalWidth
    }, i.prototype.confirm = function (t, e) {
        this.isLoaded = t, this.emitEvent("progress", [this, this.img, e])
    }, i.prototype.handleEvent = function (t) {
        var e = "on" + t.type;
        this[e] && this[e](t)
    }, i.prototype.onload = function () {
        this.confirm(!0, "onload"), this.unbindEvents()
    }, i.prototype.onerror = function () {
        this.confirm(!1, "onerror"), this.unbindEvents()
    }, i.prototype.unbindEvents = function () {
        this.proxyImage.removeEventListener("load", this), this.proxyImage.removeEventListener("error", this), this.img.removeEventListener("load", this), this.img.removeEventListener("error", this)
    }, (n.prototype = Object.create(i.prototype)).check = function () {
        this.img.addEventListener("load", this), this.img.addEventListener("error", this), this.img.src = this.url, this.getIsImageComplete() && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), this.unbindEvents())
    }, n.prototype.unbindEvents = function () {
        this.img.removeEventListener("load", this), this.img.removeEventListener("error", this)
    }, n.prototype.confirm = function (t, e) {
        this.isLoaded = t, this.emitEvent("progress", [this, this.element, e])
    }, (h.makeJQueryPlugin = function (t) {
        (t = t || e.jQuery) && ((o = t).fn.imagesLoaded = function (t, e) {
            return new h(this, t, e).jqDeferred.promise(o(this))
        })
    })(), h
}), function (i, n) {
    "function" == typeof define && define.amd ? define(["flickity/js/index", "imagesloaded/imagesloaded"], function (t, e) {
        return n(i, t, e)
    }) : "object" == typeof module && module.exports ? module.exports = n(i, require("flickity"), require("imagesloaded")) : i.Flickity = n(i, i.Flickity, i.imagesLoaded)
}(window, function (t, e, i) {
    "use strict";
    e.createMethods.push("_createImagesLoaded");
    var n = e.prototype;
    return n._createImagesLoaded = function () {
        this.on("activate", this.imagesLoaded)
    }, n.imagesLoaded = function () {
        if (this.options.imagesLoaded) {
            var n = this;
            i(this.slider).on("progress", function (t, e) {
                var i = n.getParentCell(e.img);
                n.cellSizeChange(i && i.element), n.options.freeScroll || n.positionSliderAtSelected()
            })
        }
    }, e
});

/*
	 _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
				   |__/

 Version: 1.9.0
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
	Docs: http://kenwheeler.github.io/slick
	Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
(function (i) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], i) : "undefined" != typeof exports ? module.exports = i(require("jquery")) : i(jQuery)
})(function (i) {
    "use strict";
    var e = window.Slick || {};
    e = function () {
        function e(e, o) {
            var s, n = this;
            n.defaults = {
                accessibility: !0,
                adaptiveHeight: !1,
                appendArrows: i(e),
                appendDots: i(e),
                arrows: !0,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: !1,
                autoplaySpeed: 3e3,
                centerMode: !1,
                centerPadding: "50px",
                cssEase: "ease",
                customPaging: function (e, t) {
                    return i('<button type="button" />').text(t + 1)
                },
                dots: !1,
                dotsClass: "slick-dots",
                draggable: !0,
                easing: "linear",
                edgeFriction: .35,
                fade: !1,
                focusOnSelect: !1,
                focusOnChange: !1,
                infinite: !0,
                initialSlide: 0,
                lazyLoad: "ondemand",
                mobileFirst: !1,
                pauseOnHover: !0,
                pauseOnFocus: !0,
                pauseOnDotsHover: !1,
                respondTo: "window",
                responsive: null,
                rows: 1,
                rtl: !1,
                slide: "",
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: !0,
                swipeToSlide: !1,
                touchMove: !0,
                touchThreshold: 5,
                useCSS: !0,
                useTransform: !0,
                variableWidth: !1,
                vertical: !1,
                verticalSwiping: !1,
                waitForAnimate: !0,
                zIndex: 1e3
            }, n.initials = {
                animating: !1,
                dragging: !1,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: !1,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: !1,
                slideOffset: 0,
                swipeLeft: null,
                swiping: !1,
                $list: null,
                touchObject: {},
                transformsEnabled: !1,
                unslicked: !1
            }, i.extend(n, n.initials), n.activeBreakpoint = null, n.animType = null, n.animProp = null, n.breakpoints = [], n.breakpointSettings = [], n.cssTransitions = !1, n.focussed = !1, n.interrupted = !1, n.hidden = "hidden", n.paused = !0, n.positionProp = null, n.respondTo = null, n.rowCount = 1, n.shouldClick = !0, n.$slider = i(e), n.$slidesCache = null, n.transformType = null, n.transitionType = null, n.visibilityChange = "visibilitychange", n.windowWidth = 0, n.windowTimer = null, s = i(e).data("slick") || {}, n.options = i.extend({}, n.defaults, o, s), n.currentSlide = n.options.initialSlide, n.originalSettings = n.options, "undefined" != typeof document.mozHidden ? (n.hidden = "mozHidden", n.visibilityChange = "mozvisibilitychange") : "undefined" != typeof document.webkitHidden && (n.hidden = "webkitHidden", n.visibilityChange = "webkitvisibilitychange"), n.autoPlay = i.proxy(n.autoPlay, n), n.autoPlayClear = i.proxy(n.autoPlayClear, n), n.autoPlayIterator = i.proxy(n.autoPlayIterator, n), n.changeSlide = i.proxy(n.changeSlide, n), n.clickHandler = i.proxy(n.clickHandler, n), n.selectHandler = i.proxy(n.selectHandler, n), n.setPosition = i.proxy(n.setPosition, n), n.swipeHandler = i.proxy(n.swipeHandler, n), n.dragHandler = i.proxy(n.dragHandler, n), n.keyHandler = i.proxy(n.keyHandler, n), n.instanceUid = t++, n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, n.registerBreakpoints(), n.init(!0)
        }

        var t = 0;
        return e
    }(), e.prototype.activateADA = function () {
        var i = this;
        i.$slideTrack.find(".slick-active").attr({"aria-hidden": "false"}).find("a, input, button, select").attr({tabindex: "0"})
    }, e.prototype.addSlide = e.prototype.slickAdd = function (e, t, o) {
        var s = this;
        if ("boolean" == typeof t) o = t, t = null; else if (t < 0 || t >= s.slideCount) return !1;
        s.unload(), "number" == typeof t ? 0 === t && 0 === s.$slides.length ? i(e).appendTo(s.$slideTrack) : o ? i(e).insertBefore(s.$slides.eq(t)) : i(e).insertAfter(s.$slides.eq(t)) : o === !0 ? i(e).prependTo(s.$slideTrack) : i(e).appendTo(s.$slideTrack), s.$slides = s.$slideTrack.children(this.options.slide), s.$slideTrack.children(this.options.slide).detach(), s.$slideTrack.append(s.$slides), s.$slides.each(function (e, t) {
            i(t).attr("data-slick-index", e)
        }), s.$slidesCache = s.$slides, s.reinit()
    }, e.prototype.animateHeight = function () {
        var i = this;
        if (1 === i.options.slidesToShow && i.options.adaptiveHeight === !0 && i.options.vertical === !1) {
            var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
            i.$list.animate({height: e}, i.options.speed)
        }
    }, e.prototype.animateSlide = function (e, t) {
        var o = {}, s = this;
        s.animateHeight(), s.options.rtl === !0 && s.options.vertical === !1 && (e = -e), s.transformsEnabled === !1 ? s.options.vertical === !1 ? s.$slideTrack.animate({left: e}, s.options.speed, s.options.easing, t) : s.$slideTrack.animate({top: e}, s.options.speed, s.options.easing, t) : s.cssTransitions === !1 ? (s.options.rtl === !0 && (s.currentLeft = -s.currentLeft), i({animStart: s.currentLeft}).animate({animStart: e}, {
            duration: s.options.speed,
            easing: s.options.easing,
            step: function (i) {
                i = Math.ceil(i), s.options.vertical === !1 ? (o[s.animType] = "translate(" + i + "px, 0px)", s.$slideTrack.css(o)) : (o[s.animType] = "translate(0px," + i + "px)", s.$slideTrack.css(o))
            },
            complete: function () {
                t && t.call()
            }
        })) : (s.applyTransition(), e = Math.ceil(e), s.options.vertical === !1 ? o[s.animType] = "translate3d(" + e + "px, 0px, 0px)" : o[s.animType] = "translate3d(0px," + e + "px, 0px)", s.$slideTrack.css(o), t && setTimeout(function () {
            s.disableTransition(), t.call()
        }, s.options.speed))
    }, e.prototype.getNavTarget = function () {
        var e = this, t = e.options.asNavFor;
        return t && null !== t && (t = i(t).not(e.$slider)), t
    }, e.prototype.asNavFor = function (e) {
        var t = this, o = t.getNavTarget();
        null !== o && "object" == typeof o && o.each(function () {
            var t = i(this).slick("getSlick");
            t.unslicked || t.slideHandler(e, !0)
        })
    }, e.prototype.applyTransition = function (i) {
        var e = this, t = {};
        e.options.fade === !1 ? t[e.transitionType] = e.transformType + " " + e.options.speed + "ms " + e.options.cssEase : t[e.transitionType] = "opacity " + e.options.speed + "ms " + e.options.cssEase, e.options.fade === !1 ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t)
    }, e.prototype.autoPlay = function () {
        var i = this;
        i.autoPlayClear(), i.slideCount > i.options.slidesToShow && (i.autoPlayTimer = setInterval(i.autoPlayIterator, i.options.autoplaySpeed))
    }, e.prototype.autoPlayClear = function () {
        var i = this;
        i.autoPlayTimer && clearInterval(i.autoPlayTimer)
    }, e.prototype.autoPlayIterator = function () {
        var i = this, e = i.currentSlide + i.options.slidesToScroll;
        i.paused || i.interrupted || i.focussed || (i.options.infinite === !1 && (1 === i.direction && i.currentSlide + 1 === i.slideCount - 1 ? i.direction = 0 : 0 === i.direction && (e = i.currentSlide - i.options.slidesToScroll, i.currentSlide - 1 === 0 && (i.direction = 1))), i.slideHandler(e))
    }, e.prototype.buildArrows = function () {
        var e = this;
        e.options.arrows === !0 && (e.$prevArrow = i(e.options.prevArrow).addClass("slick-arrow"), e.$nextArrow = i(e.options.nextArrow).addClass("slick-arrow"), e.slideCount > e.options.slidesToShow ? (e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows), e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows), e.options.infinite !== !0 && e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({
            "aria-disabled": "true",
            tabindex: "-1"
        }))
    }, e.prototype.buildDots = function () {
        var e, t, o = this;
        if (o.options.dots === !0 && o.slideCount > o.options.slidesToShow) {
            for (o.$slider.addClass("slick-dotted"), t = i("<ul />").addClass(o.options.dotsClass), e = 0; e <= o.getDotCount(); e += 1) t.append(i("<li />").append(o.options.customPaging.call(this, o, e)));
            o.$dots = t.appendTo(o.options.appendDots), o.$dots.find("li").first().addClass("slick-active")
        }
    }, e.prototype.buildOut = function () {
        var e = this;
        e.$slides = e.$slider.children(e.options.slide + ":not(.slick-cloned)").addClass("slick-slide"), e.slideCount = e.$slides.length, e.$slides.each(function (e, t) {
            i(t).attr("data-slick-index", e).data("originalStyling", i(t).attr("style") || "")
        }), e.$slider.addClass("slick-slider"), e.$slideTrack = 0 === e.slideCount ? i('<div class="slick-track"/>').appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track"/>').parent(), e.$list = e.$slideTrack.wrap('<div class="slick-list"/>').parent(), e.$slideTrack.css("opacity", 0), e.options.centerMode !== !0 && e.options.swipeToSlide !== !0 || (e.options.slidesToScroll = 1), i("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"), e.setupInfinite(), e.buildArrows(), e.buildDots(), e.updateDots(), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), e.options.draggable === !0 && e.$list.addClass("draggable")
    }, e.prototype.buildRows = function () {
        var i, e, t, o, s, n, r, l = this;
        if (o = document.createDocumentFragment(), n = l.$slider.children(), l.options.rows > 0) {
            for (r = l.options.slidesPerRow * l.options.rows, s = Math.ceil(n.length / r), i = 0; i < s; i++) {
                var d = document.createElement("div");
                for (e = 0; e < l.options.rows; e++) {
                    var a = document.createElement("div");
                    for (t = 0; t < l.options.slidesPerRow; t++) {
                        var c = i * r + (e * l.options.slidesPerRow + t);
                        n.get(c) && a.appendChild(n.get(c))
                    }
                    d.appendChild(a)
                }
                o.appendChild(d)
            }
            l.$slider.empty().append(o), l.$slider.children().children().children().css({
                width: 100 / l.options.slidesPerRow + "%",
                display: "inline-block"
            })
        }
    }, e.prototype.checkResponsive = function (e, t) {
        var o, s, n, r = this, l = !1, d = r.$slider.width(), a = window.innerWidth || i(window).width();
        if ("window" === r.respondTo ? n = a : "slider" === r.respondTo ? n = d : "min" === r.respondTo && (n = Math.min(a, d)), r.options.responsive && r.options.responsive.length && null !== r.options.responsive) {
            s = null;
            for (o in r.breakpoints) r.breakpoints.hasOwnProperty(o) && (r.originalSettings.mobileFirst === !1 ? n < r.breakpoints[o] && (s = r.breakpoints[o]) : n > r.breakpoints[o] && (s = r.breakpoints[o]));
            null !== s ? null !== r.activeBreakpoint ? (s !== r.activeBreakpoint || t) && (r.activeBreakpoint = s, "unslick" === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]), e === !0 && (r.currentSlide = r.options.initialSlide), r.refresh(e)), l = s) : (r.activeBreakpoint = s, "unslick" === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]), e === !0 && (r.currentSlide = r.options.initialSlide), r.refresh(e)), l = s) : null !== r.activeBreakpoint && (r.activeBreakpoint = null, r.options = r.originalSettings, e === !0 && (r.currentSlide = r.options.initialSlide), r.refresh(e), l = s), e || l === !1 || r.$slider.trigger("breakpoint", [r, l])
        }
    }, e.prototype.changeSlide = function (e, t) {
        var o, s, n, r = this, l = i(e.currentTarget);
        switch (l.is("a") && e.preventDefault(), l.is("li") || (l = l.closest("li")), n = r.slideCount % r.options.slidesToScroll !== 0, o = n ? 0 : (r.slideCount - r.currentSlide) % r.options.slidesToScroll, e.data.message) {
            case"previous":
                s = 0 === o ? r.options.slidesToScroll : r.options.slidesToShow - o, r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide - s, !1, t);
                break;
            case"next":
                s = 0 === o ? r.options.slidesToScroll : o, r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide + s, !1, t);
                break;
            case"index":
                var d = 0 === e.data.index ? 0 : e.data.index || l.index() * r.options.slidesToScroll;
                r.slideHandler(r.checkNavigable(d), !1, t), l.children().trigger("focus");
                break;
            default:
                return
        }
    }, e.prototype.checkNavigable = function (i) {
        var e, t, o = this;
        if (e = o.getNavigableIndexes(), t = 0, i > e[e.length - 1]) i = e[e.length - 1]; else for (var s in e) {
            if (i < e[s]) {
                i = t;
                break
            }
            t = e[s]
        }
        return i
    }, e.prototype.cleanUpEvents = function () {
        var e = this;
        e.options.dots && null !== e.$dots && (i("li", e.$dots).off("click.slick", e.changeSlide).off("mouseenter.slick", i.proxy(e.interrupt, e, !0)).off("mouseleave.slick", i.proxy(e.interrupt, e, !1)), e.options.accessibility === !0 && e.$dots.off("keydown.slick", e.keyHandler)), e.$slider.off("focus.slick blur.slick"), e.options.arrows === !0 && e.slideCount > e.options.slidesToShow && (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide), e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide), e.options.accessibility === !0 && (e.$prevArrow && e.$prevArrow.off("keydown.slick", e.keyHandler), e.$nextArrow && e.$nextArrow.off("keydown.slick", e.keyHandler))), e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler), e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler), e.$list.off("touchend.slick mouseup.slick", e.swipeHandler), e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler), e.$list.off("click.slick", e.clickHandler), i(document).off(e.visibilityChange, e.visibility), e.cleanUpSlideEvents(), e.options.accessibility === !0 && e.$list.off("keydown.slick", e.keyHandler), e.options.focusOnSelect === !0 && i(e.$slideTrack).children().off("click.slick", e.selectHandler), i(window).off("orientationchange.slick.slick-" + e.instanceUid, e.orientationChange), i(window).off("resize.slick.slick-" + e.instanceUid, e.resize), i("[draggable!=true]", e.$slideTrack).off("dragstart", e.preventDefault), i(window).off("load.slick.slick-" + e.instanceUid, e.setPosition)
    }, e.prototype.cleanUpSlideEvents = function () {
        var e = this;
        e.$list.off("mouseenter.slick", i.proxy(e.interrupt, e, !0)), e.$list.off("mouseleave.slick", i.proxy(e.interrupt, e, !1))
    }, e.prototype.cleanUpRows = function () {
        var i, e = this;
        e.options.rows > 0 && (i = e.$slides.children().children(), i.removeAttr("style"), e.$slider.empty().append(i))
    }, e.prototype.clickHandler = function (i) {
        var e = this;
        e.shouldClick === !1 && (i.stopImmediatePropagation(), i.stopPropagation(), i.preventDefault())
    }, e.prototype.destroy = function (e) {
        var t = this;
        t.autoPlayClear(), t.touchObject = {}, t.cleanUpEvents(), i(".slick-cloned", t.$slider).detach(), t.$dots && t.$dots.remove(), t.$prevArrow && t.$prevArrow.length && (t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()), t.$nextArrow && t.$nextArrow.length && (t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()), t.$slides && (t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function () {
            i(this).attr("style", i(this).data("originalStyling"))
        }), t.$slideTrack.children(this.options.slide).detach(), t.$slideTrack.detach(), t.$list.detach(), t.$slider.append(t.$slides)), t.cleanUpRows(), t.$slider.removeClass("slick-slider"), t.$slider.removeClass("slick-initialized"), t.$slider.removeClass("slick-dotted"), t.unslicked = !0, e || t.$slider.trigger("destroy", [t])
    }, e.prototype.disableTransition = function (i) {
        var e = this, t = {};
        t[e.transitionType] = "", e.options.fade === !1 ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t)
    }, e.prototype.fadeSlide = function (i, e) {
        var t = this;
        t.cssTransitions === !1 ? (t.$slides.eq(i).css({zIndex: t.options.zIndex}), t.$slides.eq(i).animate({opacity: 1}, t.options.speed, t.options.easing, e)) : (t.applyTransition(i), t.$slides.eq(i).css({
            opacity: 1,
            zIndex: t.options.zIndex
        }), e && setTimeout(function () {
            t.disableTransition(i), e.call()
        }, t.options.speed))
    }, e.prototype.fadeSlideOut = function (i) {
        var e = this;
        e.cssTransitions === !1 ? e.$slides.eq(i).animate({
            opacity: 0,
            zIndex: e.options.zIndex - 2
        }, e.options.speed, e.options.easing) : (e.applyTransition(i), e.$slides.eq(i).css({
            opacity: 0,
            zIndex: e.options.zIndex - 2
        }))
    }, e.prototype.filterSlides = e.prototype.slickFilter = function (i) {
        var e = this;
        null !== i && (e.$slidesCache = e.$slides, e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.filter(i).appendTo(e.$slideTrack), e.reinit())
    }, e.prototype.focusHandler = function () {
        var e = this;
        e.$slider.off("focus.slick blur.slick").on("focus.slick", "*", function (t) {
            var o = i(this);
            setTimeout(function () {
                e.options.pauseOnFocus && o.is(":focus") && (e.focussed = !0, e.autoPlay())
            }, 0)
        }).on("blur.slick", "*", function (t) {
            i(this);
            e.options.pauseOnFocus && (e.focussed = !1, e.autoPlay())
        })
    }, e.prototype.getCurrent = e.prototype.slickCurrentSlide = function () {
        var i = this;
        return i.currentSlide
    }, e.prototype.getDotCount = function () {
        var i = this, e = 0, t = 0, o = 0;
        if (i.options.infinite === !0) if (i.slideCount <= i.options.slidesToShow) ++o; else for (; e < i.slideCount;) ++o, e = t + i.options.slidesToScroll, t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow; else if (i.options.centerMode === !0) o = i.slideCount; else if (i.options.asNavFor) for (; e < i.slideCount;) ++o, e = t + i.options.slidesToScroll, t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow; else o = 1 + Math.ceil((i.slideCount - i.options.slidesToShow) / i.options.slidesToScroll);
        return o - 1
    }, e.prototype.getLeft = function (i) {
        var e, t, o, s, n = this, r = 0;
        return n.slideOffset = 0, t = n.$slides.first().outerHeight(!0), n.options.infinite === !0 ? (n.slideCount > n.options.slidesToShow && (n.slideOffset = n.slideWidth * n.options.slidesToShow * -1, s = -1, n.options.vertical === !0 && n.options.centerMode === !0 && (2 === n.options.slidesToShow ? s = -1.5 : 1 === n.options.slidesToShow && (s = -2)), r = t * n.options.slidesToShow * s), n.slideCount % n.options.slidesToScroll !== 0 && i + n.options.slidesToScroll > n.slideCount && n.slideCount > n.options.slidesToShow && (i > n.slideCount ? (n.slideOffset = (n.options.slidesToShow - (i - n.slideCount)) * n.slideWidth * -1, r = (n.options.slidesToShow - (i - n.slideCount)) * t * -1) : (n.slideOffset = n.slideCount % n.options.slidesToScroll * n.slideWidth * -1, r = n.slideCount % n.options.slidesToScroll * t * -1))) : i + n.options.slidesToShow > n.slideCount && (n.slideOffset = (i + n.options.slidesToShow - n.slideCount) * n.slideWidth, r = (i + n.options.slidesToShow - n.slideCount) * t), n.slideCount <= n.options.slidesToShow && (n.slideOffset = 0, r = 0), n.options.centerMode === !0 && n.slideCount <= n.options.slidesToShow ? n.slideOffset = n.slideWidth * Math.floor(n.options.slidesToShow) / 2 - n.slideWidth * n.slideCount / 2 : n.options.centerMode === !0 && n.options.infinite === !0 ? n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2) - n.slideWidth : n.options.centerMode === !0 && (n.slideOffset = 0, n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2)), e = n.options.vertical === !1 ? i * n.slideWidth * -1 + n.slideOffset : i * t * -1 + r, n.options.variableWidth === !0 && (o = n.slideCount <= n.options.slidesToShow || n.options.infinite === !1 ? n.$slideTrack.children(".slick-slide").eq(i) : n.$slideTrack.children(".slick-slide").eq(i + n.options.slidesToShow), e = n.options.rtl === !0 ? o[0] ? (n.$slideTrack.width() - o[0].offsetLeft - o.width()) * -1 : 0 : o[0] ? o[0].offsetLeft * -1 : 0, n.options.centerMode === !0 && (o = n.slideCount <= n.options.slidesToShow || n.options.infinite === !1 ? n.$slideTrack.children(".slick-slide").eq(i) : n.$slideTrack.children(".slick-slide").eq(i + n.options.slidesToShow + 1), e = n.options.rtl === !0 ? o[0] ? (n.$slideTrack.width() - o[0].offsetLeft - o.width()) * -1 : 0 : o[0] ? o[0].offsetLeft * -1 : 0, e += (n.$list.width() - o.outerWidth()) / 2)), e
    }, e.prototype.getOption = e.prototype.slickGetOption = function (i) {
        var e = this;
        return e.options[i]
    }, e.prototype.getNavigableIndexes = function () {
        var i, e = this, t = 0, o = 0, s = [];
        for (e.options.infinite === !1 ? i = e.slideCount : (t = e.options.slidesToScroll * -1, o = e.options.slidesToScroll * -1, i = 2 * e.slideCount); t < i;) s.push(t), t = o + e.options.slidesToScroll, o += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
        return s
    }, e.prototype.getSlick = function () {
        return this
    }, e.prototype.getSlideCount = function () {
        var e, t, o, s, n = this;
        return s = n.options.centerMode === !0 ? Math.floor(n.$list.width() / 2) : 0, o = n.swipeLeft * -1 + s, n.options.swipeToSlide === !0 ? (n.$slideTrack.find(".slick-slide").each(function (e, s) {
            var r, l, d;
            if (r = i(s).outerWidth(), l = s.offsetLeft, n.options.centerMode !== !0 && (l += r / 2), d = l + r, o < d) return t = s, !1
        }), e = Math.abs(i(t).attr("data-slick-index") - n.currentSlide) || 1) : n.options.slidesToScroll
    }, e.prototype.goTo = e.prototype.slickGoTo = function (i, e) {
        var t = this;
        t.changeSlide({data: {message: "index", index: parseInt(i)}}, e)
    }, e.prototype.init = function (e) {
        var t = this;
        i(t.$slider).hasClass("slick-initialized") || (i(t.$slider).addClass("slick-initialized"), t.buildRows(), t.buildOut(), t.setProps(), t.startLoad(), t.loadSlider(), t.initializeEvents(), t.updateArrows(), t.updateDots(), t.checkResponsive(!0), t.focusHandler()), e && t.$slider.trigger("init", [t]), t.options.accessibility === !0 && t.initADA(), t.options.autoplay && (t.paused = !1, t.autoPlay())
    }, e.prototype.initADA = function () {
        var e = this, t = Math.ceil(e.slideCount / e.options.slidesToShow),
            o = e.getNavigableIndexes().filter(function (i) {
                return i >= 0 && i < e.slideCount
            });
        e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({
            "aria-hidden": "true",
            tabindex: "-1"
        }).find("a, input, button, select").attr({tabindex: "-1"}), null !== e.$dots && (e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function (t) {
            var s = o.indexOf(t);
            if (i(this).attr({role: "tabpanel", id: "slick-slide" + e.instanceUid + t, tabindex: -1}), s !== -1) {
                var n = "slick-slide-control" + e.instanceUid + s;
                i("#" + n).length && i(this).attr({"aria-describedby": n})
            }
        }), e.$dots.attr("role", "tablist").find("li").each(function (s) {
            var n = o[s];
            i(this).attr({role: "presentation"}), i(this).find("button").first().attr({
                role: "tab",
                id: "slick-slide-control" + e.instanceUid + s,
                "aria-controls": "slick-slide" + e.instanceUid + n,
                "aria-label": s + 1 + " of " + t,
                "aria-selected": null,
                tabindex: "-1"
            })
        }).eq(e.currentSlide).find("button").attr({"aria-selected": "true", tabindex: "0"}).end());
        for (var s = e.currentSlide, n = s + e.options.slidesToShow; s < n; s++) e.options.focusOnChange ? e.$slides.eq(s).attr({tabindex: "0"}) : e.$slides.eq(s).removeAttr("tabindex");
        e.activateADA()
    }, e.prototype.initArrowEvents = function () {
        var i = this;
        i.options.arrows === !0 && i.slideCount > i.options.slidesToShow && (i.$prevArrow.off("click.slick").on("click.slick", {message: "previous"}, i.changeSlide), i.$nextArrow.off("click.slick").on("click.slick", {message: "next"}, i.changeSlide), i.options.accessibility === !0 && (i.$prevArrow.on("keydown.slick", i.keyHandler), i.$nextArrow.on("keydown.slick", i.keyHandler)))
    }, e.prototype.initDotEvents = function () {
        var e = this;
        e.options.dots === !0 && e.slideCount > e.options.slidesToShow && (i("li", e.$dots).on("click.slick", {message: "index"}, e.changeSlide), e.options.accessibility === !0 && e.$dots.on("keydown.slick", e.keyHandler)), e.options.dots === !0 && e.options.pauseOnDotsHover === !0 && e.slideCount > e.options.slidesToShow && i("li", e.$dots).on("mouseenter.slick", i.proxy(e.interrupt, e, !0)).on("mouseleave.slick", i.proxy(e.interrupt, e, !1))
    }, e.prototype.initSlideEvents = function () {
        var e = this;
        e.options.pauseOnHover && (e.$list.on("mouseenter.slick", i.proxy(e.interrupt, e, !0)), e.$list.on("mouseleave.slick", i.proxy(e.interrupt, e, !1)))
    }, e.prototype.initializeEvents = function () {
        var e = this;
        e.initArrowEvents(), e.initDotEvents(), e.initSlideEvents(), e.$list.on("touchstart.slick mousedown.slick", {action: "start"}, e.swipeHandler), e.$list.on("touchmove.slick mousemove.slick", {action: "move"}, e.swipeHandler), e.$list.on("touchend.slick mouseup.slick", {action: "end"}, e.swipeHandler), e.$list.on("touchcancel.slick mouseleave.slick", {action: "end"}, e.swipeHandler), e.$list.on("click.slick", e.clickHandler), i(document).on(e.visibilityChange, i.proxy(e.visibility, e)), e.options.accessibility === !0 && e.$list.on("keydown.slick", e.keyHandler), e.options.focusOnSelect === !0 && i(e.$slideTrack).children().on("click.slick", e.selectHandler), i(window).on("orientationchange.slick.slick-" + e.instanceUid, i.proxy(e.orientationChange, e)), i(window).on("resize.slick.slick-" + e.instanceUid, i.proxy(e.resize, e)), i("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault), i(window).on("load.slick.slick-" + e.instanceUid, e.setPosition), i(e.setPosition)
    }, e.prototype.initUI = function () {
        var i = this;
        i.options.arrows === !0 && i.slideCount > i.options.slidesToShow && (i.$prevArrow.show(), i.$nextArrow.show()), i.options.dots === !0 && i.slideCount > i.options.slidesToShow && i.$dots.show()
    }, e.prototype.keyHandler = function (i) {
        var e = this;
        i.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === i.keyCode && e.options.accessibility === !0 ? e.changeSlide({data: {message: e.options.rtl === !0 ? "next" : "previous"}}) : 39 === i.keyCode && e.options.accessibility === !0 && e.changeSlide({data: {message: e.options.rtl === !0 ? "previous" : "next"}}))
    }, e.prototype.lazyLoad = function () {
        function e(e) {
            i("img[data-lazy]", e).each(function () {
                var e = i(this), t = i(this).attr("data-lazy"), o = i(this).attr("data-srcset"),
                    s = i(this).attr("data-sizes") || r.$slider.attr("data-sizes"), n = document.createElement("img");
                n.onload = function () {
                    e.animate({opacity: 0}, 100, function () {
                        o && (e.attr("srcset", o), s && e.attr("sizes", s)), e.attr("src", t).animate({opacity: 1}, 200, function () {
                            e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")
                        }), r.$slider.trigger("lazyLoaded", [r, e, t])
                    })
                }, n.onerror = function () {
                    e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), r.$slider.trigger("lazyLoadError", [r, e, t])
                }, n.src = t
            })
        }

        var t, o, s, n, r = this;
        if (r.options.centerMode === !0 ? r.options.infinite === !0 ? (s = r.currentSlide + (r.options.slidesToShow / 2 + 1), n = s + r.options.slidesToShow + 2) : (s = Math.max(0, r.currentSlide - (r.options.slidesToShow / 2 + 1)), n = 2 + (r.options.slidesToShow / 2 + 1) + r.currentSlide) : (s = r.options.infinite ? r.options.slidesToShow + r.currentSlide : r.currentSlide, n = Math.ceil(s + r.options.slidesToShow), r.options.fade === !0 && (s > 0 && s--, n <= r.slideCount && n++)), t = r.$slider.find(".slick-slide").slice(s, n), "anticipated" === r.options.lazyLoad) for (var l = s - 1, d = n, a = r.$slider.find(".slick-slide"), c = 0; c < r.options.slidesToScroll; c++) l < 0 && (l = r.slideCount - 1), t = t.add(a.eq(l)), t = t.add(a.eq(d)), l--, d++;
        e(t), r.slideCount <= r.options.slidesToShow ? (o = r.$slider.find(".slick-slide"), e(o)) : r.currentSlide >= r.slideCount - r.options.slidesToShow ? (o = r.$slider.find(".slick-cloned").slice(0, r.options.slidesToShow), e(o)) : 0 === r.currentSlide && (o = r.$slider.find(".slick-cloned").slice(r.options.slidesToShow * -1), e(o))
    }, e.prototype.loadSlider = function () {
        var i = this;
        i.setPosition(), i.$slideTrack.css({opacity: 1}), i.$slider.removeClass("slick-loading"), i.initUI(), "progressive" === i.options.lazyLoad && i.progressiveLazyLoad()
    }, e.prototype.next = e.prototype.slickNext = function () {
        var i = this;
        i.changeSlide({data: {message: "next"}})
    }, e.prototype.orientationChange = function () {
        var i = this;
        i.checkResponsive(), i.setPosition()
    }, e.prototype.pause = e.prototype.slickPause = function () {
        var i = this;
        i.autoPlayClear(), i.paused = !0
    }, e.prototype.play = e.prototype.slickPlay = function () {
        var i = this;
        i.autoPlay(), i.options.autoplay = !0, i.paused = !1, i.focussed = !1, i.interrupted = !1
    }, e.prototype.postSlide = function (e) {
        var t = this;
        if (!t.unslicked && (t.$slider.trigger("afterChange", [t, e]), t.animating = !1, t.slideCount > t.options.slidesToShow && t.setPosition(), t.swipeLeft = null, t.options.autoplay && t.autoPlay(), t.options.accessibility === !0 && (t.initADA(), t.options.focusOnChange))) {
            var o = i(t.$slides.get(t.currentSlide));
            o.attr("tabindex", 0).focus()
        }
    }, e.prototype.prev = e.prototype.slickPrev = function () {
        var i = this;
        i.changeSlide({data: {message: "previous"}})
    }, e.prototype.preventDefault = function (i) {
        i.preventDefault()
    }, e.prototype.progressiveLazyLoad = function (e) {
        e = e || 1;
        var t, o, s, n, r, l = this, d = i("img[data-lazy]", l.$slider);
        d.length ? (t = d.first(), o = t.attr("data-lazy"), s = t.attr("data-srcset"), n = t.attr("data-sizes") || l.$slider.attr("data-sizes"), r = document.createElement("img"), r.onload = function () {
            s && (t.attr("srcset", s), n && t.attr("sizes", n)), t.attr("src", o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"), l.options.adaptiveHeight === !0 && l.setPosition(), l.$slider.trigger("lazyLoaded", [l, t, o]), l.progressiveLazyLoad()
        }, r.onerror = function () {
            e < 3 ? setTimeout(function () {
                l.progressiveLazyLoad(e + 1)
            }, 500) : (t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), l.$slider.trigger("lazyLoadError", [l, t, o]), l.progressiveLazyLoad())
        }, r.src = o) : l.$slider.trigger("allImagesLoaded", [l])
    }, e.prototype.refresh = function (e) {
        var t, o, s = this;
        o = s.slideCount - s.options.slidesToShow, !s.options.infinite && s.currentSlide > o && (s.currentSlide = o), s.slideCount <= s.options.slidesToShow && (s.currentSlide = 0), t = s.currentSlide, s.destroy(!0), i.extend(s, s.initials, {currentSlide: t}), s.init(), e || s.changeSlide({
            data: {
                message: "index",
                index: t
            }
        }, !1)
    }, e.prototype.registerBreakpoints = function () {
        var e, t, o, s = this, n = s.options.responsive || null;
        if ("array" === i.type(n) && n.length) {
            s.respondTo = s.options.respondTo || "window";
            for (e in n) if (o = s.breakpoints.length - 1, n.hasOwnProperty(e)) {
                for (t = n[e].breakpoint; o >= 0;) s.breakpoints[o] && s.breakpoints[o] === t && s.breakpoints.splice(o, 1), o--;
                s.breakpoints.push(t), s.breakpointSettings[t] = n[e].settings
            }
            s.breakpoints.sort(function (i, e) {
                return s.options.mobileFirst ? i - e : e - i
            })
        }
    }, e.prototype.reinit = function () {
        var e = this;
        e.$slides = e.$slideTrack.children(e.options.slide).addClass("slick-slide"), e.slideCount = e.$slides.length, e.currentSlide >= e.slideCount && 0 !== e.currentSlide && (e.currentSlide = e.currentSlide - e.options.slidesToScroll), e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0), e.registerBreakpoints(), e.setProps(), e.setupInfinite(), e.buildArrows(), e.updateArrows(), e.initArrowEvents(), e.buildDots(), e.updateDots(), e.initDotEvents(), e.cleanUpSlideEvents(), e.initSlideEvents(), e.checkResponsive(!1, !0), e.options.focusOnSelect === !0 && i(e.$slideTrack).children().on("click.slick", e.selectHandler), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), e.setPosition(), e.focusHandler(), e.paused = !e.options.autoplay, e.autoPlay(), e.$slider.trigger("reInit", [e])
    }, e.prototype.resize = function () {
        var e = this;
        i(window).width() !== e.windowWidth && (clearTimeout(e.windowDelay), e.windowDelay = window.setTimeout(function () {
            e.windowWidth = i(window).width(), e.checkResponsive(), e.unslicked || e.setPosition()
        }, 50))
    }, e.prototype.removeSlide = e.prototype.slickRemove = function (i, e, t) {
        var o = this;
        return "boolean" == typeof i ? (e = i, i = e === !0 ? 0 : o.slideCount - 1) : i = e === !0 ? --i : i, !(o.slideCount < 1 || i < 0 || i > o.slideCount - 1) && (o.unload(), t === !0 ? o.$slideTrack.children().remove() : o.$slideTrack.children(this.options.slide).eq(i).remove(), o.$slides = o.$slideTrack.children(this.options.slide), o.$slideTrack.children(this.options.slide).detach(), o.$slideTrack.append(o.$slides), o.$slidesCache = o.$slides, void o.reinit())
    }, e.prototype.setCSS = function (i) {
        var e, t, o = this, s = {};
        o.options.rtl === !0 && (i = -i), e = "left" == o.positionProp ? Math.ceil(i) + "px" : "0px", t = "top" == o.positionProp ? Math.ceil(i) + "px" : "0px", s[o.positionProp] = i, o.transformsEnabled === !1 ? o.$slideTrack.css(s) : (s = {}, o.cssTransitions === !1 ? (s[o.animType] = "translate(" + e + ", " + t + ")", o.$slideTrack.css(s)) : (s[o.animType] = "translate3d(" + e + ", " + t + ", 0px)", o.$slideTrack.css(s)))
    }, e.prototype.setDimensions = function () {
        var i = this;
        i.options.vertical === !1 ? i.options.centerMode === !0 && i.$list.css({padding: "0px " + i.options.centerPadding}) : (i.$list.height(i.$slides.first().outerHeight(!0) * i.options.slidesToShow), i.options.centerMode === !0 && i.$list.css({padding: i.options.centerPadding + " 0px"})), i.listWidth = i.$list.width(), i.listHeight = i.$list.height(), i.options.vertical === !1 && i.options.variableWidth === !1 ? (i.slideWidth = Math.ceil(i.listWidth / i.options.slidesToShow), i.$slideTrack.width(Math.ceil(i.slideWidth * i.$slideTrack.children(".slick-slide").length))) : i.options.variableWidth === !0 ? i.$slideTrack.width(5e3 * i.slideCount) : (i.slideWidth = Math.ceil(i.listWidth), i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0) * i.$slideTrack.children(".slick-slide").length)));
        var e = i.$slides.first().outerWidth(!0) - i.$slides.first().width();
        i.options.variableWidth === !1 && i.$slideTrack.children(".slick-slide").width(i.slideWidth - e)
    }, e.prototype.setFade = function () {
        var e, t = this;
        t.$slides.each(function (o, s) {
            e = t.slideWidth * o * -1, t.options.rtl === !0 ? i(s).css({
                position: "relative",
                right: e,
                top: 0,
                zIndex: t.options.zIndex - 2,
                opacity: 0
            }) : i(s).css({position: "relative", left: e, top: 0, zIndex: t.options.zIndex - 2, opacity: 0})
        }), t.$slides.eq(t.currentSlide).css({zIndex: t.options.zIndex - 1, opacity: 1})
    }, e.prototype.setHeight = function () {
        var i = this;
        if (1 === i.options.slidesToShow && i.options.adaptiveHeight === !0 && i.options.vertical === !1) {
            var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
            i.$list.css("height", e)
        }
    }, e.prototype.setOption = e.prototype.slickSetOption = function () {
        var e, t, o, s, n, r = this, l = !1;
        if ("object" === i.type(arguments[0]) ? (o = arguments[0], l = arguments[1], n = "multiple") : "string" === i.type(arguments[0]) && (o = arguments[0], s = arguments[1], l = arguments[2], "responsive" === arguments[0] && "array" === i.type(arguments[1]) ? n = "responsive" : "undefined" != typeof arguments[1] && (n = "single")), "single" === n) r.options[o] = s; else if ("multiple" === n) i.each(o, function (i, e) {
            r.options[i] = e
        }); else if ("responsive" === n) for (t in s) if ("array" !== i.type(r.options.responsive)) r.options.responsive = [s[t]]; else {
            for (e = r.options.responsive.length - 1; e >= 0;) r.options.responsive[e].breakpoint === s[t].breakpoint && r.options.responsive.splice(e, 1), e--;
            r.options.responsive.push(s[t])
        }
        l && (r.unload(), r.reinit())
    }, e.prototype.setPosition = function () {
        var i = this;
        i.setDimensions(), i.setHeight(), i.options.fade === !1 ? i.setCSS(i.getLeft(i.currentSlide)) : i.setFade(), i.$slider.trigger("setPosition", [i])
    }, e.prototype.setProps = function () {
        var i = this, e = document.body.style;
        i.positionProp = i.options.vertical === !0 ? "top" : "left",
            "top" === i.positionProp ? i.$slider.addClass("slick-vertical") : i.$slider.removeClass("slick-vertical"), void 0 === e.WebkitTransition && void 0 === e.MozTransition && void 0 === e.msTransition || i.options.useCSS === !0 && (i.cssTransitions = !0), i.options.fade && ("number" == typeof i.options.zIndex ? i.options.zIndex < 3 && (i.options.zIndex = 3) : i.options.zIndex = i.defaults.zIndex), void 0 !== e.OTransform && (i.animType = "OTransform", i.transformType = "-o-transform", i.transitionType = "OTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)), void 0 !== e.MozTransform && (i.animType = "MozTransform", i.transformType = "-moz-transform", i.transitionType = "MozTransition", void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (i.animType = !1)), void 0 !== e.webkitTransform && (i.animType = "webkitTransform", i.transformType = "-webkit-transform", i.transitionType = "webkitTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)), void 0 !== e.msTransform && (i.animType = "msTransform", i.transformType = "-ms-transform", i.transitionType = "msTransition", void 0 === e.msTransform && (i.animType = !1)), void 0 !== e.transform && i.animType !== !1 && (i.animType = "transform", i.transformType = "transform", i.transitionType = "transition"), i.transformsEnabled = i.options.useTransform && null !== i.animType && i.animType !== !1
    }, e.prototype.setSlideClasses = function (i) {
        var e, t, o, s, n = this;
        if (t = n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"), n.$slides.eq(i).addClass("slick-current"), n.options.centerMode === !0) {
            var r = n.options.slidesToShow % 2 === 0 ? 1 : 0;
            e = Math.floor(n.options.slidesToShow / 2), n.options.infinite === !0 && (i >= e && i <= n.slideCount - 1 - e ? n.$slides.slice(i - e + r, i + e + 1).addClass("slick-active").attr("aria-hidden", "false") : (o = n.options.slidesToShow + i, t.slice(o - e + 1 + r, o + e + 2).addClass("slick-active").attr("aria-hidden", "false")), 0 === i ? t.eq(t.length - 1 - n.options.slidesToShow).addClass("slick-center") : i === n.slideCount - 1 && t.eq(n.options.slidesToShow).addClass("slick-center")), n.$slides.eq(i).addClass("slick-center")
        } else i >= 0 && i <= n.slideCount - n.options.slidesToShow ? n.$slides.slice(i, i + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : t.length <= n.options.slidesToShow ? t.addClass("slick-active").attr("aria-hidden", "false") : (s = n.slideCount % n.options.slidesToShow, o = n.options.infinite === !0 ? n.options.slidesToShow + i : i, n.options.slidesToShow == n.options.slidesToScroll && n.slideCount - i < n.options.slidesToShow ? t.slice(o - (n.options.slidesToShow - s), o + s).addClass("slick-active").attr("aria-hidden", "false") : t.slice(o, o + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false"));
        "ondemand" !== n.options.lazyLoad && "anticipated" !== n.options.lazyLoad || n.lazyLoad()
    }, e.prototype.setupInfinite = function () {
        var e, t, o, s = this;
        if (s.options.fade === !0 && (s.options.centerMode = !1), s.options.infinite === !0 && s.options.fade === !1 && (t = null, s.slideCount > s.options.slidesToShow)) {
            for (o = s.options.centerMode === !0 ? s.options.slidesToShow + 1 : s.options.slidesToShow, e = s.slideCount; e > s.slideCount - o; e -= 1) t = e - 1, i(s.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t - s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");
            for (e = 0; e < o + s.slideCount; e += 1) t = e, i(s.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t + s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");
            s.$slideTrack.find(".slick-cloned").find("[id]").each(function () {
                i(this).attr("id", "")
            })
        }
    }, e.prototype.interrupt = function (i) {
        var e = this;
        i || e.autoPlay(), e.interrupted = i
    }, e.prototype.selectHandler = function (e) {
        var t = this, o = i(e.target).is(".slick-slide") ? i(e.target) : i(e.target).parents(".slick-slide"),
            s = parseInt(o.attr("data-slick-index"));
        return s || (s = 0), t.slideCount <= t.options.slidesToShow ? void t.slideHandler(s, !1, !0) : void t.slideHandler(s)
    }, e.prototype.slideHandler = function (i, e, t) {
        var o, s, n, r, l, d = null, a = this;
        if (e = e || !1, !(a.animating === !0 && a.options.waitForAnimate === !0 || a.options.fade === !0 && a.currentSlide === i)) return e === !1 && a.asNavFor(i), o = i, d = a.getLeft(o), r = a.getLeft(a.currentSlide), a.currentLeft = null === a.swipeLeft ? r : a.swipeLeft, a.options.infinite === !1 && a.options.centerMode === !1 && (i < 0 || i > a.getDotCount() * a.options.slidesToScroll) ? void (a.options.fade === !1 && (o = a.currentSlide, t !== !0 && a.slideCount > a.options.slidesToShow ? a.animateSlide(r, function () {
            a.postSlide(o)
        }) : a.postSlide(o))) : a.options.infinite === !1 && a.options.centerMode === !0 && (i < 0 || i > a.slideCount - a.options.slidesToScroll) ? void (a.options.fade === !1 && (o = a.currentSlide, t !== !0 && a.slideCount > a.options.slidesToShow ? a.animateSlide(r, function () {
            a.postSlide(o)
        }) : a.postSlide(o))) : (a.options.autoplay && clearInterval(a.autoPlayTimer), s = o < 0 ? a.slideCount % a.options.slidesToScroll !== 0 ? a.slideCount - a.slideCount % a.options.slidesToScroll : a.slideCount + o : o >= a.slideCount ? a.slideCount % a.options.slidesToScroll !== 0 ? 0 : o - a.slideCount : o, a.animating = !0, a.$slider.trigger("beforeChange", [a, a.currentSlide, s]), n = a.currentSlide, a.currentSlide = s, a.setSlideClasses(a.currentSlide), a.options.asNavFor && (l = a.getNavTarget(), l = l.slick("getSlick"), l.slideCount <= l.options.slidesToShow && l.setSlideClasses(a.currentSlide)), a.updateDots(), a.updateArrows(), a.options.fade === !0 ? (t !== !0 ? (a.fadeSlideOut(n), a.fadeSlide(s, function () {
            a.postSlide(s)
        })) : a.postSlide(s), void a.animateHeight()) : void (t !== !0 && a.slideCount > a.options.slidesToShow ? a.animateSlide(d, function () {
            a.postSlide(s)
        }) : a.postSlide(s)))
    }, e.prototype.startLoad = function () {
        var i = this;
        i.options.arrows === !0 && i.slideCount > i.options.slidesToShow && (i.$prevArrow.hide(), i.$nextArrow.hide()), i.options.dots === !0 && i.slideCount > i.options.slidesToShow && i.$dots.hide(), i.$slider.addClass("slick-loading")
    }, e.prototype.swipeDirection = function () {
        var i, e, t, o, s = this;
        return i = s.touchObject.startX - s.touchObject.curX, e = s.touchObject.startY - s.touchObject.curY, t = Math.atan2(e, i), o = Math.round(180 * t / Math.PI), o < 0 && (o = 360 - Math.abs(o)), o <= 45 && o >= 0 ? s.options.rtl === !1 ? "left" : "right" : o <= 360 && o >= 315 ? s.options.rtl === !1 ? "left" : "right" : o >= 135 && o <= 225 ? s.options.rtl === !1 ? "right" : "left" : s.options.verticalSwiping === !0 ? o >= 35 && o <= 135 ? "down" : "up" : "vertical"
    }, e.prototype.swipeEnd = function (i) {
        var e, t, o = this;
        if (o.dragging = !1, o.swiping = !1, o.scrolling) return o.scrolling = !1, !1;
        if (o.interrupted = !1, o.shouldClick = !(o.touchObject.swipeLength > 10), void 0 === o.touchObject.curX) return !1;
        if (o.touchObject.edgeHit === !0 && o.$slider.trigger("edge", [o, o.swipeDirection()]), o.touchObject.swipeLength >= o.touchObject.minSwipe) {
            switch (t = o.swipeDirection()) {
                case"left":
                case"down":
                    e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide + o.getSlideCount()) : o.currentSlide + o.getSlideCount(), o.currentDirection = 0;
                    break;
                case"right":
                case"up":
                    e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide - o.getSlideCount()) : o.currentSlide - o.getSlideCount(), o.currentDirection = 1
            }
            "vertical" != t && (o.slideHandler(e), o.touchObject = {}, o.$slider.trigger("swipe", [o, t]))
        } else o.touchObject.startX !== o.touchObject.curX && (o.slideHandler(o.currentSlide), o.touchObject = {})
    }, e.prototype.swipeHandler = function (i) {
        var e = this;
        if (!(e.options.swipe === !1 || "ontouchend" in document && e.options.swipe === !1 || e.options.draggable === !1 && i.type.indexOf("mouse") !== -1)) switch (e.touchObject.fingerCount = i.originalEvent && void 0 !== i.originalEvent.touches ? i.originalEvent.touches.length : 1, e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold, e.options.verticalSwiping === !0 && (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold), i.data.action) {
            case"start":
                e.swipeStart(i);
                break;
            case"move":
                e.swipeMove(i);
                break;
            case"end":
                e.swipeEnd(i)
        }
    }, e.prototype.swipeMove = function (i) {
        var e, t, o, s, n, r, l = this;
        return n = void 0 !== i.originalEvent ? i.originalEvent.touches : null, !(!l.dragging || l.scrolling || n && 1 !== n.length) && (e = l.getLeft(l.currentSlide), l.touchObject.curX = void 0 !== n ? n[0].pageX : i.clientX, l.touchObject.curY = void 0 !== n ? n[0].pageY : i.clientY, l.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(l.touchObject.curX - l.touchObject.startX, 2))), r = Math.round(Math.sqrt(Math.pow(l.touchObject.curY - l.touchObject.startY, 2))), !l.options.verticalSwiping && !l.swiping && r > 4 ? (l.scrolling = !0, !1) : (l.options.verticalSwiping === !0 && (l.touchObject.swipeLength = r), t = l.swipeDirection(), void 0 !== i.originalEvent && l.touchObject.swipeLength > 4 && (l.swiping = !0, i.preventDefault()), s = (l.options.rtl === !1 ? 1 : -1) * (l.touchObject.curX > l.touchObject.startX ? 1 : -1), l.options.verticalSwiping === !0 && (s = l.touchObject.curY > l.touchObject.startY ? 1 : -1), o = l.touchObject.swipeLength, l.touchObject.edgeHit = !1, l.options.infinite === !1 && (0 === l.currentSlide && "right" === t || l.currentSlide >= l.getDotCount() && "left" === t) && (o = l.touchObject.swipeLength * l.options.edgeFriction, l.touchObject.edgeHit = !0), l.options.vertical === !1 ? l.swipeLeft = e + o * s : l.swipeLeft = e + o * (l.$list.height() / l.listWidth) * s, l.options.verticalSwiping === !0 && (l.swipeLeft = e + o * s), l.options.fade !== !0 && l.options.touchMove !== !1 && (l.animating === !0 ? (l.swipeLeft = null, !1) : void l.setCSS(l.swipeLeft))))
    }, e.prototype.swipeStart = function (i) {
        var e, t = this;
        return t.interrupted = !0, 1 !== t.touchObject.fingerCount || t.slideCount <= t.options.slidesToShow ? (t.touchObject = {}, !1) : (void 0 !== i.originalEvent && void 0 !== i.originalEvent.touches && (e = i.originalEvent.touches[0]), t.touchObject.startX = t.touchObject.curX = void 0 !== e ? e.pageX : i.clientX, t.touchObject.startY = t.touchObject.curY = void 0 !== e ? e.pageY : i.clientY, void (t.dragging = !0))
    }, e.prototype.unfilterSlides = e.prototype.slickUnfilter = function () {
        var i = this;
        null !== i.$slidesCache && (i.unload(), i.$slideTrack.children(this.options.slide).detach(), i.$slidesCache.appendTo(i.$slideTrack), i.reinit())
    }, e.prototype.unload = function () {
        var e = this;
        i(".slick-cloned", e.$slider).remove(), e.$dots && e.$dots.remove(), e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(), e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(), e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "")
    }, e.prototype.unslick = function (i) {
        var e = this;
        e.$slider.trigger("unslick", [e, i]), e.destroy()
    }, e.prototype.updateArrows = function () {
        var i, e = this;
        i = Math.floor(e.options.slidesToShow / 2), e.options.arrows === !0 && e.slideCount > e.options.slidesToShow && !e.options.infinite && (e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), 0 === e.currentSlide ? (e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : e.currentSlide >= e.slideCount - e.options.slidesToShow && e.options.centerMode === !1 ? (e.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : e.currentSlide >= e.slideCount - 1 && e.options.centerMode === !0 && (e.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")))
    }, e.prototype.updateDots = function () {
        var i = this;
        null !== i.$dots && (i.$dots.find("li").removeClass("slick-active").end(), i.$dots.find("li").eq(Math.floor(i.currentSlide / i.options.slidesToScroll)).addClass("slick-active"))
    }, e.prototype.visibility = function () {
        var i = this;
        i.options.autoplay && (document[i.hidden] ? i.interrupted = !0 : i.interrupted = !1)
    }, i.fn.slick = function () {
        var i, t, o = this, s = arguments[0], n = Array.prototype.slice.call(arguments, 1), r = o.length;
        for (i = 0; i < r; i++) if ("object" == typeof s || "undefined" == typeof s ? o[i].slick = new e(o[i], s) : t = o[i].slick[s].apply(o[i].slick, n), "undefined" != typeof t) return t;
        return o
    }
});
/**!
 * trunk8 v1.3.3
 * https://github.com/rviscomi/trunk8
 *
 * Copyright 2012 Rick Viscomi
 * Released under the MIT License.
 *
 * Date: September 26, 2012
 */

!function (t, e) {
    "function" == typeof define && define.amd ? define(["jquery"], e) : "object" == typeof module && module.exports ? e(require("jquery")) : e(t.jQuery)
}(this, function (t) {
    var e, n, r = "center", i = "left", a = "right", s = {auto: "auto"};

    function o(e) {
        this.$element = t(e), this.original_text = t.trim(this.$element.html()), this.settings = t.extend({}, t.fn.trunk8.defaults)
    }

    function l(t) {
        var e = document.createElement("DIV");
        return e.innerHTML = t, void 0 !== e.textContent ? e.textContent : e.innerText
    }

    function u(e, n, r) {
        e = e.replace(r, "");
        var i = function (n, a) {
            var s, o, l, u, h = "";
            for (u = 0; u < n.length; u++) s = n[u], l = t.trim(e).split(" ").length, t.trim(e).length && ("string" == typeof s ? (/<br\s*\/?>/i.test(s) || (1 === l && t.trim(e).length <= s.length ? (s = e, "p" !== a && "div" !== a || (s += r), e = "") : e = e.replace(s, "")), h += t.trim(s) + (u === n.length - 1 || l <= 1 ? "" : " ")) : (o = i(s.content, s.tag), s.after && (e = e.replace(s.after, "")), o && (s.after || (s.after = " "), h += "<" + s.tag + s.attribs + ">" + o + "</" + s.tag + ">" + s.after)));
            return h
        }, a = i(n);
        return a.slice(a.length - r.length) !== r && (a += r), a
    }

    function h() {
        var e, r, i, a, o, h, c = this.data("trunk8"), f = c.settings, g = f.width, d = f.side, p = f.fill,
            m = f.parseHTML, v = n.getLineHeight(this) * f.lines, y = c.original_text, S = y.length, x = "";
        if (this.html(y), o = this.text(), m && l(y) !== y && (h = function t(e) {
            if (l(e) === e) return e.split(/\s/g);
            for (var n, r, i = [], a = /<([a-z]+)([^<]*)(?:>([\S\s]*?(?!<\1>))<\/\1>|\s+\/>)(['.?!,]*)|((?:[^<>\s])+['.?!,]*\w?|<br\s?\/?>)/gi, s = a.exec(e); s && n !== a.lastIndex;) n = a.lastIndex, s[5] ? i.push(s[5]) : s[1] && i.push({
                tag: s[1],
                attribs: s[2],
                content: s[3],
                after: s[4]
            }), s = a.exec(e);
            for (r = 0; r < i.length; r++) "string" != typeof i[r] && i[r].content && (i[r].content = t(i[r].content));
            return i
        }(y), S = (y = l(y)).length), g === s.auto) {
            if (this.height() <= v) return;
            for (e = 0, r = S - 1; e <= r;) i = e + (r - e >> 1), a = n.eatStr(y, d, S - i, p), m && h && (a = u(a, h, p)), this.html(a), this.height() > v ? r = i - 1 : (e = i + 1, x = x.length > a.length ? x : a);
            this.html(""), this.html(x), f.tooltip && this.attr("title", o)
        } else {
            if (isNaN(g)) return void t.error('Invalid width "' + g + '".');
            i = S - g, a = n.eatStr(y, d, i, p), this.html(a), f.tooltip && this.attr("title", y)
        }
        f.onTruncate()
    }

    o.prototype.updateSettings = function (e) {
        this.settings = t.extend(this.settings, e)
    }, e = {
        init: function (e) {
            return this.each(function () {
                var n = t(this), r = n.data("trunk8");
                r || n.data("trunk8", r = new o(this)), r.updateSettings(e), h.call(n)
            })
        }, update: function (e) {
            return this.each(function () {
                var n = t(this);
                e && (n.data("trunk8").original_text = e), h.call(n)
            })
        }, revert: function () {
            return this.each(function () {
                var e = t(this).data("trunk8").original_text;
                t(this).html(e)
            })
        }, getSettings: function () {
            return t(this.get(0)).data("trunk8").settings
        }
    }, (n = {
        eatStr: function (e, s, o, l) {
            var u, h, c = e.length, f = n.eatStr.generateKey.apply(null, arguments);
            if (n.eatStr.cache[f]) return n.eatStr.cache[f];
            if ("string" == typeof e && 0 !== c || t.error('Invalid source string "' + e + '".'), o < 0 || o > c) t.error('Invalid bite size "' + o + '".'); else if (0 === o) return e;
            switch ("string" != typeof (l + "") && t.error("Fill unable to be converted to a string."), s) {
                case a:
                    return n.eatStr.cache[f] = t.trim(e.substr(0, c - o)) + l;
                case i:
                    return n.eatStr.cache[f] = l + t.trim(e.substr(o));
                case r:
                    return u = c >> 1, h = o >> 1, n.eatStr.cache[f] = t.trim(n.eatStr(e.substr(0, c - u), a, o - h, "")) + l + t.trim(n.eatStr(e.substr(c - u), i, h, ""));
                default:
                    t.error('Invalid side "' + s + '".')
            }
        }, getLineHeight: function (e) {
            var n = t(e).css("float");
            "none" !== n && t(e).css("float", "none");
            var r = t(e).css("position");
            "absolute" === r && t(e).css("position", "static");
            var i, a = t(e).html(), s = "line-height-test";
            return t(e).html("i").wrap('<div id="' + s + '" />'), i = t("#" + s).innerHeight(), t(e).html(a).css({
                float: n,
                position: r
            }).unwrap(), i
        }
    }).eatStr.cache = {}, n.eatStr.generateKey = function () {
        return Array.prototype.join.call(arguments, "")
    }, t.fn.trunk8 = function (n) {
        return e[n] ? e[n].apply(this, Array.prototype.slice.call(arguments, 1)) : "object" != typeof n && n ? void t.error("Method " + n + " does not exist on jQuery.trunk8") : e.init.apply(this, arguments)
    }, t.fn.trunk8.defaults = {
        fill: "&hellip;",
        lines: 1,
        side: a,
        tooltip: !0,
        width: s.auto,
        parseHTML: !1,
        onTruncate: function () {
        }
    }
});
/**!
 * jquery.visible.min.js
 * https://github.com/customd/jquery-visible
 * @license MIT (https://github.com/customd/jquery-visible/blob/master/LICENSE.txt)
 */
!function (t) {
    var i = t(window);
    t.fn.visible = function (t, e, o) {
        if (!(this.length < 1)) {
            var r = this.length > 1 ? this.eq(0) : this, n = r.get(0), f = i.width(), h = i.height(),
                o = o ? o : "both", l = e === !0 ? n.offsetWidth * n.offsetHeight : !0;
            if ("function" == typeof n.getBoundingClientRect) {
                var g = n.getBoundingClientRect(), u = g.top >= 0 && g.top < h, s = g.bottom > 0 && g.bottom <= h,
                    c = g.left >= 0 && g.left < f, a = g.right > 0 && g.right <= f, v = t ? u || s : u && s,
                    b = t ? c || a : c && a;
                if ("both" === o) return l && v && b;
                if ("vertical" === o) return l && v;
                if ("horizontal" === o) return l && b
            } else {
                var d = i.scrollTop(), p = d + h, w = i.scrollLeft(), m = w + f, y = r.offset(), z = y.top,
                    B = z + r.height(), C = y.left, R = C + r.width(), j = t === !0 ? B : z, q = t === !0 ? z : B,
                    H = t === !0 ? R : C, L = t === !0 ? C : R;
                if ("both" === o) return !!l && p >= q && j >= d && m >= L && H >= w;
                if ("vertical" === o) return !!l && p >= q && j >= d;
                if ("horizontal" === o) return !!l && m >= L && H >= w
            }
        }
    }
}(jQuery);

/* Ajaxify v1 | Copyright (c) 2017 Elkfox Co Pty Ltd | https://elkfox.com | Project lead: George Butter | MIT License | https://github.com/Elkfox/Ajaxify */
ajaxify = function (settings) {
    settings = settings || {}
    // Change the default selectors here
    var linkParent = settings.linkParent || '.pagination' // Class of pagination container
    var parentContainer = settings.parentContainer || '#MainContent' // All of the content selector used to detect scroll bottom distance
    var endlessScrollContainer = settings.endlessScrollContainer || '.EndlessScroll' // Selector for endless scroll pages
    var endlessClickContainer = settings.endlessClickContainer || '.EndlessClick' // Class of pagination container
    var endlessOffset = settings.endlessOffset || 0 // Offset the distance from the bottom of the page
    var ajaxinateContainer = settings.ajaxinateContainer || '.Ajaxinate' // ID Selector for ajax pagination pages
    var ajaxinateLink = settings.ajaxinateLink || '.page a' // Class Selector for ajax pagination links
    var sectionId = $(endlessScrollContainer).closest('[data-section-id]').data('section-id') ||
        $(endlessClickContainer).closest('[data-section-id]').data('section-id') ||
        $(ajaxinateContainer).closest('[data-section-id]').data('section-id') || '';
    var fade = settings.fade || 'fast' // fade speed
    var textChange = settings.textChange || 'Loading' // Text whilst loading content
    const callback = settings.callback || false

    var linkElem;
    var contentContainer;
    var pageNumber;
    var pageType;
    var action;
    var moreURL;

    $.loadMore = function () {
        if (moreURL.length) {
            $.ajax({
                type: 'GET',
                dataType: 'html',
                url: moreURL,
                success: function (data) {
                    if (pageType == 'ajax') {
                        $(ajaxinateContainer).not('[data-page="' + pageNumber + '"]').hide();
                        history.pushState({}, pageNumber, moreURL);
                    } else {
                        $(linkElem).fadeOut(fade);
                    }

                    var filteredData = $(data).find(contentContainer).html();
                    $(contentContainer)
                        .find('.visually-hidden')
                        .removeClass('visually-hidden')
                        .end()
                        .find('.gridSpacer, .pagination').remove().end().append(filteredData);

                    if (pageType == 'endlessScroll') {
                        $.endlessScroll();
                    } else if (pageType == 'ajax') {
                        $.ajaxinationClick();
                    } else if (pageType == 'endlessClick') {
                        $.endlessClick();
                    }

                    $(document).trigger('ajaxify:updated', [data]);
                    if (callback && typeof (callback) === 'function') {
                        callback(data);
                    }
                }
            });
        } else {
            $(contentContainer).find('.visually-hidden').removeClass('visually-hidden');

            // Simulate ajaxify update
            $(document).trigger('ajaxify:updated');
        }
    }

    // Check whether the page is at the bottom
    $.endlessScroll = function () {
        action = 'scroll.endlessScroll--' + sectionId + ' load resize.endlessScroll--' + sectionId;
        $(window).on(action, function () {
            contentContainer = endlessScrollContainer;
            moreURL = $(contentContainer + ':last-of-type ' + linkElem).attr('href');
            pageType = 'endlessScroll';
            $(linkElem).text(textChange);
            if ($(contentContainer + ':last-of-type ' + linkElem).length) {
                var bottom = $(parentContainer).outerHeight();
                var docTop = ($(document).scrollTop() + $(window).height() + endlessOffset);
                if (docTop > bottom) {
                    $(window).off(action);
                    $.loadMore();
                }
            }
        });
    }

    //Endless click function
    $.endlessClick = function () {
        $(linkElem).on('click', function (e) {
            e.preventDefault();
            action = 'click';
            contentContainer = endlessClickContainer;
            moreURL = $(this).attr('href');
            pageType = 'endlessClick';
            $(linkElem).text(textChange);
            $(linkElem).off(action);
            $(linkElem).on('click', function (e) {
                e.preventDefault();
            });

            $.loadMore();
        });
    }

    //Ajaxination click function
    $.ajaxinationClick = function () {
        $(linkElem).on('click', function (e) {
            e.preventDefault();
            action = 'click';
            contentContainer = ajaxinateContainer;
            moreURL = $(this).attr('href');
            pageNumber = $(this).attr('data-number');
            pageType = 'ajax';
            if ($(contentContainer + '[data-page="' + pageNumber + '"]').length) {
                $(contentContainer).not('[data-page="' + pageNumber + '"]').hide();
                $(contentContainer + '[data-page="' + pageNumber + '"]').fadeIn(fade);
                history.pushState({}, pageNumber, moreURL);
            } else {
                $(linkElem).off(action);
                $.loadMore();
            }
            $('html, body').animate({scrollTop: $(parentContainer).offset().top}, 300);
        });
    }

    // Detect whether the pagination types exist
    // Endless Click Initialize
    if ($(endlessClickContainer).length) {
        linkElem = linkParent + ' a';
        $.endlessClick();
    }
    // Ajaxination Click Initialize
    if ($(ajaxinateContainer).length) {
        linkElem = ajaxinateLink;
        $.ajaxinationClick();
    }
    // Endless Scroll Initialize
    if ($(endlessScrollContainer).length) {
        linkElem = linkParent + ' a';
        $.endlessScroll();
    }

}
// Detect touch devices
var Helpers = (function () {
    var touchDevice = false;

    function setTouch() {
        touchDevice = true;
    }

    function isTouch() {
        return touchDevice;
    }

    return {
        setTouch: setTouch,
        isTouch: isTouch
    };
})();

// Library loader for 3D Model and Plyr video player
var LibraryLoader = (function () {
    var types = {
        link: 'link',
        script: 'script'
    };

    var status = {
        requested: 'requested',
        loaded: 'loaded'
    };

    var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';

    var libraries = {
        youtubeSdk: {
            tagId: 'youtube-sdk',
            src: 'https://www.youtube.com/iframe_api',
            type: types.script
        },
        plyrShopifyStyles: {
            tagId: 'plyr-shopify-styles',
            src: cloudCdn + 'shopify-plyr/v1.0/shopify-plyr.css',
            type: types.link
        },
        modelViewerUiStyles: {
            tagId: 'shopify-model-viewer-ui-styles',
            src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
            type: types.link
        }
    };

    function load(libraryName, callback) {
        var library = libraries[libraryName];

        if (!library) return;
        if (library.status === status.requested) return;

        callback = callback || function () {
        };
        if (library.status === status.loaded) {
            callback();
            return;
        }

        library.status = status.requested;

        var tag;

        switch (library.type) {
            case types.script:
                tag = createScriptTag(library, callback);
                break;
            case types.link:
                tag = createLinkTag(library, callback);
                break;
        }

        tag.id = library.tagId;
        library.element = tag;

        var firstScriptTag = document.getElementsByTagName(library.type)[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    function createScriptTag(library, callback) {
        var tag = document.createElement('script');
        tag.src = library.src;
        tag.addEventListener('load', function () {
            library.status = status.loaded;
            callback();
        });
        return tag;
    }

    function createLinkTag(library, callback) {
        var tag = document.createElement('link');
        tag.href = library.src;
        tag.rel = 'stylesheet';
        tag.type = 'text/css';
        tag.addEventListener('load', function () {
            library.status = status.loaded;
            callback();
        });
        return tag;
    }

    return {
        load: load
    };
})();

jQuery(function ($) {
    var Sections = {
        init: function () {
            $(document)
                .on('shopify:section:load', this._onSectionLoad)
                .on('shopify:section:unload', this._onSectionUnload)
                .on('shopify:section:select', this._onSectionSelect)
                .on('shopify:section:deselect', this._onSectionDeselect)
                .on('shopify:block:select', this._onBlockSelect)
                .on('shopify:block:deselect', this._onBlockDeselect);
        },

        /**
         * A section has been added or re-rendered.
         */
        _onSectionLoad: function (e) {
            var section = $(e.target).children('[data-section-type]').data('section-type') || false;

            Site.animations.init();

            switch (section) {
                case 'header':
                    _loadHeader(e.target);
                    break;
                case 'footer':
                    _loadFooter(e.target);
                    break;
                case 'product':
                    _loadProduct(e.target);
                    break;
                case 'gallery':
                    _loadGallery(e.target);
                    break;
                case 'mosaic':
                    _loadMosaic(e.target);
                case 'map':
                    _loadGmap(e.target);
                    break;
                case 'slideshow':
                    _loadHero(e.target);
                    break;
                case 'collection-template':
                    _loadCollectionTemplate(e.target);
                    break;
                case 'featured-collection':
                    _loadFeaturedCollection(e.target);
                    break;
                case 'collection-grid':
                    _loadListCollections(e.target);
                    break;
                case 'related-products':
                    _loadRelatedProductsTemplate(e.target);
                    break;
                case 'blog-template':
                    _loadBlogTemplate(e.target);
                    break;
                case 'featured-blog':
                    _loadFeaturedBlog(e.target);
                    break;
                case 'featured-video':
                    _loadFeaturedVideo(e.target);
                    break;
                case 'logos-list':
                    _loadLogosList(e.target);
                    break;
                case 'about-template':
                    _loadAboutTemplate(e.target);
                    break;
                case 'faq-template':
                    _loadFaqList(e.target);
                    break;
                case 'faq-section':
                    _loadFaqList(e.target);
                    break;
            }

            function _loadHeader(t) {
                Site.header.resetHeader();
                Site.nav.hide();
                Site.nav.init();
                Site.header.init();

                Search.init();
                if (!$('.template-cart').length) {
                    Cart.init();
                }

                setTimeout(function () {
                    $(window).scroll();
                }, 100);
            }

            function _loadFooter(t) {
                Site.footer();
            }

            function _loadProduct(t) {
                var sectionId = $(t).find('[data-section-id]').data('section-id'),
                    update = true;

                Product.init(update, sectionId);

                Site.video();
                Site.initReviews();
            }

            function _loadGmap(t) {
                Gmap.init();
            }

            function _loadFeaturedBlog(t) {
                Blog.init();
            }

            function _loadBlogTemplate(t) {
                // Reload ajaxify
                ajaxify();
                Blog.init();
            }

            function _loadGallery(t) {
                var slider = $(t).find('.js-slider'),
                    options = JSON.parse(slider.data('slick').replace(/'/g, '"'));

                options = $.extend({}, options, {
                    'prevArrow': '<button class="slick-prev slick-arrow" aria-label="' + window.theme.translations.previous + '" type="button">' + window.theme.icons.arrowSlider + '</button>',
                    'nextArrow': '<button class="slick-next slick-arrow" aria-label="' + window.theme.translations.next + '" type="button">' + window.theme.icons.arrowSlider + '</button>'
                });

                slider.on('init', function () {
                    $(this).removeClass('gallery-slider--is-loading');
                });
                slider.slick(options);
            }

            function _loadMosaic(t) {
                var section = $(t),
                    slider = $(t).find('.js-mosaic__blocks'),
                    sectionId = $(t).children().first().data('section-id'),
                    lastWindowWidth = window.innerWidth || document.documentElement.clientWidth;

                Site.sliders.initMobileSlider(slider);
                Site.sliders.truncateMosaicText(section);
                Site.video();

                $(window)
                    .on('load', Site.sliders.truncateMosaicText(section))
                    .on('resize.' + sectionId, Reqs.debounce(function () {
                        var windowWidth = window.innerWidth || document.documentElement.clientWidth;

                        // Continue on window resize width change only
                        if (lastWindowWidth != windowWidth) Site.sliders.initMobileSlider(slider);
                        lastWindowWidth = windowWidth;
                        Site.sliders.truncateMosaicText(section);
                    }, 250));
            }

            function _loadHero(t) {
                var hero = $(t).find('.js-hero-slider'),
                    options = JSON.parse(hero.data('slick').replace(/'/g, '"')),
                    scrollDownBtn = $(t).find('.js-scroll-down');

                options = $.extend({}, options, {
                    'prevArrow': '<button class="slick-prev slick-arrow" aria-label="' + window.theme.translations.previous + '" type="button">' + window.theme.icons.arrowSlider + '</button>',
                    'nextArrow': '<button class="slick-next slick-arrow" aria-label="' + window.theme.translations.next + '" type="button">' + window.theme.icons.arrowSlider + '</button>'
                });

                hero.on('init', function () {
                    var currentStyle = $(this).find('.js-slide[data-slick-index="1"]').data('style');
                    $(this).attr('data-current-style', currentStyle);
                    $(this).removeClass('hero--is-loading');
                });

                hero.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                    var activeSlide = parseInt(nextSlide + 1);
                    var $nextSlide = $(this).find('.js-slide[data-slick-index="' + activeSlide + '"]');
                    var currentStyle = $nextSlide.data('style');

                    $(this).attr('data-current-style', currentStyle);

                    $nextSlide.find('.will-lazyload').removeClass('will-lazyload').addClass('lazyload');
                });

                hero.slick(options);

                $(window).on('scroll.slideshow resize.slideshow', Reqs.throttle(function () {
                    var windowHeight = $(window).height();
                    var windowScroll = $(window).scrollTop();
                    var heroHeight = hero.height();
                    var heroOffsetTop = hero.offset().top;

                    // If Hero is outside the the viewport pause slideshow
                    if (heroOffsetTop + heroHeight >= windowScroll && heroOffsetTop - windowHeight <= windowScroll && options.autoplay) {
                        hero.slick('slickPlay');
                    } else {
                        hero.slick('slickPause');
                    }
                }, 10));

                scrollDownBtn.on('click', function (e) {
                    e.preventDefault();
                    var headerHeight = 59;
                    var scrollToPosition = parseInt(hero.offset().top + hero.outerHeight() - headerHeight);
                    $('html, body').stop(true, false).animate({'scrollTop': scrollToPosition}, 500);
                });

                Site.header.resetHeader();
                Site.header.init();
            }

            function _loadFeaturedCollection(t) {
                var collectionGrid = $(t).find('.js-collectionGrid'),
                    sectionId = collectionGrid.data('section-id');

                Collection.init();

                Site.initReviews();
                Site.sliders.collection();
                Site.sliders.setCarouselState(collectionGrid);
                $(window).on('resize.' + sectionId, Reqs.debounce(function () {
                    Site.sliders.setCarouselState(collectionGrid);
                }, 250));
            }

            function _loadCollectionTemplate(t) {
                Collection.init();
                Site.sliders.collection();
                Site.initReviews();
            }

            function _loadListCollections(t) {
                var collectionList = $(t).find('.collectionList'),
                    sectionId = collectionList.data('section-id');

                ListCollections.truncateBlockText(collectionList);
                $(window).on('resize.' + sectionId, Reqs.throttle(function () {
                    ListCollections.truncateBlockText(collectionList);
                }, 50));
                $(document).on('ajaxify:updated', function () {
                    ListCollections.truncateBlockText(collectionList);
                });
            }

            function _loadFeaturedVideo(t) {
                var videoContainer = $(t);

                videoContainer.on('lazybeforeunveil', Site.setVideoHeight(videoContainer));
                Site.setVideoHeight(videoContainer);
                Site.video();
                $(window).trigger('resize');
            }

            function _loadLogosList(t) {
                var slider, options;

                slider = $(t).find('.js-logos-slider');
                options = {
                    'infinite': true,
                    'autoplay': false,
                    'speed': 300,
                    'slidesToShow': 8,
                    'centerPadding': '80px',
                    'arrows': true,
                    'dots': false,
                    'prevArrow': '<button class="slick-prev slick-arrow" aria-label="' + window.theme.translations.previous + '" type="button">' + window.theme.icons.arrowSlider + '</button>',
                    'nextArrow': '<button class="slick-next slick-arrow" aria-label="' + window.theme.translations.next + '" type="button">' + window.theme.icons.arrowSlider + '</button>',
                    'responsive': [
                        {
                            'breakpoint': 1440,
                            'settings': {
                                'centerPadding': '40px',
                                'slidesToShow': 6
                            }
                        },
                        {
                            'breakpoint': 1024,
                            'settings': {
                                'centerPadding': '30px',
                                'slidesToShow': 5
                            }
                        },
                        {
                            'breakpoint': 992,
                            'settings': {
                                'centerPadding': '25px',
                                'slidesToShow': 4
                            }
                        },
                        {
                            'breakpoint': 768,
                            'settings': {
                                'centerPadding': '20px',
                                'slidesToShow': 3
                            }
                        },
                        {
                            'breakpoint': 640,
                            'settings': {
                                'centerPadding': '15px',
                                'slidesToShow': 2
                            }
                        },
                        {
                            'breakpoint': 375,
                            'settings': {
                                'centerPadding': '10px',
                                'slidesToShow': 1
                            }
                        }
                    ]
                };

                slider.slick(options);
            }

            function _loadAboutTemplate(t) {
                Site.header.init();
            }

            function _loadRelatedProductsTemplate(t) {
                RelatedProducts.init();
            }

            function _loadFaqList(t) {
                var $faqList = $(t).find('.faq-list');

                $faqList.on('click', '.faq-list__item-question', function (e) {
                    e.preventDefault();
                    $(this).parent().toggleClass('is-expanded');
                });
            }
        },

        /**
         * A section has been deleted or is being re-rendered.
         */
        _onSectionUnload: function (e) {
            var section = e.target.children[0].getAttribute('data-section-type') || false;

            switch (section) {
                case 'header':
                    _unloadHeader(e.target);
                    break;
                case 'gallery':
                    _unloadGallery(e.target);
                    break;
                case 'slideshow':
                    _unloadHero(e.target);
                    break;
                case 'logos-list':
                    _unloadLogosList(e.target);
                    break;
                case 'mosaic':
                    _unloadMosaic(e.target);
                    break;
                case 'popup':
                    _unloadPopup(e.target);
                    break;
                case 'product':
                    _unloadProduct(e.target);
                    break;
                case 'collection-grid':
                    _unloadListCollections(e.target);
                    break;
                case 'collection-template':
                    _unloadProductGrid(e.target);
                    break;
                case 'featured-collection':
                    _unloadProductGrid(e.target);
                    break;
                case 'related-products':
                    _unloadProductGrid(e.target);
                    break;
                case 'blog-template':
                    _unloadBlogTemplate(e.target);
                    break;
            }

            function _unloadHeader(t) {
                $(window).off('scroll.header resize.header');
            }

            function _unloadGallery(t) {
                var slider = $(t).find('.js-slider');

                slider.slick('unslick');

                $(window).off('scroll.gallery');
            }

            function _unloadHero(t) {
                var hero = $(t).find('.js-hero-slider');

                hero.slick('unslick');

                $(window).off('scroll.slideshow resize.slideshow');
            }

            function _unloadLogosList(t) {
                var slider = $(t).find('.js-logos-slider');

                slider.slick('unslick');
            }

            function _unloadMosaic(t) {
                var slider = $(t).find('.js-mosaic__blocks'),
                    isSlickActive = slider.hasClass('slick-initialized'),
                    sectionId = sectionId = $(t).children().first().data('section-id');

                if (isSlickActive) {
                    slider.slick('unslick');
                }
                $(window).off('resize.' + sectionId);
            }

            function _unloadPopup(t) {
                Popup.hide();
            }

            function _unloadListCollections(t) {
                var sectionId = $(t).children().first().data('section-id'),
                    actions = 'scroll.endlessScroll--' + sectionId + ' load resize.endlessScroll--' + sectionId + ' resize.' + sectionId;

                // Destroy ajaxify event listeners
                $(window).off(actions);
            }

            function _unloadProduct(t) {
                var sectionId = $(t).children().first().data('section-id'),
                    $shopBar = $('#shop-bar');

                $shopBar.remove();

                ProductVideo.removeSectionVideos(sectionId);
                ProductModel.removeSectionModels(sectionId);

                $(window).off('resize.product');
                $(window).off('scroll.product');
            }

            function _unloadProductGrid(t) {
                var sectionId = $(t).children().first().data('section-id'),
                    actions = 'resize.' + sectionId + ' scroll.endlessScroll--' + sectionId + ' load resize.endlessScroll--' + sectionId;

                $(window).off(actions);
                $(window).off('resize.collection');
            }

            function _unloadBlogTemplate(t) {
                var sectionId = $(t).children().first().data('section-id'),
                    actions = 'scroll.endlessScroll--' + sectionId + ' load resize.endlessScroll--' + sectionId;

                // Destroy ajaxify event listeners
                $(window).off(actions);
            }
        },

        /**
         * User has selected the section in the sidebar.
         */
        _onSectionSelect: function (e) {
            var section = e.target.children[0].getAttribute('data-section-type') || e.target.children[1].getAttribute('data-section-type') || e.target.children[2].getAttribute('data-section-type') || false;

            switch (section) {
                case 'header':
                    _selectHeader(e.target);
                    break;
                case 'blog-template':
                    _selectBlog(e.target);
                    break;
                case 'popup':
                    _selectPopup(e.target);
                    break;
                case 'featured-video':
                    _selectFeaturedVideo(e.target);
                    break;
            }

            function _selectHeader(t) {
                Site.header.resetHeader();
                Site.nav.hide();
                Site.header.init();
            }

            function _selectPopup(t) {
                Popup.init();
            }

            function _selectBlog(t) {
                Blog.init();
            }

            function _selectFeaturedVideo(t) {
                var videoContainer = $(t);

                videoContainer.on('lazybeforeunveil', Site.setVideoHeight(videoContainer));
                Site.setVideoHeight(videoContainer);
                $(window).trigger('resize');
            }
        },

        /**
         * User has selected the section in the sidebar.
         */
        _onSectionDeselect: function (e) {
            var section = e.target.children[0].getAttribute('data-section-type') || false;

            switch (section) {
                case 'header':
                    _deselectHeader(e.target);
                    break;
            }

            function _deselectHeader(t) {
                Site.nav.hide();
            }

        },

        /**
         * User has selected the block in the sidebar.
         */
        _onBlockSelect: function (e) {
            var block = e.target.getAttribute('data-block') || false;

            switch (block) {
                case 'slide':
                    _selectBlockSlide(e.target);
                    break;
                case 'mosaic':
                    _selectBlockMosaic(e.target);
                    break;
                case 'testimonial':
                    _selectBlockTestimonial(e.target);
                    break;
                case 'item_logo':
                    _selectBlockItemLogo(e.target);
                    break;
            }

            function _selectBlockSlide(t) {
                var slider = $(t).parents('.slick-slider'),
                    index = $(t).parents('.slick-slide:not(.slick-cloned)').attr('data-slick-index');

                slider.slick('slickGoTo', index);
                slider.slick('slickPause');
            }

            function _selectBlockMosaic(t) {
                var section = $(t).parents('.section-mosaic'),
                    slider = $(t).parents('.js-mosaic__blocks'),
                    isSlickActive = slider.hasClass('slick-initialized'),
                    index;

                if (isSlickActive) {
                    index = $(t).parents('.slick-slide:not(.slick-cloned)').attr('data-slick-index');

                    slider.slick('slickGoTo', index);
                    slider.slick('slickPause');
                }

                Site.sliders.truncateMosaicText(section);
                Site.video();
            }

            function _selectBlockItemLogo(t) {
                var slider = $(t).parents('.js-logos-slider'),
                    index = $(t).parents('.slick-slide:not(.slick-cloned)').attr('data-slick-index');

                slider.slick('slickGoTo', index);
            }
        },

        /**
         * User has DEselected the block in the sidebar.
         */
        _onBlockDeselect: function (e) {
            var block = e.target.getAttribute('data-block') || false;

            switch (block) {
                case 'slide':
                    _deselectBlockSlide(e.target);
                    break;
                case 'item_logo':
                    _deselectBlockItemLogo(e.target);
                    break;
            }

            function _deselectBlockSlide(t) {
                var slider = $(t).parents('.slick-slider'),
                    options = JSON.parse(slider.data('slick').replace(/'/g, '"'));

                if (options.autoplay) {
                    slider.slick('slickPlay');
                }
            }

            function _deselectBlockItemLogo(t) {
                var slider = $(t).parents('.js-logos-slider');
                slider.slick('slickPlay');
            }
        }
    }

    var s;
    window.Site = {
        settings: {
            b: $('body'),
            w: $(window),
            d: $(document)
        },

        init: function () {
            s = this.settings;

            this.general();
            this.setScrollbarWidth();
            this.header.init();
            this.footer();
            this.nav.init();
            this.sliders.init();
            this.addresses.init();
            this.webkitSizing();
            this.keyboardAccessible();
            this.video();
            this.faq();
            this.checkReviewsApp();

            if (this.getQueryParameter('customer_posted') == "true") {
                $('body').addClass('signUp-posted');
                s.d.scrollTop(s.d.height() - s.w.height());
            }
        },

        /*
		 * General Bindings
		 */
        general: function () {
            // Social sharing links
            s.b.on('click', '.share-link', function (event) {

                event.preventDefault();

                var el = $(this),
                    popup = el.attr('data-network'),
                    link = el.attr('href'),
                    w = 700,
                    h = 400;

                switch (popup) {
                    case 'twitter':
                        h = 300;
                        break;
                }

                window.open(link, popup, 'width=' + w + ', height=' + h);
            });

            // Smooth scroll to anchored element
            s.b.on('click', '[data-anchor-link]', function (e) {
                var anchor = $(this).attr('href');

                if ($(anchor).length) {
                    var anchorTop = $(anchor).offset().top - 60;
                    $('html, body').stop().animate({scrollTop: anchorTop});

                    e.preventDefault();
                }

            });
        },

        setScrollbarWidth: function () {
            var root = document.documentElement,
                scrollbarWidth = scrollLock.getPageScrollBarWidth() + 'px';

            root.style.setProperty('--scrollbar-width', scrollbarWidth);
        },

        getQueryParameter: function (name) {
            name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
            var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
                results = regex.exec(location.search);
            return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
        },

        keyboardAccessible: function () {
            s.w.mousedown(function (event) {
                s.b.addClass("no-outline");
            });
            s.w.keyup(function (event) {
                if (event.keyCode === 9) {
                    s.b.removeClass("no-outline");
                }
            });
        },

        webkitSizing: function () {
            if (Modernizr.touch) {
                var ww = $(window).outerWidth();
                var nw = Site.nav.getWidth();

                $('html, body').css({'max-width': ww});
                // Size offcanvas nav
                $('.nav-hamburger').css({'width': nw});
                // Size header
                $('.site-header').css({'width': ww});

                $(window).resize(function () {
                    var ww = $(window).outerWidth();
                    var nw = Site.nav.getWidth();

                    $('html, body').css({'max-width': ww});
                    // Size offcanvas nav
                    $('.nav-hamburger').css({'width': nw});
                    // Size header
                    $('.site-header').css({'width': ww});
                });
            }
        },

        /*
		 * Header Scroll Function
		 */
        header: {
            init: function () {
                var $header = $('.site-header'),
                    $bodyWrap = $('.bodyWrap'),
                    lastWindowWidth = window.innerWidth || document.documentElement.clientWidth,
                    stickyHeader = document.querySelectorAll('#shopify-section-header');

                // Sticky header IE polyfill
                Stickyfill.add(stickyHeader);
                checkNavigationOverlapping();

                $(window)
                    .off('resize.header scroll.header')
                    .on('load', checkNavigationOverlapping)
                    .on('scroll.header', Reqs.throttle(stickyHeaderState, 50))
                    .on('resize.header', Reqs.throttle(Site.setCartClosePosition, 50))
                    .on('resize.header', Reqs.debounce(function () {
                        var windowWidth = window.innerWidth || document.documentElement.clientWidth;

                        // Skip window height resize event
                        if (lastWindowWidth != windowWidth) checkNavigationOverlapping();
                        lastWindowWidth = windowWidth;
                    }, 250));

                function stickyHeaderState() {
                    var scrolled = $(window).scrollTop(),
                        contentTop = $bodyWrap.offset().top;
                    if (scrolled > contentTop) {
                        $header.addClass('header--has-scrolled');
                    } else {
                        $header.removeClass( 'header--has-scrolled' );
                    }
                }

                function checkNavigationOverlapping() {
                    var isNavigationStandard = $header.hasClass('header--standard'),
                        $scrollableElement = document.querySelector('.nav-search-scroller');

                    if (isNavigationStandard) {
                        var isNavigationOverlapping = getNavigationOverlapping();
                        var isDesktop = $(window).width() >= 1024;

                        if (isNavigationOverlapping || !isDesktop) {
                            $header.removeClass('header--is-standard header--search-visible').addClass('header--is-hamburger');
                            scrollLock.enablePageScroll($scrollableElement);
                        } else {
                            Site.nav.hide();
                        }
                    }

                    setBodySpacer();
                    setTimeout(setBodySpacer, 100); // Needed for section:unload event when section is disabled
                }

                function getNavigationOverlapping() {
                    $header.addClass('header--is-standard').removeClass('header--is-hamburger');

                    var headerContainerWidth = $('.site-header .container > .row').width();
                    var navMenuWidth = getMenuItemsWidth();
                    var isNavigationOverlapping = false;
                    var isNavCentered = $header.hasClass('header--logo_center_links_center') || $header.hasClass('header--logo_left_links_center');
                    var isNavLeftLogoCentered = $header.hasClass('header--logo_center_links_left') || $header.hasClass('header--logo_left_links_left');
                    var additionalSpace = 40; // Additional spacing from margins
                    var headerIconsWidth = $('.header-icons').outerWidth();
                    var logoWidth = $('.main-logo__image').length ? $('.main-logo__image').data('width') : 0;
                    logoWidth += $('.main-logo__text').outerWidth();

                    if (isNavCentered) {
                        logoWidth = logoWidth < headerIconsWidth ? headerIconsWidth : logoWidth;
                        logoWidth = logoWidth * 2;
                        headerIconsWidth = 0;
                    }

                    isNavigationOverlapping = parseInt(headerContainerWidth) < parseInt(navMenuWidth + logoWidth + headerIconsWidth + additionalSpace);

                    if (isNavLeftLogoCentered) {
                        isNavigationOverlapping = parseInt((headerContainerWidth - logoWidth) / 2) < parseInt(navMenuWidth);
                    }

                    return isNavigationOverlapping;
                }

                function getMenuItemsWidth() {
                    var itemsWidth = 0;
                    $('.nav-standard .menu > li').each(function () {
                        itemsWidth += $(this).outerWidth(true);
                    });
                    return itemsWidth;
                }

                function setBodySpacer() {
                    var heroEnabled = Site.isHeroEnabled();

                    if (heroEnabled) {
                        $header.addClass('header--no-bg');
                        $bodyWrap.removeAttr('data-spacer');
                    } else {
                        $header.removeClass('header--no-bg');
                        $bodyWrap.attr('data-spacer', 'default');

                        if ($header.hasClass('header--is-hamburger')) {
                            $bodyWrap.attr('data-spacer', 'small');
                        } else if ($header.hasClass('header--logo_center_links_center'))
                            $bodyWrap.attr('data-spacer', 'large');
                    }
                }
            },

            resetHeader: function () {
                var $body = $('body'),
                    $bodyWrap = $('.bodyWrap'),
                    $hamburger = $('#hamburger-menu'),
                    $transformElements = $('.site-header, .siteAlert, .bodyWrap, .shop-bar'),
                    $scrollableElement = document.querySelector('.nav-inner');

                $body.removeClass('nav--is-visible');
                $bodyWrap.removeAttr('style');
                $transformElements.css('transform', 'none');
                $hamburger.removeClass('open');

                scrollLock.enablePageScroll($scrollableElement);

                if ($body.hasClass('cart--is-visible')) {
                    $('.js-cartToggle').trigger('click');
                }
            }
        },

        isHeroEnabled: function () {
            return $('.main-content').children().first('.shopify-section').hasClass('header--full') || $('.main-content').children().first('.shopify-section').find('[data-header-style="index"]').length;
        },

        setCartClosePosition: function () {
            if ($('#cartTotal').length) {
                var $cartBtnClose = $('.cartContainer .js-cartToggle'),
                    scrollTop = $(window).scrollTop(),
                    cartBtnPositionTop = $('#cartTotal').offset().top - scrollTop,
                    containerPadding = 40,
                    cartBtnTop = cartBtnPositionTop - containerPadding;

                $cartBtnClose.css('top', cartBtnTop);
            }
        },

        footer: function () {
            var $shopBar = $('#shop-bar');
            var $productContainer = $('.js-product-template');
            var $siteFooter = $('.site-footer');

            var selectors = {
                disclosureLocale: '[data-disclosure-locale]',
                disclosureCurrency: '[data-disclosure-currency]'
            };

            var $disclosureLocale = $(selectors.disclosureLocale, $siteFooter);
            var disclosureLocale = {};

            var $disclosureCurrency = $(selectors.disclosureCurrency, $siteFooter);
            var disclosureCurrency = {};

            if ($disclosureLocale.length) {
                disclosureLocale = new Disclosure($disclosureLocale);
            }
            if ($disclosureCurrency.length) {
                disclosureCurrency = new Disclosure($disclosureCurrency);
            }

            $(window).on('scroll',
                Reqs.throttle(function () {
                    var scrolled = $(window).scrollTop();

                    if ($productContainer.length && $shopBar.length) {
                        var productContainerOffset = $productContainer.offset().top;

                        if (scrolled > productContainerOffset) {
                            $shopBar.addClass('shop-bar--is-visible');
                            $siteFooter.addClass('site-footer--push')
                        } else if (scrolled < productContainerOffset - 60) {
                            $shopBar.removeClass('shop-bar--is-visible');
                            $siteFooter.removeClass('site-footer--push')
                        }
                    }
                }, 100)
            );
        },

        video: function () {
            var self = this;

            Reqs.lightbox();
            $('.js-video').each(function () {
                var container = $(this).closest('.video-module');
                var isImageHeight = $(container).data('height') == 'original-height';

                if (isImageHeight) {
                    self.setVideoHeight(container);
                    $(window).on('resize', Reqs.debounce(function () {
                        self.setVideoHeight(container);
                    }, 250));
                    $(container).on('lazybeforeunveil', self.setVideoHeight(container));
                }

                $(this).magnificPopup({
                    closeMarkup: '<button title="%title%" type="button" class="mfp-close">' + window.theme.icons.close + '</button>',
                    type: 'iframe',
                    mainClass: 'mfp-fade',
                    removalDelay: 160,
                    preloader: false,
                    autoFocusLast: false,
                    fixedContentPos: false,
                    iframe: {
                        markup: '<div class="mfp-iframe-scaler">' +
                            '<div class="mfp-close"></div>' +
                            '<iframe class="mfp-iframe" frameborder="0" allowfullscreen allow="autoplay, fullscreen"></iframe>' +
                            '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button
                        patterns: {
                            youtube: {
                                index: 'youtube.com/',
                                id: 'v=',
                                src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0modestbranding=0' // URL that will be set as a source for iframe.
                            },
                            youtube_short: {
                                index: 'youtu.be/',
                                id: 'youtu.be/',
                                src: '//www.youtube.com/embed/%id%?autoplay=1&autohide=0&branding=0&cc_load_policy=0&controls=0&fs=0&iv_load_policy=3&modestbranding=1&playsinline=1&quality=hd720&rel=0&showinfo=0&wmode=opaque'
                            }
                        },
                        srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
                    }
                });
            });
        },

        setVideoHeight: function (container) {
            var contentHeight = $(container).find('.video-text__content').outerHeight();
            var $videoContainer = $(container).find('.video-container > img, .video-placeholder, .placeholder-svg');

            $videoContainer.css('min-height', contentHeight)
        },

        faq: function () {
            $('.faq-list__item-question').on('click', function (e) {
                e.preventDefault();
                $(this).parent().toggleClass('is-expanded');
            });
        },

        /*
		 * Sliders
		 */
        sliders: {
            init: function () {
                this.hero();
                this.carousel();
                this.collection();
                this.gallery();
                this.mosaic();
                this.logosList();
            },

            /* Homepage Hero Slider */
            hero: function () {
                var hero = $('.js-hero-slider'),
                    scrollDownBtn = $('.js-scroll-down');

                if (!Modernizr.cssvhunit || !Modernizr.cssvmaxunit) hero.css('height', $(window).height());

                hero.each(function () {
                    var currentHero = $(this),
                        options = JSON.parse(currentHero.data('slick').replace(/'/g, '"'));

                    options = $.extend({}, options, {
                        'prevArrow': '<button class="slick-prev slick-arrow" aria-label="' + window.theme.translations.previous + '" type="button">' + window.theme.icons.arrowSlider + '</button>',
                        'nextArrow': '<button class="slick-next slick-arrow" aria-label="' + window.theme.translations.next + '" type="button">' + window.theme.icons.arrowSlider + '</button>'
                    });

                    currentHero.on('init', function () {
                        var currentStyle = $(this).find('.js-slide[data-slick-index="1"]').data('style');
                        $(this)
                            .attr('data-current-style', currentStyle)
                            .removeClass('hero--is-loading');
                    });

                    currentHero.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                        var activeSlide = parseInt(nextSlide + 1),
                            $nextSlide = $(this).find('.js-slide[data-slick-index="' + activeSlide + '"]'),
                            currentStyle = $nextSlide.data('style');

                        $(this).attr('data-current-style', currentStyle);

                        $nextSlide.find('.will-lazyload').removeClass('will-lazyload').addClass('lazyload');
                    });

                    currentHero.slick(options);

                    $(window).on('scroll.slideshow resize.slideshow', Reqs.throttle(function () {
                        var isSlideshowVisible = currentHero.visible(true),
                            slickInitialized = currentHero.hasClass('slick-initialized');

                        if (slickInitialized) {
                            if (isSlideshowVisible && options.autoplay) {
                                // If Hero is inside the viewport play slideshow
                                currentHero.slick('slickPlay');
                            } else {
                                // If Hero is outside the the viewport pause slideshow
                                currentHero.slick('slickPause');
                            }
                        }
                    }, 100));
                });

                $('.slick-list').attr('tabindex', '-1');

                scrollDownBtn.on('click', function (e) {
                    e.preventDefault();
                    var headerHeight = 59;
                    var scrollToPosition = parseInt(hero.offset().top + hero.outerHeight() - headerHeight);
                    $('html, body').stop(true, false).animate({'scrollTop': scrollToPosition}, 500);
                });
            },

            /* Carousel Slider
			 * Called multiple times throughout site
			 */
            carousel: function () {
                var $carousel = $('.js-carousel-slider');
                var flickity = $carousel.data('flickity');
                if (flickity == undefined) {
                    $carousel.flickity({
                        cellSelector: '.js-slide',
                        cellAlign: 'center',
                        watchCSS: true,
                        prevNextButtons: false,
                        pageDots: false
                    });
                }
            },

            /* Collection Slider */
            collection: function () {
                var $container = $('.js-collection-grid');
                var $carousel = $('.js-collection-slider');

                $carousel.find('.will-animate').removeClass('will-animate');

                $('.quickView-button', $carousel).on('click', function () {
                    $(this).closest('.slick-slide').addClass('slick-slide--quickView');
                });

                $('html, body').on('quickView:show', function () {
                    setQuickViewPosition();
                    $carousel.find('.slick-slide--quickView').removeClass('slick-slide--quickView');
                });

                $('html, body').on('quickView:ajax', setQuickViewPosition);

                $container.each(function () {
                    Site.sliders.setCarouselState($(this));
                });

                $(window).on('resize', Reqs.debounce(function () {
                    setQuickViewPosition();

                    $container.each(function () {
                        Site.sliders.setCarouselState($(this));
                    });
                }, 250));

                function setQuickViewPosition() {
                    var $slide = $carousel.find('.slick-slide--quickView');

                    if (!$slide.length) {
                        $slide = $carousel.find('.quickView--is-visible').closest('.slick-slide');
                    }

                    if ($carousel.length && $slide.length) {
                        var $quickView = $slide.find('.quickView-wrap');
                        var offsetLeft = $carousel.find('.slick-slide.slick-current').position().left - $slide.position().left;

                        $quickView.css('left', offsetLeft);
                    }
                }
            },

            setCarouselState: function ($container) {
                if (typeof $container == 'undefined') return;

                Site.removeAnimationClass($container);

                var $carousel = $container.find('.js-collection-slider');

                if ($carousel.length) {
                    var isDesktopInitialized = $carousel.hasClass('slick-initialized'),
                        slidesPerRow = parseInt($container.data('slides-per-row')),
                        windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
                        options = {
                            'slidesPerRow': slidesPerRow,
                            'infinite': false,
                            'dots': false,
                            'prevArrow': '<button class="slick-prev slick-arrow" aria-label="' + window.theme.translations.previous + '" type="button">' + window.theme.icons.arrowLong + '</button>',
                            'nextArrow': '<button class="slick-next slick-arrow" aria-label="' + window.theme.translations.next + '" type="button">' + window.theme.icons.arrowLong + '</button>',
                            'responsive': [
                                {
                                    'breakpoint': 1024,
                                    'settings': {
                                        'slidesPerRow': 2
                                    }
                                }
                            ]
                        };

                    if (windowWidth >= 768) {
                        // Init carousel on desktop
                        initDesktopCarousel();
                    } else {
                        // Destroy carousel if initialized on desktop
                        if (isDesktopInitialized) {
                            $carousel.slick('unslick');
                        }
                    }

                    setArrowsPosition();
                }

                function initDesktopCarousel() {
                    if (!isDesktopInitialized) {
                        $carousel.on('init', setArrowsPosition);
                        $carousel
                            .slick(options)
                            .on('beforeChange', function () {
                                if ($('.quickView--is-visible').length) {
                                    QuickView.hide();
                                }
                            });
                    }
                }

                function setArrowsPosition() {
                    var $arrows = $carousel.find('.slick-arrow');
                    var arrowTop = $carousel.find('.collectionBlock-image').outerHeight() / 2;
                    $arrows.css('top', arrowTop);
                }
            },

            /* Gallery Slider */
            gallery: function () {
                var slider = $('.js-slider');

                slider.each(function () {
                    var currentSlider = $(this),
                        options = JSON.parse(currentSlider.data('slick').replace(/'/g, '"'));

                    options = $.extend({}, options, {
                        'prevArrow': '<button class="slick-prev slick-arrow" aria-label="' + window.theme.translations.previous + '" type="button">' + window.theme.icons.arrowSlider + '</button>',
                        'nextArrow': '<button class="slick-next slick-arrow" aria-label="' + window.theme.translations.next + '" type="button">' + window.theme.icons.arrowSlider + '</button>'
                    });

                    currentSlider.on('init', function () {
                        $(this).removeClass('gallery-slider--is-loading');
                    });

                    currentSlider.slick(options);

                    // Pause slider if it's outside the viewport to prevent elements shaking
                    $(window).on('scroll.gallery',
                        Reqs.debounce(function () {
                            var isSliderVisible = isAnyPartOfElementInViewport(currentSlider.get(0));

                            if (isSliderVisible && options.autoplay) {
                                currentSlider.slick('slickPlay');
                            } else {
                                currentSlider.slick('slickPause');
                            }
                        }, 150)
                    );
                });

                function isAnyPartOfElementInViewport(el) {

                    const rect = el.getBoundingClientRect();
                    const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
                    const windowWidth = (window.innerWidth || document.documentElement.clientWidth);

                    const vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
                    const horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);

                    return (vertInView && horInView);
                }
            },

            /* Mosaic Slider Mobile */
            mosaic: function () {
                var self = this,
                    slider = $('.js-mosaic__blocks');

                slider.each(function () {
                    var currentSlider = $(this),
                        section = $(this).closest('.section-mosaic'),
                        sectionId = $(this).closest('[data-section-id]').data('section-id'),
                        lastWindowWidth = window.innerWidth || document.documentElement.clientWidth;

                    self.initMobileSlider(currentSlider);
                    $(window)
                        .on('load', self.truncateMosaicText(section))
                        .on('resize.' + sectionId, Reqs.debounce(function () {
                            var windowWidth = window.innerWidth || document.documentElement.clientWidth;

                            // Continue on window resize width change only
                            if (lastWindowWidth != windowWidth) self.initMobileSlider(currentSlider);
                            lastWindowWidth = windowWidth;

                            self.truncateMosaicText(section)
                        }, 250));
                });
            },

            truncateMosaicText: function (container) {
                $(container).find('.mosaic__heading, .mosaic__subheading').trunk8({lines: 1});
                $(container).find('.mosaic__text').trunk8({lines: 2});
                $(container).find('.mosaic__block-text-title').trunk8({lines: 3});
                $(container).find('.mosaic__image-text > p').trunk8({lines: 8});
            },

            initMobileSlider: function (currentSlider) {
                var isMobile = $(window).width() < 768;
                var isSlickActive = currentSlider.hasClass('slick-initialized');
                var options = {
                    'infinite': true,
                    'autoplay': false,
                    'speed': 300,
                    'slidesToShow': 1,
                    'arrows': true,
                    'prevArrow': '<button class="slick-prev slick-arrow" aria-label="' + window.theme.translations.previous + '" type="button">' + window.theme.icons.arrowSlider + '</button>',
                    'nextArrow': '<button class="slick-next slick-arrow" aria-label="' + window.theme.translations.next + '" type="button">' + window.theme.icons.arrowSlider + '</button>',
                    'dots': false
                };

                // Init Slick on mobily only and destroy it otherwise
                if (isMobile && !isSlickActive) {
                    currentSlider.slick(options);
                } else if (!isMobile && isSlickActive) {
                    currentSlider.slick('unslick');
                }
            },

            /* Logos list carousel */
            logosList: function () {
                var self = this;
                var slider = $('.js-logos-slider');
                var options = {
                    'infinite': true,
                    'autoplay': false,
                    'speed': 300,
                    'slidesToShow': 8,
                    'centerPadding': '80px',
                    'arrows': true,
                    'dots': false,
                    'prevArrow': '<button class="slick-prev slick-arrow" aria-label="' + window.theme.translations.previous + '" type="button">' + window.theme.icons.arrowSlider + '</button>',
                    'nextArrow': '<button class="slick-next slick-arrow" aria-label="' + window.theme.translations.next + '" type="button">' + window.theme.icons.arrowSlider + '</button>',
                    'responsive': [
                        {
                            'breakpoint': 1440,
                            'settings': {
                                'centerPadding': '40px',
                                'slidesToShow': 6
                            }
                        },
                        {
                            'breakpoint': 1024,
                            'settings': {
                                'centerPadding': '30px',
                                'slidesToShow': 5
                            }
                        },
                        {
                            'breakpoint': 992,
                            'settings': {
                                'centerPadding': '25px',
                                'slidesToShow': 4
                            }
                        },
                        {
                            'breakpoint': 768,
                            'settings': {
                                'centerPadding': '20px',
                                'slidesToShow': 3
                            }
                        },
                        {
                            'breakpoint': 640,
                            'settings': {
                                'centerPadding': '15px',
                                'slidesToShow': 2
                            }
                        },
                        {
                            'breakpoint': 375,
                            'settings': {
                                'centerPadding': '10px',
                                'slidesToShow': 1
                            }
                        }
                    ]
                };

                slider.each(function () {
                    $(this).slick(options);
                });
            },

            checkThumbnailsOverflow: function ($thumbs) {
                var thumbWidth = $thumbs.find('.js-slide').outerWidth(),
                    slidesCount = $thumbs.find('.js-slide').length,
                    slidesWidth = parseInt(thumbWidth * slidesCount),
                    slidesContainerWidth = $thumbs.width();

                return (slidesContainerWidth < slidesWidth);
            },
        },

        /*
		 * Main Menu
		 */
        nav: {
            getWidth: function () {
                var ww = $(window).outerWidth();

                if (ww >= 1280) {
                    return ww / 3;
                } else if (ww >= 768) {
                    return ww * 2 / 3;
                } else {
                    return ww;
                }
            },
            init: function () {
                Site.nav.bindings();
                Site.nav.activeLinks();
            },
            bindings: function () {
                var $body = $('body'),
                    $header = $('.site-header');

                $('.js-menuToggle').on('click', function (e) {
                    e.preventDefault();

                    $('body').hasClass('nav--is-visible') ? Site.nav.hide() : Site.nav.show();
                });

                $('.nav-standard .has-submenu').on('mouseover', function () {
                    $(this).addClass('is-expanded').find('a[aria-expanded]').attr('aria-expanded', true);
                    $(this).siblings().removeClass('is-expanded').find('a[aria-expanded]').attr('aria-expanded', false);
                });

                // Close dropdown
                $('.nav-standard .menu-item--dropdown').on('mouseleave', function () {
                    $(this).removeClass('is-expanded').find('a[aria-expanded]').attr('aria-expanded', false);
                });

                // Open/close megamenu
                $('.nav-standard .menu-item--meganav')
                    .on('mouseover', function () {
                        $('.site-header').addClass('header--megamenu-visible');
                        $(this).find('.visible-nav-link').removeAttr('tabindex');
                    })
                    .on('mouseleave', function () {
                        $(this).removeClass('is-expanded').find('a[aria-expanded]').attr('aria-expanded', false);
                        $('.site-header').removeClass('header--megamenu-visible');
                        $('.visible-nav-link').attr('tabindex', '-1');
                    });

                // A11y
                $('.nav-standard .toggle-submenu').on('click', function (e) {
                    var el = $(this),
                        isSubmenuOpen = el.parent().hasClass('is-expanded');

                    if (isSubmenuOpen) {
                        // Close mega menu
                        Site.nav.submenuStandard.close();
                    } else {
                        Site.nav.submenuStandard.open(el);
                    }
                });

                // Close header dropdowns and search on focus another elements or ESC key is pressed
                $body.on('keyup', function (e) {
                    if (e.keyCode !== slate.utils.keyboardKeys.TAB && e.keyCode !== slate.utils.keyboardKeys.ESCAPE) return;

                    var $focusedElement = $(e.target),
                        isSubmenuChild = $focusedElement.parents('.submenu').length,
                        isHamburgerChild = $focusedElement.parents('.nav-hamburger').length,
                        isSearchChild = $focusedElement.parents('.nav-search').length || !$focusedElement.is('.js-searchToggle--open');

                    if (e.keyCode === slate.utils.keyboardKeys.TAB) {
                        if (!isSubmenuChild) {
                            // Close submenu or megamenu
                            Site.nav.submenuStandard.close();
                        }

                        if (!isHamburgerChild) {
                            // Close hamburger menu
                            Site.nav.hide();
                        }

                        if (!isSearchChild) {
                            // Close search
                            Site.nav.search.close();
                            Search.close();
                        }
                    } else if (e.keyCode === slate.utils.keyboardKeys.ESCAPE) {
                        Site.nav.submenuStandard.close();
                        Site.nav.search.close();
                        Search.close();
                        Site.nav.hide();
                    }
                });

                $('.main-content').children().first().on('click', function () {
                    Site.nav.hide();
                });

                $('.nav-hamburger .has-submenu .dropdown-arrow').on('click', function (e) {
                    if ($(this).parent().hasClass('is-expanded')) {
                        Site.nav.submenu.close($(this).parent());
                    } else {
                        Site.nav.submenu.open($(this).parent());
                    }
                });

                $('.js-searchToggle').on('click', function (e) {
                    e.preventDefault();

                    if ($header.hasClass('header--search-visible')) {
                        Site.nav.search.close();
                        Search.close();
                    } else {
                        var search = $(this).data('search-nav');
                        Site.nav.search.open(search);
                    }
                });

                // Hide search modal on click outside
                $(document).on('click', function (e) {
                    if (!$(e.target).is('.nav-search-overlay, .nav-search-overlay *, .js-searchToggle, .js-searchToggle *')) {
                        if ($header.hasClass('header--search-visible')) {
                            Site.nav.search.close();
                            Search.close();
                        }
                    }
                });

                // Close hamburger menu on body click
                $body.on('click', function (e) {
                    if (!$(e.target).is('.js-menuToggle, .js-menuToggle *, .nav-main *')) {
                        Site.nav.hide();
                    }
                });
            },
            show: function () {
                var navMenuWidth = $('.nav-hamburger').width() + 'px',
                    $body = $('body'),
                    $hamburger = $('#hamburger-menu'),
                    $transformElements = $('.site-header, .siteAlert, .bodyWrap, .shop-bar'),
                    $scrollableElement = document.querySelector('.nav-inner');

                $hamburger.addClass('open');
                $body.addClass('nav--is-visible');

                scrollLock.disablePageScroll($scrollableElement);

                $('.header-icons a:not(.js-menuToggle)').attr('tabindex', '-1');
                $('.nav-hamburger').find('button, a').removeAttr('tabindex');

                $transformElements.css({'transform': 'translateX(' + navMenuWidth + ')'});

                $(window).on('resize.siteNav', Reqs.debounce(function () {
                    var isHamburger = $('.site-header').hasClass('header--is-hamburger');
                    if (isHamburger) {
                        navMenuWidth = $('.nav-hamburger').width() + 'px';
                        $transformElements.css({'transform': 'translateX(' + navMenuWidth + ')'});
                    }
                }, 100));
            },
            hide: function () {
                var $body = $('body'),
                    $hamburger = $('#hamburger-menu'),
                    $transformElements = $('.site-header, .siteAlert, .bodyWrap, .shop-bar'),
                    $scrollableElement = document.querySelector('.nav-inner');

                if (!$body.hasClass('nav--is-visible')) return;

                $hamburger.removeClass('open');
                $body.addClass('nav--is-hiding').removeClass('nav--is-visible');
                $transformElements.css({'transform': 'none'});
                scrollLock.enablePageScroll($scrollableElement);

                $(window).off('resize.siteNav');

                setTimeout(function () {
                    $body.removeClass('nav--is-hiding');
                }, 300);

                $('.header-icons a').removeAttr('tabindex');
                $('.nav-hamburger').find('button, a').attr('tabindex', '-1');
            },

            activeLinks: function () {
                var $menu_items = $(".menu-item"),
                    $submenu_items = $('.submenu-item');

                $menu_items.each(function () {
                    if ($(this).find('> a').attr('href') === window.location.pathname) {
                        $(this).addClass('is-active');
                    }
                    // if no top-level link is active, then a submenu link is probably active
                    else {
                        $submenu_items.each(function () {
                            if ($(this).find('> a').attr('href') === window.location.pathname) {
                                $(this).addClass('is-active'); // activate the active submenu link
                                $(this).closest('.menu-item.has-submenu').addClass('is-active'); // activate parent as well
                            } else {
                                return; // must be homepage or page not in menu
                            }
                        });
                    }
                });
            },

            submenuStandard: {
                open: function (el) {
                    // Close other mega menus
                    el.parent().siblings('.menu-item--meganav').removeClass('is-expanded').find('a[aria-expanded]').attr('aria-expanded', false);
                    el.parent().siblings('.menu-item--meganav').find('.visible-nav-link').attr('tabindex', '-1');

                    // Open selected mega menu
                    el.attr('aria-expanded', true).parent().addClass('is-expanded');
                    el.parent().find('.visible-nav-link').removeAttr('tabindex');

                    // Header state when megamenu is open
                    if (el.parents('.menu-item--meganav').length) {
                        $('.site-header').addClass('header--megamenu-visible');
                    }
                },
                close: function () {
                    $('.visible-nav-link').attr('tabindex', '-1');
                    $('.nav-standard .menu li').removeClass('is-expanded').find('a[aria-expanded]').attr('aria-expanded', false);
                    $('.site-header').removeClass('header--megamenu-visible');
                }
            },

            /*
			 * Sub Menus
			 */
            submenu: {
                open: function (el) {
                    var $elSubMenu = $(el);

                    $elSubMenu.addClass('is-expanded').find('> .submenu').stop(true).slideDown('fast');
                    $elSubMenu.find('.visible-nav-link').removeAttr('tabindex');
                },
                close: function (el) {
                    var $elSubMenu = $(el);

                    $elSubMenu.removeClass('is-expanded').find('> .submenu').stop(true).slideUp('fast');
                    $elSubMenu.find('.visible-nav-link').attr('tabindex', '-1');
                }
            },

            /*
			 * Search
			 */
            search: {
                open: function (search) {
                    var $header = $('.site-header'),
                        $searchToggleBtn = $('.js-searchToggle'),
                        $searchInput = $(search).find('.nav-search-input'),
                        $clickableElements = $(search).find('.nav-search-input, .nav-search-submit, .js-searchToggle--close'),
                        $scrollableElement = document.querySelector('.nav-search-scroller');

                    $header.addClass('header--search-visible');
                    $searchToggleBtn.attr('aria-expanded', true);
                    $clickableElements.removeAttr('tabindex');
                    $searchInput.focus().select();

                    scrollLock.disablePageScroll($scrollableElement);
                },
                close: function () {
                    var $header = $('.site-header'),
                        $searchToggleBtn = $('.js-searchToggle'),
                        $searchToggleBtnOpen = $('.js-searchToggle--open'),
                        $clickableElements = $('.nav-search-input, .nav-search-submit, .js-searchToggle--close'),
                        $scrollableElement = document.querySelector('.nav-search-scroller'),
                        isSearchVisible = $header.hasClass('header--search-visible');

                    $clickableElements.attr('tabindex', '-1');
                    $searchToggleBtn.attr('aria-expanded', false);

                    if (isSearchVisible) {
                        $header.addClass('header--search-hiding').removeClass('header--search-visible');
                        $searchToggleBtnOpen.focus();
                        setTimeout(function () {
                            $header.removeClass('header--search-hiding');
                            scrollLock.enablePageScroll($scrollableElement);
                        }, 300);
                    }
                }
            }
        },

        /*
		 * Form Address Validation
		 */
        addresses: {
            addAddressForm: $(".js-addAddress > form"),
            editAddressForm: $(".js-editAddress > form"),
            init: function () {
                $addAddressForm = this.addAddressForm,
                    $editAddressForm = this.editAddressForm;

                Site.addresses.validating();
            },
            validating: function () {
                $addAddressForm.add($editAddressForm).submit(function (e) {
                    var isEmpty = true;

                    // Display notification if input is empty
                    $(this).find('input').not(".optional").each(function () {
                        if (!$(this).val()) {
                            $(this).next().addClass("validation--showup");
                        } else {
                            $(this).next().removeClass("validation--showup");
                        }
                    });

                    // Detect whether form is valid
                    $(this).find('input').not(".optional").each(function () {
                        if (!$(this).val()) {
                            isEmpty = false;
                        }
                    });
                    if (!isEmpty) {
                        return false;
                    }
                });
            }
        },

        checkReviewsApp: function () {
            var showReviews = false,
                showYotpo = false,
                yotpoID = "";

            var checking = setInterval(function () {
                var reviewsAppInstalled = typeof window.SPR == 'function' && showReviews || typeof yotpo == 'object' && showYotpo && yotpoID;
                if (!reviewsAppInstalled) {
                    $('body').attr('data-app-reviews', 'not-installed');
                } else {
                    $('body').removeAttr('data-app-reviews');
                    clearInterval(checking);
                }
            }, 1000);

            setTimeout(function () {
                clearInterval(checking);
            }, 20000);
        },

        animations: {
            init: function () {
                var self = this,
                    enableAnimations = (true);

                $('body').removeClass('is-page-loading');

                if (enableAnimations) {
                    // Allow animations
                    $('body').addClass('allow-animations');

                    this.animateAll();

                    $(document).on('ajaxify:updated', this.animateAll);
                    $(window)
                        .on('load', this.animateAll)
                        .on('scroll', Reqs.throttle(self.animateAll, 100));
                }
            },

            animateAll: function () {
                var animatedElements = $('.will-animate');

                animatedElements.each(function () {
                    var $element = $(this),
                        animationClass = 'animated ' + $element.data('animation'),
                        delay = $element.data('animation-delay') || 0,
                        duration = 200 + delay; // 1000ms is the default duration time

                    if ($element.visible(true)) {
                        $element.addClass(animationClass).removeClass('will-animate');

                        setTimeout(function () {
                            $element.removeClass(animationClass);
                        }, duration);
                    }
                });
            }
        },

        initReviews: function () {
            var showReviews = (false),
                enableYotpo = (false),
                yotpoID = "";

            if (enableYotpo && yotpoID != '' && typeof yotpo != 'undefined') {
                yotpo.initialized ? yotpo.refreshWidgets() : yotpo.initWidgets();
                $('.star-clickable').removeAttr('tabindex');
            } else if (showReviews && typeof window.SPR == 'function') {
                window.SPR.initDomEls();
                window.SPR.loadBadges();
                window.SPR.loadProducts();
            }
        },

        removeAnimationClass: function (container) {
            // Remove will-animate class to prevent elements stay hidden on horizontal scroll
            $('.will-animate', container).removeClass('will-animate');
        }
    }

    Site.init();
    Cart.init();
    Collection.init();
    ListCollections.init();
    Blog.init();
    $(document).ready(function () {
        Site.animations.init();
        Gmap.init();

        $(window).trigger('scroll');
    });

    Sections.init();
    Popup.init();
    Search.init();

    if ($('.template-product').length) {
        Product.init();
        RelatedProducts.init();
    }

    if ($('.featured-product').length) {
        Product.init();
    }

    if ($('.template-password').length) {
        Password.init();
    }

    if ($('.template-customers-login').length) {
        Login.init();
    }

    if ($('.template-customers-addresses').length) {
        Addresses.init();
    }

    if ($('.template-search').length) {
        SearchTemplate.init();
    }

    var showQuickView = (false);
    if (showQuickView) {
        QuickView.init();
    }

    slate.a11y.pageLinkFocus($(window.location.hash));

    $('.in-page-link').on('click', function (evt) {
        slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
    });

    $(document).on('shopify:section:reorder', Site.header.init);
    $(document).on('shopify:section:unload', Site.header.init);
});
// end .ready()
$(document).one('touchstart', function () {
    Helpers.setTouch();
});

var popoverTimer,
    Cart = {
        init: function () {
            var $cart = $('#Cart'),
                $body = $('body'),
                $header = $('.site-header'),
                $popover = $('#CartPopoverCont'),
                enableAjaxCart = (false),
                bodyLock = 0;

            this.counter();

            $(window).on('resize', Reqs.throttle(Site.setCartClosePosition, 10));

            /* Continue Shopping link - hide cart overlay if on desktop */
            $cart.on('click', '.js-continueShopping', function (e) {
                e.preventDefault();
                var referrer = document.referrer;
                var origin = window.location.origin + '/';
                var isMobile = $(window).width() < 768;

                if (!isMobile && !(window.location.href.indexOf('/cart') > -1)) {
                    $('.js-cartToggle-close').eq(0).trigger('click');
                } else {
                    if (referrer === origin) {
                        window.location.href = window.theme.routes.root_url;
                    } else {
                        history.back(1);
                    }
                }
            });

            // Don't init cart functions if ajax cart disabled
            if (!enableAjaxCart) return false;

            $(document).off('click', '.js-cartToggle');
            $(document).on('click', '.js-cartToggle', function (e) {
                var $this = $(this),
                    isCartTemplate = $('body').hasClass('template-cart'),
                    windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
                    $scrollableElement = document.querySelector('.scroll');

                if (isCartTemplate) return false;

                if (windowWidth > 768) {
                    e.preventDefault();

                    Site.setCartClosePosition();

                    $body.toggleClass('cart--is-visible');
                    if ($body.hasClass('cart--is-visible')) {
                        $cart.removeClass('close');
                        $cart.addClass('open');
                        $('#cartTotal').attr('aria-expanded', true);
                        scrollLock.disablePageScroll($scrollableElement);
                    } else {
                        $cart.removeClass('open');
                        $cart.addClass('close');
                        $('#cartTotal').attr('aria-expanded', false);
                        Cart.popover.hide($popover);
                        scrollLock.enablePageScroll($scrollableElement);
                    }
                    $('.js-continueShopping').attr('tabindex', '0');
                } else {
                    if ($this.hasClass('js-cartToggle-close')) {
                        e.preventDefault();
                        $('html').css('overflow', 'initial');
                        $body.removeClass('cart--is-visible');
                        $cart.removeClass('open');
                        $cart.addClass('close');
                        $('#cartTotal').attr('aria-expanded', false);
                        Cart.popover.hide($popover);
                    }
                    $('.js-continueShopping').attr('tabindex', '-1');
                }
            });

            $('body').on('click', '.js-productForm-submit', function (e) {
                var $form = $(this).closest('form.productForm');

                if (enableAjaxCart) {
                    e.preventDefault();

                    if ($form.find('[type="file"]').length) return;

                    Cart.submit($(this));
                }
            });

            $(window).on('keyup', function (e) {
                if (e.key === "Escape") {
                    $body.removeClass('cart--is-visible');
                    $cart.removeClass('open');
                    $cart.addClass('close');
                    $scrollableElement = document.querySelector('.scroll');
                    $('#cartTotal').attr('aria-expanded', false);
                    Cart.popover.hide($popover);
                    scrollLock.enablePageScroll($scrollableElement);
                }
            });
        },
        submit: function (el) {
            var $form = el.closest('form.productForm'),
                product_handle = el.attr("data-handle"),
                variant_id = $form.find('[name="id"]').val(),
                form_array = $form.serializeArray();

            var form_data = {};

            $.map(form_array, function (val, i) {
                form_data[val.name] = val.value;
            });

            $.ajax({
                method: 'POST',
                url: '/cart/add.js',
                dataType: 'json',
                data: form_data,
                success: function (product) {
                    el.attr('disabled', true).html(window.theme.icons.check);
                    setTimeout(function () {
                        el.attr('disabled', false).html(window.theme.translations.form_submit);
                    }, 2000);

                    Cart.getCart(Cart.buildCart);

                    if ($(window).width() >= 550) {
                        Cart.popover.show(product);
                    }
                },
                // If there are no products in the inventory
                error: function (data) {
                    $.ajax({
                        method: 'GET',
                        url: '/products/' + product_handle + '.js',
                        dataType: 'json',
                        success: function (product) {
                            var variants = product.variants,
                                // variants is an array [0{},1{},2{}...]
                                variant = $.each(variants, function (i, val) {
                                    // val returns the contents of 0,1,2
                                    if (val.id == variant_id) {
                                        return variant_quantity = val.inventory_quantity; // set variant_quantity variable
                                    }
                                }),
                                $popover = $('#CartPopoverCont'), // same popover container used to show succesful cart/add.js
                                error_details = window.theme.translations.form_submit_error_details, // translation string
                                tag = new RegExp('\[\[i\]\]'), // checks for [[i]]
                                error = error_details; // set error to just default to error_details

                            if (tag.test(error_details) == true) {
                                // [[i]] is part of the trans string, this can be whatever,
                                // but in the tutorial we use [[i]] so leave it
                                error = error_details.replace('[[i]]', variant_quantity); // re-set error with new string
                            }

                            el.html(window.theme.translations.form_submit_error); // swap button text
                            setTimeout(function () {
                                el.html(window.theme.translations.form_submit); // swap it back
                            }, 1000);

                            // clear popover timer, set at top of Cart object
                            clearTimeout(popoverTimer);

                            // empty popover, add error (with inventory), show it, remove click events so it doesn't open cart
                            $popover.empty().append('<div class="popover-error">' + error + '</div>').addClass('is-visible').css({'pointer-events': 'none'});
                            // set new instance of popoverTimer
                            popoverTimer = setTimeout(function () {
                                $popover.removeClass('is-visible').css({'pointer-events': 'auto'});
                            }, 5000);
                        },
                        error: function () {
                            console.log("Error: product is out of stock. If you're seeing this, Cart.submit.error() must have failed.");
                        }
                    });
                }
            });
        },
        popover: {
            show: function (product) {
                var $popover = $('#CartPopoverCont'),
                    item = {},
                    unitPrice = '',
                    source = $('#CartPopover').html(),
                    template = Handlebars.compile(source),
                    price = Shopify.formatMoney(product.final_price, window.money_format);

                // Unit price
                if (product.unit_price_measurement) {
                    unitPrice = Shopify.formatMoney(product.unit_price, window.money_format) + ' ';
                    if (product.unit_price_measurement.reference_value != 1) {
                        unitPrice += product.unit_price_measurement.reference_value;
                    }
                    unitPrice += product.unit_price_measurement.reference_unit;
                }

                // Product image
                if (product.image != null) {
                    var prodImg = product.image.replace(/(\.[^.]*)$/, "_150x$1").replace('http:', '');
                } else {
                    var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
                }

                item = {
                    item_count: product.quantity,
                    img: prodImg,
                    name: function () {
                        name = product.product_title;

                        if (name.length > 20) {
                            name = name.substring(0, 20) + ' ...';
                        }

                        return name;
                    },
                    variation: product.variant_title == 'Default Title' ? false : product.variant_title,
                    price: product.price,
                    price_formatted: price,
                    unit_price: unitPrice
                }

                $popover.empty().append(template(item));
                $popover.addClass('is-visible');

                // clear popover timer, set at top of Cart object
                clearTimeout(popoverTimer);

                // set new instace of popoverTimer
                popoverTimer = setTimeout(function () {
                    Cart.popover.hide($popover);
                }, 5000);
            },
            hide: function (el) {
                el.removeClass('is-visible');
                setTimeout(function () {
                    el.empty();
                }, 300);
            }
        },
        getCart: function (callback) {
            $.getJSON('/cart.js', function (cart, textStatus) {
                if ((typeof callback) === 'function') {
                    callback(cart);
                } else {
                    ShopifyAPI.onCartUpdate(cart);
                }
            });
        },
        buildCart: function (cart) {
            var self = this;
            var $cart = $('#Cart');
            var $body = $('body');

            // Start with a fresh cart div
            $cart.empty();

            // Append close icon if page is not cart template only
            if (!$body.hasClass('template-cart')) {
                $cart.append('<div class="js-cartToggle js-cartToggle-close cart-close">' + window.theme.icons.close + '</div>');
            }

            // Show empty cart
            if (cart.item_count === 0) {
                $cart.append('<div class="cart-title cart-title--empty">\
							<h2>' + window.theme.translations.cart_title + '</h2>\
							<p>' + window.theme.translations.cart_empty + '</p>\
							<a tabindex="-1" class="js-continueShopping js-continueShopping--empty js-go-back button">' + window.theme.translations.continue_shopping + '</a>\
						</div>');

                // Update cart total
                self.updateCartTotal();
                Site.setCartClosePosition();

                return;
            }

            // Handlebars.js cart layout
            var items = [],
                item = {},
                data = {},
                source = $("#CartTemplate").html(),
                template = Handlebars.compile(source);

            // Add each item to our handlebars.js data
            $.each(cart.items, function (index, cartItem) {
                var itemAdd = cartItem.quantity + 1,
                    itemMinus = cartItem.quantity - 1,
                    itemQty = cartItem.quantity,
                    itemVariantId = cartItem.variant_id,
                    composition = '',
                    compositionId = '',
                    discountsArray = cartItem.discounts,
                    discounts = '',
                    productPrice = '',
                    productTotalPrice = '',
                    delivery_campaign_label = '',
                    unitPrice = '';

                var deliveryTimes = {};
                if (document.querySelector('#delivery-times')) {
                    deliveryTimes = JSON.parse(document.querySelector('#delivery-times').innerHTML);
                }

                if (deliveryTimes[`${cartItem.id}_tags`] && deliveryTimes[`${cartItem.id}_tags`].includes('delivery_campaign')) {
                    delivery_campaign_label = deliveryTimes[`${cartItem.id}_delivery_label`]
                }
                // Get composition
                if (cartItem.hasOwnProperty('properties') && cartItem.properties !== null) {
                    composition = cartItem.properties.Composition;
                }
                if (cartItem.hasOwnProperty('properties') && cartItem.properties !== null) {
                    compositionId = cartItem.properties.sofaBundleId;
                }

                const compare_at_price = deliveryTimes[`${cartItem.id}_compare_at_price`] ? parseInt(deliveryTimes[`${cartItem.id}_compare_at_price`]) : 0;

                if (compare_at_price > cartItem.final_price) {
                    productPrice += '<div class="sale">'
                    productPrice += '<span class="product-sale--badge">' + Math.round((1 - (cartItem.final_price / compare_at_price)) * 100) + '%</span>';
                    productPrice += '<span class="product-sale-price" style="margin: 0 16px;">' + Shopify.formatMoney(cartItem.final_price, window.money_format) + '</span>';
                    productPrice += '<s style="color: #888888; font-weight: 400;">' + Shopify.formatMoney(compare_at_price, window.money_format) + '</s> ';
                    productPrice += '</div>'
                } else {
                    productPrice += '<span>' + Shopify.formatMoney(cartItem.final_price, window.money_format) + '</span>';
                }

                // Get total line price value
                if (cartItem.original_line_price > cartItem.final_line_price) {
                    productTotalPrice += '<s>' + Shopify.formatMoney(cartItem.original_line_price, window.money_format) + '</s> ';
                }
                productTotalPrice += Shopify.formatMoney(cartItem.final_line_price, window.money_format);

                // Get discounts
                if (discountsArray.length) {
                    discounts += '<div class="cart-product-discounts">';
                    for (var j = 0; j < discountsArray.length; j++) {
                        discounts += '<p>' + discountsArray[j].title + ' (-' + Shopify.formatMoney(discountsArray[j].amount, window.money_format) + ')</p>';
                    }
                    discounts += '</div>';
                }

                // Unit price
                if (cartItem.unit_price_measurement) {
                    unitPrice = Shopify.formatMoney(cartItem.unit_price, window.money_format) + ' ';
                    if (cartItem.unit_price_measurement.reference_value != 1) {
                        unitPrice += cartItem.unit_price_measurement.reference_value;
                    }
                    unitPrice += cartItem.unit_price_measurement.reference_unit;
                }

                /* Hack to get product image thumbnail
			*   - If image is not null
			*     - Remove file extension, add _small, and re-add extension
			*     - Create server relative link
			*   - A hard-coded url of no-image
			*/

                if (cartItem.image != null) {
                    var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_300x$1").replace('http:', '');
                } else {
                    var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
                }

                var prodName = cartItem.product_title,
                    prodVariation = cartItem.variant_title;

                if (prodVariation == 'Default Title') {
                    prodVariation = false;
                }

                // Create item's data object and add to 'items' array
                item = {
                    id: cartItem.variant_id,
                    url: cartItem.url,
                    key: cartItem.key,
                    img: prodImg,
                    name: prodName,
                    variation: prodVariation,
                    itemAdd: itemAdd,
                    itemMinus: itemMinus,
                    itemQty: itemQty,
                    itemVariantId: itemVariantId,
                    composition: composition,
                    compositionId: compositionId,
                    properties: cartItem.properties,
                    delivery_time: deliveryTimes[cartItem.id] || "",
                    delivery_campaign_label: delivery_campaign_label,
                    price: cartItem.price,
                    priceFormatted: productPrice,
                    unitPrice: unitPrice,
                    linePriceFormatted: productTotalPrice,
                    discounts: discounts,
                    vendor: cartItem.vendor,
                    iconPlus: window.theme.icons.plus,
                    iconMinus: window.theme.icons.minus,
                    fabricProduct: cartItem.product_type === "Fabric Samples"
                };

                items.push(item);
            });

            // Update cart totals
            var totalDiscounts = '';
            var cartDiscounts = cart.cart_level_discount_applications;

            if (cartDiscounts.length) {
                totalDiscounts += '<p class="cart-discounts">';
                for (var j = 0; j < cartDiscounts.length; j++) {
                    totalDiscounts += '<span>' + cartDiscounts[j].title + ':</span>';
                    totalDiscounts += '<span>-' + Shopify.formatMoney(cartDiscounts[j].total_allocated_amount, window.money_format) + '</span>';
                }
                totalDiscounts += '</p>';
            }

            // Gather all cart data and add to DOM
            data = {
                item_count: cart.item_count,
                items: items,
                note: cart.note,
                totalDiscounts: totalDiscounts,
                totalPrice: Shopify.formatMoney(cart.total_price, window.money_format)
            }

            // update cart slide-out with new cart
            $cart.append(template(data));

            // Update cart total
            Cart.updateCartTotal();

            Site.setCartClosePosition();

            /**
             * Re-init the ajax cart buttons.
             * These are added to the handlebars template, but this
             * js needs to fire to show them after the new
             * cart is built and inserted.
             * @see https://help.shopify.com/themes/customization/cart/add-more-checkout-buttons-to-cart-page
             */
            if (window.Shopify && Shopify.StorefrontExpressButtons) {
                Shopify.StorefrontExpressButtons.initialize();
            }
        },
        /*
	 * Form Counter
	 */
        counter: function () {
            var self = this,
                $cart = $('#Cart');

            $cart.on('blur', '.inputCounter', function () {
                var el = $(this),
                    value = $(this).val();

                self.inputCounter(el, value);
            });

            $cart.on('click', '.inputCounter-down', function () {
                var el = $(this),
                    $input = el.siblings('.inputCounter'),
                    value = parseInt($input.val()) - 1;

                self.inputCounter(el, value);
            }).on('click', '.inputCounter-up', function () {
                var el = $(this),
                    $input = el.siblings('.inputCounter'),
                    value = parseInt($input.val()) + 1;

                self.inputCounter(el, value);
            });

            /* Remove line item on x click */
            $cart.on('click', '.cart-product-remove', function () {
                var el = $(this);

                self.inputCounter(el, 0);
            });
        },

        // Product/Quick View Product Submit Form
        inputCounter: function (el, value) {
            var self = this,
                $cart = $('#Cart'),
                $input = el.closest('.line-item').find('.inputCounter');

            // Set quantity to 0 and remove the item
            if (value == 0) {
                $input.closest('.line-item').fadeOut(function () {
                    $(this).remove();
                });

                // Prevent a negative quantity
            } else if (value < 0) {
                value = 0;
            }

            var qty = value;
            var id = $input.attr('id');
            var line = parseInt($input.attr('data-line'));

            $.ajax({
                type: 'post',
                url: '/cart/change.js',
                dataType: 'json',
                data: {
                    'quantity': qty,
                    'line': line
                },
                success: function (cart) {
                    Cart.buildCart(cart);
                }
            });

            // remove line item if the quantity is 0
            if (qty == 0) {
                $(this).closest('.line-item').fadeOut(function () {
                    $(this).remove();
                    self.updateCartTotal();
                });
            }
        },
        updateCartTotal: function () {
            $.getJSON('/cart.js', function (cart) {
                $('#CartToggleItemCount').html(cart.item_count);
                $('#CartToggleItemCount').attr("data-count", cart.item_count);
                cart.item_count ? $('.js-cartToggle').removeClass('cartToggle--empty') : $('.js-cartToggle').addClass('cartToggle--empty');
                groupCart();
            });
        }
    };

var Collection = {
    selectors: {
        body: 'body',
        collectionWrapper: '[data-collection-wrapper]',
        collectionBannerImage: '[data-collection-banner-image]',
        collectionBannerContent: '[data-collection-banner-content]',
        collectionProductsWrapper: '[data-collection-products-wrapper]',
        collectionProducts: '[data-collection-products]',
        collectionFilters: '[data-collection-filters]',
        collectionFiltersResetButton: '[data-collection-filters-reset-button]',
        collectionFilter: '[data-collection-filter]',
        collectionFilterTag: '[data-collection-filter-tag]',
        collectionFilterTagButton: '[data-collection-filter-tag-button]',
        collectionFilterTitle: '[data-collection-filter-title]',
        collectionPagination: '[data-collection-pagination]',
        collectionSort: '[data-collection-sort]',
        collectionBlockImage: '.collectionBlock-image',
        collectionFeaturedImage: '.featured-block',
        productsFoundLabel: '[data-products-found-label]',
        loadMoreButton: '[data-load-more]',
        loadMoreIcon: '[data-icon-load-more]',
        gridSpacer: '.gridSpacer'
    },
    classes: {
        loading: 'loading',
        isActive: 'is-active',
        isVisible: 'is-visible',
        isExpanded: 'is-expanded',
        isLoading: 'is-loading',
        ajaxSorting: 'ajax-sorting',
        hasTagsExpanded: 'has-tags-expanded',
        collectionFiltersTop: 'collection__filters--top',
        collectionFiltersHasTagsSelected: 'collection__filters--has-tags-selected',
        collectionFiltersResetButtonFullwidth: 'collection__filters-reset--fullwidth',
        collectionFilterAccordionExpanded: 'collection__filter--accordion-expanded'
    },
    init: function () {
        var self = this;

        this.filterProductsRequest = null;

        if ($(this.selectors.collectionSort).length) {
            $(this.selectors.collectionSort).on('change', function () {
                document.location.href = '?sort_by=' + this.options[this.selectedIndex].value;
            });
        }

        $(this.selectors.collectionProducts).each(function () {
            var $container = $(this),
                sectionId = $(this).data('section-id'),
                imageSize = $container.data('image-size');

            if (imageSize == 'contain') {
                var $image = $(self.selectors.collectionBlockImage, $container);
                Collection.setBadgePosition($image);
                $(window).on('resize.' + sectionId, Reqs.debounce(self.setBadgePosition.bind(self, $image), 50));
            }

            self.initFilters($container);
        });

        ajaxify();
        Product.qtyAdjust();

        $(document).on('ajaxify:updated', function () {
            Site.initReviews();
        });

        // Truncate Featured Image text
        this.truncateFeaturedImageText();
        $(window).on('resize.collection', Reqs.throttle(self.truncateFeaturedImageText.bind(self), 50));
    },

    ajaxSort: function (url) {
        var self = this,
            $loadMoreIcon = $(this.selectors.loadMoreIcon);

        $loadMoreIcon.show();
        $(this.selectors.collectionProducts).hide().next('.row').hide();

        $.ajax({
            type: 'GET',
            dataType: "html",
            url: url,
            success: function (data) {
                var products = $(data).find(self.selectors.collectionProducts)[0].outerHTML;
                var nextPage = $(data).find(self.selectors.collectionProducts).next('.row')[0] ? $(data).find(self.selectors.collectionProducts).next('.row')[0].outerHTML : '';

                $(self.selectors.collectionProducts).replaceWith(products);
                $(self.selectors.collectionProducts).next('.row').replaceWith(nextPage);
                $loadMoreIcon.hide();

                $(self.selectors.collectionSort).removeClass(self.classes.loading);
                $(self.selectors.body).removeClass(self.classes.ajaxSorting);

            }
        });
    },

    /*
	 * AJAX call to load more products
	 */
    initLoadMore: function () {
        var self = this;

        $(this.selectors.body).on('click', self.selectors.loadMoreButton, function (event) {
            var isLoading = $(this).hasClass(self.classes.isLoading);

            if (isLoading) return;

            // hide open quickViews
            QuickView.hide();

            var $el = $(event.target);
            var url = $el.attr('href');

            event.preventDefault();

            $el.addClass(self.classes.loading);

            // load products
            self.ajaxLoadMore(url);

        });
    },

    ajaxLoadMore: function (url) {
        var self = this;

        $.ajax({
            type: 'GET',
            dataType: "html",
            url: url,
            success: function (data) {
                var products = $(data).find(self.selectors.collectionProducts).html(),
                    nextPage = $(data).find(self.selectors.loadMoreButton).attr('href');

                $(self.selectors.collectionProducts).find(self.selectors.gridSpacer).remove();

                $(products).appendTo(self.selectors.collectionProducts);

                if (typeof (nextPage) !== 'undefined') {
                    $(self.selectors.loadMoreButton).attr('href', nextPage).removeClass(self.classes.loading);
                } else {
                    $(self.selectors.loadMoreButton).remove();
                }

                collectionBlocks = $('.js-collectionBlock');
            }
        });
    },

    setBadgePosition: function (image) {
        $(image).each(function () {
            var $image = $(this),
                $saleBadge = $image.find('.product-status-flag');

            if (!$saleBadge.length) return;

            var imageAspectRatio = $image.data('aspectratio'),
                imageWidth = $image.outerWidth(),
                imageHeight = $image.outerHeight(),
                containerAspectRatio = imageWidth / imageHeight,
                posTop = 0,
                posLeft = 0;

            if (imageAspectRatio < containerAspectRatio) {
                posLeft = (imageWidth - (imageHeight * imageAspectRatio)) / 2;
            } else {
                posTop = (imageHeight - (imageWidth / imageAspectRatio)) / 2;
            }

            $saleBadge.css({
                'top': posTop,
                'left': posLeft
            });
        });
    },

    initFilters: function (container) {
        var self = this,
            $container = $(container),
            $collectionFilters = $(this.selectors.collectionFilters);

        if (!$collectionFilters.length) return;

        var sectionId = $(container).data('section-id'),
            collection = $container.data('collection'),
            tags = $container.data('tags'),
            sort = $container.data('sort');

        this.preventBannerContentOverflow();
        this.checkFiltersPosition();
        $(window).on('resize.' + sectionId, Reqs.debounce(function () {
            self.preventBannerContentOverflow(self);
            self.checkFiltersPosition(self);
        }, 50));

        /* Bind toggle buttons */
        $collectionFilters.on('click', this.selectors.collectionFilterTitle, function () {
            var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
                isTopPosition = windowWidth < 1280 || $('.collection__filters--top').length,
                isAriaExpanded = !($(this).parent().hasClass(self.classes.isExpanded) || $(this).parent().hasClass(self.classes.collectionFilterAccordionExpanded));

            if (isTopPosition) {
                $(this)
                    .parent()
                    .toggleClass(self.classes.isExpanded)
                    .attr('aria-expanded', isAriaExpanded)
                    .siblings()
                    .removeClass(self.classes.isExpanded)
                    .attr('aria-expanded', false);

                if ($collectionFilters.find('.collection__filter.is-expanded').length) {
                    $collectionFilters.addClass(self.classes.hasTagsExpanded);
                } else {
                    $collectionFilters.removeClass(self.classes.hasTagsExpanded);
                }
            } else {
                $(this)
                    .parent()
                    .toggleClass(self.classes.collectionFilterAccordionExpanded)
                    .attr('aria-expanded', isAriaExpanded)
                    .siblings()
                    .removeClass(self.classes.isExpanded)
                    .attr('aria-expanded', false);
            }
        });

        /* Close dropdowns on click outside their container */
        $(document).on('click', function (e) {
            if (!$(e.target).is('.collection__filters *')) {
                $collectionFilters
                    .find(self.selectors.collectionFilter)
                    .removeClass(self.classes.isExpanded)
                    .attr('aria-expanded', false)
                    .end()
                    .removeClass(self.classes.hasTagsExpanded);
            }
        });

        $collectionFilters.on('click', this.selectors.collectionFilterTagButton, function (e) {
            var $collectionFilterTag = $(this).parent(),
                selectedTag = $(this).data('tag'),
                isTagActive = $collectionFilterTag.hasClass(self.classes.isActive);

            if (isTagActive) {
                var tagIndex = tags.indexOf(selectedTag);

                $collectionFilterTag.removeClass(self.classes.isActive);

                if (tagIndex > -1) {
                    tags.splice(tagIndex, 1);
                }
            } else {
                $collectionFilterTag.addClass(self.classes.isActive);

                tags.push(selectedTag);
            }

            $container.attr('data-tags', tags);

            // Close filters dropdown on tag select
            $collectionFilters
                .find(self.selectors.collectionFilter)
                .removeClass(self.classes.isExpanded)
                .attr('aria-expanded', false)
                .end()
                .removeClass(self.classes.hasTagsExpanded);

            var requestedURL = collection + '/' + tags.join('+') + '?sort_by=' + sort;

            self.requestFilteredProducts(self, container, requestedURL, tags);

            e.preventDefault();
        });

        this.bindResetButton(container);
    },

    requestFilteredProducts: function (instance, container, requestedURL, tags) {
        var self = instance,
            $container = $(container),
            productsTop = parseInt(Math.ceil($(self.selectors.collectionWrapper).offset().top) - 60), // Add 60px to give space for the header
            imageSize = $(container).data('image-size');

        // Kill previous ajax request
        if (self.filterProductsRequest != null) {
            self.filterProductsRequest.abort();
        }

        if (!tags.length) {
            $(self.selectors.collectionFiltersResetButton).removeClass(self.classes.isVisible).slideUp(300);
            $(self.selectors.collectionFilters).removeClass(self.classes.collectionFiltersHasTagsSelected);
        }

        $(self.selectors.collectionWrapper).addClass(self.classes.isLoading);

        // Scroll back to top
        $('html, body').stop(true).animate({'scrollTop': productsTop}, 300);

        self.filterProductsRequest = $.ajax({
            method: 'GET',
            url: requestedURL,
            dataType: 'html',
        }).done(function (data) {
            var collectionProducts = $(data).find(self.selectors.collectionProducts).html(),
                productsFoundLabel = $(data).find(self.selectors.productsFoundLabel).html(),
                $pagination = $(data).find(self.selectors.collectionPagination);

            $container.html(collectionProducts);
            $(self.selectors.productsFoundLabel).html(productsFoundLabel);

            if ($pagination.length) {
                $(self.selectors.collectionPagination, container).html($pagination.html());
            } else {
                $(self.selectors.collectionPagination, container).empty();
            }

            self.bindResetButton(container);

            Site.animations.animateAll();
            Site.initReviews();
            ajaxify();

            if (imageSize == 'contain') {
                var $image = $(self.selectors.collectionBlockImage, container);

                self.setBadgePosition($image);
                $(window)
                    .off('resize.products')
                    .on('resize.products', Reqs.debounce(Collection.setBadgePosition.bind(this, $image), 50));
            }

            // Show reset button if there are tags selected
            if (tags.length) {
                $(self.selectors.collectionFiltersResetButton)
                    .addClass(self.classes.isVisible)
                    .slideDown(300);

                $(self.selectors.collectionFilters).addClass(self.classes.collectionFiltersHasTagsSelected);
            }

            // Stop loading animation
            setTimeout(function () {
                $(self.selectors.collectionWrapper).removeClass(self.classes.isLoading);
            }, 450);

            // Update page URL if supported by the browser
            if (history.replaceState) {
                window.history.pushState({path: requestedURL}, '', requestedURL);
            }
        }).fail(function (jqXHR, textStatus, errorThrown) {
            $(self.selectors.collectionWrapper).removeClass(self.classes.isLoading);
        });
    },

    checkFiltersPosition: function () {
        var isFiltersPositionTop = $(this.selectors.collectionFilters).hasClass(this.classes.collectionFiltersTop),
            windowWidth = window.innerWidth || document.documentElement.clientWidth,
            containerWidth = $(this.selectors.collectionFilters).children().first().width(),
            $resetButton = $(this.selectors.collectionFiltersResetButton),
            $collectionFilter = $(this.selectors.collectionFilter),
            resetButtonWidth = $resetButton.outerWidth(true),
            collectionFiltersWidth = 0,
            spaceBetween = 60,
            isOverlapping = false;

        // Run only if filters position is set to "Top" or window width is < 1280
        if (isFiltersPositionTop || windowWidth < 1280) {
            $collectionFilter.each(function () {
                collectionFiltersWidth += $(this).outerWidth(true);
            });

            isOverlapping = (containerWidth - collectionFiltersWidth - spaceBetween) < resetButtonWidth;

            if (isOverlapping) {
                $resetButton.parent().addClass(this.classes.collectionFiltersResetButtonFullwidth);
            } else {
                $resetButton.parent().removeClass(this.classes.collectionFiltersResetButtonFullwidth);
            }
        }
    },

    preventBannerContentOverflow: function () {
        var $image = $(this.selectors.collectionBannerImage),
            $content = $(this.selectors.collectionBannerContent),
            contentHeight = $content.outerHeight();

        $image.css('min-height', contentHeight);
    },

    /* Reset filters */
    bindResetButton: function (container) {
        var self = this,
            $collectionFilters = $(self.selectors.collectionFilters),
            collection = $(container).data('collection'),
            sort = $(container).data('sort'),
            requestedURL = collection + '/?sort_by=' + sort;

        $(this.selectors.collectionFiltersResetButton).on('click', function (e) {
            $collectionFilters.find(self.selectors.collectionFilter).removeClass(self.classes.isExpanded);
            $collectionFilters.find(self.selectors.collectionFilterTag).removeClass(self.classes.isActive);
            $collectionFilters.removeClass(self.classes.hasTagsExpanded);

            // Reset saved tags
            tags = [];
            $(container).attr('data-tags', false);

            self.requestFilteredProducts(self, container, requestedURL, tags);

            e.preventDefault();
        });
    },

    truncateFeaturedImageText: function () {
        var $heading = $('h2', this.selectors.collectionFeaturedImage),
            $text = $('p', this.selectors.collectionFeaturedImage),
            textLines = 4,
            imageAspectRatio = 1,
            windowWidth = window.innerWidth || document.documentElement.clientWidth;

        // Limit text lines to 2 if product image aspect ratio is less than 1
        if (imageAspectRatio < 1 || windowWidth < 768) {
            textLines = 2;
        }

        $heading.trunk8({lines: 2});
        $text.trunk8({lines: textLines});
    }
}

var ListCollections = {
    selectors: {
        listCollectionsContainer: '.collectionList',
        collectionBlock: '.collectionBlock',
        collectionBlockTitle: '.collectionBlock-info h2',
        collectionBlockText: '.collectionBlock-info h4'
    },
    classes: {
        isLoading: 'is-loading',
        gridLargeOneQuarter: 'lg_s14'
    },
    init: function () {
        var self = this;

        $(this.selectors.listCollectionsContainer).each(function () {
            var $container = $(this),
                sectionId = $container.data('section-id');

            self.truncateBlockText($container);
            $(window).on('resize.' + sectionId, Reqs.throttle(self.truncateBlockText.bind(self, $container), 50));

            $(document).on('ajaxify:updated', function () {
                self.truncateBlockText($container);
            });
        })
    },

    truncateBlockText: function ($collectionList) {
        var fourPerRow = $collectionList.find(this.selectors.collectionBlock).hasClass(this.classes.gridLargeOneQuarter),
            textLines = fourPerRow ? 2 : 3;

        $(this.selectors.collectionBlockText, $collectionList).trunk8({
            lines: textLines
        });

        $(this.selectors.collectionBlockTitle, $collectionList).trunk8({
            lines: 2
        });

        $(this.selectors.collectionBlock, $collectionList).removeClass(this.classes.isLoading);
    }
}


/*
 * quickView AJAX methods
 *
 * Key:
 * * el = ELEMENT attached to, one or more .js-collectionBlock
 * * handle = product HANDLE, delivered from the front-end  attached to .js-quickView
 * * obj = product OBJECT, in JSON
 */

var QuickView = {
    selectors: {
        section: '[data-section-id]',
        quickViewButton: '.js-quickView-button',
        collectionGrid: '.js-collectionGrid',
        productMedia: '[data-product-single-media-group]',
        productMediaSlider: '[data-product-single-media-slider]',
        productMediaWrapper: '[data-product-single-media-wrapper]',
        productMediaThumbs: '[data-product-single-media-thumbs]',
        productMediaTypeVideo: '[data-product-media-type-video]',
        productMediaTypeModel: '[data-product-media-type-model]',
        productTitle: '[data-product-title]',
        productForm: '[data-product-form]',
        productFormBlock: '.productForm-block',
        productFormSelectWrapper: '.selector-wrapper',
        productDescription: '[data-product-description]',
        collectionBlock: '[data-collection-block]'
    },

    settings: {
        enableVideoLooping: false,
        showQuantity: false
    },

    init: function () {
        var self = this,
            isQuickViewLoading = this.isQuickViewLoading = false;

        $(document).on('click', this.selectors.quickViewButton, function (e) {
            var $selector = $(this),
                el = $(this).closest(self.selectors.collectionBlock), // the .collectionBlock that contains the product js-quickView;
                url = $(this).attr('href'),
                sectionId = $selector.closest(self.selectors.section).data('section-id');

            if (!isQuickViewLoading) {
                self.isQuickViewLoading = true;
                el.addClass('quickView--is-loading');

                // if loaded and visible
                if (el.hasClass('is-loaded') && el.hasClass('quickView--is-visible')) {
                    self.hide(self);
                }

                // if loaded but not visible, no other quickViews open
                else if (el.hasClass('is-loaded') && !el.hasClass('quickView--is-visible') && !$('.quickView--is-visible').length) {
                    self.show(el);
                }

                // if loaded and not visible, other quickViews are open
                else if (el.hasClass('is-loaded') && !el.hasClass('quickView--is-visible') && $('.quickView--is-visible').length) {
                    self.hide(self);
                    setTimeout(function () {
                        self.show(el);
                    }, 200);
                }

                // if not loaded yet, other quickViews open
                else if ($('.quickView--is-visible').length) {
                    self.hide(self);
                    setTimeout(function () {
                        self.ajax(el, url, sectionId);
                    }, 200);
                }

                // if not loaded yet, no other quickViews open
                else {
                    self.ajax(el, url, sectionId);
                }
            }

            e.preventDefault();
        });
    },

    show: function (el) {
        var self = this,
            sub = ($(window).height() - 680) / 2,
            offset = el.children('.quickView').offset().top,
            headerHeight = 60,
            scrollPosition = offset - sub - headerHeight;

        el.addClass('quickView--is-active');
        el.removeClass('quickView--is-loading');

        $('html, body').stop(true, true).animate({scrollTop: scrollPosition}, 300, function () {
            Site.initReviews();

            ColorSwatches.bind(el);

            if (el.hasClass('is-loaded')) {
                el.addClass('quickView--is-visible');
            } else {
                el.addClass('quickView--is-visible is-loaded');
            }

            self.isQuickViewLoading = false;
        });

        $('html, body').trigger('quickView:show');
    },

    hide: function () {
        var $collectionBlock = $(this.selectors.collectionBlock),
            isQuickViewVisible = $collectionBlock.hasClass('quickView--is-visible');

        if (isQuickViewVisible) {
            $collectionBlock.removeClass('quickView--is-visible quickView--is-active quickView--is-loading');
        }

        $collectionBlock.find('.product-image.is-selected').trigger('mediaHidden').addClass('hidden');

        setTimeout(function () {
            Site.animations.animateAll();
        }, 300);

        $('html, body').trigger('quickView:hide');
    },

    ajax: function (el, url, sectionId) {
        var self = this,
            showProductDescription = false;

        el.addClass('quickView--is-loading');

        $.ajax({
            url: url,
            cache: false,
            dataType: 'html'
        }).done(function (data) {
            var productSectionId = 'product-template',
                productJSON = $(data).find('#ProductJson--' + productSectionId).text(),
                productMediaJson = $(data).find('#ModelJson-' + productSectionId).html(),
                product = JSON.parse(productJSON),
                productMediaSlider = self.modifyProductMediaSettings($(data).find(self.selectors.productMediaSlider), self.settings),
                productMediaThumbs = $(data).find(self.selectors.productMediaThumbs).html(),
                productTitle = self.addProductTitleLink($(data).find(self.selectors.productTitle), url),
                productForm = self.modifyProductFormIds($(data).find(self.selectors.productForm), product.id),
                productDescription = showProductDescription ? $(data).find(self.selectors.productDescription).html() : '',
                isProductMediaSingle = $(data).find('.js-productImgContainer > .js-slide').length == 1,
                item = {},
                source = $('#ProductQuickViewTemplate--' + sectionId).html(),
                template = Handlebars.compile(source);

            item = {
                productMediaSlider: productMediaSlider,
                productMediaThumbs: productMediaThumbs,
                productTitle: productTitle,
                productForm: productForm,
                productDescription: productDescription,
                productMediaJson: productMediaJson,
                isProductMediaSingle: isProductMediaSingle
            };

            el.append(template(item));
            el.attr('data-section-id', productSectionId);
            el.on('click', '.js-quickView-close', function (e) {
                e.preventDefault();
                self.hide(self)
            });

            self.initProductMediaSlider(el);
            self.initProductVideo(el);
            self.initMediaSwitch(el);
            self.initModelViewerLibraries(el);
            self.initShopifyXrLaunch(el);
            self.initVariants(el, product);
            self.initPaymentButton(el);
            self.show(el);

            $('html, body').trigger('quickView:ajax');
        });
    },

    /* Product Slider */
    initProductMediaSlider: function (container) {
        var self = this,
            $productSection = $(container),
            $productImgSlider = $productSection.find('.js-productImgSlider'),
            $productImgSliderNav = $productSection.find('.js-productImgSlider-nav'),
            activeArrows = $productImgSlider.data('arrows'),
            isDraggable = !($productImgSlider.find('.product-single__media--video').length || $productImgSlider.find('.product-single__media--model').length),
            activeSlide = $productImgSlider.find('.is-selected-product').index(),
            lastWindowWidth = window.innerWidth || document.documentElement.clientWidth;

        activeSlide = activeSlide == -1 ? 0 : activeSlide;

        if ($productImgSlider.find('.js-slide').length > 1) {
            $productImgSlider
                .on('ready.flickity', function () {
                    $productImgSlider.attr('tabindex', '-1');
                    $productImgSlider.find('.js-slide').attr('tabindex', '-1');
                })
                .on('change.flickity', function (event, index) {
                    var $currentSlide = $productImgSlider.find('.js-slide').eq(index),
                        $currentSlideImage = $currentSlide.find('.product-single__media--image');

                    if (!$currentSlideImage.hasClass('lazyloaded')) {
                        $currentSlideImage.addClass('lazyload');
                    }
                })
                .on('settle.flickity', function (event, index) {
                    var $currentSlide = $productImgSlider.find('.js-slide').eq(index),
                        mediaId = $currentSlide.data('media-id');

                    self.switchMedia(container, mediaId);
                });

            $productImgSlider.flickity({
                cellSelector: '.js-slide',
                prevNextButtons: activeArrows,
                arrowShape: window.theme.icons.arrowNavSlider,
                pageDots: false,
                initialIndex: activeSlide,
                draggable: true,
                adaptiveHeight: false,
                contain: true,
                wrapAround: true
            });

            $productImgSliderNav.on('ready.flickity', function () {
                $productImgSliderNav.attr('tabindex', '-1');
            });

            initSliderNav();
            $(window).on('resize.product', Reqs.debounce(function () {
                var windowWidth = window.innerWidth || document.documentElement.clientWidth;
                // Continue on window resize width change only
                if (lastWindowWidth != windowWidth) initSliderNav();
                lastWindowWidth = windowWidth;
            }, 250));

            function initSliderNav() {
                var isInitialized = $productImgSliderNav.data('flickity'),
                    sliderNavArrows = Site.sliders.checkThumbnailsOverflow($productImgSliderNav);

                if (isInitialized != undefined) {
                    $productImgSliderNav.flickity('destroy');
                }

                $productImgSliderNav.flickity({
                    cellSelector: '.js-slide',
                    asNavFor: $productImgSlider[0],
                    initialIndex: activeSlide,
                    pageDots: false,
                    prevNextButtons: sliderNavArrows,
                    arrowShape: window.theme.icons.arrowNavSlider,
                    contain: true,
                    wrapAround: sliderNavArrows,
                    watchCSS: true
                });
            }
        }
    },

    handleMediaFocus: function (e) {
        // If not ENTER key (13) or TAB key (9)
        if (e.keyCode !== 13 && e.keyCode !== 9) return;

        var $container = $(e.currentTarget).closest(this.selectors.collectionBlock),
            mediaId = $(e.currentTarget).data('thumbnail-id'),
            slideIndex = $(this.selectors.productMediaWrapper + '[data-media-id="' + mediaId + '"]', $container).index(),
            flick = $(this.selectors.productMediaSlider, $container).data('flickity');
        flickNav = $(this.selectors.productMediaThumbs, $container).data('flickity');

        // Go to the related slide media
        if (flick && flick.isActive && slideIndex > -1 && e.keyCode === 13) {
            flick.select(slideIndex);
        }

        // Move thumbs to the selected one
        if (flickNav && flickNav.isActive && slideIndex > -1) {
            flickNav.select(slideIndex);
        }
    },

    switchMedia: function (container, mediaId) {
        var $container = $(container),
            $currentMedia = $(this.selectors.productMediaWrapper + ':not(.hide)', $container),
            $newMedia = $(this.selectors.productMediaWrapper + '[data-media-id="' + mediaId + '"]', $container),
            $otherMedia = $(this.selectors.productMediaWrapper + ':not([data-media-id="' + mediaId + '"])', $container),
            isFocusEnabled = !$('body').hasClass('no-outline');

        if (isFocusEnabled) $newMedia.focus();

        $currentMedia.trigger('mediaHidden');
        $newMedia.removeClass('hidden').trigger('mediaVisible');
        $otherMedia.addClass('hidden');
    },

    initMediaSwitch: function (container) {
        var self = this,
            $container = $(container),
            $productThumbImages = $('[data-thumbnail-id]', $container);

        if (!$productThumbImages.length) return;

        $productThumbImages
            .on('click', function (e) {
                e.preventDefault();
            })
            .on('keyup', self.handleMediaFocus.bind(self));
    },

    initProductVideo: function (container) {
        var sectionId = $(container).data('section-id');

        $(this.selectors.productMediaTypeVideo, container).each(function () {
            var $video = $(this);
            ProductVideo.init($video, sectionId);
        });
    },

    initModelViewerLibraries: function (container) {
        var sectionId = $(container).data('section-id'),
            $modelViewerElements = $(this.selectors.productMediaTypeModel, container);
        if ($modelViewerElements.length < 1) return;

        ProductModel.init($modelViewerElements, sectionId);
    },

    initShopifyXrLaunch: function (container) {
        var self = this;

        $(document).on('shopify_xr_launch', function () {
            var $currentMedia = $(self.selectors.productMediaWrapper + ':not(.hide)', container);
            $currentMedia.trigger('xrLaunch');
        });
    },

    initVariants: function (container, product) {
        var self = this,
            selectId = 'product-select--' + product.id + '-quickView';

        /**
         * Reinitialize variant dropdown.
         */
        if ($('#' + selectId, container).length > 0) {
            new Shopify.OptionSelectors(selectId, {
                enableHistoryState: false,
                product: product,
                onVariantSelected: Product.selectCallback
            });
        }

        manageOptions(product);

        function manageOptions(productObject) {
            if (productObject['options'].length === 1 && productObject['variants'].length) {
                if (productObject['variants'][0].title !== 'Default Title') {
                    for (i = 0; i < productObject['options'].length; i++) {
                        $('#' + selectId + '-option-' + [i])
                            .closest(self.selectors.productFormSelectWrapper)
                            .attr('data-id', 'product-select-option-' + [i])
                            .prepend(window.theme.icons.arrow);
                    }
                } else {
                    $('#' + selectId + '-option-' + '0').closest(self.selectors.productFormBlock).hide();
                }
            } else if (productObject['options'].length > 1) {
                for (i = 0; i < productObject['options'].length; i++) {
                    $('#' + selectId + '-option-' + [i])
                        .closest(self.selectors.productFormSelectWrapper)
                        .attr('data-id', 'product-select-option-' + [i])
                        .prepend(window.theme.icons.arrow);
                }
            }
        }

        if (self.enableColorSwatches) {
            ColorSwatches.bind(container);
        }
    },

    initPaymentButton: function (container) {
        // Init dynamic checkout buttons
        var enablePaymentButton = (false),
            $addToCartButton = $('.js-productForm-submit', container);

        if (enablePaymentButton) {
            $addToCartButton.addClass('add-to-cart-btn-style');

            if (Shopify.PaymentButton) {
                Shopify.PaymentButton.init();
            }
        } else {
            $addToCartButton.removeClass('add-to-cart-btn-style');
        }
    },

    modifyProductMediaSettings: function (productMediaSlider, settings) {
        productMediaSlider.find('.product-image').each(function () {
            $(this)
                .attr('data-enable-video-looping', settings.enableVideoLooping)
                .attr('data-show_quantity', settings.showQuantity)
                .attr('tabindex', '-1');
        });
        return productMediaSlider.html();
    },

    modifyProductFormIds: function (productForm, productId) {
        // Find all ID attributes and add "--quickView" suffix
        productForm.find('[id]').each(function () {
            var currentId = $(this).attr('id'),
                newId = currentId + '--' + productId + '-quickView';
            $(this).attr('id', newId);
        });

        return productForm.html();
    },

    addProductTitleLink: function (productTitle, url) {
        var productTitleText = productTitle.find('.product-title').text();
        productTitle.find('.product-title').html('<a href="' + url + '">' + productTitleText + '</a>');
        return productTitle.html();
    }
};

var Product = {
    selectors: {
        body: 'body',
        productSection: '[data-section-type="product"]',
        productSectionContainer: '.js-product-template',
        productSliderContainer: '.js-productImgContainer',
        productSlider: '.js-productImgSlider',
        productSliderNav: '.js-productImgSlider-nav',
        productSlide: '.js-slide',
        productScroller: '.js-productImgScroller',
        productScrollerNav: '.js-productImgScroller-nav',
        productScrollerContainer: '.js-row--scrollable',
        productSelected: '.is-selected-product',
        productMediaWrapper: '[data-product-single-media-wrapper]',
        productMediaTypeVideo: '[data-product-media-type-video]',
        productMediaTypeModel: '[data-product-media-type-model]',
        productMediaVideo: '.product-single__media--video',
        productMediaModel: '.product-single__media--model',
        productMediaImage: '.product-single__media--image',
        productMediaThumb: '.product-single__media-thumb',
        productThumbnail: '.js-product-single__thumbnail',
        productImage: '.product-image',
        productImageLightboxLink: '[data-lightbox-link]',
        productLayoutScrollable: '.product-layout--scrollable',
        productTabs: '.js-product-tabs',
        productTabsNav: '.product-tabs-nav',
        productTabsContents: '.product-tabs-contents',
        productTabTitle: '.product-tab-title',
        productTabContent: '.product-tab-content',
        productForm: '.productForm',
        productFormBlock: '.productForm-block',
        productFormSelectWrapper: '.selector-wrapper',
        shopBar: '.shop-bar',
        zoomContainer: '.zoom-container'
    },

    init: function (update, sectionId) {
        var self = this,
            update = (typeof update !== 'undefined') ? update : false;

        if (update) {
            var container = $('[data-section-id="' + sectionId + '"]');

            this.initSingleProduct(container, update);
        } else {
            $(this.selectors.productSection).each(function () {
                var container = $(this);

                self.initSingleProduct(container, update);
            });
        }
    },

    initSingleProduct: function (container, update) {
        var self = this,
            showShopBar = $(this.selectors.shopBar, container).length,
            isLayoutScrollable = $(this.selectors.productLayoutScrollable, container).length,
            isOnboarding = $(container).hasClass('onboarding-product'),
            isProductTemplate = !$(container).hasClass('featured-product');

        if (!isOnboarding) {

            ColorSwatches.bind(container);

            if (isProductTemplate) {
                self.mfpOpen = true;
                self.initProductTabs(container);
                self.initImageGallery(container);
                self.qtyAdjust();

                if (isLayoutScrollable) {
                    self.initScroller(container, update);
                } else {
                    self.initProductMediaSlider(container);
                }

                if (showShopBar) {
                    self.initShopBar(container);
                }
            } else {
                self.initProductMediaSlider(container);
            }

            self.initProductVideo(container);
            self.initMediaSwitch(container);
            self.initModelViewerLibraries(container);
            self.initShopifyXrLaunch(container);
            self.initVariants(container);
            Site.initReviews();
        }
    },

    /* Product Slider */
    initProductMediaSlider: function (container) {
        var self = this,
            $productImgSlider = $(self.selectors.productSlider, container),
            $productImgSliderNav = $(self.selectors.productSliderNav, container),
            activeArrows = $productImgSlider.data('arrows'),
            activeDots = $productImgSlider.data('dots'),
            isDraggable = !($(self.selectors.productMediaVideo, $productImgSlider).length || $(self.selectors.productMediaModel, $productImgSlider).length),
            activeSlide = $(self.selectors.productSelected, $productImgSlider).index(),
            hasSlides = $(self.selectors.productSlide, $productImgSlider).length > 1,
            lastWindowWidth = window.innerWidth || document.documentElement.clientWidth;

        activeSlide = activeSlide == -1 ? 0 : activeSlide;

        if (hasSlides) {
            $productImgSlider
                .on('ready.flickity', function () {
                    $productImgSlider.attr('tabindex', '-1');
                    $(self.selectors.productSlide, $productImgSlider).attr('tabindex', '-1');
                })
                .on('change.flickity', function (event, index) {
                    var $currentSlide = $(self.selectors.productSlide, $productImgSlider).eq(index),
                        $currentSlideImage = $(self.selectors.productMediaImage, $currentSlide);

                    if (!$currentSlideImage.hasClass('lazyloaded')) {
                        $currentSlideImage.addClass('lazyload');
                    }

                    // Disable lightbox when changing slides
                    setTimeout(function () {
                        self.mfpOpen = true;
                    }, 10);
                })
                .on('dragStart.flickity', function (event, index) {
                    self.mfpOpen = false;
                }).on('settle.flickity', function (event, index) {
                var $currentSlide = $(self.selectors.productSlide, $productImgSlider).eq(index),
                    mediaId = $currentSlide.data('media-id');

                self.switchMedia(container, mediaId);
            });

            $productImgSlider.flickity({
                cellSelector: self.selectors.productSlide,
                prevNextButtons: activeArrows,
                arrowShape: window.theme.icons.arrowNavSlider,
                pageDots: activeDots,
                initialIndex: activeSlide,
                draggable: true,
                adaptiveHeight: false,
                contain: true,
                wrapAround: true
            });

            $productImgSliderNav.on('ready.flickity', function () {
                $productImgSliderNav.attr('tabindex', '-1');
            });

            initSliderNav();
            $(window).on('resize.product', Reqs.debounce(function () {
                var windowWidth = window.innerWidth || document.documentElement.clientWidth;
                // Continue on window resize width change only
                if (lastWindowWidth != windowWidth) initSliderNav();
                lastWindowWidth = windowWidth;
            }, 250));

            function initSliderNav() {
                var isInitialized = $productImgSliderNav.data('flickity'),
                    sliderNavArrows = Site.sliders.checkThumbnailsOverflow($productImgSliderNav);

                if (isInitialized != undefined) {
                    $productImgSliderNav.flickity('destroy');
                }

                $productImgSliderNav.flickity({
                    cellSelector: '.js-slide',
                    asNavFor: $productImgSlider[0],
                    initialIndex: activeSlide,
                    pageDots: false,
                    prevNextButtons: sliderNavArrows,
                    arrowShape: window.theme.icons.arrowNavSlider,
                    contain: true,
                    wrapAround: sliderNavArrows
                });
            }
        }
    },

    initImageGallery: function (container) {
        var self = this,
            $productImgContainer = $(self.selectors.productSliderContainer, container),
            lightbox = $productImgContainer.data('lightbox');

        if (!lightbox) return;

        Reqs.lightbox();
        Reqs.zoom();

        $(self.selectors.productImageLightboxLink, $productImgContainer).magnificPopup({
            mainClass: 'mfp-fade-in-up',
            type: 'image',
            removalDelay: 300,
            fixedContentPos: true,
            closeOnContentClick: false,
            closeOnBgClick: false,
            closeBtnInside: true,
            gallery: {
                enabled: true,
                preload: 0,
                tCounter: '<div class="mfp-counter-text">%curr% / %total%</div>',
                arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%">' + window.theme.icons.arrowSlider + '</button>'
            },
            tLoading: '<span class="icon-loader"></span>',
            closeMarkup: '<button title="%title%" type="button" class="mfp-close">' + window.theme.icons.close + '</button>',
            disableOn: function () {
                return self.mfpOpen;
            },
            callbacks: {
                open: function () {
                    var imgSrc = $(this.currItem.el).attr('href'),
                        $contentContainer = $(this.contentContainer);
                    self.initZoom(imgSrc, $contentContainer);
                },
                change: function () {
                    var imgSrc = $(this.currItem.el).attr('href'),
                        $contentContainer = $(this.contentContainer);
                    self.initZoom(imgSrc, $contentContainer);
                }
            }
        });
    },

    initZoom: function (imgSrc, $contentContainer) {
        if (!$(this.selectors.zoomContainer, $contentContainer).length) {
            $contentContainer.append('<span class="zoom-container"></span>');
        }

        $contentContainer
            .find(this.selectors.zoomContainer)
            .removeClass('zoom-container--loaded is-zoomed')
            .trigger('zoom.destroy')
            .empty()
            .zoom({
                on: 'click',
                url: imgSrc,
                magnify: 1.5,
                duration: 500,
                callback: function () {
                    $(this).parent().removeClass('is-zoomed').addClass('zoom-container--loaded');
                },
                onZoomIn: function () {
                    $(this).parent().addClass('is-zoomed');
                },
                onZoomOut: function () {
                    $(this).parent().removeClass('is-zoomed');
                }
            });
    },

    /* Product Tabs */
    initProductTabs: function (container) {
        var self = this,
            $productTabs = $(this.selectors.productTabs, container);

        enquire.register("screen and (min-width: 768px)", function () {
            var tabsTitles = $(self.selectors.productTabsNav, $productTabs),
                tabsContents = $(self.selectors.productTabsContents, $productTabs);
            $(self.selectors.productTabTitle, $productTabs).remove().appendTo(tabsTitles);
            $(self.selectors.productTabContent, $productTabs).remove().appendTo(tabsContents);
        });

        enquire.register("screen and (max-width: 767px)", function () {
            var tabsTitles = $(self.selectors.productTabTitle, $productTabs),
                tabsContents = $(self.selectors.productTabContent, $productTabs);

            for (var i = 0; i < tabsTitles.length; i++) {
                tabsTitles.eq(i).remove().appendTo($productTabs);
                tabsContents.eq(i).remove().appendTo($productTabs);
            }
        });

        // Click the product-tab title to change the tab
        $productTabs.on('click', self.selectors.productTabTitle, function () {
            var tabIndex = $(this).index(),
                isActive = $(this).hasClass('is-active'),
                tabsCount = $(this).siblings(self.selectors.productTabTitle).length + 1,
                windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

            // Do nothing if there's a single tab on Desktop
            if (tabsCount == 1 && windowWidth >= 768) return;

            $productTabs.find(self.selectors.productTabTitle).removeClass('is-active');
            $productTabs.find(self.selectors.productTabContent).removeClass('is-active');

            if (isActive) {
                tabIndex++;

                // Check if next tab exists or set to first
                if (!$productTabs.find(self.selectors.productTabTitle).eq(tabIndex).length) {
                    tabIndex = 0;
                }

                if (windowWidth >= 768) {
                    $productTabs.find(self.selectors.productTabTitle).eq(tabIndex).addClass('is-active').siblings().removeClass('is-active');
                    $productTabs.find(self.selectors.productTabContent).eq(tabIndex).addClass('is-active').siblings().removeClass('is-active');
                } else {
                    if ($(this).next().next(self.selectors.productTabTitle).length) {
                        // Show next tab on mobile if exists
                        $(this).next().next(self.selectors.productTabTitle).addClass('is-active').next(self.selectors.productTabContent).addClass('is-active');
                    } else {
                        if (tabsCount == 1) {
                            // Close current tab if it's a single one
                            $(this).removeClass('is-active').next(self.selectors.productTabContent).removeClass('is-active');
                        } else {
                            // Show first tab on mobile if the current is last
                            $(this).parent().find(self.selectors.productTabTitle).eq(0).addClass('is-active').next(self.selectors.productTabContent).addClass('is-active');
                        }
                    }
                }
            } else {
                if (windowWidth >= 768) {
                    $productTabs.find(self.selectors.productTabTitle).eq(tabIndex).addClass('is-active').siblings().removeClass('is-active');
                    $productTabs.find(self.selectors.productTabContent).eq(tabIndex).addClass('is-active').siblings().removeClass('is-active');
                } else {
                    $(this).addClass('is-active').next(self.selectors.productTabContent).addClass('is-active');
                }
            }

            // Scroll to the active tab on mobile
            if (windowWidth < 768 && $productTabs.find(self.selectors.productTabTitle + '.is-active').length) {
                setTimeout(function () {
                    var activeTabPosition = $productTabs.find(self.selectors.productTabTitle + '.is-active').offset().top - 61; // 60px header height + 1px border top width
                    $('html, body').stop(true, true).animate({scrollTop: activeTabPosition});
                }, 300);
            }
        });
    },

    initScroller: function (container, update) {
        var self = this,
            productImages = $(self.selectors.productImage, container).length;

        if (productImages > 1) {
            var isPageLoaded = false,
                $productLayoutScrollable = $(self.selectors.productLayoutScrollable, container),
                $productImg = $(self.selectors.productImage, container),
                $productImgNav = $(self.selectors.productScrollerNav, container);

            // Adjust thumbnails position if change setting in TE
            if (update) stickyThumbnails();

            $(window)
                .on('scroll.product', Reqs.throttle(stickyThumbnails, 10))
                .on('load', function () {
                    isPageLoaded = true;
                });

            // Bind product thumb image click to scroll function
            $productImgNav.on('click', self.selectors.productThumbnail, function (e) {
                e.preventDefault();

                var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

                if (windowWidth >= 768) {
                    var id = $(this).parent().data('id'),
                        $selectedImage = $(self.selectors.productImage + '[data-id="' + id + '"]'),
                        headerHeight = 59,
                        additionalSpace = 40;

                    if ($selectedImage.length) {
                        var mediaId = $selectedImage.data('media-id');
                        if (isPageLoaded || update) {
                            $('html, body')
                                .stop(true, false)
                                .animate({scrollTop: $selectedImage.offset().top - headerHeight - additionalSpace}, 500, function () {
                                    Product.switchMedia(container, mediaId)
                                });
                        }
                    }
                }
            });

            $(window).on('resize.product', Reqs.throttle(toggleMobileSlider, 250));

            toggleMobileSlider();

            function toggleMobileSlider() {
                var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
                    hasSlides = $(self.selectors.productSlide, $productLayoutScrollable).length > 1;

                if (windowWidth < 768 && hasSlides) {
                    initMobileSlider();
                } else {
                    destroyMobileSlider();
                }
            }

            function stickyThumbnails() {
                var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

                if (windowWidth >= 768) {
                    var scrolled = $(window).scrollTop(),
                        productOffset = $productLayoutScrollable.offset().top - 100;

                    for (var i = $productImg.length - 1; i >= 0; i--) {
                        var $currentProduct = $(self.selectors.productImage).eq(i),
                            id = $currentProduct.data('id'),
                            productOffset = parseInt($currentProduct.offset().top - 100);

                        if (scrolled >= productOffset) {
                            $productImgNav.find(self.selectors.productMediaThumb + '[data-id="' + id + '"]').addClass('active').siblings().removeClass('active');
                            break;
                        }
                    }
                }
            }
        }

        // If product layout is scroller and is mobile then load slider
        function initMobileSlider() {
            var $productImgSlider = $(self.selectors.productScroller, container),
                $productImgSliderNav = $(self.selectors.productScrollerNav, container),
                hasSlides = $(self.selectors.productSlide, container).length > 1,
                activeArrows = $productImgSlider.data('arrows'),
                activeDots = $productImgSlider.data('dots'),
                sliderNavArrows = Site.sliders.checkThumbnailsOverflow($productImgSliderNav),
                isDraggable = !($(self.selectors.productMediaVideo, $productImgSlider).length || $(self.selectors.productMediaModel, $productImgSlider).length),
                activeSlide = $(self.selectors.productSelected, $productImgSlider).index();

            activeSlide = activeSlide == -1 ? 0 : activeSlide;

            var flickity = $productImgSlider.data('flickity'),
                flickityNav = $productImgSliderNav.data('flickity');

            if (hasSlides) {
                if (flickity == undefined) {

                    $productImgSlider
                        .on('change.flickity', function (event, index) {
                            var $currentSlide = $(self.selectors.productSlide, $productImgSlider).eq(index);
                            if (!$currentSlide.hasClass('lazyloaded')) {
                                $currentSlide.addClass('lazyload');
                            }

                            // Disable lightbox when changing slides
                            setTimeout(function () {
                                self.mfpOpen = true;
                            }, 10);
                        })
                        .on('dragStart.flickity', function (event, index) {
                            self.mfpOpen = false;
                        });

                    $productImgSlider.flickity({
                        cellSelector: '.js-slide',
                        prevNextButtons: activeArrows,
                        arrowShape: window.theme.icons.arrowNavSlider,
                        pageDots: activeDots,
                        initialIndex: activeSlide,
                        draggable: true,
                        selectedAttraction: 0.08,
                        friction: 0.8,
                        adaptiveHeight: false,
                        contain: true,
                        wrapAround: true
                    });
                }

                if (flickityNav == undefined) {
                    $productImgSliderNav.flickity({
                        cellSelector: '.js-slide',
                        asNavFor: $productImgSlider[0],
                        initialIndex: activeSlide,
                        pageDots: false,
                        prevNextButtons: sliderNavArrows,
                        arrowShape: window.theme.icons.arrowNavSlider,
                        contain: true,
                        cellAlign: 'left',
                        wrapAround: sliderNavArrows
                    });
                }
            }
        }

        function destroyMobileSlider() {
            var $productImgSlider = $(self.selectors.productScroller, container),
                $productImgSliderNav = $(self.selectors.productScrollerNav, container),
                flickity = $productImgSlider.data('flickity'),
                flickityNav = $productImgSliderNav.data('flickity');

            if (flickity && flickity.isActive) {
                $productImgSlider.flickity('destroy')
            }

            if (flickityNav && flickityNav.isActive) {
                $productImgSliderNav.flickity('destroy')
            }
        }
    },

    handleMediaFocus: function (e, container) {
        // Do nothing if not ENTER key (13) or TAB key (9)
        if (e.keyCode !== 13 && e.keyCode !== 9) return;

        var mediaId = $(e.currentTarget).data('thumbnail-id'),
            slideIndex = $(this.selectors.productSlide + '[data-media-id="' + mediaId + '"]', container).index(),
            flick = $(this.selectors.productSliderContainer, container).data('flickity'),
            flickNav = $(this.selectors.productSliderNav, container).data('flickity');

        // Go to the related slide media
        if (flick && flick.isActive && slideIndex > -1 && e.keyCode === 13) {
            flick.select(slideIndex);
        }

        // Move thumbs to the selected one
        if (flickNav && flickNav.isActive && slideIndex > -1) {
            flickNav.select(slideIndex);
        }
    },

    switchMedia: function (container, mediaId) {
        var $currentMedia = $(this.selectors.productMediaWrapper + ':not(.hide)', container),
            $newMedia = $(this.selectors.productMediaWrapper + '[data-media-id="' + mediaId + '"]', container),
            $otherMedia = $(this.selectors.productMediaWrapper + ':not([data-media-id="' + mediaId + '"])', container),
            isFocusEnabled = !$(this.selectors.body).hasClass('no-outline');

        if (isFocusEnabled) $newMedia.focus();

        $currentMedia.trigger('mediaHidden');
        $newMedia.removeClass('hidden').trigger('mediaVisible');
        $otherMedia.addClass('hidden');
    },

    pauseOtherMedia: function (mediaId, container) {
        var $currentMedia = $(this.selectors.productMediaWrapper + '[data-media-id="' + mediaId + '"]'),
            $otherMedia = $(this.selectors.productMediaWrapper + ':not([data-media-id="' + mediaId + '"])');

        $currentMedia.removeClass('hidden');
        $otherMedia.trigger('mediaHidden').addClass('hidden');
    },

    initMediaSwitch: function (container) {
        var $productThumbImages = $(this.selectors.productThumbnail, container);

        if (!$productThumbImages.length) return;

        $productThumbImages
            .on('click', function (e) {
                e.preventDefault();
            })
            .on('keyup', this.handleMediaFocus.bind(this));
    },

    initProductVideo: function (container) {
        var sectionId = $(container).data('section-id');

        $(this.selectors.productMediaTypeVideo, container).each(function () {
            var $video = $(this);
            ProductVideo.init($video, sectionId);
        });
    },

    initModelViewerLibraries: function (container) {
        var sectionId = $(container).data('section-id'),
            $modelViewerElements = $(this.selectors.productMediaTypeModel, container);

        if ($modelViewerElements.length < 1) return;

        ProductModel.init($modelViewerElements, sectionId);
    },

    initShopifyXrLaunch: function (container) {
        var self = this;

        $(document).on('shopify_xr_launch', function () {
            var $currentMedia = $(self.selectors.productMediaWrapper + ':not(.hide)', container);
            $currentMedia.trigger('xrLaunch');
        });
    },

    initVariants: function (container) {
        /**
         * Initialize variants dropdown.
         */
        var self = this,
            sectionId = $(container).data('section-id'),
            productJSON = $('#ProductJson--' + sectionId).text(),
            product = JSON.parse(productJSON),
            selectId = 'product-select',
            isFeaturedProduct = $(container).hasClass('featured-product'),
            enableHistoryState = !isFeaturedProduct;

        if (isFeaturedProduct) {
            selectId = 'product-select--' + sectionId;
        }

        if ($('#' + selectId, container).length > 0) {
            new Shopify.OptionSelectors(selectId, {
                enableHistoryState: enableHistoryState,
                product: product,
                onVariantSelected: Product.selectCallback
            });
        }

        manageOptions(product, sectionId);

        function manageOptions(productObject, id) {
            var selectId = '#product-select-option-',
                dataId = 'product-select-option-';

            if (isFeaturedProduct) {
                selectId = '#product-select--' + id + '-option-';
            }

            if (productObject['options'].length === 1 && productObject['variants'].length) {
                if (productObject['variants'][0].title !== 'Default Title') {
                    for (i = 0; i < productObject['options'].length; i++) {
                        $(selectId + [i])
                            .closest(self.selectors.productFormSelectWrapper)
                            .attr('data-id', dataId + [i])
                            .prepend(window.theme.icons.arrow)
                            .prepend('<label>' + productObject['options'][0] + '</label>');
                    }
                }
            } else if (productObject['variants'].length) {
                for (i = 0; i < productObject['options'].length; i++) {
                    $(selectId + [i])
                        .closest(self.selectors.productFormSelectWrapper)
                        .attr('data-id', dataId + [i])
                        .prepend(window.theme.icons.arrow);
                }
            }
        }

        ColorSwatches.bind(container);
    },

    /*
	 * Sticky "Shop" Bar in product.liquid
	 * Hidden via CSS under 768px viewport size
	 */
    initShopBar: function (container) {
        var self = this,
            sectionId = $(container).data('section-id'),
            product = JSON.parse(document.getElementById('ProductJson--' + sectionId).innerHTML),
            $body = $(self.selectors.body),
            $productForm = $(self.selectors.productForm, container),
            $shopBar = $(self.selectors.shopBar, container),
            $productContainer = $(self.selectors.productSectionContainer, container),
            $siteFooter = $('.site-footer'),
            selectId = '#shop-bar-select-option-';
        /*
		* Move shop bar html outside the .bodyWrap
		* .bodyWrap has transform property which causes the shop bar disappearing as it has position: fixed
		*/
        $shopBar.remove().appendTo($body);

        if ($('#shop-bar-select').length > 0) {
            new Shopify.OptionSelectors('shop-bar-select', {
                enableHistoryState: true,
                product: product,
                onVariantSelected: Product.selectCallback
            });
        }

        manageOptions(product);

        function manageOptions(productObject) {
            if (productObject['options'].length === 1 && productObject['variants'].length) {
                if (productObject['variants'][0].title !== 'Default Title') {
                    for (i = 0; i < productObject['options'].length; i++) {
                        $(selectId + [i])
                            .closest(self.selectors.productFormSelectWrapper)
                            .attr('data-id', selectId + [i])
                            .prepend(window.theme.icons.arrow)
                            .prepend('<label>' + productObject['options'][0] + '</label>');
                    }
                }
            } else if (productObject['variants'].length) {
                for (i = 0; i < productObject['options'].length; i++) {
                    $(selectId + [i])
                        .closest(self.selectors.productFormSelectWrapper)
                        .attr('data-id', selectId + [i])
                        .prepend(window.theme.icons.arrow);
                }
            }
        }

        // Update shop bar on product form variant change
        $shopBar.on('change', 'select', function (e) {
            var id = $(this).attr('id');
            var optionSelected = $(this).val();
            id = id.replace('shop-bar-', 'product-');

            $productForm.find('select#' + id).val(optionSelected).triggerHandler('change');

            // Update product form color swatches
            if (!$(id).is(':visible')) {
                $('[data-select-id="' + id + '"][value="' + optionSelected + '"]"')
                    .prop('checked', true)
                    .closest('.swatch').find('.header__value').text(optionSelected);
            }
        });

        // Update shop bar on product form variant change
        $productForm.on('change', 'select', function (e) {
            var id = '#' + $(this).attr('id');
            var optionSelected = $(this).val();
            id = id.replace('product-', 'shop-bar-');

            $(id).val(optionSelected).triggerHandler('change');
        });

        $(window).on('scroll.product',
            Reqs.throttle(function () {
                var scrolled = $(window).scrollTop();

                if ($productContainer.length && $shopBar.length) {
                    var productContainerOffset = $productContainer.offset().top;

                    if (scrolled > productContainerOffset) {
                        $shopBar.addClass('shop-bar--is-visible');
                        $siteFooter.addClass('site-footer--push')
                    } else if (scrolled < productContainerOffset - 60) {
                        $shopBar.removeClass('shop-bar--is-visible');
                        $siteFooter.removeClass('site-footer--push')
                    }
                }
            }, 100)
        ).trigger('scroll.product');
    },

    // this is what is being called from the product.liquid
    selectCallback: function (variant, selector) {
        Product.callback({
            money_format: window.money_format,
            variant: variant,
            selector: selector
        });

        ColorSwatches.init(variant, selector);
    },

    callback: function (options) {
        var container = $(options.selector.variantIdField).closest('[data-section-id]'),
            variant = options.variant;

        //el is options.selector.variantIdField, the tie that binds
        var gold = $(options.selector.variantIdField).attr('id');
        var id = gold.replace(/\D/g, '');
        var fp = $('.featured-product--' + id);

        if ($(options.selector.variantIdField).parents('.featured-product').length > 0) {

            var $submit = $(fp).find('.js-productForm-submit'),
                $price = $(fp).find('.product-price'),
                $normal_price = $(fp).find('.product-normal-price'),
                $sale_price = $(fp).find('.product-sale-price'),
                $compare_price = $(fp).find('.product-compare-price'),
                $unit_price = $(fp).find('.product-unit-price'),
                $counter = $(fp).find('.js-counter').not('.cart-product-quantity .js-counter'),
                $sale_container = $price.find('.sale'),
                $notification_form = $(fp).find('.notification-form');
        } else {
            var $submit = $('.js-productForm-submit', container),
                $price = $('.product-price', container),
                $normal_price = $('.product-normal-price', container),
                $sale_price = $('.product-sale-price', container),
                $compare_price = $('.product-compare-price', container),
                $unit_price = $('.product-unit-price', container),
                $counter = $('.js-counter', container).not('.cart-product-quantity .js-counter'),
                $sale_container = $price.find('.sale'),
                $notification_form = $('.notification-form', container);
        }

        if (variant) {
            if (variant.available) {
                $submit.removeClass('is-disabled').prop('disabled', false).html(window.theme.translations.form_submit);
                $counter.css({'pointer-events': 'auto'});

                $price.attr('data-price', variant.price);
                $normal_price.html(Shopify.formatMoney(variant.price, window.money_format));
                $notification_form.addClass('visually-hidden');
                if (variant.compare_at_price != null) {
                    if (variant.compare_at_price > variant.price) {
                        if ($sale_container.length) {
                            $compare_price.html(Shopify.formatMoney(variant.compare_at_price, window.money_format));
                            $sale_price.html(Shopify.formatMoney(variant.price, window.money_format));
                        } else {
                            $price.append('<div class="sale" itemprop="price"><strike class="product-compare-price"></strike> <span class="product-sale-price"></span></div>');
                            $compare_price.html(Shopify.formatMoney(variant.compare_at_price, window.money_format));
                            $sale_price.html(Shopify.formatMoney(variant.price, window.money_format));
                        }
                        $normal_price.hide();
                        $sale_container.show();
                    } else if (variant.compare_at_price <= variant.price) {
                        if ($normal_price.length) {
                            $normal_price.html(Shopify.formatMoney(variant.price, window.money_format));
                        } else {
                            $price.append('<div class="product-normal-price" itemprop="price">' + Shopify.formatMoney(variant.price, window.money_format) + '</div>');
                        }
                        $sale_container.hide();
                        $normal_price.show();
                    }
                } else {
                    $sale_container.hide();
                    $normal_price.show();

                }
                document.addEventListener('shopify:payment_button:loaded', showButtons($submit));

                function showButtons($submit) {
                    var sibling = $submit.next();
                    if ($(sibling).hasClass('shopify-payment-button')) {
                        $(sibling).show();
                    }
                }
            }
            // this variant sold out
            else {
                $submit.addClass('is-disabled').prop('disabled', true).html(window.theme.translations.sold_out);
                $counter.css({'pointer-events': 'none'});

                $price.attr('data-price', variant.price);
                $normal_price.html(Shopify.formatMoney(variant.price, window.money_format));
                $notification_form.removeClass('visually-hidden');

                document.addEventListener('shopify:payment_button:loaded', checkButtons($submit));

                function checkButtons($submit) {
                    var sibling = $submit.next();
                    if ($(sibling).hasClass('shopify-payment-button')) {
                        $(sibling).hide();
                    }
                }

                if (variant.compare_at_price != null) {
                    if (variant.compare_at_price > variant.price) {
                        if ($sale_container.length) {
                            $compare_price.html(Shopify.formatMoney(variant.compare_at_price, window.money_format));
                            $sale_price.html(Shopify.formatMoney(variant.price, window.money_format));
                        } else {
                            $price.append('<div class="sale" itemprop="price"><strike class="product-compare-price"></strike> <span class="product-sale-price"></span></div>');
                            $compare_price.html(Shopify.formatMoney(variant.compare_at_price, window.money_format));
                            $sale_price.html(Shopify.formatMoney(variant.price, window.money_format));
                        }
                        $normal_price.hide();
                        $sale_container.show();
                    } else if (variant.compare_at_price <= variant.price) {
                        if ($normal_price.length) {
                            $normal_price.html(Shopify.formatMoney(variant.price, window.money_format));
                        } else {
                            $price.append('<div class="product-normal-price" itemprop="price">' + Shopify.formatMoney(variant.price, window.money_format) + '</div>');
                        }
                        $sale_container.hide();
                        $normal_price.show();
                    }
                } else {
                    $sale_container.hide();
                    $normal_price.show();
                }
            }

            // Update unit price
            if (variant.unit_price_measurement) {
                var unitPrice = Shopify.formatMoney(variant.unit_price, window.money_format) + ' ';
                if (variant.unit_price_measurement.reference_value != 1) {
                    unitPrice += variant.unit_price_measurement.reference_value;
                }
                unitPrice += variant.unit_price_measurement.reference_unit;

                $unit_price.html(unitPrice);
            }

            Product.showVariantImage(variant, container);
        } else {
            $notification_form.removeClass('visually-hidden');
            $submit.addClass('is-disabled').prop('disabled', true).html(window.theme.translations.unavailable);
            $counter.css({'pointer-events': 'none'});
            document.addEventListener('shopify:payment_button:loaded', checkButtons($submit));

            function checkButtons($submit) {
                var sibling = $submit.next();
                if ($(sibling).hasClass('shopify-payment-button')) {
                    $(sibling).hide();
                }
            }
        }
    },

    // show variant image within quickView or within slideshow (mobile product page)
    showVariantImage: function (variant, container) {
        var variantMediaId = variant.featured_media ? variant.featured_media.id : '',
            $productImage = container.find('.product-image'),
            $imgSlider = container.find('.js-productImgContainer'),
            $imgScrollerNav = container.find('.productImgScroller-nav'),
            flick = $imgSlider.data('flickity');

        // Activate image slide in mobile view
        if (flick && flick.isActive) {
            var $variantSlide = $imgSlider.find('[data-id="' + variantMediaId + '"]');

            if ($variantSlide.index() != -1) {
                flick.select($variantSlide.index());
            }

            $productImage.removeClass('is-selected-product');
            $variantSlide.addClass('is-selected-product');
        } else {
            var $variantThumb = $imgScrollerNav.find('[data-id="' + variantMediaId + '"] .js-product-single__thumbnail');

            if ($variantThumb.length) {
                $variantThumb.trigger('click');
            }
        }
    },

    qtyAdjust: function () {
        // Setup listeners to add/subtract from the input
        var $body = $('body');
        $body.off('click', '.js-qty__adjust-btn');
        $body.on('click', '.js-qty__adjust-btn', function (e) {
            e.preventDefault();
            var $adjustBtn = $(this),
                $qtySelector = $(this).siblings('input[name="quantity"]');
            qty = validateQty(parseInt($qtySelector.val().replace(/\D/g, '')));

            // Add or subtract from the current quantity
            if ($adjustBtn.hasClass('increase')) {
                qty += 1;
            } else {
                qty -= 1;
                if (qty < 1) qty = 1;
            }

            // Update the input's number
            $qtySelector.val(qty);
        });

        // Prevent 0 quantity
        $body.off('focusout', '.qty__adjust > input');
        $body.on('focusout', '.qty__adjust > input', function (e) {
            var currentValue = $(this).val();
            if (!currentValue) $(this).prop('value', 1);
        });

        $body.off('keydown', '.qty__adjust > input');
        $body.on('keydown', '.qty__adjust > input', function (e) {
            var currentValue = $(this).val();
            if (e.keyCode === 13 && !currentValue) $(this).prop('value', 1);
        });

        function validateQty(qty) {
            if ((parseFloat(qty) != parseInt(qty)) || isNaN(qty)) {
                qty = 1;
            }
            return qty;
        };
    }
}

window.isYoutubeAPILoaded = false;

function onYouTubeIframeAPIReady() {
    ProductVideo.loadVideos(ProductVideo.hosts.youtube);
    window.isYoutubeAPILoaded = true;
}

var ProductVideo = (function () {
    var videos = {};

    var hosts = {
        html5: 'html5',
        youtube: 'youtube'
    };

    var selectors = {
        productMediaWrapper: '[data-product-single-media-wrapper]'
    };

    var attributes = {
        enableVideoLooping: 'enable-video-looping',
        videoId: 'video-id',
        mediaId: 'media-id'
    };

    function init(videoContainer, sectionId) {
        if (!videoContainer.length) {
            return;
        }

        var videoElement = videoContainer.find('iframe, video')[0];
        var mediaId = videoContainer.data('mediaId');

        if (!videoElement) {
            return;
        }

        videos[mediaId] = {
            mediaId: mediaId,
            sectionId: sectionId,
            host: hostFromVideoElement(videoElement),
            container: videoContainer,
            element: videoElement,
            ready: function () {
                createPlayer(this);
            }
        };

        var video = videos[mediaId];

        switch (video.host) {
            case hosts.html5:
                window.Shopify.loadFeatures([
                    {
                        name: 'video-ui',
                        version: '1.0',
                        onLoad: setupPlyrVideos
                    }
                ]);
                LibraryLoader.load('plyrShopifyStyles');
                break;
            case hosts.youtube:
                if (window.isYoutubeAPILoaded) {
                    ProductVideo.loadVideos(ProductVideo.hosts.youtube);
                } else {
                    LibraryLoader.load('youtubeSdk');
                }
                break;
        }
    }

    function setupPlyrVideos(errors) {
        if (errors) {
            fallbackToNativeVideo();
            return;
        }

        loadVideos(hosts.html5);
    }

    function createPlayer(video) {
        if (video.player) {
            return;
        }

        var productMediaWrapper = video.container,
            enableLooping = productMediaWrapper.data(attributes.enableVideoLooping),
            mediaId = productMediaWrapper.data(attributes.mediaId);

        switch (video.host) {
            case hosts.html5:
                // eslint-disable-next-line no-undef
                video.player = new Shopify.Plyr(video.element, {
                    loop: {active: enableLooping},
                    focusOnPlay: true
                });

                video.player.on('play', function () {
                    Product.pauseOtherMedia(mediaId);
                });
                break;
            case hosts.youtube:
                var videoId = productMediaWrapper.data(attributes.videoId);
                video.player = new YT.Player(video.element, {
                    videoId: videoId,
                    events: {
                        // onReady: function(event) {},
                        onStateChange: function (event) {
                            if (event.data === 0 && enableLooping) event.target.seekTo(0);
                            if (event.data === 1) Product.pauseOtherMedia(mediaId);
                        }
                    }
                });
                break;
        }

        productMediaWrapper.on('mediaHidden xrLaunch', function (e) {
            if (!video.player) return;

            if (video.host === hosts.html5) {
                video.player.pause();
            }

            if (video.host === hosts.youtube && video.player.pauseVideo) {
                video.player.pauseVideo();
            }
        });

        productMediaWrapper.on('mediaVisible', function (e) {
            if (Helpers.isTouch()) return;
            if (!video.player) return;

            if (video.host === hosts.html5) {
                video.player.play();
            }

            if (video.host === hosts.youtube && video.player.playVideo) {
                video.player.playVideo();
            }
        });
    }

    function hostFromVideoElement(video) {
        if (video.tagName === 'VIDEO') {
            return hosts.html5;
        }

        if (video.tagName === 'IFRAME') {
            if (
                /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
                    video.src
                )
            ) {
                return hosts.youtube;
            }
        }
        return null;
    }

    function loadVideos(host) {
        for (var key in videos) {
            if (videos.hasOwnProperty(key)) {
                var video = videos[key];
                if (video.host === host) {
                    video.ready();
                }
            }
        }
    }

    function fallbackToNativeVideo() {
        for (var key in videos) {
            if (videos.hasOwnProperty(key)) {
                var video = videos[key];

                if (video.nativeVideo) continue;

                if (video.host === hosts.html5) {
                    video.element.setAttribute('controls', 'controls');
                    video.nativeVideo = true;
                }
            }
        }
    }

    function removeSectionVideos(sectionId) {
        for (var key in videos) {
            if (videos.hasOwnProperty(key)) {
                var video = videos[key];

                if (video.sectionId === sectionId) {
                    if (video.player) video.player.destroy();
                    delete videos[key];
                }
            }
        }
    }

    return {
        init: init,
        hosts: hosts,
        loadVideos: loadVideos,
        removeSectionVideos: removeSectionVideos
    };
})();

var ProductModel = (function () {
    var modelJsonSections = {},
        models = {},
        xrButtons = {};

    var selectors = {
        mediaGroup: '[data-product-single-media-group]',
        xrButton: '[data-shopify-xr]'
    };

    function init(modelViewerContainers, sectionId) {
        modelJsonSections[sectionId] = {
            loaded: false
        };

        modelViewerContainers.each(function (index) {
            var $modelViewerContainer = $(this);
            var mediaId = $modelViewerContainer.data('media-id');
            var $modelViewerElement = $(
                $modelViewerContainer.find('model-viewer')[0]
            );
            var modelId = $modelViewerElement.data('model-id');

            if (index === 0) {
                var $xrButton = $modelViewerContainer
                    .closest(selectors.mediaGroup)
                    .find(selectors.xrButton);
                xrButtons[sectionId] = {
                    $element: $xrButton,
                    defaultId: modelId
                };
            }

            models[mediaId] = {
                modelId: modelId,
                mediaId: mediaId,
                sectionId: sectionId,
                $container: $modelViewerContainer,
                $element: $modelViewerElement
            };
        });

        window.Shopify.loadFeatures([
            {
                name: 'shopify-xr',
                version: '1.0',
                onLoad: setupShopifyXr
            },
            {
                name: 'model-viewer-ui',
                version: '1.0',
                onLoad: setupModelViewerUi
            }
        ]);
        LibraryLoader.load('modelViewerUiStyles');
    }

    function setupShopifyXr(errors) {
        if (errors) return;

        if (!window.ShopifyXR) {
            document.addEventListener('shopify_xr_initialized', function () {
                setupShopifyXr();
            });
            return;
        }

        for (var sectionId in modelJsonSections) {
            if (modelJsonSections.hasOwnProperty(sectionId)) {
                var modelSection = modelJsonSections[sectionId];

                if (modelSection.loaded) continue;
                var $modelJson = $('#ModelJson-' + sectionId);

                window.ShopifyXR.addModels(JSON.parse($modelJson.html()));
                modelSection.loaded = true;
            }
        }
        window.ShopifyXR.setupXRElements();
    }

    function setupModelViewerUi(errors) {
        if (errors) return;

        for (var key in models) {
            if (models.hasOwnProperty(key)) {
                var model = models[key];
                if (!model.modelViewerUi) {
                    model.modelViewerUi = new Shopify.ModelViewerUI(model.$element);
                }

                setupModelViewerListeners(model);
            }
        }
    }

    function setupModelViewerListeners(model) {
        var xrButton = xrButtons[model.sectionId];

        model.$container.on('mediaVisible', function () {
            xrButton.$element.attr('data-shopify-model3d-id', model.modelId);
            Product.pauseOtherMedia(model.mediaId);
            if (Helpers.isTouch()) return;
            model.modelViewerUi.play();
        });

        model.$container
            .on('mediaHidden', function () {
                xrButton.$element.attr('data-shopify-model3d-id', xrButton.defaultId);
                model.modelViewerUi.pause();
            })
            .on('xrLaunch', function () {
                model.modelViewerUi.pause();
            });

        model.$element.on('shopify_model_viewer_ui_toggle_play', function () {
            Product.pauseOtherMedia(model.mediaId);
        });
    }

    function removeSectionModels(sectionId) {
        for (var key in models) {
            if (models.hasOwnProperty(key)) {
                var model = models[key];
                if (model.sectionId === sectionId) {
                    models[key].modelViewerUi.destroy();
                    delete models[key];
                }
            }
        }
        delete modelJsonSections[sectionId];
    }

    return {
        init: init,
        removeSectionModels: removeSectionModels
    };
})();

var RelatedProducts = {
    init: function () {
        var $container = $('[data-section-type="related-products"]');
        var sectionId = $container.attr('data-section-id');
        var productId = $container.data('product-id');
        var limit = $container.data('limit');
        var requestUrl = window.theme.routes.product_recommendations_url + '?section_id=' + sectionId + '&limit=' + limit + '&product_id=' + productId;
        var imageSize = $container.data('image-size');

        $.get(requestUrl)
            .done(function (data) {
                var products = $(data).find('[data-section-type="related-products"]').html();
                $container.hide().html(products).slideDown('slow');

                var $image = $container.find('.collectionBlock-image');

                Site.animations.animateAll();
                Site.initReviews();

                if (imageSize == 'contain') {
                    Collection.setBadgePosition($image);
                    $(window)
                        .off('resize.products')
                        .on('resize.products', Reqs.debounce(Collection.setBadgePosition.bind(this, $image), 50));
                }
            });
    }
}

var Blog = {
    selectors: {
        blogSection: '[data-blog-section]',
        blogTemplate: '[data-blog-template]',
        blogPost: '[data-blog-post]',
        blogPostContent: '[data-post-title], [data-post-excerpt]'
    },
    classes: {
        blogPostHasImage: 'blogModule-posts__post--has-image'
    },
    init: function () {
        var self = this,
            $blogSections = $(this.selectors.blogSection),
            $blog = $(this.selectors.blogTemplate),
            showFeatured = $blog.data('featured');

        this.truncateText();
        $(window)
            .on('load', this.truncateText.bind(this))
            .on('resize', Reqs.throttle(self.truncateText.bind(self), 50));

        $(document).on('ajaxify:updated', this.truncateText.bind(this));

        $blogSections.each(function () {
            var $container = $(this);
            Site.removeAnimationClass($container);
        });
    },

    truncateText: function () {
        var self = this,
            $blogPost = $(this.selectors.blogPost);

        if ($blogPost.length) {
            $blogPost.each(function () {
                var $itemContent = $(this).find(self.selectors.blogPostContent),
                    hasImage = $(this).hasClass(self.classes.blogPostHasImage),
                    lines = hasImage ? 2 : 4;

                $itemContent.trunk8({lines: lines});
            });
        }
    }
}

var Reqs = {
    throttle: function (fn, threshhold, scope) {
        threshhold || (threshhold = 250);

        var last,
            deferTimer;

        return function () {
            var context = scope || this;

            var now = +new Date,
                args = arguments;

            if (last && now < last + threshhold) {
                // hold on to it
                clearTimeout(deferTimer);
                deferTimer = setTimeout(function () {
                    last = now;
                    fn.apply(context, args);
                }, threshhold);
            } else {
                last = now;
                fn.apply(context, args);
            }
        }
    },
    debounce: function (fn, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) fn.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) fn.apply(context, args);
        };
    },
    lightbox: function () {
        /*! Magnific Popup - v1.1.0 - 2016-02-20
		* http://dimsemenov.com/plugins/magnific-popup/
		* Copyright (c) 2016 Dmitry Semenov; */
        !function (a) {
            "function" == typeof define && define.amd ? define(["jquery"], a) : a("object" == typeof exports ? require("jquery") : window.jQuery || window.Zepto)
        }(function (a) {
            var b, c, d, e, f, g, h = "Close", i = "BeforeClose", j = "AfterClose", k = "BeforeAppend",
                l = "MarkupParse", m = "Open", n = "Change", o = "mfp", p = "." + o, q = "mfp-ready",
                r = "mfp-removing", s = "mfp-prevent-close", t = function () {
                }, u = !!window.jQuery, v = a(window), w = function (a, c) {
                    b.ev.on(o + a + p, c)
                }, x = function (b, c, d, e) {
                    var f = document.createElement("div");
                    return f.className = "mfp-" + b, d && (f.innerHTML = d), e ? c && c.appendChild(f) : (f = a(f), c && f.appendTo(c)), f
                }, y = function (c, d) {
                    b.ev.triggerHandler(o + c, d), b.st.callbacks && (c = c.charAt(0).toLowerCase() + c.slice(1), b.st.callbacks[c] && b.st.callbacks[c].apply(b, a.isArray(d) ? d : [d]))
                }, z = function (c) {
                    return c === g && b.currTemplate.closeBtn || (b.currTemplate.closeBtn = a(b.st.closeMarkup.replace("%title%", b.st.tClose)), g = c), b.currTemplate.closeBtn
                }, A = function () {
                    a.magnificPopup.instance || (b = new t, b.init(), a.magnificPopup.instance = b)
                }, B = function () {
                    var a = document.createElement("p").style, b = ["ms", "O", "Moz", "Webkit"];
                    if (void 0 !== a.transition) return !0;
                    for (; b.length;) if (b.pop() + "Transition" in a) return !0;
                    return !1
                };
            t.prototype = {
                constructor: t, init: function () {
                    var c = navigator.appVersion;
                    b.isLowIE = b.isIE8 = document.all && !document.addEventListener, b.isAndroid = /android/gi.test(c), b.isIOS = /iphone|ipad|ipod/gi.test(c), b.supportsTransition = B(), b.probablyMobile = b.isAndroid || b.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent), d = a(document), b.popupsCache = {}
                }, open: function (c) {
                    var e;
                    if (c.isObj === !1) {
                        b.items = c.items.toArray(), b.index = 0;
                        var g, h = c.items;
                        for (e = 0; e < h.length; e++) if (g = h[e], g.parsed && (g = g.el[0]), g === c.el[0]) {
                            b.index = e;
                            break
                        }
                    } else b.items = a.isArray(c.items) ? c.items : [c.items], b.index = c.index || 0;
                    if (b.isOpen) return void b.updateItemHTML();
                    b.types = [], f = "", c.mainEl && c.mainEl.length ? b.ev = c.mainEl.eq(0) : b.ev = d, c.key ? (b.popupsCache[c.key] || (b.popupsCache[c.key] = {}), b.currTemplate = b.popupsCache[c.key]) : b.currTemplate = {}, b.st = a.extend(!0, {}, a.magnificPopup.defaults, c), b.fixedContentPos = "auto" === b.st.fixedContentPos ? !b.probablyMobile : b.st.fixedContentPos, b.st.modal && (b.st.closeOnContentClick = !1, b.st.closeOnBgClick = !1, b.st.showCloseBtn = !1, b.st.enableEscapeKey = !1), b.bgOverlay || (b.bgOverlay = x("bg").on("click" + p, function () {
                        b.close()
                    }), b.wrap = x("wrap").attr("tabindex", -1).on("click" + p, function (a) {
                        b._checkIfClose(a.target) && b.close()
                    }), b.container = x("container", b.wrap)), b.contentContainer = x("content"), b.st.preloader && (b.preloader = x("preloader", b.container, b.st.tLoading));
                    var i = a.magnificPopup.modules;
                    for (e = 0; e < i.length; e++) {
                        var j = i[e];
                        j = j.charAt(0).toUpperCase() + j.slice(1), b["init" + j].call(b)
                    }
                    y("BeforeOpen"), b.st.showCloseBtn && (b.st.closeBtnInside ? (w(l, function (a, b, c, d) {
                        c.close_replaceWith = z(d.type)
                    }), f += " mfp-close-btn-in") : b.wrap.append(z())), b.st.alignTop && (f += " mfp-align-top"), b.fixedContentPos ? b.wrap.css({
                        overflow: b.st.overflowY,
                        overflowX: "hidden",
                        overflowY: b.st.overflowY
                    }) : b.wrap.css({
                        top: v.scrollTop(),
                        position: "absolute"
                    }), (b.st.fixedBgPos === !1 || "auto" === b.st.fixedBgPos && !b.fixedContentPos) && b.bgOverlay.css({
                        height: d.height(),
                        position: "absolute"
                    }), b.st.enableEscapeKey && d.on("keyup" + p, function (a) {
                        27 === a.keyCode && b.close()
                    }), v.on("resize" + p, function () {
                        b.updateSize()
                    }), b.st.closeOnContentClick || (f += " mfp-auto-cursor"), f && b.wrap.addClass(f);
                    var k = b.wH = v.height(), n = {};
                    if (b.fixedContentPos && b._hasScrollBar(k)) {
                        var o = b._getScrollbarSize();
                        o && (n.marginRight = o)
                    }
                    b.fixedContentPos && (b.isIE7 ? a("body, html").css("overflow", "hidden") : n.overflow = "hidden");
                    var r = b.st.mainClass;
                    return b.isIE7 && (r += " mfp-ie7"), r && b._addClassToMFP(r), b.updateItemHTML(), y("BuildControls"), a("html").css(n), b.bgOverlay.add(b.wrap).prependTo(b.st.prependTo || a(document.body)), b._lastFocusedEl = document.activeElement, setTimeout(function () {
                        b.content ? (b._addClassToMFP(q), b._setFocus()) : b.bgOverlay.addClass(q), d.on("focusin" + p, b._onFocusIn)
                    }, 16), b.isOpen = !0, b.updateSize(k), y(m), c
                }, close: function () {
                    b.isOpen && (y(i), b.isOpen = !1, b.st.removalDelay && !b.isLowIE && b.supportsTransition ? (b._addClassToMFP(r), setTimeout(function () {
                        b._close()
                    }, b.st.removalDelay)) : b._close())
                }, _close: function () {
                    y(h);
                    var c = r + " " + q + " ";
                    if (b.bgOverlay.detach(), b.wrap.detach(), b.container.empty(), b.st.mainClass && (c += b.st.mainClass + " "), b._removeClassFromMFP(c), b.fixedContentPos) {
                        var e = {marginRight: ""};
                        b.isIE7 ? a("body, html").css("overflow", "") : e.overflow = "", a("html").css(e)
                    }
                    d.off("keyup" + p + " focusin" + p), b.ev.off(p), b.wrap.attr("class", "mfp-wrap").removeAttr("style"), b.bgOverlay.attr("class", "mfp-bg"), b.container.attr("class", "mfp-container"), !b.st.showCloseBtn || b.st.closeBtnInside && b.currTemplate[b.currItem.type] !== !0 || b.currTemplate.closeBtn && b.currTemplate.closeBtn.detach(), b.st.autoFocusLast && b._lastFocusedEl && a(b._lastFocusedEl).focus(), b.currItem = null, b.content = null, b.currTemplate = null, b.prevHeight = 0, y(j)
                }, updateSize: function (a) {
                    if (b.isIOS) {
                        var c = document.documentElement.clientWidth / window.innerWidth, d = window.innerHeight * c;
                        b.wrap.css("height", d), b.wH = d
                    } else b.wH = a || v.height();
                    b.fixedContentPos || b.wrap.css("height", b.wH), y("Resize")
                }, updateItemHTML: function () {
                    var c = b.items[b.index];
                    b.contentContainer.detach(), b.content && b.content.detach(), c.parsed || (c = b.parseEl(b.index));
                    var d = c.type;
                    if (y("BeforeChange", [b.currItem ? b.currItem.type : "", d]), b.currItem = c, !b.currTemplate[d]) {
                        var f = b.st[d] ? b.st[d].markup : !1;
                        y("FirstMarkupParse", f), f ? b.currTemplate[d] = a(f) : b.currTemplate[d] = !0
                    }
                    e && e !== c.type && b.container.removeClass("mfp-" + e + "-holder");
                    var g = b["get" + d.charAt(0).toUpperCase() + d.slice(1)](c, b.currTemplate[d]);
                    b.appendContent(g, d), c.preloaded = !0, y(n, c), e = c.type, b.container.prepend(b.contentContainer), y("AfterChange")
                }, appendContent: function (a, c) {
                    b.content = a, a ? b.st.showCloseBtn && b.st.closeBtnInside && b.currTemplate[c] === !0 ? b.content.find(".mfp-close").length || b.content.append(z()) : b.content = a : b.content = "", y(k), b.container.addClass("mfp-" + c + "-holder"), b.contentContainer.append(b.content)
                }, parseEl: function (c) {
                    var d, e = b.items[c];
                    if (e.tagName ? e = {el: a(e)} : (d = e.type, e = {data: e, src: e.src}), e.el) {
                        for (var f = b.types, g = 0; g < f.length; g++) if (e.el.hasClass("mfp-" + f[g])) {
                            d = f[g];
                            break
                        }
                        e.src = e.el.attr("data-mfp-src"), e.src || (e.src = e.el.attr("href"))
                    }
                    return e.type = d || b.st.type || "inline", e.index = c, e.parsed = !0, b.items[c] = e, y("ElementParse", e), b.items[c]
                }, addGroup: function (a, c) {
                    var d = function (d) {
                        d.mfpEl = this, b._openClick(d, a, c)
                    };
                    c || (c = {});
                    var e = "click.magnificPopup";
                    c.mainEl = a, c.items ? (c.isObj = !0, a.off(e).on(e, d)) : (c.isObj = !1, c.delegate ? a.off(e).on(e, c.delegate, d) : (c.items = a, a.off(e).on(e, d)))
                }, _openClick: function (c, d, e) {
                    var f = void 0 !== e.midClick ? e.midClick : a.magnificPopup.defaults.midClick;
                    if (f || !(2 === c.which || c.ctrlKey || c.metaKey || c.altKey || c.shiftKey)) {
                        var g = void 0 !== e.disableOn ? e.disableOn : a.magnificPopup.defaults.disableOn;
                        if (g) if (a.isFunction(g)) {
                            if (!g.call(b)) return !0
                        } else if (v.width() < g) return !0;
                        c.type && (c.preventDefault(), b.isOpen && c.stopPropagation()), e.el = a(c.mfpEl), e.delegate && (e.items = d.find(e.delegate)), b.open(e)
                    }
                }, updateStatus: function (a, d) {
                    if (b.preloader) {
                        c !== a && b.container.removeClass("mfp-s-" + c), d || "loading" !== a || (d = b.st.tLoading);
                        var e = {status: a, text: d};
                        y("UpdateStatus", e), a = e.status, d = e.text, b.preloader.html(d), b.preloader.find("a").on("click", function (a) {
                            a.stopImmediatePropagation()
                        }), b.container.addClass("mfp-s-" + a), c = a
                    }
                }, _checkIfClose: function (c) {
                    if (!a(c).hasClass(s)) {
                        var d = b.st.closeOnContentClick, e = b.st.closeOnBgClick;
                        if (d && e) return !0;
                        if (!b.content || a(c).hasClass("mfp-close") || b.preloader && c === b.preloader[0]) return !0;
                        if (c === b.content[0] || a.contains(b.content[0], c)) {
                            if (d) return !0
                        } else if (e && a.contains(document, c)) return !0;
                        return !1
                    }
                }, _addClassToMFP: function (a) {
                    b.bgOverlay.addClass(a), b.wrap.addClass(a)
                }, _removeClassFromMFP: function (a) {
                    this.bgOverlay.removeClass(a), b.wrap.removeClass(a)
                }, _hasScrollBar: function (a) {
                    return (b.isIE7 ? d.height() : document.body.scrollHeight) > (a || v.height())
                }, _setFocus: function () {
                    (b.st.focus ? b.content.find(b.st.focus).eq(0) : b.wrap).focus()
                }, _onFocusIn: function (c) {
                    return c.target === b.wrap[0] || a.contains(b.wrap[0], c.target) ? void 0 : (b._setFocus(), !1)
                }, _parseMarkup: function (b, c, d) {
                    var e;
                    d.data && (c = a.extend(d.data, c)), y(l, [b, c, d]), a.each(c, function (c, d) {
                        if (void 0 === d || d === !1) return !0;
                        if (e = c.split("_"), e.length > 1) {
                            var f = b.find(p + "-" + e[0]);
                            if (f.length > 0) {
                                var g = e[1];
                                "replaceWith" === g ? f[0] !== d[0] && f.replaceWith(d) : "img" === g ? f.is("img") ? f.attr("src", d) : f.replaceWith(a("<img>").attr("src", d).attr("class", f.attr("class"))) : f.attr(e[1], d)
                            }
                        } else b.find(p + "-" + c).html(d)
                    })
                }, _getScrollbarSize: function () {
                    if (void 0 === b.scrollbarSize) {
                        var a = document.createElement("div");
                        a.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;", document.body.appendChild(a), b.scrollbarSize = a.offsetWidth - a.clientWidth, document.body.removeChild(a)
                    }
                    return b.scrollbarSize
                }
            }, a.magnificPopup = {
                instance: null,
                proto: t.prototype,
                modules: [],
                open: function (b, c) {
                    return A(), b = b ? a.extend(!0, {}, b) : {}, b.isObj = !0, b.index = c || 0, this.instance.open(b)
                },
                close: function () {
                    return a.magnificPopup.instance && a.magnificPopup.instance.close()
                },
                registerModule: function (b, c) {
                    c.options && (a.magnificPopup.defaults[b] = c.options), a.extend(this.proto, c.proto), this.modules.push(b)
                },
                defaults: {
                    disableOn: 0,
                    key: null,
                    midClick: !1,
                    mainClass: "",
                    preloader: !0,
                    focus: "",
                    closeOnContentClick: !1,
                    closeOnBgClick: !0,
                    closeBtnInside: !0,
                    showCloseBtn: !0,
                    enableEscapeKey: !0,
                    modal: !1,
                    alignTop: !1,
                    removalDelay: 0,
                    prependTo: null,
                    fixedContentPos: "auto",
                    fixedBgPos: "auto",
                    overflowY: "auto",
                    closeMarkup: '<button title="%title%" type="button" class="mfp-close">&#215;</button>',
                    tClose: "Close (Esc)",
                    tLoading: "Loading...",
                    autoFocusLast: !0
                }
            }, a.fn.magnificPopup = function (c) {
                A();
                var d = a(this);
                if ("string" == typeof c) if ("open" === c) {
                    var e, f = u ? d.data("magnificPopup") : d[0].magnificPopup, g = parseInt(arguments[1], 10) || 0;
                    f.items ? e = f.items[g] : (e = d, f.delegate && (e = e.find(f.delegate)), e = e.eq(g)), b._openClick({mfpEl: e}, d, f)
                } else b.isOpen && b[c].apply(b, Array.prototype.slice.call(arguments, 1)); else c = a.extend(!0, {}, c), u ? d.data("magnificPopup", c) : d[0].magnificPopup = c, b.addGroup(d, c);
                return d
            };
            var C, D, E, F = "inline", G = function () {
                E && (D.after(E.addClass(C)).detach(), E = null)
            };
            a.magnificPopup.registerModule(F, {
                options: {
                    hiddenClass: "hide",
                    markup: "",
                    tNotFound: "Content not found"
                }, proto: {
                    initInline: function () {
                        b.types.push(F), w(h + "." + F, function () {
                            G()
                        })
                    }, getInline: function (c, d) {
                        if (G(), c.src) {
                            var e = b.st.inline, f = a(c.src);
                            if (f.length) {
                                var g = f[0].parentNode;
                                g && g.tagName && (D || (C = e.hiddenClass, D = x(C), C = "mfp-" + C), E = f.after(D).detach().removeClass(C)), b.updateStatus("ready")
                            } else b.updateStatus("error", e.tNotFound), f = a("<div>");
                            return c.inlineElement = f, f
                        }
                        return b.updateStatus("ready"), b._parseMarkup(d, {}, c), d
                    }
                }
            });
            var H, I = "ajax", J = function () {
                H && a(document.body).removeClass(H)
            }, K = function () {
                J(), b.req && b.req.abort()
            };
            a.magnificPopup.registerModule(I, {
                options: {
                    settings: null,
                    cursor: "mfp-ajax-cur",
                    tError: '<a href="%url%">The content</a> could not be loaded.'
                }, proto: {
                    initAjax: function () {
                        b.types.push(I), H = b.st.ajax.cursor, w(h + "." + I, K), w("BeforeChange." + I, K)
                    }, getAjax: function (c) {
                        H && a(document.body).addClass(H), b.updateStatus("loading");
                        var d = a.extend({
                            url: c.src, success: function (d, e, f) {
                                var g = {data: d, xhr: f};
                                y("ParseAjax", g), b.appendContent(a(g.data), I), c.finished = !0, J(), b._setFocus(), setTimeout(function () {
                                    b.wrap.addClass(q)
                                }, 16), b.updateStatus("ready"), y("AjaxContentAdded")
                            }, error: function () {
                                J(), c.finished = c.loadError = !0, b.updateStatus("error", b.st.ajax.tError.replace("%url%", c.src))
                            }
                        }, b.st.ajax.settings);
                        return b.req = a.ajax(d), ""
                    }
                }
            });
            var L, M = function (c) {
                if (c.data && void 0 !== c.data.title) return c.data.title;
                var d = b.st.image.titleSrc;
                if (d) {
                    if (a.isFunction(d)) return d.call(b, c);
                    if (c.el) return c.el.attr(d) || ""
                }
                return ""
            };
            a.magnificPopup.registerModule("image", {
                options: {
                    markup: '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
                    cursor: "mfp-zoom-out-cur",
                    titleSrc: "title",
                    verticalFit: !0,
                    tError: '<a href="%url%">The image</a> could not be loaded.'
                }, proto: {
                    initImage: function () {
                        var c = b.st.image, d = ".image";
                        b.types.push("image"), w(m + d, function () {
                            "image" === b.currItem.type && c.cursor && a(document.body).addClass(c.cursor)
                        }), w(h + d, function () {
                            c.cursor && a(document.body).removeClass(c.cursor), v.off("resize" + p)
                        }), w("Resize" + d, b.resizeImage), b.isLowIE && w("AfterChange", b.resizeImage)
                    }, resizeImage: function () {
                        var a = b.currItem;
                        if (a && a.img && b.st.image.verticalFit) {
                            var c = 0;
                            b.isLowIE && (c = parseInt(a.img.css("padding-top"), 10) + parseInt(a.img.css("padding-bottom"), 10)), a.img.css("max-height", b.wH - c)
                        }
                    }, _onImageHasSize: function (a) {
                        a.img && (a.hasSize = !0, L && clearInterval(L), a.isCheckingImgSize = !1, y("ImageHasSize", a), a.imgHidden && (b.content && b.content.removeClass("mfp-loading"), a.imgHidden = !1))
                    }, findImageSize: function (a) {
                        var c = 0, d = a.img[0], e = function (f) {
                            L && clearInterval(L), L = setInterval(function () {
                                return d.naturalWidth > 0 ? void b._onImageHasSize(a) : (c > 200 && clearInterval(L), c++, void (3 === c ? e(10) : 40 === c ? e(50) : 100 === c && e(500)))
                            }, f)
                        };
                        e(1)
                    }, getImage: function (c, d) {
                        var e = 0, f = function () {
                            c && (c.img[0].complete ? (c.img.off(".mfploader"), c === b.currItem && (b._onImageHasSize(c), b.updateStatus("ready")), c.hasSize = !0, c.loaded = !0, y("ImageLoadComplete")) : (e++, 200 > e ? setTimeout(f, 100) : g()))
                        }, g = function () {
                            c && (c.img.off(".mfploader"), c === b.currItem && (b._onImageHasSize(c), b.updateStatus("error", h.tError.replace("%url%", c.src))), c.hasSize = !0, c.loaded = !0, c.loadError = !0)
                        }, h = b.st.image, i = d.find(".mfp-img");
                        if (i.length) {
                            var j = document.createElement("img");
                            j.className = "mfp-img", c.el && c.el.find("img").length && (j.alt = c.el.find("img").attr("alt")), c.img = a(j).on("load.mfploader", f).on("error.mfploader", g), j.src = c.src, i.is("img") && (c.img = c.img.clone()), j = c.img[0], j.naturalWidth > 0 ? c.hasSize = !0 : j.width || (c.hasSize = !1)
                        }
                        return b._parseMarkup(d, {
                            title: M(c),
                            img_replaceWith: c.img
                        }, c), b.resizeImage(), c.hasSize ? (L && clearInterval(L), c.loadError ? (d.addClass("mfp-loading"), b.updateStatus("error", h.tError.replace("%url%", c.src))) : (d.removeClass("mfp-loading"), b.updateStatus("ready")), d) : (b.updateStatus("loading"), c.loading = !0, c.hasSize || (c.imgHidden = !0, d.addClass("mfp-loading"), b.findImageSize(c)), d)
                    }
                }
            });
            var N, O = function () {
                return void 0 === N && (N = void 0 !== document.createElement("p").style.MozTransform), N
            };
            a.magnificPopup.registerModule("zoom", {
                options: {
                    enabled: !1, easing: "ease-in-out", duration: 300, opener: function (a) {
                        return a.is("img") ? a : a.find("img")
                    }
                }, proto: {
                    initZoom: function () {
                        var a, c = b.st.zoom, d = ".zoom";
                        if (c.enabled && b.supportsTransition) {
                            var e, f, g = c.duration, j = function (a) {
                                var b = a.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),
                                    d = "all " + c.duration / 1e3 + "s " + c.easing, e = {
                                        position: "fixed",
                                        zIndex: 9999,
                                        left: 0,
                                        top: 0,
                                        "-webkit-backface-visibility": "hidden"
                                    }, f = "transition";
                                return e["-webkit-" + f] = e["-moz-" + f] = e["-o-" + f] = e[f] = d, b.css(e), b
                            }, k = function () {
                                b.content.css("visibility", "visible")
                            };
                            w("BuildControls" + d, function () {
                                if (b._allowZoom()) {
                                    if (clearTimeout(e), b.content.css("visibility", "hidden"), a = b._getItemToZoom(), !a) return void k();
                                    f = j(a), f.css(b._getOffset()), b.wrap.append(f), e = setTimeout(function () {
                                        f.css(b._getOffset(!0)), e = setTimeout(function () {
                                            k(), setTimeout(function () {
                                                f.remove(), a = f = null, y("ZoomAnimationEnded")
                                            }, 16)
                                        }, g)
                                    }, 16)
                                }
                            }), w(i + d, function () {
                                if (b._allowZoom()) {
                                    if (clearTimeout(e), b.st.removalDelay = g, !a) {
                                        if (a = b._getItemToZoom(), !a) return;
                                        f = j(a)
                                    }
                                    f.css(b._getOffset(!0)), b.wrap.append(f), b.content.css("visibility", "hidden"), setTimeout(function () {
                                        f.css(b._getOffset())
                                    }, 16)
                                }
                            }), w(h + d, function () {
                                b._allowZoom() && (k(), f && f.remove(), a = null)
                            })
                        }
                    }, _allowZoom: function () {
                        return "image" === b.currItem.type
                    }, _getItemToZoom: function () {
                        return b.currItem.hasSize ? b.currItem.img : !1
                    }, _getOffset: function (c) {
                        var d;
                        d = c ? b.currItem.img : b.st.zoom.opener(b.currItem.el || b.currItem);
                        var e = d.offset(), f = parseInt(d.css("padding-top"), 10),
                            g = parseInt(d.css("padding-bottom"), 10);
                        e.top -= a(window).scrollTop() - f;
                        var h = {width: d.width(), height: (u ? d.innerHeight() : d[0].offsetHeight) - g - f};
                        return O() ? h["-moz-transform"] = h.transform = "translate(" + e.left + "px," + e.top + "px)" : (h.left = e.left, h.top = e.top), h
                    }
                }
            });
            var P = "iframe", Q = "//about:blank", R = function (a) {
                if (b.currTemplate[P]) {
                    var c = b.currTemplate[P].find("iframe");
                    c.length && (a || (c[0].src = Q), b.isIE8 && c.css("display", a ? "block" : "none"))
                }
            };
            a.magnificPopup.registerModule(P, {
                options: {
                    markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
                    srcAction: "iframe_src",
                    patterns: {
                        youtube: {
                            index: "youtube.com",
                            id: "v=",
                            src: "//www.youtube.com/embed/%id%?autoplay=1"
                        },
                        vimeo: {index: "vimeo.com/", id: "/", src: "//player.vimeo.com/video/%id%?autoplay=1"},
                        gmaps: {index: "//maps.google.", src: "%id%&output=embed"}
                    }
                }, proto: {
                    initIframe: function () {
                        b.types.push(P), w("BeforeChange", function (a, b, c) {
                            b !== c && (b === P ? R() : c === P && R(!0))
                        }), w(h + "." + P, function () {
                            R()
                        })
                    }, getIframe: function (c, d) {
                        var e = c.src, f = b.st.iframe;
                        a.each(f.patterns, function () {
                            return e.indexOf(this.index) > -1 ? (this.id && (e = "string" == typeof this.id ? e.substr(e.lastIndexOf(this.id) + this.id.length, e.length) : this.id.call(this, e)), e = this.src.replace("%id%", e), !1) : void 0
                        });
                        var g = {};
                        return f.srcAction && (g[f.srcAction] = e), b._parseMarkup(d, g, c), b.updateStatus("ready"), d
                    }
                }
            });
            var S = function (a) {
                var c = b.items.length;
                return a > c - 1 ? a - c : 0 > a ? c + a : a
            }, T = function (a, b, c) {
                return a.replace(/%curr%/gi, b + 1).replace(/%total%/gi, c)
            };
            a.magnificPopup.registerModule("gallery", {
                options: {
                    enabled: !1,
                    arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
                    preload: [0, 2],
                    navigateByImgClick: !0,
                    arrows: !0,
                    tPrev: "Previous (Left arrow key)",
                    tNext: "Next (Right arrow key)",
                    tCounter: "%curr% of %total%"
                }, proto: {
                    initGallery: function () {
                        var c = b.st.gallery, e = ".mfp-gallery";
                        return b.direction = !0, c && c.enabled ? (f += " mfp-gallery", w(m + e, function () {
                            c.navigateByImgClick && b.wrap.on("click" + e, ".mfp-img", function () {
                                return b.items.length > 1 ? (b.next(), !1) : void 0
                            }), d.on("keydown" + e, function (a) {
                                37 === a.keyCode ? b.prev() : 39 === a.keyCode && b.next()
                            })
                        }), w("UpdateStatus" + e, function (a, c) {
                            c.text && (c.text = T(c.text, b.currItem.index, b.items.length))
                        }), w(l + e, function (a, d, e, f) {
                            var g = b.items.length;
                            e.counter = g > 1 ? T(c.tCounter, f.index, g) : ""
                        }), w("BuildControls" + e, function () {
                            if (b.items.length > 1 && c.arrows && !b.arrowLeft) {
                                var d = c.arrowMarkup,
                                    e = b.arrowLeft = a(d.replace(/%title%/gi, c.tPrev).replace(/%dir%/gi, "left")).addClass(s),
                                    f = b.arrowRight = a(d.replace(/%title%/gi, c.tNext).replace(/%dir%/gi, "right")).addClass(s);
                                e.click(function () {
                                    b.prev()
                                }), f.click(function () {
                                    b.next()
                                }), b.container.append(e.add(f))
                            }
                        }), w(n + e, function () {
                            b._preloadTimeout && clearTimeout(b._preloadTimeout), b._preloadTimeout = setTimeout(function () {
                                b.preloadNearbyImages(), b._preloadTimeout = null
                            }, 16)
                        }), void w(h + e, function () {
                            d.off(e), b.wrap.off("click" + e), b.arrowRight = b.arrowLeft = null
                        })) : !1
                    }, next: function () {
                        b.direction = !0, b.index = S(b.index + 1), b.updateItemHTML()
                    }, prev: function () {
                        b.direction = !1, b.index = S(b.index - 1), b.updateItemHTML()
                    }, goTo: function (a) {
                        b.direction = a >= b.index, b.index = a, b.updateItemHTML()
                    }, preloadNearbyImages: function () {
                        var a, c = b.st.gallery.preload, d = Math.min(c[0], b.items.length),
                            e = Math.min(c[1], b.items.length);
                        for (a = 1; a <= (b.direction ? e : d); a++) b._preloadItem(b.index + a);
                        for (a = 1; a <= (b.direction ? d : e); a++) b._preloadItem(b.index - a)
                    }, _preloadItem: function (c) {
                        if (c = S(c), !b.items[c].preloaded) {
                            var d = b.items[c];
                            d.parsed || (d = b.parseEl(c)), y("LazyLoad", d), "image" === d.type && (d.img = a('<img class="mfp-img" />').on("load.mfploader", function () {
                                d.hasSize = !0
                            }).on("error.mfploader", function () {
                                d.hasSize = !0, d.loadError = !0, y("LazyLoadError", d)
                            }).attr("src", d.src)), d.preloaded = !0
                        }
                    }
                }
            });
            var U = "retina";
            a.magnificPopup.registerModule(U, {
                options: {
                    replaceSrc: function (a) {
                        return a.src.replace(/\.\w+$/, function (a) {
                            return "@2x" + a
                        })
                    }, ratio: 1
                }, proto: {
                    initRetina: function () {
                        if (window.devicePixelRatio > 1) {
                            var a = b.st.retina, c = a.ratio;
                            c = isNaN(c) ? c() : c, c > 1 && (w("ImageHasSize." + U, function (a, b) {
                                b.img.css({"max-width": b.img[0].naturalWidth / c, width: "100%"})
                            }), w("ElementParse." + U, function (b, d) {
                                d.src = a.replaceSrc(d, c)
                            }))
                        }
                    }
                }
            }), A()
        });
    },
    zoom: function () {
        /*!
			Zoom 1.7.21
			license: MIT
			http://www.jacklmoore.com/zoom
		*/
        (function (o) {
            var t = {
                url: !1,
                callback: !1,
                target: !1,
                duration: 120,
                on: "mouseover",
                touch: !0,
                onZoomIn: !1,
                onZoomOut: !1,
                magnify: 1
            };
            o.zoom = function (t, n, e, i) {
                var u, c, a, r, m, l, s, f = o(t), h = f.css("position"), d = o(n);
                return t.style.position = /(absolute|fixed)/.test(h) ? h : "relative", t.style.overflow = "hidden", e.style.width = e.style.height = "", o(e).addClass("zoomImg").css({
                    position: "absolute",
                    top: 0,
                    left: 0,
                    opacity: 0,
                    width: e.width * i,
                    height: e.height * i,
                    border: "none",
                    maxWidth: "none",
                    maxHeight: "none"
                }).appendTo(t), {
                    init: function () {
                        c = f.outerWidth(), u = f.outerHeight(), n === t ? (r = c, a = u) : (r = d.outerWidth(), a = d.outerHeight()), m = (e.width - c) / r, l = (e.height - u) / a, s = d.offset()
                    }, move: function (o) {
                        var t = o.pageX - s.left, n = o.pageY - s.top;
                        n = Math.max(Math.min(n, a), 0), t = Math.max(Math.min(t, r), 0), e.style.left = t * -m + "px", e.style.top = n * -l + "px"
                    }
                }
            }, o.fn.zoom = function (n) {
                return this.each(function () {
                    var e = o.extend({}, t, n || {}), i = e.target && o(e.target)[0] || this, u = this, c = o(u),
                        a = document.createElement("img"), r = o(a), m = "mousemove.zoom", l = !1, s = !1;
                    if (!e.url) {
                        var f = u.querySelector("img");
                        if (f && (e.url = f.getAttribute("data-src") || f.currentSrc || f.src), !e.url) return
                    }
                    c.one("zoom.destroy", function (o, t) {
                        c.off(".zoom"), i.style.position = o, i.style.overflow = t, a.onload = null, r.remove()
                    }.bind(this, i.style.position, i.style.overflow)), a.onload = function () {
                        function t(t) {
                            f.init(), f.move(t), r.stop().fadeTo(o.support.opacity ? e.duration : 0, 1, o.isFunction(e.onZoomIn) ? e.onZoomIn.call(a) : !1)
                        }

                        function n() {
                            r.stop().fadeTo(e.duration, 0, o.isFunction(e.onZoomOut) ? e.onZoomOut.call(a) : !1)
                        }

                        var f = o.zoom(i, u, a, e.magnify);
                        "grab" === e.on ? c.on("mousedown.zoom", function (e) {
                            1 === e.which && (o(document).one("mouseup.zoom", function () {
                                n(), o(document).off(m, f.move)
                            }), t(e), o(document).on(m, f.move), e.preventDefault())
                        }) : "click" === e.on ? c.on("click.zoom", function (e) {
                            return l ? void 0 : (l = !0, t(e), o(document).on(m, f.move), o(document).one("click.zoom", function () {
                                n(), l = !1, o(document).off(m, f.move)
                            }), !1)
                        }) : "toggle" === e.on ? c.on("click.zoom", function (o) {
                            l ? n() : t(o), l = !l
                        }) : "mouseover" === e.on && (f.init(), c.on("mouseenter.zoom", t).on("mouseleave.zoom", n).on(m, f.move)), e.touch && c.on("touchstart.zoom", function (o) {
                            o.preventDefault(), s ? (s = !1, n()) : (s = !0, t(o.originalEvent.touches[0] || o.originalEvent.changedTouches[0]))
                        }).on("touchmove.zoom", function (o) {
                            o.preventDefault(), f.move(o.originalEvent.touches[0] || o.originalEvent.changedTouches[0])
                        }).on("touchend.zoom", function (o) {
                            o.preventDefault(), s && (s = !1, n())
                        }), o.isFunction(e.callback) && e.callback.call(a)
                    }, a.setAttribute("role", "presentation"), a.alt = "", a.src = e.url
                })
            }, o.fn.zoom.defaults = t
        })(window.jQuery);
    },
    cookie: function () {
        /*!
		 * JavaScript Cookie v2.1.0
		 * https://github.com/js-cookie/js-cookie
		 *
		 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
		 * Released under the MIT license
		 */

        !function (e) {
            if ("function" == typeof define && define.amd) define(e); else if ("object" == typeof exports) module.exports = e(); else {
                var n = window.Cookies, t = window.Cookies = e();
                t.noConflict = function () {
                    return window.Cookies = n, t
                }
            }
        }(function () {
            function e() {
                for (var e = 0, n = {}; e < arguments.length; e++) {
                    var t = arguments[e];
                    for (var o in t) n[o] = t[o]
                }
                return n
            }

            function n(t) {
                function o(n, r, i) {
                    var c;
                    if (arguments.length > 1) {
                        if (i = e({path: "/"}, o.defaults, i), "number" == typeof i.expires) {
                            var s = new Date;
                            s.setMilliseconds(s.getMilliseconds() + 864e5 * i.expires), i.expires = s
                        }
                        try {
                            c = JSON.stringify(r), /^[\{\[]/.test(c) && (r = c)
                        } catch (a) {
                        }
                        return r = t.write ? t.write(r, n) : encodeURIComponent(String(r)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), n = encodeURIComponent(String(n)), n = n.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent), n = n.replace(/[\(\)]/g, escape), document.cookie = [n, "=", r, i.expires && "; expires=" + i.expires.toUTCString(), i.path && "; path=" + i.path, i.domain && "; domain=" + i.domain, i.secure ? "; secure" : ""].join("")
                    }
                    n || (c = {});
                    for (var p = document.cookie ? document.cookie.split("; ") : [], d = /(%[0-9A-Z]{2})+/g, u = 0; u < p.length; u++) {
                        var f = p[u].split("="), l = f[0].replace(d, decodeURIComponent), m = f.slice(1).join("=");
                        '"' === m.charAt(0) && (m = m.slice(1, -1));
                        try {
                            if (m = t.read ? t.read(m, l) : t(m, l) || m.replace(d, decodeURIComponent), this.json) try {
                                m = JSON.parse(m)
                            } catch (a) {
                            }
                            if (n === l) {
                                c = m;
                                break
                            }
                            n || (c[l] = m)
                        } catch (a) {
                        }
                    }
                    return c
                }

                return o.get = o.set = o, o.getJSON = function () {
                    return o.apply({json: !0}, [].slice.call(arguments))
                }, o.defaults = {}, o.remove = function (n, t) {
                    o(n, "", e(t, {expires: -1}))
                }, o.withConverter = n, o
            }

            return n(function () {
            })
        });
    }
}

var Gmap = {
    init: function () {

        $("div[data-section-type='map']").each(function () {

            var target = $(this);
            var key = $(target).data('key');

            $.getScript(
                'https://maps.googleapis.com/maps/api/js?key=' + key
            ).then(function () {
                createMap(target);
            });

            function createMap(container) {
                var style = $(container).data('style');
                var zoom = $(container).data('zoom');
                var id = $(container).data('section-id');
                var address = $(container).data('address');
                var map = new GMaps({
                    div: '.map--' + id,
                    lat: 37.4439064,
                    lng: -122.1639733,
                    navigationControl: false,
                    mapTypeControl: false,
                    scaleControl: false,
                    draggable: false,
                    zoom: zoom
                });

                var standard = [];
                var silver = [{
                    "elementType": "geometry",
                    "stylers": [{"color": "#f5f5f5"}]
                }, {
                    "elementType": "labels.icon",
                    "stylers": [{"visibility": "off"}]
                }, {
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#616161"}]
                }, {
                    "elementType": "labels.text.stroke",
                    "stylers": [{"color": "#f5f5f5"}]
                }, {
                    "featureType": "administrative.land_parcel",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#bdbdbd"}]
                }, {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [{"color": "#eeeeee"}]
                }, {
                    "featureType": "poi",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#757575"}]
                }, {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [{"color": "#e5e5e5"}]
                }, {
                    "featureType": "poi.park",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#9e9e9e"}]
                }, {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [{"color": "#ffffff"}]
                }, {
                    "featureType": "road.arterial",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#757575"}]
                }, {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [{"color": "#dadada"}]
                }, {
                    "featureType": "road.highway",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#616161"}]
                }, {
                    "featureType": "road.local",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#9e9e9e"}]
                }, {
                    "featureType": "transit.line",
                    "elementType": "geometry",
                    "stylers": [{"color": "#e5e5e5"}]
                }, {
                    "featureType": "transit.station",
                    "elementType": "geometry",
                    "stylers": [{"color": "#eeeeee"}]
                }, {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [{"color": "#c9c9c9"}]
                }, {"featureType": "water", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"}]}];
                var retro = [{
                    "elementType": "geometry",
                    "stylers": [{"color": "#ebe3cd"}]
                }, {
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#523735"}]
                }, {
                    "elementType": "labels.text.stroke",
                    "stylers": [{"color": "#f5f1e6"}]
                }, {
                    "featureType": "administrative",
                    "elementType": "geometry.stroke",
                    "stylers": [{"color": "#c9b2a6"}]
                }, {
                    "featureType": "administrative.land_parcel",
                    "elementType": "geometry.stroke",
                    "stylers": [{"color": "#dcd2be"}]
                }, {
                    "featureType": "administrative.land_parcel",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#ae9e90"}]
                }, {
                    "featureType": "landscape.natural",
                    "elementType": "geometry",
                    "stylers": [{"color": "#dfd2ae"}]
                }, {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [{"color": "#dfd2ae"}]
                }, {
                    "featureType": "poi",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#93817c"}]
                }, {
                    "featureType": "poi.park",
                    "elementType": "geometry.fill",
                    "stylers": [{"color": "#a5b076"}]
                }, {
                    "featureType": "poi.park",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#447530"}]
                }, {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [{"color": "#f5f1e6"}]
                }, {
                    "featureType": "road.arterial",
                    "elementType": "geometry",
                    "stylers": [{"color": "#fdfcf8"}]
                }, {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [{"color": "#f8c967"}]
                }, {
                    "featureType": "road.highway",
                    "elementType": "geometry.stroke",
                    "stylers": [{"color": "#e9bc62"}]
                }, {
                    "featureType": "road.highway.controlled_access",
                    "elementType": "geometry",
                    "stylers": [{"color": "#e98d58"}]
                }, {
                    "featureType": "road.highway.controlled_access",
                    "elementType": "geometry.stroke",
                    "stylers": [{"color": "#db8555"}]
                }, {
                    "featureType": "road.local",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#806b63"}]
                }, {
                    "featureType": "transit.line",
                    "elementType": "geometry",
                    "stylers": [{"color": "#dfd2ae"}]
                }, {
                    "featureType": "transit.line",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#8f7d77"}]
                }, {
                    "featureType": "transit.line",
                    "elementType": "labels.text.stroke",
                    "stylers": [{"color": "#ebe3cd"}]
                }, {
                    "featureType": "transit.station",
                    "elementType": "geometry",
                    "stylers": [{"color": "#dfd2ae"}]
                }, {
                    "featureType": "water",
                    "elementType": "geometry.fill",
                    "stylers": [{"color": "#b9d3c2"}]
                }, {"featureType": "water", "elementType": "labels.text.fill", "stylers": [{"color": "#92998d"}]}];
                var dark = [{
                    "elementType": "geometry",
                    "stylers": [{"color": "#212121"}]
                }, {
                    "elementType": "labels.icon",
                    "stylers": [{"visibility": "off"}]
                }, {
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#757575"}]
                }, {
                    "elementType": "labels.text.stroke",
                    "stylers": [{"color": "#212121"}]
                }, {
                    "featureType": "administrative",
                    "elementType": "geometry",
                    "stylers": [{"color": "#757575"}]
                }, {
                    "featureType": "administrative.country",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#9e9e9e"}]
                }, {
                    "featureType": "administrative.land_parcel",
                    "stylers": [{"visibility": "off"}]
                }, {
                    "featureType": "administrative.locality",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#bdbdbd"}]
                }, {
                    "featureType": "poi",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#757575"}]
                }, {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [{"color": "#181818"}]
                }, {
                    "featureType": "poi.park",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#616161"}]
                }, {
                    "featureType": "poi.park",
                    "elementType": "labels.text.stroke",
                    "stylers": [{"color": "#1b1b1b"}]
                }, {
                    "featureType": "road",
                    "elementType": "geometry.fill",
                    "stylers": [{"color": "#2c2c2c"}]
                }, {
                    "featureType": "road",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#8a8a8a"}]
                }, {
                    "featureType": "road.arterial",
                    "elementType": "geometry",
                    "stylers": [{"color": "#373737"}]
                }, {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [{"color": "#3c3c3c"}]
                }, {
                    "featureType": "road.highway.controlled_access",
                    "elementType": "geometry",
                    "stylers": [{"color": "#4e4e4e"}]
                }, {
                    "featureType": "road.local",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#616161"}]
                }, {
                    "featureType": "transit",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#757575"}]
                }, {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [{"color": "#000000"}]
                }, {"featureType": "water", "elementType": "labels.text.fill", "stylers": [{"color": "#3d3d3d"}]}];
                var night = [{
                    "elementType": "geometry",
                    "stylers": [{"color": "#242f3e"}]
                }, {
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#746855"}]
                }, {
                    "elementType": "labels.text.stroke",
                    "stylers": [{"color": "#242f3e"}]
                }, {
                    "featureType": "administrative.locality",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#d59563"}]
                }, {
                    "featureType": "poi",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#d59563"}]
                }, {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [{"color": "#263c3f"}]
                }, {
                    "featureType": "poi.park",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#6b9a76"}]
                }, {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [{"color": "#38414e"}]
                }, {
                    "featureType": "road",
                    "elementType": "geometry.stroke",
                    "stylers": [{"color": "#212a37"}]
                }, {
                    "featureType": "road",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#9ca5b3"}]
                }, {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [{"color": "#746855"}]
                }, {
                    "featureType": "road.highway",
                    "elementType": "geometry.stroke",
                    "stylers": [{"color": "#1f2835"}]
                }, {
                    "featureType": "road.highway",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#f3d19c"}]
                }, {
                    "featureType": "transit",
                    "elementType": "geometry",
                    "stylers": [{"color": "#2f3948"}]
                }, {
                    "featureType": "transit.station",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#d59563"}]
                }, {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [{"color": "#17263c"}]
                }, {
                    "featureType": "water",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#515c6d"}]
                }, {"featureType": "water", "elementType": "labels.text.stroke", "stylers": [{"color": "#17263c"}]}];
                var aubergine = [{
                    "elementType": "geometry",
                    "stylers": [{"color": "#1d2c4d"}]
                }, {
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#8ec3b9"}]
                }, {
                    "elementType": "labels.text.stroke",
                    "stylers": [{"color": "#1a3646"}]
                }, {
                    "featureType": "administrative.country",
                    "elementType": "geometry.stroke",
                    "stylers": [{"color": "#4b6878"}]
                }, {
                    "featureType": "administrative.land_parcel",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#64779e"}]
                }, {
                    "featureType": "administrative.province",
                    "elementType": "geometry.stroke",
                    "stylers": [{"color": "#4b6878"}]
                }, {
                    "featureType": "landscape.man_made",
                    "elementType": "geometry.stroke",
                    "stylers": [{"color": "#334e87"}]
                }, {
                    "featureType": "landscape.natural",
                    "elementType": "geometry",
                    "stylers": [{"color": "#023e58"}]
                }, {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [{"color": "#283d6a"}]
                }, {
                    "featureType": "poi",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#6f9ba5"}]
                }, {
                    "featureType": "poi",
                    "elementType": "labels.text.stroke",
                    "stylers": [{"color": "#1d2c4d"}]
                }, {
                    "featureType": "poi.park",
                    "elementType": "geometry.fill",
                    "stylers": [{"color": "#023e58"}]
                }, {
                    "featureType": "poi.park",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#3C7680"}]
                }, {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [{"color": "#304a7d"}]
                }, {
                    "featureType": "road",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#98a5be"}]
                }, {
                    "featureType": "road",
                    "elementType": "labels.text.stroke",
                    "stylers": [{"color": "#1d2c4d"}]
                }, {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [{"color": "#2c6675"}]
                }, {
                    "featureType": "road.highway",
                    "elementType": "geometry.stroke",
                    "stylers": [{"color": "#255763"}]
                }, {
                    "featureType": "road.highway",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#b0d5ce"}]
                }, {
                    "featureType": "road.highway",
                    "elementType": "labels.text.stroke",
                    "stylers": [{"color": "#023e58"}]
                }, {
                    "featureType": "transit",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#98a5be"}]
                }, {
                    "featureType": "transit",
                    "elementType": "labels.text.stroke",
                    "stylers": [{"color": "#1d2c4d"}]
                }, {
                    "featureType": "transit.line",
                    "elementType": "geometry.fill",
                    "stylers": [{"color": "#283d6a"}]
                }, {
                    "featureType": "transit.station",
                    "elementType": "geometry",
                    "stylers": [{"color": "#3a4762"}]
                }, {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [{"color": "#0e1626"}]
                }, {"featureType": "water", "elementType": "labels.text.fill", "stylers": [{"color": "#4e6d70"}]}];

                var styles = '';
                if (style == 'standard') {
                    styles = standard;
                } else if (style == 'silver') {
                    styles = silver;
                } else if (style == 'retro') {
                    styles = retro;
                } else if (style == 'dark') {
                    styles = dark;
                } else if (style == 'night') {
                    styles = night;
                } else {
                    styles = aubergine;
                }

                map.addStyle({
                    styledMapName: "Styled Map",
                    styles: styles,
                    mapTypeId: "map_style"
                });

                map.setStyle("map_style");
                GMaps.geocode({
                    address: address,
                    callback: function (results, status) {
                        if (status == 'OK') {
                            var latlng = results[0].geometry.location;
                            map.setCenter(latlng.lat(), latlng.lng());
                            map.addMarker({
                                lat: latlng.lat(),
                                lng: latlng.lng()
                            });
                        }
                    }
                });
            }

        });
    }
}

var ColorSwatches = {
    init: function (variant, selector) {
        var form = $('#' + selector.domIdPrefix).closest('form'),
            enableColorSwatches = false;

        if (enableColorSwatches) {
            if (variant) {
                for (var i = 0, length = variant.options.length; i < length; i++) {
                    var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + escape(variant.options[i]) + '"]');
                    if (radioButton.length) {
                        radioButton.get(0).checked = true;
                    }
                }
            }
        }
    },
    bind: function (container) {
        var enableColorSwatches = false;

        if (!enableColorSwatches) return;

        container.find('.productForm').on('change', '.swatch :radio', function () {
            var colorTitle = $(this).closest('label').attr('title');
            var optionIndex = $(this).closest('.swatch').attr('data-option-index');
            var optionValue = $(this).val();

            $(this)
                .closest('form')
                .find('.single-option-selector')
                .eq(optionIndex)
                .val(optionValue)
                .trigger('change');

            $(this).closest('.swatch').find('.header__value').fadeIn(300).text(colorTitle);
        });

        // Set color title on page load
        container.find('.productForm .swatch :radio:checked').trigger('change');
        container.find('.productForm-block--swatches').removeClass('is-loading');
    },
    unbind: function (container) {
        $('.productForm', container).off('change', '.swatch :radio');
    }
}

var Popup = {
    init: function () {
        var self = this,
            $popup = this.$popup = $('#popup'),
            $popupClose = $popup.find('.popup__close'),
            popupEnabled = $popup.data('enabled'),
            popupTimeout = this.popupTimeout = 0;

        if (popupEnabled) {
            var testMode = $popup.data('testmode'),
                modalDelay = parseInt($popup.data('delay')) * 1000, // Convert from ms to seconds
                reappearTime = parseInt($popup.data('reappear_time')) * 1000; // Convert from ms to seconds

            enquire.register("screen and (min-width:768px)", function () {
                Reqs.cookie();

                if (testMode) {
                    self.show($popup, modalDelay, testMode);
                } else {
                    //If cookie doesn't exist or it's expired
                    if (Cookies.get('newsletter_delay') === undefined || reappearTime == 0) {
                        self.show($popup, modalDelay, testMode);
                        self.createCookie(reappearTime);
                    }
                }
            });

            $(window).on('resize', Reqs.debounce(function () {
                var windowWidth = window.innerWidth || document.documentElement.clientWidth,
                    hasPopup = $popup.hasClass('popup--visible');

                // Hide popup on mobile if visible
                if (windowWidth < 768 && hasPopup) {
                    self.hide();
                }
            }, 100));

            $popupClose.on('click', function () {
                $popup.removeClass('popup--visible');
            });
        }
    },
    show: function ($popup, modalDelay, testMode) {
        //Only show if it hasn't already been shown during that browser session
        if (sessionStorage.name != "shown" && $('html').hasClass('lt-ie9') == false) {
            this.popupTimeout = setTimeout(function () {
                $popup.addClass('popup--visible');
            }, modalDelay);

            // Safari Private Browsing Mode shiv
            if (typeof localStorage === 'object') {
                try {
                    localStorage.setItem('localStorage', 1);
                    localStorage.removeItem('localStorage');
                    sessionStorage.name = "shown";
                } catch (e) {
                    Storage.prototype._setItem = Storage.prototype.setItem;
                    Storage.prototype.setItem = function () {
                    };
                }
            }
        } else if (testMode) {
            this.popupTimeout = setTimeout(function () {
                $popup.addClass('popup--visible');
            }, modalDelay);
        }
    },
    hide: function () {
        clearTimeout(this.popupTimeout);
        this.$popup.removeClass('popup--visible');
    },
    createCookie: function (reappearTime) {
        if (reappearTime != 0) {
            Cookies.set('newsletter_delay', 'value', {expires: reappearTime});
        }
    }
}

var SearchTemplate = {
    init: function () {
        var $image = $('.collectionBlock-image'),
            imageSize = "cover";

        if (imageSize == 'contain') {
            Collection.setBadgePosition($image);
            $(window).on('resize.search', Reqs.debounce(Collection.setBadgePosition.bind(this, $image), 50));
        }
    }
}
var Search = {
    init: function () {
        var self = this,
            enableSearch = (false);

        if (!enableSearch) return;

        this.searchForm = $('.nav-search .search-form');
        this.searchContainer = $('.nav-search-container');
        this.searchScroller = $('.nav-search-scroller');
        this.searchResultsContainer = $('#search-results');
        this.searchType = this.searchForm.find('input[name="type"]').val();
        this.searchOptionsPrefix = this.searchForm.find('input[name="options[prefix]"]').val();
        this.searchRequest = null;
        this.searchForm.on('keyup', '.nav-search-input', function (e) {
            // Close if escape key pressed
            if (e.keyCode === slate.utils.keyboardKeys.ESCAPE) {
                self.close();
                Site.nav.search.close();
            }

            if (e.keyCode === slate.utils.keyboardKeys.ENTER) e.preventDefault();

            var query = $(this).val();
            if (query.length) {
                self.request(query);
            } else {
                self.close();
            }
        });
    },
    close: function () {
        this.searchResultsContainer.empty();
        this.searchContainer.removeClass('is-searching');
    },
    request: function (query) {
        var self = this;

        // Kill previous ajax request
        if (this.searchRequest != null) {
            this.searchRequest.abort();
        }

        this.searchResultsContainer.empty();
        this.searchContainer.addClass('is-searching');

        // Do a new ajax request
        this.searchRequest = $.ajax({
            method: 'GET',
            url: window.theme.routes.search_url + '?view=json',
            dataType: 'json',
            data: {
                q: query,
                type: self.searchType,
                options: {prefix: self.searchOptionsPrefix}
            }
        }).done(function (data) {
            self.displaySearchResults(data);
        }).fail(function (data) {
            self.displaySearchResults(data);
        });
    },
    displaySearchResults: function (data) {
        var self = this,
            searchResultsContent = self.getResultsContent(data),
            imageSize = "cover";

        self.searchResultsContainer.html(searchResultsContent);
        self.searchContainer.removeClass('is-searching');

        var $image = $('.result__image', self.searchResultsContainer);
        if (imageSize == 'contain') {
            Collection.setBadgePosition($image);
            $(window).on('resize.search', Reqs.debounce(Collection.setBadgePosition.bind(this, $image), 50));
        }
    },
    getResultsContent: function (data) {
        var searchResults = '',
            searchResultsProducts = '',
            searchResultsPages = '',
            searchResultsArticles = '',
            limitProducts = 4,
            limitPages = 10,
            limitArticles = 10,
            countProducts = 0,
            countPages = 0,
            countArticles = 0,
            viewAllProducts = '',
            searchQuery = $('.nav-search-input').val(),
            searchOptionsPrefix = $('.nav-search-options').val(),
            searchType = "product";

        if (data.results) {
            for (var i = 0; i < data.results.length; i++) {
                var title = data.results[i].title,
                    url = data.results[i].url,
                    price = Shopify.formatMoney(data.results[i].price),
                    image = data.results[i].featured_image,
                    imageWidths = '295,394,590,700,800,1000,1200,1500,1800,2000,2400',
                    imageAspectRatio = data.results[i].image_aspectratio || 1, // Default to 1 if aspect ratio is not defined
                    imageBlank = "//cdn.shopify.com/s/files/1/0579/4680/0283/t/23/assets/blank_1x1.gif?v=5084931654425739242",
                    object_type = data.results[i].object_type,
                    sold_out = data.results[i].available ? false : true,
                    on_sale = data.results[i].on_sale,
                    badge = '',
                    badgeText = '',
                    badgeClass = ' product-status-flag--' + 'rectangle',
                    badgeStyle = "rectangle";

                if (object_type == 'product') {
                    if (on_sale || sold_out) {
                        badgeClass += on_sale ? ' is-sale' : '';
                        badgeClass += sold_out ? ' is-sold-out' : '';

                        badge = '<span class="product-status-flag' + badgeClass + '">';
                        if (sold_out) {
                            badgeText = window.theme.translations.sold_out;
                        } else if (on_sale) {
                            badgeText = window.theme.translations.on_sale;
                        } else if (on_sale && sold_out) {
                            badgeText = window.theme.translations.sold_out;
                        }
                        // New line required to prevent ellipse when style is set to "circle"
                        if (badgeStyle == 'circle') badgeText = badgeText.replace(' ', '<br>');

                        badge += badgeText;
                        badge += '</span>';
                    }
                    if (countProducts < limitProducts) {
                        searchResultsProducts +=
                            '<li class="result__item">' +
                            '<div class="result__image" data-aspectratio="' + imageAspectRatio + '">' +
                            '<a href="' + url + '">' +
                            '<img class="lazyload" alt="' + title + '"' +
                            'src="' + imageBlank + '"' +
                            'data-src="' + image.replace('_1x1.', '_{width}x.') + '"' +
                            'data-widths="[' + imageWidths + ']"' +
                            'data-aspectratio="' + imageAspectRatio + '"' +
                            'data-sizes="auto" />' + badge + '</a>' +
                            '</div>' +
                            '<p class="result__price">' + price + '</p>' +
                            '<h3 class="result__title"><a href="' + url + '">' + title + '</a></h3>' +
                            '</li>';
                    }
                    countProducts++;
                } else if (object_type == 'page') {
                    if (countPages < limitPages) {
                        searchResultsPages += '<li class="result__item"><h3 class="result__title"><a href="' + url + '">' + title + '</a></h3></li>';
                    }
                    countPages++;
                } else if (object_type == 'article') {
                    if (countArticles < limitArticles) {
                        searchResultsArticles += '<li class="result__item"><h3 class="result__title"><a href="' + url + '">' + title + '</a></h3></li>';
                    }
                    countArticles++;
                }
            }
        }

        // Check for empty results
        searchResultsProducts = countProducts ? searchResultsProducts : '<li class="result__item"><p class="result__title">' + window.theme.translations.no_results + '</p></li>';
        searchResultsPages = countPages ? searchResultsPages : '<li class="result__item"><p class="result__title">' + window.theme.translations.no_results + '</p></li>';
        searchResultsArticles = countArticles ? searchResultsArticles : '<li class="result__item"><p class="result__title">' + window.theme.translations.no_results + '</p></li>';

        // View all products button
        viewAllProducts = countProducts ? '<a href="' + window.theme.routes.search_url + '?type=product&q=' + searchQuery + '&options[prefix]=' + searchOptionsPrefix + '" class="view-all" title="' + window.theme.translations.view_all + '">' + window.theme.icons.arrowLong + '</a>' : '';

        // Always display products
        searchResults +=
            '<div class="results__column results__column--products">' +
            '<div class="results__heading">' +
            '<span>' + window.theme.translations.results_products + ' (' + countProducts + ')</span>' + viewAllProducts +
            '</div>' +
            '<ul class="results__list">' + searchResultsProducts + '</ul>' +
            '</div>';

        // Only display pages if enabled
        if (searchType.indexOf('pages') > -1) {
            searchResults +=
                '<div class="results__column results__column--pages">' +
                '<div class="results__heading">' +
                '<span>' + window.theme.translations.results_pages + ' (' + countPages + ')</span>' +
                '</div>' +
                '<ul class="results__list">' + searchResultsPages + '</ul>' +
                '</div>';
        }
        // Only display articles if enabled
        if (searchType.indexOf('articles') > -1) {
            searchResults +=
                '<div class="results__column results__column--articles">' +
                '<div class="results__heading">' +
                '<span>' + window.theme.translations.results_articles + ' (' + countArticles + ')</span>' +
                '</div>' +
                '<ul class="results__list">' + searchResultsArticles + '</ul>' +
                '</div>';
        }

        return searchResults;
    }
}

var Password = {
    init: function () {
        var $targets = $('.password-signup, .password-login');

        $targets.each(function () {
            var $el = $(this);
            if ($el.find('div.errors').length) {
                $el.find('input.password, input.email').select();
            }
        });
    }
}

var Login = {
    init: function () {
        this.bind();

        if (window.location.hash == '#recover') {
            this.recover.show();
        } else {
            this.recover.hide();
        }
    },

    bind: function () {
        $('.js-recoverToggle').on('click', Login.recover.show);
        $('.js-recoverCancel').on('click', Login.recover.hide);
    },

    recover: {
        show: function (e) {
            $('.js-loginForm').hide();
            $('.js-recoverForm').show();
            window.location.hash = '#recover';
            return false;
        },
        hide: function (e) {
            $('.js-loginForm').show();
            $('.js-recoverForm').hide();
            window.location.hash = '';
            return false;
        }
    }
}

var Addresses = {
    init: function () {
        // Initialize observers on address selectors
        new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
            hideElement: 'AddressProvinceContainerNew'
        });

        // Setup province selector on each customer address


        // Modified contents of customer_area.js (global asset)
        Shopify.CustomerAddress = {
            toggleForm: function (id) {
                var editEl = document.getElementById('EditAddress_' + id);
                editEl.style.display = editEl.style.display == 'none' ? '' : 'none';
                return false;
            },

            toggleNewForm: function () {
                var el = document.getElementById('AddAddress'),
                    toggle = document.getElementById('js-addAddress');
                el.style.display = el.style.display == 'none' ? '' : 'none';
                toggle.style.display = toggle.style.display == 'inline-block' ? 'none' : 'inline-block';
                return false;
            },

            destroy: function (id, confirm_msg) {
                if (confirm(confirm_msg || "Are you sure you wish to delete this address?")) {
                    Shopify.postLink('/account/addresses/' + id, {'parameters': {'_method': 'delete'}});
                }
            }
        }
    }
}

/**
 * Slate utilities
 * -----------------------------------------------------------------------------
 * A collection of useful utilities to help build your theme
 *
 *
 * @namespace utils
 */

slate.utils = {
    /**
     * Get the query params in a Url
     * Ex
     * https://mysite.com/search?q=noodles&b
     * getParameterByName('q') = "noodles"
     * getParameterByName('b') = "" (empty value)
     * getParameterByName('test') = null (absent)
     */
    getParameterByName: function (name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },

    keyboardKeys: {
        TAB: 9,
        ENTER: 13,
        ESCAPE: 27,
        LEFTARROW: 37,
        RIGHTARROW: 39
    }
};

slate.a11y = {
    /**
     * For use when focus shifts to a container rather than a link
     * eg for In-page links, after scroll, focus shifts to content area so that
     * next `tab` is where user expects if focusing a link, just $link.focus();
     *
     * @param {JQuery} $element - The element to be acted upon
     */
    pageLinkFocus: function ($element) {
        var focusClass = 'js-focus-hidden';

        $element
            .first()
            .attr('tabIndex', '-1')
            .focus()
            .addClass(focusClass)
            .one('blur', callback);

        function callback() {
            $element
                .first()
                .removeClass(focusClass)
                .removeAttr('tabindex');
        }
    },

    /**
     * If there's a hash in the url, focus the appropriate element
     */
    focusHash: function () {
        var hash = window.location.hash;

        // is there a hash in the url? is it an element on the page?
        if (hash && document.getElementById(hash.slice(1))) {
            this.pageLinkFocus($(hash));
        }
    },

    /**
     * When an in-page (url w/hash) link is clicked, focus the appropriate element
     */
    bindInPageLinks: function () {
        $('a[href*=#]').on(
            'click',
            function (evt) {
                this.pageLinkFocus($(evt.currentTarget.hash));
            }.bind(this)
        );
    },

    /**
     * Traps the focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    trapFocus: function (options) {
        var eventsName = {
            focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
            focusout: options.namespace
                ? 'focusout.' + options.namespace
                : 'focusout',
            keydown: options.namespace
                ? 'keydown.' + options.namespace
                : 'keydown.handleFocus'
        };

        /**
         * Get every possible visible focusable element
         */
        var $focusableElements = options.$container.find(
            $(
                'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
            ).filter(':visible')
        );
        var firstFocusable = $focusableElements[0];
        var lastFocusable = $focusableElements[$focusableElements.length - 1];

        if (!options.$elementToFocus) {
            options.$elementToFocus = options.$container;
        }

        function _manageFocus(evt) {
            if (evt.keyCode !== slate.utils.keyboardKeys.TAB) return;

            /**
             * On the last focusable element and tab forward,
             * focus the first element.
             */
            if (evt.target === lastFocusable && !evt.shiftKey) {
                evt.preventDefault();
                firstFocusable.focus();
            }
            /**
             * On the first focusable element and tab backward,
             * focus the last element.
             */
            if (evt.target === firstFocusable && evt.shiftKey) {
                evt.preventDefault();
                lastFocusable.focus();
            }
        }

        options.$container.attr('tabindex', '-1');
        options.$elementToFocus.focus();

        $(document).off('focusin');

        $(document).on(eventsName.focusout, function () {
            $(document).off(eventsName.keydown);
        });

        $(document).on(eventsName.focusin, function (evt) {
            if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;

            $(document).on(eventsName.keydown, function (evt) {
                _manageFocus(evt);
            });
        });
    },

    /**
     * Removes the trap of focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    removeTrapFocus: function (options) {
        var eventName = options.namespace
            ? 'focusin.' + options.namespace
            : 'focusin';

        if (options.$container && options.$container.length) {
            options.$container.removeAttr('tabindex');
        }

        $(document).off(eventName);
    },

    /**
     * Add aria-describedby attribute to external and new window links
     *
     * @param {object} options - Options to be used
     * @param {object} options.messages - Custom messages to be used
     * @param {jQuery} options.$links - Specific links to be targeted
     */
    accessibleLinks: function (options) {
        var body = document.querySelector('body');

        var idSelectors = {
            newWindow: 'a11y-new-window-message',
            external: 'a11y-external-message',
            newWindowExternal: 'a11y-new-window-external-message'
        };

        if (options.$links === undefined || !options.$links.jquery) {
            options.$links = $('a[href]:not([aria-describedby])');
        }

        function generateHTML(customMessages) {
            if (typeof customMessages !== 'object') {
                customMessages = {};
            }

            var messages = $.extend(
                {
                    newWindow: 'Opens in a new window.',
                    external: 'Opens external website.',
                    newWindowExternal: 'Opens external website in a new window.'
                },
                customMessages
            );

            var container = document.createElement('ul');
            var htmlMessages = '';

            for (var message in messages) {
                htmlMessages +=
                    '<li id=' + idSelectors[message] + '>' + messages[message] + '</li>';
            }

            container.setAttribute('hidden', true);
            container.innerHTML = htmlMessages;

            body.appendChild(container);
        }

        function _externalSite($link) {
            var hostname = window.location.hostname;

            return $link[0].hostname !== hostname;
        }

        $.each(options.$links, function () {
            var $link = $(this);
            var target = $link.attr('target');
            var rel = $link.attr('rel');
            var isExternal = _externalSite($link);
            var isTargetBlank = target === '_blank';

            if (isExternal) {
                $link.attr('aria-describedby', idSelectors.external);
            }
            if (isTargetBlank) {
                if (rel === undefined || rel.indexOf('noopener') === -1) {
                    $link.attr('rel', function (i, val) {
                        var relValue = val === undefined ? '' : val + ' ';
                        return relValue + 'noopener';
                    });
                }
                $link.attr('aria-describedby', idSelectors.newWindow);
            }
            if (isExternal && isTargetBlank) {
                $link.attr('aria-describedby', idSelectors.newWindowExternal);
            }
        });

        generateHTML(options.messages);
    }
};

var Disclosure = (function () {
    var selectors = {
        disclosureList: '[data-disclosure-list]',
        disclosureToggle: '[data-disclosure-toggle]',
        disclosureInput: '[data-disclosure-input]',
        disclosureOptions: '[data-disclosure-option]'
    };

    var classes = {
        listVisible: 'disclosure-list--visible'
    };

    function Disclosure($disclosure) {
        this.$container = $disclosure;
        this.cache = {};
        this._cacheSelectors();
        this._connectOptions();
        this._connectToggle();
        this._onFocusOut();
    }

    Disclosure.prototype = $.extend({}, Disclosure.prototype, {
        _cacheSelectors: function () {
            this.cache = {
                $disclosureList: this.$container.find(selectors.disclosureList),
                $disclosureToggle: this.$container.find(selectors.disclosureToggle),
                $disclosureInput: this.$container.find(selectors.disclosureInput),
                $disclosureOptions: this.$container.find(selectors.disclosureOptions)
            };
        },

        _connectToggle: function () {
            this.cache.$disclosureToggle.on(
                'click',
                function (evt) {
                    var ariaExpanded = $(evt.currentTarget).attr('aria-expanded') === 'true';
                    $(evt.currentTarget).attr('aria-expanded', !ariaExpanded);

                    this.cache.$disclosureList.toggleClass(classes.listVisible);
                    evt.preventDefault();
                }.bind(this)
            );
        },

        _connectOptions: function () {
            this.cache.$disclosureOptions.on(
                'click',
                function (evt) {
                    this._submitForm($(evt.currentTarget).data('value'));
                    evt.preventDefault();
                }.bind(this)
            );
        },

        _onFocusOut: function () {
            this.cache.$disclosureToggle.on(
                'focusout',
                function (evt) {
                    var disclosureLostFocus =
                        this.$container.has(evt.relatedTarget).length === 0;

                    if (disclosureLostFocus) {
                        this._hideList();
                    }
                }.bind(this)
            );

            this.cache.$disclosureList.on(
                'focusout',
                function (evt) {
                    var childInFocus =
                        $(evt.currentTarget).has(evt.relatedTarget).length > 0;
                    var isVisible = this.cache.$disclosureList.hasClass(
                        classes.listVisible
                    );

                    if (isVisible && !childInFocus) {
                        this._hideList();
                    }
                }.bind(this)
            );

            this.$container.on(
                'keyup',
                function (evt) {
                    if (evt.which !== slate.utils.keyboardKeys.ESCAPE) return;
                    this._hideList();
                    this.cache.$disclosureToggle.focus();
                }.bind(this)
            );

            this.bodyOnClick = function (evt) {
                var isOption = this.$container.has(evt.target).length > 0;
                var isVisible = this.cache.$disclosureList.hasClass(
                    classes.listVisible
                );

                if (isVisible && !isOption) {
                    this._hideList();
                }
            }.bind(this);

            $('body').on('click', this.bodyOnClick);
        },

        _submitForm: function (value) {
            this.cache.$disclosureInput.val(value);
            this.$container.parents('form').submit();
        },

        _hideList: function () {
            this.cache.$disclosureList.removeClass(classes.listVisible);
            this.cache.$disclosureToggle.attr('aria-expanded', false);
        },

        unload: function () {
            $('body').off('click', this.bodyOnClick);
            this.cache.$disclosureOptions.off();
            this.cache.$disclosureToggle.off();
            this.cache.$disclosureList.off();
            this.$container.off();
        }
    });

    return Disclosure;
})();
